(function () {
function initOttoConfigurator(root) {
if (!root || root.getAttribute('data-otto-cfg-initialized') === '1') return;
root.setAttribute('data-otto-cfg-initialized', '1');
function settingString(value, fallback) {
if (value == null) return fallback;
var text = String(value).trim();
return text ? text : fallback;
}
var cfgNode = root.querySelector('[data-otto-cfg-config]');
var cfg = {};
if (cfgNode) {
try {
cfg = JSON.parse(cfgNode.textContent || '{}');
} catch (err) {
cfg = {};
}
}
var settings = cfg.settings || {};
var loopCfg = cfg.loop || {};
var foundingCfg = cfg.founding || {};
var pickupCfg = cfg.pickup || {};
var pricingCfg = cfg.pricing || {};
var avatarFallbacks = cfg.avatarFallbacks || {};
var CadenceEngine = window.OttoCfgV2Cadence || null;
/* Shared meal-plan engine (otto-engine.js) — the same source of truth the
 * customer portal uses. Adds evaluatePack / computeDogPortion on top of the
 * legacy cadence surface. Falls back to the legacy module if not present. */
var Engine = window.OttoEngine || window.OttoCfgV2Cadence || null;
var SECTION_ID = cfg.sectionId || root.getAttribute('data-otto-cfg-section-id') || '';
/* Returning-customer detection: tier 1 (logged in) is known server-side via the
 * config block; tier 2 (logged out) is the soft email check at the ZIP gate. */
var ottoCustomer = cfg.customer || {};
var ottoUrls = cfg.urls || {};
var ottoWorkerUrl = String(cfg.workerUrl || '').replace(/\/$/, '');
var existingPlanChecked = {};
/* Set once a returning customer is hard-blocked at the ZIP gate (logged-in with
 * a live plan). Prevents advancing past the gate into a second checkout. */
var existingPlanBlocked = false;
var existingPlanStatus = null;
var existingPlanFirstName = '';
    /* Referral: ?ref=CODE → first-party cookie + cart attr (storefront domain). */
    (function captureReferralRef() {
      var COOKIE = 'otto_ref';
      var TTL_DAYS = 60;
      function normalize(code) {
        return String(code || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '');
      }
      function readCookie(name) {
        var parts = (document.cookie || '').split(';');
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i].trim();
          if (p.indexOf(name + '=') === 0) {
            try {
              return decodeURIComponent(p.slice(name.length + 1));
            } catch (e) {
              return p.slice(name.length + 1);
            }
          }
        }
        return '';
      }
      function writeCookie(code) {
        var maxAge = TTL_DAYS * 86400;
        document.cookie =
          COOKIE + '=' + encodeURIComponent(code) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
        try {
          localStorage.setItem(COOKIE, code);
        } catch (e) { /* ignore */ }
      }
      function readStored() {
        var c = normalize(readCookie(COOKIE));
        if (c) return c;
        try {
          return normalize(localStorage.getItem(COOKIE) || '');
        } catch (e) {
          return '';
        }
      }
      var fromQuery = '';
      try {
        fromQuery = normalize(new URLSearchParams(window.location.search || '').get('ref') || '');
      } catch (e) { /* ignore */ }
      var code = fromQuery || readStored();
      if (!code) return;
      if (fromQuery || !readCookie(COOKIE)) writeCookie(code);
      try {
        window.__ottoRefCode = code;
      } catch (e) { /* ignore */ }
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { otto_ref: code } })
        }).catch(function () { /* ignore */ });
      } catch (e) { /* ignore */ }
      if (fromQuery && ottoWorkerUrl) {
        var sessionId = 'anon';
        try {
          sessionId = localStorage.getItem('otto_ref_sid') || '';
          if (!sessionId) {
            sessionId = 's' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
            localStorage.setItem('otto_ref_sid', sessionId);
          }
        } catch (e) {
          sessionId = 'anon';
        }
        fetch(ottoWorkerUrl + '/portal/rewards/click', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ code: code, sessionId: sessionId })
        }).catch(function () { /* ignore */ });
      }
    })();
    root.addEventListener('error', function (event) {
      var target = event && event.target;
      if (!target || target.tagName !== 'IMG') return;
      var fallbackSrc = target.getAttribute('data-fallback-src');
      if (!fallbackSrc || target.getAttribute('src') === fallbackSrc) return;
      target.setAttribute('src', fallbackSrc);
    }, true);
    var allCards = root.querySelectorAll('.otto-cfg-card');
    var TOTAL_STEPS = allCards.length;
    if (TOTAL_STEPS === 0) return;
    var currentStep = 1;
    var selections = {};
    var completedSteps = {};
    var everCompletedSteps = {};
    var isHydratingState = false;
    var normalizedPath = (window.location && window.location.pathname ? window.location.pathname : '/').replace(/\/+$/, '') || '/';
    var STORAGE_KEY = 'otto_cfg_state_v2_' + normalizedPath;
    var LEGACY_STORAGE_KEY = 'otto_cfg_state_' + SECTION_ID + '_' + window.location.pathname;
    var STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
    var RESET_JUMP_KEY = STORAGE_KEY + '_reset_jump';
    var resetUtilityBar = $('[data-cfg-reset-bar]');
    var zipResetAction = $('[data-cfg-zip-reset]');
var REVIEW_V2_EXPERIMENT_ENABLED = false;
var REVIEW_V3_EXPERIMENT_ENABLED = false;
try {
var reviewFlag = new URLSearchParams(window.location.search || '').get('review_v2');
REVIEW_V2_EXPERIMENT_ENABLED = reviewFlag === '1' || String(reviewFlag || '').toLowerCase() === 'true';
} catch (_reviewFlagErr) {}
try {
var reviewV3Flag = new URLSearchParams(window.location.search || '').get('review_v3');
REVIEW_V3_EXPERIMENT_ENABLED = reviewV3Flag === '1' || String(reviewV3Flag || '').toLowerCase() === 'true';
} catch (_reviewV3FlagErr) {}
    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return root.querySelectorAll(sel); }
    function setControlNeedsAnswer(el, needs) {
      if (!el) return;
      el.classList.toggle('is-invalid', !!needs);
      el.setAttribute('aria-invalid', needs ? 'true' : 'false');
      var wrap = el.closest('.otto-cfg-select-wrap, .otto-cfg-combobox');
      if (wrap) wrap.classList.toggle('is-invalid', !!needs);
    }
    function markOutOfOrderRequired(fields, markAllEmpty) {
      var list = fields || [];
      var lastFilled = -1;
      list.forEach(function (f, i) {
        if (f && f.valid) lastFilled = i;
      });
      list.forEach(function (f, i) {
        if (!f || !f.el) return;
        var needs = markAllEmpty ? !f.valid : (lastFilled > i && !f.valid);
        setControlNeedsAnswer(f.el, needs);
      });
    }
    function saveProgressState() {
      if (isHydratingState) return;
      try {
        var payload = {
          version: 1,
          timestamp: Date.now(),
          currentStep: currentStep,
          selections: selections,
          completedSteps: completedSteps,
          everCompletedSteps: everCompletedSteps
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (err) {}
      updateResetBarVisibility();
      updateZipResetVisibility();
      scheduleConfiguratorDraftSave();
    }
    var configuratorDraftSaveTimer = null;
    function canSaveConfiguratorDraft() {
      if (ottoCustomer && ottoCustomer.loggedIn) return false;
      if (existingPlanBlocked) return false;
      var owner = selections.owner && typeof selections.owner === 'object' ? selections.owner : null;
      var email = owner && owner.email ? String(owner.email).trim() : '';
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    function draftGuideName() {
      var familiarity = String((selections.owner && selections.owner.familiarity) || '').trim();
      if (!familiarity) return '';
      var tile = root.querySelector(
        '[data-cfg-type="owner_feeding"] [data-cfg-owner-familiarity-value="' + familiarity + '"]'
      );
      var gn = tile ? tile.getAttribute('data-owner-guide-name') : '';
      return gn ? gn.trim() : '';
    }
    function pushConfiguratorDraftNow() {
      if (!canSaveConfiguratorDraft() || !ottoWorkerUrl) return;
      var owner = selections.owner || {};
      var email = String(owner.email || '').trim();
      fetch(ottoWorkerUrl + '/configurator/draft', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          selections: selections,
          currentStep: currentStep,
          configPath: normalizedPath,
          origin: window.location.origin,
          completedSteps: completedSteps,
          everCompletedSteps: everCompletedSteps,
          serviceEligible: selections.service_eligible !== false,
          zip: String(selections.zip || selections.zip_attempted || ''),
          guideName: draftGuideName(),
          rawFamiliarity: String(owner.familiarity || '').trim(),
          guideOptIn: owner.guide_opt_in === true
        })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (!data || !data.ok || !data.token) return;
          selections.resume_token = data.token;
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
              version: 1,
              timestamp: Date.now(),
              currentStep: currentStep,
              selections: selections,
              completedSteps: completedSteps,
              everCompletedSteps: everCompletedSteps
            }));
          } catch (err) {}
        })
        .catch(function () {});
    }
    function scheduleConfiguratorDraftSave() {
      if (!canSaveConfiguratorDraft()) return;
      if (configuratorDraftSaveTimer) clearTimeout(configuratorDraftSaveTimer);
      configuratorDraftSaveTimer = setTimeout(function () {
        configuratorDraftSaveTimer = null;
        pushConfiguratorDraftNow();
      }, 10000);
    }
    function applyResumePayload(resumeData) {
      if (!resumeData || !resumeData.selections || typeof resumeData.selections !== 'object') return false;
      isHydratingState = true;
      try {
        selections = resumeData.selections;
        if (resumeData.completedSteps && typeof resumeData.completedSteps === 'object') {
          completedSteps = resumeData.completedSteps;
        }
        if (resumeData.everCompletedSteps && typeof resumeData.everCompletedSteps === 'object') {
          everCompletedSteps = resumeData.everCompletedSteps;
        }
        var restoredStep = parseInt(resumeData.currentStep, 10);
        if (restoredStep > 0) currentStep = restoredStep;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({
            version: 1,
            timestamp: Date.now(),
            currentStep: currentStep,
            selections: selections,
            completedSteps: completedSteps,
            everCompletedSteps: everCompletedSteps
          }));
        } catch (err) {}
        try {
          var resumeUrl = new URL(window.location.href);
          if (resumeUrl.searchParams.has('resume')) {
            resumeUrl.searchParams.delete('resume');
            window.history.replaceState({}, '', resumeUrl.pathname + resumeUrl.search + resumeUrl.hash);
          }
        } catch (err) {}
        return true;
      } finally {
        isHydratingState = false;
      }
    }
    function clearProgressState() {
      try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(LEGACY_STORAGE_KEY);
      } catch (err) {}
    }
    function clearShopifyCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) throw new Error('cart_clear_failed');
        return res;
      });
    }
    function parseProgressPayload(raw) {
      if (!raw) return null;
      var parsed = null;
      try {
        parsed = JSON.parse(raw);
      } catch (err) {
        return null;
      }
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.timestamp || Date.now() - Number(parsed.timestamp) > STORAGE_TTL_MS) return null;
      return parsed;
    }
    function loadProgressState() {
      try {
        var parsed = parseProgressPayload(localStorage.getItem(STORAGE_KEY));
        var loadedFromLegacy = false;
        if (!parsed) {
          parsed = parseProgressPayload(localStorage.getItem(LEGACY_STORAGE_KEY));
          loadedFromLegacy = !!parsed;
        }
        if (!parsed) {
          clearProgressState();
          return;
        }
        if (parsed.selections && typeof parsed.selections === 'object') selections = parsed.selections;
        if (selections.founding_choice === 'reserve') selections.founding_choice = 'notify';
        if (parsed.completedSteps && typeof parsed.completedSteps === 'object') completedSteps = parsed.completedSteps;
        if (parsed.everCompletedSteps && typeof parsed.everCompletedSteps === 'object') {
          everCompletedSteps = parsed.everCompletedSteps;
        } else {
          everCompletedSteps = Object.assign({}, completedSteps);
        }
        var restoredStep = parseInt(parsed.currentStep, 10);
        if (restoredStep > 0) currentStep = restoredStep;
        if (loadedFromLegacy) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
        }
      } catch (err) {
        clearProgressState();
      }
    }
    function markStepCompleted(stepNum) {
      if (!stepNum) return;
      completedSteps[stepNum] = true;
      everCompletedSteps[stepNum] = true;
    }
    function titleCase(str) {
      if (!str) return '';
      return str.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
function normalizeCustomBreedLabel(value) {
var raw = String(value || '').trim();
if (!raw) return '';
return raw
.toLowerCase()
.replace(/\s+/g, ' ')
.replace(/\b([a-z])/g, function (ch) { return ch.toUpperCase(); });
}
    function esc(val) {
      return String(val == null ? '' : val)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
    /* Shared authoritative (Loop-backed) "already has a plan?" check. Returns a
     * Promise<{ existingOttoPlan, planStatus }> and caches per email. */
    function ottoExistingPlanCheck(emailVal) {
      var Modal = window.OttoCfgPlanModal;
      var email = String(emailVal || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return Promise.resolve({ existingOttoPlan: false, planStatus: null, firstName: '' });
      }
      if (existingPlanChecked.hasOwnProperty(email)) return existingPlanChecked[email];
      var prefetch = window.__ottoPlanPrefetch;
      if (prefetch && String(prefetch.email || '').toLowerCase() === email) {
        if (prefetch.done) {
          var cached = Promise.resolve({
            existingOttoPlan: !!prefetch.result,
            planStatus: prefetch.planStatus || (prefetch.result ? 'ACTIVE' : null),
            firstName: prefetch.firstName || '',
          });
          existingPlanChecked[email] = cached;
          return cached;
        }
        if (prefetch.promise) {
          existingPlanChecked[email] = prefetch.promise;
          return prefetch.promise;
        }
      }
      if (!ottoWorkerUrl) return Promise.resolve({ existingOttoPlan: false, planStatus: null, firstName: '' });
      var p = fetch(ottoWorkerUrl + '/account/check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (Modal && Modal.parseAccountCheckResponse) return Modal.parseAccountCheckResponse(data);
        return {
          existingOttoPlan: !!(data && data.existingOttoPlan),
          planStatus: data && data.planStatus ? String(data.planStatus).toUpperCase() : (data && data.existingOttoPlan ? 'ACTIVE' : null),
          firstName: data && data.firstName ? String(data.firstName).trim() : '',
        };
      }).catch(function () {
        return { existingOttoPlan: false, planStatus: null, firstName: '' };
      });
      existingPlanChecked[email] = p;
      return p;
    }
    function handlePlanStartFresh() {
      if (ottoCustomer && ottoCustomer.loggedIn) {
        var logoutBase = (ottoUrls && ottoUrls.logout) || '/account/logout';
        var returnPath = window.location.pathname + window.location.search;
        var sep = logoutBase.indexOf('?') >= 0 ? '&' : '?';
        window.location.href = logoutBase + sep + 'return_url=' + encodeURIComponent(returnPath);
        return;
      }
      existingPlanBlocked = false;
      existingPlanModalShown = false;
      window.__ottoPlanModalShown = false;
      var zipCard = root.querySelector('[data-cfg-type="zip_validator"]');
      if (zipCard) {
        zipCard.classList.remove('otto-cfg-card--plan-blocked');
        var banner = zipCard.querySelector('[data-cfg-existing-plan]');
        if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
        var zipCheckBtn = zipCard.querySelector('[data-cfg-zip-check]');
        if (zipCheckBtn) {
          zipCheckBtn.disabled = false;
          zipCheckBtn.removeAttribute('aria-disabled');
          zipCheckBtn.classList.remove('is-disabled');
        }
      }
      var zipInput = root.querySelector('[data-cfg-zip-email]');
      if (zipInput) {
        zipInput.value = '';
        try { zipInput.focus(); } catch (e) {}
      }
    }
    var existingPlanModalShown = !!window.__ottoPlanModalShown;
    function showExistingPlanModal(emailVal, planStatus, firstName) {
      var Modal = window.OttoCfgPlanModal;
      if (!Modal) return;
      existingPlanModalShown = true;
      existingPlanStatus = planStatus || existingPlanStatus || 'ACTIVE';
      existingPlanFirstName = String(firstName || existingPlanFirstName || (ottoCustomer && ottoCustomer.firstName) || '').trim();
      Modal.show({
        planStatus: existingPlanStatus,
        loggedIn: !!(ottoCustomer && ottoCustomer.loggedIn),
        firstName: existingPlanFirstName,
        emailVal: emailVal,
        urls: ottoUrls,
        onStartFresh: handlePlanStartFresh,
      });
    }
    /* Logged-in returning-customer modal is handled by otto-configurator-v2-plan-guard.js
     * (loads synchronously before this bundle). ZIP-gate hard block still runs below. */
var DOG_AVATAR_FALLBACKS = {
doodle: settingString(avatarFallbacks.doodle, ''),
terrier: settingString(avatarFallbacks.terrier, ''),
spaniel: settingString(avatarFallbacks.spaniel, ''),
shepherd: settingString(avatarFallbacks.shepherd, ''),
coonhound: settingString(avatarFallbacks.coonhound, ''),
hound: settingString(avatarFallbacks.hound, ''),
retriever: settingString(avatarFallbacks.retriever, ''),
bulldog: settingString(avatarFallbacks.bulldog, ''),
mastiff: settingString(avatarFallbacks.mastiff, ''),
pointer: settingString(avatarFallbacks.pointer, ''),
setter: settingString(avatarFallbacks.setter, ''),
corgi: settingString(avatarFallbacks.corgi, ''),
poodle: settingString(avatarFallbacks.poodle, ''),
griffon: settingString(avatarFallbacks.griffon, ''),
pinscher: settingString(avatarFallbacks.pinscher, ''),
schnauzer: settingString(avatarFallbacks.schnauzer, ''),
generic: settingString(avatarFallbacks.generic, '')
    };
    var DOG_AVATAR_BREED_OVERRIDES = {};
    var dogBreedAvatarByKey = {};
var dogBreedExactAvatarByKey = {};
var DOG_AVATAR_ALIAS_TO_CANONICAL = {
'lab': 'labrador retriever',
'labrador': 'labrador retriever',
'chocolate lab': 'labrador retriever',
'black lab': 'labrador retriever',
'yellow lab': 'labrador retriever',
'pit': 'american pit bull terrier',
'pitbull': 'american pit bull terrier',
'pit bull': 'american pit bull terrier',
'pittie': 'american pit bull terrier',
'gsd': 'german shepherd dog',
'german shepherd': 'german shepherd dog',
'shepherd': 'german shepherd dog',
'frenchie': 'french bulldog',
'yorkie': 'yorkshire terrier',
'doxie': 'dachshund',
'wiener dog': 'dachshund',
'sausage dog': 'dachshund',
'aussie': 'australian shepherd',
'husky': 'siberian husky',
'rottie': 'rottweiler',
'doberman': 'doberman pinscher',
'pom': 'pomeranian',
'cavalier': 'cavalier king charles spaniel',
'king charles': 'cavalier king charles spaniel',
'westie': 'west highland white terrier'
};
var isDogAvatarEnabled = (typeof settings.show_avatars === 'boolean' ? settings.show_avatars : true);
    function normalizeBreedKey(value) {
      if (!value) return '';
      return String(value)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }
    function getDogAvatarFamily(breed) {
      var raw = String(breed || '');
      if (/\b(doodle|poo|pomsky|morkie|chiweenie|cockapoo|cavapoo|puggle)\b/i.test(raw)) return 'doodle';
      if (/\bcoonhound\b/i.test(raw)) return 'coonhound';
      if (/\bterrier\b/i.test(raw)) return 'terrier';
      if (/\bspaniel\b/i.test(raw)) return 'spaniel';
      if (/\bshepherd\b/i.test(raw)) return 'shepherd';
      if (/\bretriever\b/i.test(raw)) return 'retriever';
      if (/\bmastiff\b/i.test(raw)) return 'mastiff';
      if (/\bbulldog\b/i.test(raw)) return 'bulldog';
      if (/\bpointer\b/i.test(raw)) return 'pointer';
      if (/\bsetter\b/i.test(raw)) return 'setter';
      if (/\bcorgi\b/i.test(raw)) return 'corgi';
      if (/\bpinscher\b/i.test(raw)) return 'pinscher';
      if (/\bschnauzer\b/i.test(raw)) return 'schnauzer';
      if (/\bgriffon\b/i.test(raw)) return 'griffon';
      if (/\bpoodle\b/i.test(raw)) return 'poodle';
      if (/\bhound\b/i.test(raw)) return 'hound';
      return 'generic';
    }
    function getDogAvatarFallbackUrl(breed) {
      var family = getDogAvatarFamily(breed);
      return DOG_AVATAR_FALLBACKS[family] || DOG_AVATAR_FALLBACKS.generic;
    }
function resolveClosestBreedAvatarKey(rawBreed) {
var normalized = normalizeBreedKey(rawBreed);
if (!normalized) return '';
if (dogBreedExactAvatarByKey[normalized]) return normalized;
var bestKey = '';
var bestScore = 0;
Object.keys(DOG_AVATAR_ALIAS_TO_CANONICAL).forEach(function (alias) {
var canonical = String(DOG_AVATAR_ALIAS_TO_CANONICAL[alias] || '').trim();
if (!canonical || !dogBreedExactAvatarByKey[canonical]) return;
var aliasNorm = normalizeBreedKey(alias);
if (!aliasNorm) return;
var re = new RegExp('(^|\\s)' + aliasNorm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)');
if (!re.test(normalized)) return;
var aliasWordCount = aliasNorm.split(' ').filter(Boolean).length;
var score = aliasWordCount * 10;
if (score > bestScore) {
bestScore = score;
bestKey = canonical;
} else if (score === bestScore && bestKey && bestKey !== canonical) {
bestKey = '';
}
});
return bestKey;
}
    function isBlockedAvatarUrl(url) {
      var value = String(url || '').trim();
      if (!value) return true;
      return value.indexOf('/breed-svgs-2/') > -1 || value.indexOf('/breed-svgs-2%2F') > -1;
    }
    function getDogAvatarPrimaryUrl(breed) {
      var key = normalizeBreedKey(breed);
      if (!key) return getDogAvatarFallbackUrl('');
      var overrideUrl = String(DOG_AVATAR_BREED_OVERRIDES[key] || '').trim();
      if (overrideUrl && !isBlockedAvatarUrl(overrideUrl)) {
        dogBreedAvatarByKey[key] = overrideUrl;
        return dogBreedAvatarByKey[key];
      }
      var exactUrl = String(dogBreedExactAvatarByKey[key] || '').trim();
      if (exactUrl && !isBlockedAvatarUrl(exactUrl)) {
        dogBreedAvatarByKey[key] = exactUrl;
        return dogBreedAvatarByKey[key];
      }
      if (dogBreedAvatarByKey[key] && !isBlockedAvatarUrl(dogBreedAvatarByKey[key])) {
        return dogBreedAvatarByKey[key];
      }
var closestKey = resolveClosestBreedAvatarKey(breed);
if (closestKey) {
var closestUrl = String(dogBreedExactAvatarByKey[closestKey] || '').trim();
if (closestUrl && !isBlockedAvatarUrl(closestUrl)) {
dogBreedAvatarByKey[key] = closestUrl;
return dogBreedAvatarByKey[key];
}
}
      dogBreedAvatarByKey[key] = getDogAvatarFallbackUrl(breed);
      return dogBreedAvatarByKey[key];
    }
    function getDogAvatarModel(dog, idx) {
      var safeDog = dog || {};
      var label = titleCase(safeDog.name) || ('Dog ' + (idx + 1));
      var breed = String(safeDog.breed || '').trim();
      var resolvedSrc = String(safeDog.avatar || '').trim();
      var resolvedFallback = String(safeDog.avatar_fallback || '').trim();
      if (resolvedSrc && isBlockedAvatarUrl(resolvedSrc)) resolvedSrc = '';
      if (resolvedFallback && isBlockedAvatarUrl(resolvedFallback)) resolvedFallback = '';
      if (!resolvedSrc) resolvedSrc = getDogAvatarPrimaryUrl(breed);
      if (!resolvedFallback) resolvedFallback = getDogAvatarFallbackUrl(breed);
      return {
        label: label,
        src: resolvedSrc,
        fallback: resolvedFallback,
        alt: label + ' avatar'
      };
    }
    function buildDogAvatarHtml(dog, idx, sizeClass) {
      if (!isDogAvatarEnabled) return '';
      var avatar = getDogAvatarModel(dog, idx);
      return '<img class="otto-cfg-dog-avatar ' + esc(sizeClass || '') + '" src="' + esc(avatar.src) + '" data-fallback-src="' + esc(avatar.fallback) + '" alt="' + esc(avatar.alt) + '" loading="lazy">';
    }
    function syncAllAvatarElementsVisibility() {
      $$('.otto-cfg-dog-avatar').forEach(function (avatarEl) {
        avatarEl.hidden = !isDogAvatarEnabled;
      });
    }
    function buildDogTabLabelHtml(dog, idx) {
      var avatarHtml = buildDogAvatarHtml(dog, idx, 'otto-cfg-dog-avatar--tab');
      var label = titleCase((dog && dog.name) ? dog.name : '') || ('Dog ' + (idx + 1));
      return '<span class="otto-cfg-dog-tab__inner">' + avatarHtml + '<span class="otto-cfg-dog-tab__label">' + esc(label) + '</span><span class="otto-cfg-dog-tab__check"> &#10003;</span></span>';
    }
    function setZipButtonLabel(button, text, useShimmer) {
      if (!button) return;
      var label = String(text == null ? '' : text);
      button.textContent = label;
      button.removeAttribute('data-zip-loading-label');
    }
function isFeedingSetupCardInteractable() {
var card = $('[data-cfg-type="feeding_setup"]');
if (!card || card.hidden) return false;
var style = window.getComputedStyle(card);
if (!style) return true;
if (style.display === 'none' || style.visibility === 'hidden') return false;
return true;
}
function ensureMealsPerDayDefault() {
var meals = parseInt(selections.meals_per_day, 10);
var source = String(selections.meals_per_day_source || '').trim().toLowerCase();
if (!isFeedingSetupCardInteractable()) {
if (meals !== 1 && meals !== 2) selections.meals_per_day = 2;
selections.meals_per_day_source = 'auto';
return;
}
if (source !== 'user') {
delete selections.meals_per_day;
delete selections.meals_per_day_source;
}
}
    var resumeApplied = false;
    if (window.__ottoCfgResumePayload) {
      resumeApplied = applyResumePayload(window.__ottoCfgResumePayload);
      window.__ottoCfgResumePayload = null;
    }
    if (!resumeApplied) {
      loadProgressState();
    }
    function consumeResetJumpFlag() {
      try {
        var raw = sessionStorage.getItem(RESET_JUMP_KEY);
        if (raw !== '1') return false;
        sessionStorage.removeItem(RESET_JUMP_KEY);
        return true;
      } catch (err) {
        return false;
      }
    }
    function isPageReload() {
      try {
        if (window.performance && typeof window.performance.getEntriesByType === 'function') {
          var navEntries = window.performance.getEntriesByType('navigation');
          if (navEntries && navEntries.length) return navEntries[0].type === 'reload';
        }
        if (window.performance && window.performance.navigation) {
          return window.performance.navigation.type === 1;
        }
      } catch (err) {}
      return false;
    }
    var isReloadNavigation = isPageReload();
    var shouldJumpToFirstStep = consumeResetJumpFlag();
    var shouldForceFirstStep = shouldJumpToFirstStep || isReloadNavigation;
    if (shouldJumpToFirstStep) {
      selections = {};
      completedSteps = {};
      everCompletedSteps = {};
      clearProgressState();
    }
ensureMealsPerDayDefault();
    if (shouldForceFirstStep) currentStep = 1;
    if (shouldForceFirstStep && window.history && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    function readCssPixels(varName) {
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue(varName);
      var parsed = parseFloat(raw);
      if (isFinite(parsed)) return parsed;
      // CSS custom properties can be calc() expressions; measure resolved px value.
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(' + varName + ',0px)';
      document.body.appendChild(probe);
      var measured = probe.getBoundingClientRect().height;
      document.body.removeChild(probe);
      return isFinite(measured) ? measured : null;
    }
    function getBaseStickyOffset() {
      var live = readCssPixels('--sticky-offset');
      if (live != null) return live;
      var fallback = readCssPixels('--sticky-area-height');
      return fallback == null ? 0 : fallback;
    }
    function getStableStickyAreaHeight() {
      var stickyArea = readCssPixels('--sticky-area-height');
      return stickyArea == null ? 0 : stickyArea;
    }
    function getVisibleUtilityBarHeight() {
      if (!resetUtilityBar || !resetUtilityBar.classList.contains('is-visible')) return 0;
      var rect = resetUtilityBar.getBoundingClientRect();
      if (rect.height <= 0) return 0;
      var styles = window.getComputedStyle(resetUtilityBar);
      var marginBottom = parseFloat(styles.marginBottom || '0') || 0;
      return rect.height + marginBottom;
    }
    function getEffectiveStickyOffset() {
      var total = getBaseStickyOffset();
      if (!resetUtilityBar || !resetUtilityBar.classList.contains('is-visible')) return total;
      var rect = resetUtilityBar.getBoundingClientRect();
      if (rect.height <= 0) return total;
      var styles = window.getComputedStyle(resetUtilityBar);
      var marginBottom = parseFloat(styles.marginBottom || '0') || 0;
      return total + rect.height + marginBottom;
    }
    function scrollToCard(card) {
      if (!card) return;
      var stickyHeight = getEffectiveStickyOffset();
      var isMobile = window.innerWidth < 1000;
      if (isMobile) {
        var mobileHeadline = card.querySelector('.otto-cfg-card__headline');
        var mobileRect = mobileHeadline ? mobileHeadline.getBoundingClientRect() : card.getBoundingClientRect();
        var mobileY = mobileRect.top + window.pageYOffset - stickyHeight - 16;
        window.scrollTo({ top: Math.max(0, mobileY), behavior: 'smooth' });
        return;
      }
      var availableH = window.innerHeight - stickyHeight;
      var children = card.children;
      var firstRect = null, lastRect = null;
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (c.offsetHeight > 0 && getComputedStyle(c).display !== 'none') {
          if (!firstRect) firstRect = c.getBoundingClientRect();
          lastRect = c.getBoundingClientRect();
        }
      }
      if (!firstRect) return;
      var contentH = lastRect.bottom - firstRect.top;
      if (contentH < availableH) {
        var centerOffset = (availableH - contentH) / 2;
        var y = firstRect.top + window.pageYOffset - stickyHeight - centerOffset;
      } else {
        var headline = card.querySelector('.otto-cfg-card__headline');
        var r = headline ? headline.getBoundingClientRect() : firstRect;
        var y = r.top + window.pageYOffset - stickyHeight - 16;
      }
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
/* ---- Desktop media sizing ---- */
    var cfgMedia = root.querySelector('.otto-cfg__media');
    function sizeMedia() {
      if (!cfgMedia) return;
if (window.innerWidth < 1000) {
cfgMedia.style.height = '';
cfgMedia.style.top = '';
return;
}
      var stickyH = getStableStickyAreaHeight() + getVisibleUtilityBarHeight();
var baseTop = stickyH + 32;
      var available = window.innerHeight - stickyH - 32 - 40;
      var w = cfgMedia.offsetWidth;
      var h = Math.max(460, Math.min(w, available));
var top = baseTop;
var isSquareLimited = available > w && Math.abs(h - w) < 1;
if (isSquareLimited) top = baseTop + ((available - h) / 2);
      cfgMedia.style.height = h + 'px';
cfgMedia.style.top = Math.max(baseTop, top) + 'px';
    }
    sizeMedia();
    var _resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(function () {
        sizeMedia();
      }, 80);
    }, { passive: true });
/* ---- Feeding calculation ---- */
    function settingNum(value, fallback) {
      var n = parseFloat(value);
      return isFinite(n) ? n : fallback;
    }
    var FEEDING_RATES = [
{ min: 1, max: 5, rate: settingNum(settings.feed_rate_1_5_pct, 5) / 100 },
{ min: 6, max: 10, rate: settingNum(settings.feed_rate_6_10_pct, 4) / 100 },
{ min: 11, max: 20, rate: settingNum(settings.feed_rate_11_20_pct, 3) / 100 },
{ min: 21, max: 40, rate: settingNum(settings.feed_rate_21_40_pct, 2.5) / 100 },
{ min: 41, max: 80, rate: settingNum(settings.feed_rate_41_80_pct, 2.25) / 100 },
{ min: 81, max: 500, rate: settingNum(settings.feed_rate_81_plus_pct, 2) / 100 }
    ];
    /* Adult feeds the weight-band baseline as-is; only senior gets a
     * life-stage multiplier. */
    var LIFE_STAGE = {
senior: settingNum(settings.life_stage_senior_multiplier, 80) / 100
    };
    /* Growth stages feed a direct age-based percent of current body weight
     * (goal and activity multipliers intentionally not applied — puppies are
     * actively growing and necessarily active). Young Adult is the taper
     * stage between Juvenile and the adult weight bands. Legacy "puppy" (old
     * 3-stage model, no birthdate) feeds the Growing Puppy percent. */
    var STAGE_FEED_PCT = {
young_puppy: settingNum(settings.feed_pct_young_puppy, 9) / 100,
growing_puppy: settingNum(settings.feed_pct_growing_puppy, 7) / 100,
puppy: settingNum(settings.feed_pct_growing_puppy, 7) / 100,
juvenile: settingNum(settings.feed_pct_juvenile, 5) / 100,
young_adult: settingNum(settings.feed_pct_young_adult, 3) / 100
    };
    function isGrowthStageKey(stage) {
      if (Engine && typeof Engine.isGrowthStage === 'function') return Engine.isGrowthStage(stage);
      var s = String(stage || '').trim().toLowerCase();
      return s === 'young_puppy' || s === 'growing_puppy' || s === 'juvenile' || s === 'young_adult';
    }
    /* Young puppies eat small, frequent meals: 4 feedings/day at 8-16 weeks,
     * 3/day at 4-6 months. 0 = no stage override (household setting applies). */
    function stageMealsPerDay(stage) {
      if (Engine && typeof Engine.recommendedMealsPerDay === 'function') return Engine.recommendedMealsPerDay(stage);
      var s = String(stage || '').trim().toLowerCase();
      if (s === 'young_puppy') return 4;
      if (s === 'growing_puppy') return 3;
      return 0;
    }
    /* Effective feedings/day for a dog: stage recommendation for young
     * puppies, else the dog/household meals-per-day selection. */
    function mealsPerDayForDogDisplay(dog, fallbackMeals) {
      var stageMeals = stageMealsPerDay(dog && dog.life_stage);
      if (stageMeals > 0) return stageMeals;
      var n = Number(fallbackMeals || 0);
      return n > 0 ? n : 0;
    }
    /* Daily-intake-weighted feedings/day for the dogs on a plan, so meal
     * counts stay accurate when a puppy eating 3-4x/day shares a delivery
     * with adult dogs on the household 1x/2x setting. */
    function effectiveMealsPerDayForDogs(dogList, fallbackMeals) {
      var mealsPerDay = Number(fallbackMeals || 0) || getMealsPerDay() || 2;
      var list = Array.isArray(dogList) ? dogList : [];
      var weighted = 0;
      var totalDaily = 0;
      list.forEach(function (dog) {
        var daily = Number((dog && dog.daily_intake) || (dog && dog.dailyLb) || (dog && dog.daily_lb) || 0);
        var m = mealsPerDayForDogDisplay(dog, mealsPerDay);
        if (daily > 0 && m > 0) {
          weighted += daily * m;
          totalDaily += daily;
        }
      });
      if (totalDaily > 0) return weighted / totalDaily;
      if (list.length === 1) return mealsPerDayForDogDisplay(list[0], mealsPerDay);
      return mealsPerDay;
    }
    function lifeStageLabel(stage) {
      if (Engine && typeof Engine.stageLabel === 'function') return Engine.stageLabel(stage);
      var s = String(stage || '').trim();
      if (!s) return '';
      return s.split('_').map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      }).join(' ');
    }
    /* Size class from breed (weight-band fallback for grown unknowns) so
     * stage boundaries flex per breed size without asking the customer. */
    function sizeClassFor(breed, weight, birthdate) {
      if (Engine && typeof Engine.sizeClassForDog === 'function') {
        return Engine.sizeClassForDog({ breed: breed, weight: weight, birthdate: birthdate }, settings);
      }
      return '';
    }
    function deriveStageFromBirthdate(birthdate, breed, weight) {
      if (!birthdate || !Engine || typeof Engine.ageMonthsFromBirthdate !== 'function') return '';
      var months = Engine.ageMonthsFromBirthdate(birthdate);
      if (months == null) return '';
      return Engine.stageFromAgeMonths(months, settings, sizeClassFor(breed, weight, birthdate)) || '';
    }
    var ACTIVITY = {
light: settingNum(settings.activity_light_multiplier, 85) / 100,
recommended: settingNum(settings.activity_normal_multiplier, 100) / 100,
active: settingNum(settings.activity_active_multiplier, 120) / 100
};
var GOAL = {
maintain: settingNum(settings.goal_maintain_multiplier, 100) / 100,
lean_out: settingNum(settings.goal_lean_out_multiplier, 90) / 100,
gain_weight: settingNum(settings.goal_gain_weight_multiplier, 110) / 100
};
var LBS_PER_TOTE = settingNum(settings.lbs_per_tote, 18);
var NON_FREEZER_MAX_TOTES_PER_PROTEIN = Math.max(1, Math.floor(settingNum(settings.non_freezer_max_totes_per_protein, 3)));
var NON_FREEZER_HOUSEHOLD_MAX_TOTES = Math.max(0, Math.floor(settingNum(settings.non_freezer_household_max_totes, 0)));
    var MAX_TOTE_SEARCH = 20;
    var FREEZER_PROGRAM_TITLE = 'Freezer program';
    var FREEZER_PROGRAM_TILE_EXPLAINER = '';
    var FREEZER_BUILDER_TITLE = 'Build your freezer';
    var FREEZER_HOW_IT_WORKS_BULLET_1 = 'You select your proteins.';
    var FREEZER_HOW_IT_WORKS_BULLET_2 = 'We deliver a freezer at no extra cost for program use.';
    var FREEZER_HOW_IT_WORKS_BULLET_3 = 'Each refill delivers a full freezer ({totes} totes).';
    var FREEZER_HOW_IT_WORKS_BULLET_4 = 'We refill your freezer about every {days}, based on your household usage.';
    var FREEZER_PROGRAM_DISCOUNT_PERCENT = 10;
    var FREEZER_SIZE_CU_FT = 14;
    var FREEZER_USABLE_FACTOR = 0.85;
    var POD_WIDTH_IN = 3.25;
    var POD_DEPTH_IN = 3.25;
    var POD_HEIGHT_IN = 4.5;
    var PODS_PER_TOTE = 18;
var FREEZER_TOTE_CAPACITY_SETTING = parseInt(settings.freezer_program_tote_capacity, 10) || 0;
var FREEZER_MAX_REFILL_DAYS = settingNum(settings.freezer_max_refill_days, 60);
    var FREEZER_SPACE_PROFILE_STANDARD = 'standard';
    var FREEZER_SPACE_PROFILE_EXTRA = 'extra';
    var FREEZER_SPACE_PROFILE_LARGE = 'large';
var FREEZER_SPACE_NON_FREEZER_CAP_STANDARD = Math.max(1, Math.floor(settingNum(settings.freezer_space_cap_standard, 2)));
var FREEZER_SPACE_NON_FREEZER_CAP_EXTRA = Math.max(1, Math.floor(settingNum(settings.freezer_space_cap_extra, 4)));
var FREEZER_SPACE_NON_FREEZER_CAP_LARGE = Math.max(1, Math.floor(settingNum(settings.freezer_space_cap_dedicated, 6)));
var LOOP_VARIANT_BY_PROTEIN = Array.isArray(loopCfg.variantByProtein) && loopCfg.variantByProtein.length
? loopCfg.variantByProtein.filter(function (row) { return !(row && row.enabled === false); })
: [
{ protein: 'Beef Blend', variantId: 41568146358347 },
{ protein: 'Chicken Blend', variantId: 42165705637963 },
{ protein: 'Lamb Blend', variantId: 42165717008459 },
{ protein: 'Turkey Blend', variantId: 42165712748619 }
];
/* Weekly selling plans only (1-12 weeks). The legacy day-keyed map was removed:
   its plan IDs were reassigned to the weekly group and would resolve wrong cadences. */
var LOOP_SELLING_PLAN_BY_WEEKS_DEFAULT = {
regular: {
'1': 1799454795,
'2': 1799487563,
'3': 1799520331,
'4': 1799553099,
'5': 1799585867,
'6': 1799618635,
'7': 1799651403,
'8': 1799684171,
'9': 1799716939,
'10': 1799749707,
'11': 1965555787,
'12': 1965588555
},
freezer: {}
};
function foundingExpansionEnabled() {
return !!(foundingCfg && foundingCfg.enabled);
}
/** True when this session should use founding reserve checkout (theme on + founding ZIP). */
function foundingModeEnabled() {
return foundingExpansionEnabled() && String(selections.service_zone || '') === 'founding';
}
function introModeEnabled() {
return String(selections.service_zone || '') === 'live';
}
function matureModeEnabled() {
return String(selections.service_zone || '') === 'mature';
}
function pickupOptionEnabled() {
return pickupCfg && pickupCfg.enabled !== false;
}
function pickupModeEnabled() {
return String(selections.service_zone || '') === 'pickup'
  || String(selections.fulfillment || '') === 'pickup';
}
function hasFoundingChoiceCard() {
  return !!$('[data-cfg-type="founding_choice"]');
}
function normalizeFoundingChoice(choice) {
  var value = String(choice || '');
  if (value === 'reserve') return 'notify';
  return value;
}
function foundingNotifySelected() {
  return normalizeFoundingChoice(selections.founding_choice) === 'notify';
}
function foundingChoicePathActive() {
  if (!pickupOptionEnabled() || !hasFoundingChoiceCard()) return false;
  if (selections.founding_choice === 'pickup' || pickupModeEnabled()) return true;
  if (foundingNotifySelected()) return true;
  return foundingModeEnabled() || String(selections.service_zone || '') === 'founding';
}
function foundingPitchShouldShow() {
  return false;
}
function fulfillmentDropLabel() {
  return pickupModeEnabled() ? 'pickup' : 'delivery';
}
function checkoutPricingZone() {
if (foundingModeEnabled()) return 'founding';
if (matureModeEnabled()) return 'mature';
if (introModeEnabled() || pickupModeEnabled()) return 'intro';
return '';
}
function clampDiscountPct(value, fallback) {
var pct = Number(value);
if (!isFinite(pct)) pct = fallback;
if (pct < 0) return 0;
if (pct > 100) return 100;
return Math.round(pct);
}
/** Lifetime member % for tile strike-through (founding + intro). Mature is retail. */
function foundingOngoingPctForDisplay() {
if (foundingModeEnabled()) return clampDiscountPct(foundingCfg && foundingCfg.ongoingDiscountPercent, 20);
if (introModeEnabled() || pickupModeEnabled()) return clampDiscountPct(pricingCfg && pricingCfg.introOngoingPercent, 20);
return 0;
}
function discountedPriceCents(cents, pct) {
var c = Math.max(0, Math.floor(Number(cents) || 0));
var p = Math.max(0, Math.min(100, Math.round(Number(pct) || 0)));
if (!p) return c;
return Math.max(0, Math.round((c * (100 - p)) / 100));
}
function memberOffPillHtml(pct) {
  var n = Math.round(Number(pct) || 0);
  if (!(n > 0)) return '';
  return '<span class="otto-cfg-tile__price-off otto-cfg-tile__day-badge otto-cfg-tile__day-badge--earliest">' + n + '% OFF</span>';
}
/** Menu tile price HTML — retail only, or strike + sale on one line with an off pill. */
function proteinTilePriceHtml(priceCents) {
var retailCents = Math.max(0, Math.floor(Number(priceCents) || 0));
var retailText = (retailCents / 100).toFixed(2);
var pct = foundingOngoingPctForDisplay();
if (!pct) {
return '<span class="otto-cfg-tile__price">$' + retailText + '/lb</span>';
}
var saleText = (discountedPriceCents(retailCents, pct) / 100).toFixed(2);
return (
'<span class="otto-cfg-tile__price otto-cfg-tile__price--founding">' +
memberOffPillHtml(pct) +
'<span class="otto-cfg-tile__price-row">' +
'<span class="otto-cfg-tile__price-retail">$' + retailText + '</span>' +
'<span class="otto-cfg-tile__price-sale">$' + saleText + '/lb</span>' +
'</span></span>'
);
}
function syncProductTileFoundingPrices() {
$$('[data-cfg-type="product_selector"] .otto-cfg-tile--product[data-product-price]').forEach(function (btn) {
var cents = parseInt(btn.getAttribute('data-product-price') || '0', 10) || 0;
var priceEl = btn.querySelector('.otto-cfg-tile__price');
if (!priceEl) return;
var tmp = document.createElement('div');
tmp.innerHTML = proteinTilePriceHtml(cents);
var next = tmp.firstChild;
if (next) priceEl.replaceWith(next);
});
}
function foundingReservationDiscountCode() {
return String(foundingCfg.reservationDiscountCode || '').trim();
}
function reservationDiscountNeedles() {
var needles = { 'founding-reserve': true };
var configured = foundingReservationDiscountCode();
if (configured) needles[configured.toLowerCase()] = true;
return needles;
}
function cartDiscountCodes(body) {
var codes = Array.isArray(body && body.discount_codes) ? body.discount_codes : [];
return codes
  .map(function (d) { return String(d && d.code || '').trim(); })
  .filter(Boolean);
}
function cartHasApplicableDiscount(body, code) {
var needle = String(code || '').trim().toLowerCase();
if (!needle) return false;
var codes = Array.isArray(body && body.discount_codes) ? body.discount_codes : [];
return codes.some(function (d) {
return d && String(d.code || '').toLowerCase() === needle && d.applicable !== false;
});
}
function fetchShopifyCart() {
return fetch('/cart.js', {
headers: { Accept: 'application/json' },
credentials: 'same-origin'
}).then(function (res) {
return res.json().catch(function () { return {}; });
});
}
function updateCartDiscountCodes(codes) {
return fetch('/cart/update.js', {
method: 'POST',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/json'
},
credentials: 'same-origin',
body: JSON.stringify({ discount: Array.isArray(codes) ? codes.join(',') : '' })
}).then(function (res) {
return res.json().catch(function () { return {}; }).then(function (body) {
if (!res.ok) throw new Error('Unable to update cart discounts.');
return body;
});
});
}
/** Drop FOUNDING-RESERVE (or the configured reservation code) without touching other codes. */
function stripReservationDiscount(cart) {
var needles = reservationDiscountNeedles();
function fromCart(body) {
  var current = cartDiscountCodes(body);
  var kept = current.filter(function (code) {
    return !needles[String(code).toLowerCase()];
  });
  if (kept.length === current.length) return Promise.resolve(body || {});
  return updateCartDiscountCodes(kept);
}
if (cart && Array.isArray(cart.discount_codes)) return fromCart(cart);
return fetchShopifyCart().then(fromCart);
}
function foundingCheckoutUrl(code) {
var trimmed = String(code || '').trim();
if (!trimmed) return '/checkout';
return '/checkout?discount=' + encodeURIComponent(trimmed);
}
function foundingCopy(key, fallback) {
if (!foundingModeEnabled()) return fallback;
var copy = foundingCfg.copy || {};
var val = String(copy[key] || '').trim();
return val || fallback;
}
function foundingSellingPlanMapConfigured() {
var map = foundingCfg && foundingCfg.sellingPlanByWeeks;
if (!map || typeof map !== 'object') return null;
if (!Object.keys(map.regular || {}).length) return null;
return map;
}
function foundingSellingPlanMap() {
if (!foundingModeEnabled()) return null;
return foundingSellingPlanMapConfigured();
}
function matureSellingPlanMapConfigured() {
var map = pricingCfg && pricingCfg.sellingPlanByWeeks;
if (!map || typeof map !== 'object') return null;
if (!Object.keys(map.regular || {}).length) return null;
return map;
}
function matureSellingPlanMap() {
if (!matureModeEnabled()) return null;
return matureSellingPlanMapConfigured();
}
function resolveActiveSellingPlanByWeeks() {
var foundingMap = foundingSellingPlanMap();
if (foundingMap) return foundingMap;
var matureMap = matureSellingPlanMap();
if (matureMap) return matureMap;
if (loopCfg.sellingPlanByWeeks && typeof loopCfg.sellingPlanByWeeks === 'object'
&& Object.keys(loopCfg.sellingPlanByWeeks.regular || {}).length) {
return loopCfg.sellingPlanByWeeks;
}
return LOOP_SELLING_PLAN_BY_WEEKS_DEFAULT;
}
function getActiveSellingPlanByWeeks() {
return resolveActiveSellingPlanByWeeks();
}
if (foundingExpansionEnabled() && !foundingSellingPlanMapConfigured() && window && window.console && console.warn) {
console.warn('[otto-cfg] Founding mode is on but founding selling-plan map is empty.');
}
function parseZipAllowSet(raw) {
var set = {};
String(raw || '').split(',').forEach(function (z) {
var t = String(z || '').trim();
if (t) set[t] = true;
});
return set;
}
/** mature | live (intro) | founding | waitlist — mature > intro > founding. */
function classifyServiceZone(zip, liveSet, foundingSet, matureSet) {
var z = String(zip || '').trim();
if (!z) return 'waitlist';
if (matureSet && matureSet[z]) return 'mature';
if (liveSet && liveSet[z]) return 'live';
if (foundingExpansionEnabled() && foundingSet && foundingSet[z]) return 'founding';
return 'waitlist';
}
function zoneAllowsCheckout(zone) {
return zone === 'live' || zone === 'mature' || zone === 'founding' || zone === 'pickup';
}
function applyServiceZone(zone) {
var next = zoneAllowsCheckout(zone) ? zone : 'waitlist';
selections.service_zone = next;
selections.service_eligible = next !== 'waitlist';
if (next !== 'pickup' && selections.fulfillment === 'pickup') delete selections.fulfillment;
syncFoundingPathUi();
}
function normalizeGoalValue(value) {
var goal = String(value || '').trim().toLowerCase();
if (goal !== 'maintain' && goal !== 'lean_out' && goal !== 'gain_weight') return '';
return goal;
}
function getDailyIntake(weight, stage, activity, goal) {
      var actMult = ACTIVITY[activity] || 1.0;
      var raw;
      var stageKey = String(stage || '').trim().toLowerCase();
      var entry = null;
      for (var i = 0; i < FEEDING_RATES.length; i++) {
        if (weight >= FEEDING_RATES[i].min && weight <= FEEDING_RATES[i].max) {
          entry = FEEDING_RATES[i];
          break;
        }
      }
      if (!entry) return 0;
      if (STAGE_FEED_PCT[stageKey] > 0) {
        var stagePct = STAGE_FEED_PCT[stageKey];
        // Young Adult tapers toward the adult bands but never below them.
        if (stageKey === 'young_adult') stagePct = Math.max(stagePct, entry.rate);
        raw = weight * stagePct;
      } else {
        var stageMult = LIFE_STAGE[stageKey] || 1.0;
        var normalizedGoal = normalizeGoalValue(goal) || 'maintain';
        var goalMult = GOAL[normalizedGoal] || 1.0;
        raw = weight * entry.rate * stageMult * actMult * goalMult;
      }
      if (CadenceEngine && typeof CadenceEngine.roundDailyIntake === 'function') {
        return CadenceEngine.roundDailyIntake(raw, weight, settings);
      }
      return Math.round(raw * 2) / 2;
    }
    function getPortionLadder() {
      if (Engine && typeof Engine.parsePortionLadder === 'function') {
        return Engine.parsePortionLadder(settings.portion_ladder_oz);
      }
      return [2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64];
    }
    /** Configurator raw-portion stepper floor — keeps max-interval delivery at min lb. */
    var RAW_PORTION_ADJUSTER_MIN_OZ = 4;
    function getRawPortionAdjusterLadder() {
      var filtered = getPortionLadder().filter(function (oz) {
        return oz >= RAW_PORTION_ADJUSTER_MIN_OZ;
      });
      return filtered.length ? filtered : [RAW_PORTION_ADJUSTER_MIN_OZ];
    }
    function nearestPortionRungIndex(ladder, oz) {
      var target = Number(oz) || 0;
      if (!(target > 0) || !ladder.length) return 0;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < ladder.length; i++) {
        var dist = Math.abs(ladder[i] - target);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }
    function getDogRecommendedPortionOz(dog) {
      if (!dog) return 0;
      var weight = Number(dog.weight || 0);
      if (weight > 0 && Engine && typeof Engine.computeDogPortion === 'function') {
        var portion = Engine.computeDogPortion({
          weight: weight,
          birthdate: dog.birthdate || '',
          life_stage: dog.life_stage || dog.stage,
          activity: dog.activity,
          goal: dog.goal,
          meals: getMealsPerDay() || 2
        }, settings);
        var snappedOz = Number(portion && portion.snappedOz) || 0;
        if (snappedOz > 0) return snappedOz;
      }
      var dailyLb = Number(dog.daily_intake || 0);
      return dailyLb > 0 ? dailyLb * 16 : 0;
    }
    function isRawFeeder() {
      return String(ownerState().familiarity || '').trim().toLowerCase() === 'raw';
    }
    function dogIsFullRawSelected(dog) {
      var pct = Number(dog && dog.raw_percent);
      return pct > 0 && normalizeRawPercent(pct) >= 100;
    }
    function rawShareCardExists() {
      return !!$('[data-cfg-type="raw_share"]');
    }
    function zipGatePassed() {
      if (waitlistPathActive()) return false;
      var zipStep = getStepByType('zip_validator');
      if (!zipStep) return true;
      return isCanonicalStepComplete(zipStep);
    }
    function isPreviousVisibleStepComplete(card) {
      if (!card) return false;
      var step = parseInt(card.getAttribute('data-cfg-step'), 10);
      var prev = getPreviousVisibleStepNum(step);
      if (!prev) return true;
      if (completedSteps[prev] || everCompletedSteps[prev]) return true;
      var prevCard = $('[data-cfg-step="' + prev + '"]');
      var prevType = prevCard ? prevCard.getAttribute('data-cfg-type') : '';
      if (prevType === 'raw_share' || prevType === 'raw_portion_check') {
        return false;
      }
      return isCanonicalStepComplete(prev);
    }
    function dogNeedsRawPortionCheck(dog) {
      if (!isRawFeeder()) return false;
      if (!rawShareCardExists()) return true;
      return dogIsFullRawSelected(dog);
    }
    function shouldShowRawShareCard() {
      /* Raw percentage is chosen on the dog profile card. */
      return false;
    }
    function shouldShowRawPortionCard() {
      /* Confirmation happens on the dog profile card, so this step stays skipped. */
      return false;
    }
    function rawPortionDogIndexes() {
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      var out = [];
      dogs.forEach(function (dog, i) {
        if (dogNeedsRawPortionCheck(dog)) out.push(i);
      });
      return out;
    }
    function dogPortionBasis(dog) {
      if (!dog) return '';
      return [
        Number(dog.weight) || 0,
        String(dog.life_stage || ''),
        String(dog.activity || ''),
        String(dog.goal || '')
      ].join('|');
    }
    function resolveDogPortionOz(dog) {
      var chosen = Number(dog && dog.portion_oz);
      if (dog && dog.portion_confirmed && dog.portion_user_selected && isFinite(chosen) && chosen > 0) {
        var ladder = dog.portion_choice_mode === 'custom'
          ? getRawPortionAdjusterLadder()
          : getPortionLadder();
        if (Engine && typeof Engine.snapOz === 'function') {
          return Engine.snapOz(chosen, ladder, 'nearest');
        }
        return chosen;
      }
      return getDogRecommendedPortionOz(dog);
    }
    var RAW_SHARE_OPTIONS = [25, 50, 100];
    var RAW_SHARE_DISPLAY_ORDER = [100, 50, 25];
    var RAW_SHARE_HELPER_DEFAULTS = {
      100: 'Their full meals. We’ll still ease them onto raw.',
      50: 'Half Otto, half their current food.',
      25: 'A little Otto mixed into their regular food.'
    };
    function normalizeRawPercent(val) {
      var n = Math.round(Number(val));
      if (RAW_SHARE_OPTIONS.indexOf(n) >= 0) return n;
      if (!(n > 0)) return 100;
      return RAW_SHARE_OPTIONS.reduce(function (best, opt) {
        return Math.abs(opt - n) < Math.abs(best - n) ? opt : best;
      });
    }
    function dogRawPercent(dog) {
      return normalizeRawPercent(dog && dog.raw_percent);
    }
    function effectivePortionOz(portionOz, rawPercent) {
      var oz = Number(portionOz) || 0;
      var pct = normalizeRawPercent(rawPercent);
      if (!(oz > 0)) return 0;
      return oz * pct / 100;
    }
    function dogEffectiveDailyLb(dog) {
      return effectivePortionOz(resolveDogPortionOz(dog), dogRawPercent(dog)) / 16;
    }
    function rawShareShortLabel(pct) {
      var n = normalizeRawPercent(pct);
      if (n <= 25) return 'Topper (25%)';
      if (n <= 50) return '50/50 mix';
      return '100% raw';
    }
    function rawShareTileHelper(pct, card) {
      var n = normalizeRawPercent(pct);
      var fromCard = card && card.getAttribute('data-cfg-raw-share-helper-' + n);
      if (fromCard && String(fromCard).trim()) return String(fromCard).trim();
      return RAW_SHARE_HELPER_DEFAULTS[n] || '';
    }
    function formatOttoBrand(text) {
      return esc(text).replace(/\b[Oo][Tt][Tt][Oo]\b/g, '<b>otto</b>');
    }
    function cfgMinDeliveryLb() {
      return Math.max(1, Number(settings.min_delivery_lb) || 18);
    }
    function cfgMinPickupLb() {
      return Math.max(1, Number(settings.min_pickup_lb) || 12);
    }
    function usePickupMinPack() {
      if (!pickupOptionEnabled()) return false;
      if (foundingNotifySelected()) return false;
      if (pickupModeEnabled() || selections.founding_choice === 'pickup') return true;
      var zone = String(selections.service_zone || '');
      if (zone === 'live' || zone === 'mature' || zone === 'waitlist') return false;
      if (zone === 'founding' || foundingModeEnabled()) return true;
      return !zone;
    }
    function cfgMinPackLb() {
      return usePickupMinPack() ? cfgMinPickupLb() : cfgMinDeliveryLb();
    }
    function packEngineSettings() {
      var minLb = cfgMinPackLb();
      if (Number(settings.min_delivery_lb) === minLb) return settings;
      return Object.assign({}, settings, { min_delivery_lb: minLb });
    }
    function cfgMaxFrequencyWeeks() {
      var maxDays = Math.max(7, Number(settings.max_delivery_interval_days) || 70);
      if (CadenceEngine && typeof CadenceEngine.buildCadenceList === 'function') {
        var maxWeeks = 1;
        (CadenceEngine.buildCadenceList(settings) || []).forEach(function (c) {
          if (c && c.days <= maxDays && Number(c.weeks) > maxWeeks) maxWeeks = Number(c.weeks);
        });
        return maxWeeks;
      }
      return Math.max(1, Math.floor(maxDays / 7));
    }
    function householdOttoDailyLb(overrideIdx, overridePct) {
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      return dogs.reduce(function (sum, dog, idx) {
        var pct = (idx === overrideIdx) ? normalizeRawPercent(overridePct) : dogRawPercent(dog);
        return sum + effectivePortionOz(resolveDogPortionOz(dog), pct) / 16;
      }, 0);
    }
    function rawShareViableAtPercent(dogIdx, pct) {
      if (normalizeRawPercent(pct) >= 100) return true;
      var daily = householdOttoDailyLb(dogIdx, pct);
      if (!(daily > 0)) return false;
      var packLb = daily * cfgMaxFrequencyWeeks() * 7;
      if (Engine && typeof Engine.roundDeliveryLb === 'function') {
        packLb = Engine.roundDeliveryLb(packLb, settings);
      }
      return packLb >= cfgMinPackLb();
    }
    function feasibleRawSharePercents(dogIdx) {
      return RAW_SHARE_OPTIONS.filter(function (pct) {
        return rawShareViableAtPercent(dogIdx, pct);
      });
    }
    function snapDogRawPercentToFeasible(dogIdx) {
      if (!Array.isArray(selections.dogs) || !selections.dogs[dogIdx]) return;
      var current = Number(selections.dogs[dogIdx].raw_percent);
      if (!(current > 0)) return;
      var feasible = feasibleRawSharePercents(dogIdx);
      if (!feasible.length) feasible = [100];
      if (isFinite(current) && feasible.indexOf(normalizeRawPercent(current)) >= 0) {
        selections.dogs[dogIdx].raw_percent = normalizeRawPercent(current);
        return;
      }
      var sorted = feasible.slice().sort(function (a, b) { return a - b; });
      var nextUp = null;
      if (isFinite(current) && current > 0) {
        sorted.forEach(function (pct) {
          if (nextUp == null && pct >= current) nextUp = pct;
        });
      }
      selections.dogs[dogIdx].raw_percent = nextUp != null ? nextUp : (sorted[sorted.length - 1] || 100);
    }
    function refreshRawShareCards() {
      $$('[data-cfg-type="raw_share"]').forEach(function (card) {
        if (card && typeof card._renderRawShareCard === 'function') card._renderRawShareCard();
      });
    }
    function snapHouseholdRawShareToPackMin() {
      if (!Array.isArray(selections.dogs)) return false;
      var changed = false;
      selections.dogs.forEach(function (_dog, idx) {
        var before = Number(selections.dogs[idx] && selections.dogs[idx].raw_percent);
        snapDogRawPercentToFeasible(idx);
        var after = Number(selections.dogs[idx] && selections.dogs[idx].raw_percent);
        if (before !== after) changed = true;
      });
      if (changed) {
        syncPortionDailyTotal();
        invalidateDeliverySelections();
        invalidateReviewStep();
        if (typeof updateMealPrices === 'function') updateMealPrices();
      }
      refreshRawShareCards();
      if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
      if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
      if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
      if (typeof renderDeliveryTiles === 'function') renderDeliveryTiles(true);
      if (typeof renderFreezerProgramCard === 'function') renderFreezerProgramCard(true);
      return changed;
    }
    function isRawShareDogComplete(dog, idx) {
      if (!dog) return false;
      var pct = Number(dog.raw_percent);
      if (!(pct > 0)) return false;
      return feasibleRawSharePercents(idx).indexOf(normalizeRawPercent(pct)) >= 0;
    }
    function hasValidRawShareSelection() {
      if (!rawShareCardExists() || !shouldShowRawShareCard()) return true;
      if (!hasValidDogInfoSelection()) return false;
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      if (!dogs.length) return false;
      for (var i = 0; i < dogs.length; i++) {
        if (!isRawShareDogComplete(dogs[i], i)) return false;
      }
      return true;
    }
    function syncPortionDailyTotal() {
      if (!Array.isArray(selections.dogs) || !selections.dogs.length) return;
      selections.daily_total = selections.dogs.reduce(function (sum, dog) {
        return sum + effectivePortionOz(resolveDogPortionOz(dog), dogRawPercent(dog)) / 16;
      }, 0);
    }
    function clearOneDogPortionChoice(dog) {
      if (!dog || typeof dog !== 'object') return;
      delete dog.portion_oz;
      delete dog.portion_confirmed;
      delete dog.portion_choice_mode;
      delete dog.portion_user_selected;
    }
    function clearDogPortionChoices() {
      if (!Array.isArray(selections.dogs)) return;
      selections.dogs.forEach(clearOneDogPortionChoice);
      delete selections.raw_portion_active_idx;
    }
    function clearUnusedRawPortionChoices() {
      if (!Array.isArray(selections.dogs)) return;
      selections.dogs.forEach(function (dog) {
        if (!dogNeedsRawPortionCheck(dog)) clearOneDogPortionChoice(dog);
      });
    }
    function hasValidRawPortionSelection() {
      if (!shouldShowRawPortionCard()) return true;
      if (!hasValidDogInfoSelection()) return false;
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      var idxs = rawPortionDogIndexes();
      if (!idxs.length) return true;
      for (var i = 0; i < idxs.length; i++) {
        if (!isRawPortionDogComplete(dogs[idxs[i]])) return false;
      }
      return true;
    }
    /** Snapped daily portion (oz) — uses customer choice when confirmed, else engine suggestion. */
    function getDogSnappedPortionOz(dog) {
      return resolveDogPortionOz(dog);
    }
    function getFreezerProfileForCadence() {
      var profile = getSelectedFreezerSpaceProfile();
      return profile || FREEZER_SPACE_PROFILE_STANDARD;
    }
    function mapCadenceOption(opt) {
      return {
        key: opt.key,
        label: opt.label,
        weeks: opt.weeks,
        days: opt.days,
        lbs: opt.lbs,
        totes: 0,
        bags: opt.bags,
        bagSizes: opt.bagSizes
      };
    }
    function getCadenceOptionsForDaily(totalDaily) {
      if (!(totalDaily > 0) || !CadenceEngine) return [];
      return CadenceEngine.getCadenceOptions(totalDaily, packEngineSettings(), getFreezerProfileForCadence()).map(mapCadenceOption);
    }
    function getToteOptions(totalDaily, maxTotes) {
      return getCadenceOptionsForDaily(totalDaily);
    }
    function getValidTotes(totalDaily, maxTotes) {
      return getCadenceOptionsForDaily(totalDaily);
    }
    function getSelectedFreezerSpaceProfile() {
      if (!$('[data-cfg-type="freezer_space"]')) return FREEZER_SPACE_PROFILE_LARGE;
      var profile = String(selections.freezer_space_profile || '').trim();
      if (profile === FREEZER_SPACE_PROFILE_STANDARD || profile === FREEZER_SPACE_PROFILE_EXTRA || profile === FREEZER_SPACE_PROFILE_LARGE) {
        return profile;
      }
      return '';
    }
    function getProfileNonFreezerHouseholdCap() {
      var profile = getSelectedFreezerSpaceProfile();
      if (profile === FREEZER_SPACE_PROFILE_STANDARD) return FREEZER_SPACE_NON_FREEZER_CAP_STANDARD;
      if (profile === FREEZER_SPACE_PROFILE_EXTRA) return FREEZER_SPACE_NON_FREEZER_CAP_EXTRA;
      if (profile === FREEZER_SPACE_PROFILE_LARGE) return FREEZER_SPACE_NON_FREEZER_CAP_LARGE;
      return 0;
    }
    function getEffectiveNonFreezerHouseholdMaxTotes() {
      if (!$('[data-cfg-type="freezer_space"]')) {
        return NON_FREEZER_HOUSEHOLD_MAX_TOTES > 0 ? NON_FREEZER_HOUSEHOLD_MAX_TOTES : NON_FREEZER_MAX_TOTES_PER_PROTEIN;
      }
      var profileCap = Math.max(1, Math.floor(getProfileNonFreezerHouseholdCap()));
      if (NON_FREEZER_HOUSEHOLD_MAX_TOTES > 0) return Math.max(1, Math.min(NON_FREEZER_HOUSEHOLD_MAX_TOTES, profileCap));
      return profileCap;
    }
    function getEffectiveNonFreezerPerProteinMaxTotes() {
      if (!$('[data-cfg-type="freezer_space"]')) return NON_FREEZER_MAX_TOTES_PER_PROTEIN;
      return Math.max(1, Math.min(NON_FREEZER_MAX_TOTES_PER_PROTEIN, getEffectiveNonFreezerHouseholdMaxTotes()));
    }
    function getSingleNonFreezerMaxTotes() {
      return Math.min(getEffectiveNonFreezerPerProteinMaxTotes(), getEffectiveNonFreezerHouseholdMaxTotes());
    }
    function shouldShowFreezerProgram(totalDaily) {
      if (totalDaily <= 0) return false;
      var options = getToteOptions(totalDaily, MAX_TOTE_SEARCH);
      return options.some(function (opt) { return opt.totes > getSingleNonFreezerMaxTotes(); });
    }
    function isFreezerCadenceEligible(totalDaily) {
      var cadenceDays = getFreezerCadenceDays(totalDaily);
      return cadenceDays > 0 && cadenceDays <= FREEZER_MAX_REFILL_DAYS;
    }
    function getFreezerCapacity() {
      var freezerVolumeIn3 = FREEZER_SIZE_CU_FT * 1728;
      var usableVolumeIn3 = freezerVolumeIn3 * FREEZER_USABLE_FACTOR;
      var podVolumeIn3 = POD_WIDTH_IN * POD_DEPTH_IN * POD_HEIGHT_IN;
      if (podVolumeIn3 <= 0) return { pods: 0, totes: 0, lbs: 0 };
      var rawPods = Math.floor(usableVolumeIn3 / podVolumeIn3);
      var roundedPods = Math.floor(rawPods / PODS_PER_TOTE) * PODS_PER_TOTE;
      var computedTotes = Math.floor(roundedPods / PODS_PER_TOTE);
      var totes = FREEZER_TOTE_CAPACITY_SETTING > 0 ? FREEZER_TOTE_CAPACITY_SETTING : computedTotes;
      return {
        pods: totes * PODS_PER_TOTE,
        totes: totes,
        lbs: totes * LBS_PER_TOTE
      };
    }
    var FREEZER_CAPACITY = getFreezerCapacity();
    function getFreezerCadenceDays(totalDaily) {
      if (totalDaily <= 0 || FREEZER_CAPACITY.lbs <= 0) return 0;
      /* Snap to whole weeks so the cadence matches the weekly selling plans used at checkout. */
      var rawDays = FREEZER_CAPACITY.lbs / totalDaily;
      return Math.max(1, Math.round(rawDays / 7)) * 7;
    }
    function getFreezerCadenceLabel(days) {
      if (days <= 0) return '';
      var weeks = Math.max(1, Math.round(days / 7));
      return weeks === 1 ? 'Every week' : ('Every ' + weeks + ' weeks');
    }
    function clearFreezerProgramSelections() {
      delete selections.freezer_program;
      delete selections.freezer_fixed_totes;
      delete selections.freezer_fixed_pods;
      delete selections.freezer_fixed_lbs;
      delete selections.freezer_cadence_days;
      delete selections.freezer_cadence_label;
      selections.freezer_allocations = [];
    }
function cloneSubscriptionRows(rows) {
if (!Array.isArray(rows)) return [];
return rows.map(function (row) {
return row && typeof row === 'object' ? Object.assign({}, row) : row;
});
}
function getStandardDeliverySnapshotFromSelections() {
if (!hasValidStandardDeliverySelection()) return null;
var subs = cloneSubscriptionRows(selections.subscriptions || []);
if (!subs.length) return null;
return {
totes: Number(selections.totes || 0),
delivery_interval: Number(selections.delivery_interval || 0),
delivery_lbs: Number(selections.delivery_lbs || 0),
subscriptions: subs
};
}
function saveStandardDeliverySnapshot() {
var snapshot = getStandardDeliverySnapshotFromSelections();
if (!snapshot) return false;
selections.standard_delivery_snapshot = snapshot;
return true;
}
function hasStandardDeliverySnapshot() {
var snapshot = selections.standard_delivery_snapshot;
return !!(snapshot && Array.isArray(snapshot.subscriptions) && snapshot.subscriptions.length);
}
function restoreStandardDeliverySnapshot() {
if (!hasStandardDeliverySnapshot()) return false;
var snapshot = selections.standard_delivery_snapshot;
clearFreezerProgramSelections();
selections.totes = Number(snapshot.totes || 0);
selections.delivery_interval = Number(snapshot.delivery_interval || 0);
selections.delivery_lbs = Number(snapshot.delivery_lbs || 0);
selections.subscriptions = cloneSubscriptionRows(snapshot.subscriptions || []);
return hasValidStandardDeliverySelection();
}
    function buildDefaultFreezerAllocations(proteinGroups) {
      var groups = Array.isArray(proteinGroups) ? proteinGroups : [];
      var totalTotes = Math.max(0, Math.floor(Number(FREEZER_CAPACITY.totes || 0)));
      if (!groups.length || totalTotes <= 0) return [];
      var items = groups.map(function (grp, idx) {
        var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
        var daily = Number((grp && grp.dailyTotal) || 0);
        if (!isFinite(daily) || daily < 0) daily = 0;
        return { idx: idx, protein: proteinName, daily: daily, totes: 0 };
      });
      var totalDaily = items.reduce(function (sum, item) { return sum + item.daily; }, 0);
      if (totalDaily <= 0) {
        items[0].totes = totalTotes;
        return items.map(function (item) { return { protein: item.protein, totes: item.totes }; });
      }
      var assigned = 0;
      items.forEach(function (item) {
        var share = (item.daily / totalDaily) * totalTotes;
        item.totes = Math.floor(share);
        assigned += item.totes;
      });
      var remaining = totalTotes - assigned;
      if (remaining > 0) {
        var ranked = items.slice().sort(function (a, b) {
          if (b.daily !== a.daily) return b.daily - a.daily;
          return a.idx - b.idx;
        });
        var rIdx = 0;
        while (remaining > 0 && ranked.length > 0) {
          ranked[rIdx].totes += 1;
          remaining -= 1;
          rIdx += 1;
          if (rIdx >= ranked.length) rIdx = 0;
        }
      }
      return items.map(function (item) {
        return { protein: item.protein, totes: item.totes };
      });
    }
    function getFreezerAllocationsForDisplay(proteinGroups) {
      var groups = Array.isArray(proteinGroups) ? proteinGroups : [];
      if (!groups.length) return [];
      var existing = Array.isArray(selections.freezer_allocations) ? selections.freezer_allocations : [];
      if (!existing.length) {
        var selectedProtein = String(selections.protein || '').trim();
        if (selectedProtein && !selections.per_dog_protein) {
          return groups.map(function (grp, idx) {
            var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
            return {
              protein: proteinName,
              totes: proteinName === selectedProtein ? FREEZER_CAPACITY.totes : 0
            };
          });
        }
        return buildDefaultFreezerAllocations(groups);
      }
      var existingMap = {};
      existing.forEach(function (row) {
        if (!row || !row.protein) return;
        var totes = Number(row.totes || 0);
        if (!isFinite(totes) || totes < 0) totes = 0;
        existingMap[String(row.protein)] = Math.floor(totes);
      });
      return groups.map(function (grp, idx) {
        var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
        var mapped = existingMap[proteinName];
        if (!isFinite(mapped) || mapped < 0) mapped = 0;
        return { protein: proteinName, totes: mapped };
      });
    }
/* ---- Meal price updater ---- */
    function getMealsPerDay() {
      var meals = parseInt(selections.meals_per_day, 10);
      return (meals === 1 || meals === 2) ? meals : 0;
    }
    function getMealsPerDayForDog(dog) {
      var dogMeals = parseInt(dog && dog.meals_per_day, 10);
      if (dogMeals === 1 || dogMeals === 2) return dogMeals;
      return getMealsPerDay() || 0;
    }
    function cadenceWeeksFrom(intervalDays, weeks) {
      var w = Math.max(0, Math.floor(Number(weeks || 0)));
      if (!w && Number(intervalDays) > 0) w = Math.max(1, Math.round(Number(intervalDays) / 7));
      return w;
    }
    function formatCadenceText(intervalDays, weeks, options) {
      var opts = options || {};
      var w = cadenceWeeksFrom(intervalDays, weeks);
      if (w <= 0) return '';
      var label = w === 1 ? 'week' : (w + ' weeks');
      return (opts.lowercase ? 'every ' : 'Every ') + label;
    }
function normalizeProteinValue(value) {
return String(value == null ? '' : value)
.replace(/&amp;/gi, '&')
.toLowerCase()
.replace(/\s+/g, ' ')
.trim();
}
function proteinsMatch(left, right) {
var a = normalizeProteinValue(left);
var b = normalizeProteinValue(right);
if (!a || !b) return false;
if (a === b) return true;
return a.indexOf(b) >= 0 || b.indexOf(a) >= 0;
}
function resolveLoopVariantIdForProtein(proteinName) {
var match = LOOP_VARIANT_BY_PROTEIN.find(function (row) {
return row && row.variantId && proteinsMatch(row.protein, proteinName);
});
if (!match) return 0;
var variantId = Math.floor(Number(match.variantId || 0));
return variantId > 0 ? variantId : 0;
}
function resolveLoopSellingPlanId(mode, intervalDays, intervalWeeks) {
var modeKey = String(mode || '').trim().toLowerCase();
if (modeKey !== 'regular' && modeKey !== 'freezer') return 0;
var weeks = Math.max(0, Math.floor(Number(intervalWeeks || 0)));
if (!weeks && intervalDays > 0) weeks = Math.max(1, Math.round(Number(intervalDays) / 7));
var weekKey = String(weeks);
var planMap = getActiveSellingPlanByWeeks();
var byWeeks = planMap[modeKey] || {};
var planId = Math.floor(Number(byWeeks[weekKey] || 0));
if (planId > 0) return planId;
/* Freezer cadence is day-derived; if no dedicated freezer plans exist, bill on the matching weekly plan. */
if (modeKey === 'freezer') {
var regularByWeeks = planMap.regular || {};
planId = Math.floor(Number(regularByWeeks[weekKey] || 0));
if (planId > 0) return planId;
}
return 0;
}
var CFG_DELIVERY_WEEKDAYS = [
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' }
];
var CFG_PICKUP_WEEKDAYS = CFG_DELIVERY_WEEKDAYS.concat([
  { value: 6, label: 'Saturday', short: 'Sat' },
  { value: 0, label: 'Sunday', short: 'Sun' }
]);
/** Allowed weekdays for the current ZIP; null = not loaded / use the catalog. */
var cfgAllowedDeliveryWeekdays = null;
/** Zone label from /delivery-zones (e.g. "OC · Zone 5 · North Tustin"). */
var cfgDeliveryZoneLabel = '';
var CFG_MS_PER_DAY = 86400000;
function cfgWeekdayCatalog() {
  return pickupModeEnabled() ? CFG_PICKUP_WEEKDAYS : CFG_DELIVERY_WEEKDAYS;
}
function normalizeCfgDeliveryWeekday(val) {
  var n = Math.round(Number(val));
  if (pickupModeEnabled() && n === 0) return 0;
  var max = pickupModeEnabled() ? 6 : 5;
  return n >= 1 && n <= max ? n : null;
}
function cfgWeekdayChosen(wd) {
  return wd === 0 || (typeof wd === 'number' && wd >= 1);
}
function cfgAllowedWeekdayList() {
  var catalog = cfgWeekdayCatalog();
  if (!Array.isArray(cfgAllowedDeliveryWeekdays) || !cfgAllowedDeliveryWeekdays.length) {
    return catalog.slice();
  }
  return catalog.filter(function (w) {
    return cfgAllowedDeliveryWeekdays.indexOf(w.value) !== -1;
  });
}
/** Customer-facing zone name: last segment of "OC · Zone 5 · North Tustin". */
function cfgDeliveryZoneDisplayName() {
  var raw = String(cfgDeliveryZoneLabel || '').trim();
  if (!raw) return '';
  var parts = raw.split(/\s*[·|]\s*/).map(function (part) {
    return String(part || '').trim();
  }).filter(Boolean);
  if (parts.length > 1) return parts[parts.length - 1];
  return raw;
}
function clearDeliveryWeekdayPolicy() {
  cfgAllowedDeliveryWeekdays = null;
  cfgDeliveryZoneLabel = '';
}
function applyPickupWeekdayPolicy() {
  cfgAllowedDeliveryWeekdays = [0, 1, 2, 3, 4, 5, 6];
}
function syncDeliveryZoneCopy() {
  if (typeof syncDeliveryDayCopy === 'function') syncDeliveryDayCopy();
  if (typeof syncFoundingPitchCopy === 'function') syncFoundingPitchCopy();
  if (typeof syncFoundingChoiceCopy === 'function') syncFoundingChoiceCopy();
}
function fetchDeliveryWeekdayPolicy(zip, callback) {
  var pickup = pickupModeEnabled();
  if (pickup) applyPickupWeekdayPolicy();
  var z = String(zip || '').replace(/\D/g, '').slice(0, 5);
  if (!z || z.length !== 5 || !ottoWorkerUrl) {
    if (!pickup) clearDeliveryWeekdayPolicy();
    if (typeof callback === 'function') callback(pickup ? cfgAllowedDeliveryWeekdays : null);
    syncDeliveryZoneCopy();
    return;
  }
  fetch(ottoWorkerUrl + '/delivery-zones?zip=' + encodeURIComponent(z), {
    method: 'GET',
    headers: { Accept: 'application/json' }
  })
    .then(function (res) { return res.json().catch(function () { return {}; }); })
    .then(function (data) {
      if (data && data.ok) {
        if (!pickup && Array.isArray(data.weekdays) && data.weekdays.length) {
          cfgAllowedDeliveryWeekdays = data.weekdays.map(function (n) {
            return Math.round(Number(n));
          }).filter(function (n) { return n >= 1 && n <= 5; });
        } else if (pickup) {
          applyPickupWeekdayPolicy();
        }
        cfgDeliveryZoneLabel = String(data.zoneLabel || '').trim();
      } else if (!pickup) {
        clearDeliveryWeekdayPolicy();
      } else {
        applyPickupWeekdayPolicy();
      }
      if (typeof callback === 'function') callback(cfgAllowedDeliveryWeekdays);
      syncDeliveryZoneCopy();
    })
    .catch(function () {
      if (!pickup) clearDeliveryWeekdayPolicy();
      else applyPickupWeekdayPolicy();
      if (typeof callback === 'function') callback(pickup ? cfgAllowedDeliveryWeekdays : null);
      syncDeliveryZoneCopy();
    });
}
function cfgDeliveryWeekdayLabel(weekday, plural) {
  var found = CFG_PICKUP_WEEKDAYS.find(function (w) { return w.value === weekday; });
  if (!found) return '';
  return plural ? (found.label + 's') : found.label;
}
function cfgNextDeliveryOnWeekday(weekday) {
  var cursor = new Date(Date.now() + CFG_MS_PER_DAY);
  cursor.setHours(9, 0, 0, 0);
  for (var i = 0; i < 14; i++) {
    if (cursor.getDay() === weekday) return cursor;
    cursor = new Date(cursor.getTime() + CFG_MS_PER_DAY);
  }
  return null;
}
function cfgFormatDeliveryDate(d) {
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
}
function cfgFormatFirstDeliverySubline(d) {
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
}
function cfgWeekStartMonday(d) {
  var copy = new Date(d);
  copy.setHours(9, 0, 0, 0);
  var day = copy.getDay();
  var diff = day === 0 ? -6 : 1 - day;
  copy.setDate(copy.getDate() + diff);
  return copy.getTime();
}
function cfgSameCalendarWeek(a, b) {
  if (!a || !b || isNaN(a.getTime()) || isNaN(b.getTime())) return false;
  return cfgWeekStartMonday(a) === cfgWeekStartMonday(b);
}
function cfgDeliveryWeekdaysBySoonest() {
  return cfgAllowedWeekdayList().sort(function (a, b) {
    var da = cfgNextDeliveryOnWeekday(a.value);
    var db = cfgNextDeliveryOnWeekday(b.value);
    var ta = da && !isNaN(da.getTime()) ? da.getTime() : Infinity;
    var tb = db && !isNaN(db.getTime()) ? db.getTime() : Infinity;
    return ta - tb;
  });
}
function cfgFormatFirstDeliveryTileTitle(firstDelivery, today, weekdayValue, tomorrowLabel) {
  if (!firstDelivery || isNaN(firstDelivery.getTime())) return '';
  var datePart = cfgFormatFirstDeliverySubline(firstDelivery);
  var todayDay = today && !isNaN(today.getTime()) ? today.getDay() : -1;
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  var isTomorrow = tomorrow.getDay() === weekdayValue;
  var isToday = todayDay === weekdayValue;
  // Maximum clarity, minimum debate:
  // - Tomorrow for +1 day
  // - Next when the option is the following week (same weekday, or 7+ days out)
  // - Otherwise just the concrete date (no "This" / weekend special cases)
  if (isTomorrow) return String(tomorrowLabel || 'Tomorrow') + ', ' + datePart;
  if (isToday) return 'Next ' + datePart;
  var daysUntil = Math.round((firstDelivery.getTime() - today.getTime()) / CFG_MS_PER_DAY);
  if (daysUntil >= 7) return 'Next ' + datePart;
  return datePart;
}
function cfgDeliveryDayCadenceSubline(weekday, weeks, cadenceTemplate) {
  var weekdayName = cfgDeliveryWeekdayLabel(weekday, false);
  var weekdayPlural = cfgDeliveryWeekdayLabel(weekday, true);
  if (weeks === 1) return 'Then every week on ' + weekdayPlural;
  if (weeks > 1) {
    return cfgFillDeliveryDayTemplate(
      cadenceTemplate || 'Then every {weeks} weeks on {weekday}s',
      { weeks: weeks, weekday: weekdayName }
    );
  }
  return '';
}
function cfgDefaultDeliveryWeekday() {
  var best = null;
  var bestTime = Infinity;
  cfgAllowedWeekdayList().forEach(function (w) {
    var delivery = cfgNextDeliveryOnWeekday(w.value);
    if (delivery && delivery.getTime() < bestTime) {
      bestTime = delivery.getTime();
      best = w.value;
    }
  });
  return best == null ? 2 : best;
}
function cfgCadenceWeeksForDeliveryDay() {
  var weeks = Number(selections.delivery_weeks || 0);
  if (weeks > 0) return weeks;
  var interval = Number(selections.delivery_interval || 0);
  return interval > 0 ? Math.max(1, Math.round(interval / 7)) : 0;
}
function cfgFillDeliveryDayTemplate(template, tokens) {
  var out = String(template || '');
  Object.keys(tokens || {}).forEach(function (key) {
    out = out.split('{' + key + '}').join(String(tokens[key] == null ? '' : tokens[key]));
  });
  return out;
}
function cfgFormatWeekdayList(weekdays, plural) {
  var names = (weekdays || []).map(function (w) {
    var value = typeof w === 'number' ? w : w && w.value;
    return cfgDeliveryWeekdayLabel(value, !!plural);
  }).filter(Boolean);
  if (!names.length) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return names[0] + ' & ' + names[1];
  return names.slice(0, -1).join(', ') + ', & ' + names[names.length - 1];
}
function cfgIsSingleDeliveryDayMode() {
  return cfgAllowedWeekdayList().length === 1;
}
function deliveryWeekdayCartProperty() {
  if (foundingModeEnabled()) return {};
  var wd = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
  if (cfgWeekdayChosen(wd)) return { '_otto_delivery_weekday': String(wd) };
  return {};
}
function foundingCartLineExtras() {
  var extras = {};
  if (foundingModeEnabled()) extras._otto_founding = '1';
  var zone = checkoutPricingZone();
  if (zone) extras._otto_pricing = zone;
  if (pickupModeEnabled()) extras._otto_fulfillment = 'pickup';
  return extras;
}
function cfgDeliveryDayReviewSummary() {
  var wd = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
  if (!cfgWeekdayChosen(wd)) return '';
  return cfgDeliveryWeekdayLabel(wd, true);
}
function buildLoopCartItemsFromSelections() {
if (foundingModeEnabled() && !foundingSellingPlanMap()) {
return { ok: false, error: 'Founding mode is not fully configured yet. Please contact support.', items: [] };
}
if (matureModeEnabled() && !matureSellingPlanMap()) {
return { ok: false, error: 'Mature ZIP pricing is not fully configured yet. Please contact support.', items: [] };
}
var subs = Array.isArray(selections.subscriptions) ? selections.subscriptions.filter(Boolean) : [];
if (!subs.length) return { ok: false, error: 'Please complete your delivery selections first.', items: [] };
var hasFreezerSub = subs.some(function (sub) { return !!(sub && sub.freezer_program); });
var mode = (selections.freezer_program || hasFreezerSub) ? 'freezer' : 'regular';
if (mode === 'freezer') {
if (!selections.freezer_program) return { ok: false, error: 'Freezer mode is not currently selected.', items: [] };
return buildFreezerLoopItems(subs, mode);
}
return buildPerDogLoopItems();
}
/* Freezer program: one line per protein tote allocation (legacy household
 * grouping). Left intact pending the future per-dog freezer breakdown. */
function buildFreezerLoopItems(subs, mode) {
var items = [];
for (var i = 0; i < subs.length; i++) {
var sub = subs[i] || {};
var protein = String(sub.protein || '').trim();
var variantId = resolveLoopVariantIdForProtein(protein);
if (!variantId) {
return { ok: false, error: 'Missing variant mapping for "' + (protein || ('Protein ' + (i + 1))) + '".', items: [] };
}
var quantity = Math.max(0, Math.floor(Number(sub.lbs || sub.totes || 0)));
if (!quantity) {
return { ok: false, error: 'Invalid delivery quantity (lb) for "' + (protein || ('Protein ' + (i + 1))) + '".', items: [] };
}
var interval = Math.max(0, Math.floor(Number(sub.interval || 0)));
var weeks = Math.max(0, Math.floor(Number(sub.weeks || 0)));
if (!weeks && interval > 0) weeks = Math.max(1, Math.round(interval / 7));
var sellingPlanId = resolveLoopSellingPlanId(mode, interval, weeks);
if (!sellingPlanId) {
return { ok: false, error: 'No selling plan mapped for ' + mode + ' every ' + (weeks || interval) + (weeks ? ' week(s)' : ' days') + '.', items: [] };
}
var bagMeta = '';
if (CadenceEngine && typeof CadenceEngine.bagSplit === 'function') {
var split = CadenceEngine.bagSplit(quantity, settingNum(settings.bag_capacity_lb, 20));
if (split && split.count) bagMeta = split.count + ' bags · ' + split.sizes.join('+');
}
var properties = {
'_otto_mode': mode,
'_otto_engine': 'v2',
'_otto_interval_days': String(interval),
'_otto_cadence_weeks': String(weeks || ''),
'_otto_daily_lb': String(sub.daily_lb || selections.daily_total || ''),
'_otto_protein': protein || ('Protein ' + (i + 1))
};
if (bagMeta) properties._otto_bags = bagMeta;
if (Array.isArray(sub.dogs) && sub.dogs.length) {
properties._otto_dogs = sub.dogs.join(', ');
}
Object.assign(properties, deliveryWeekdayCartProperty(), foundingCartLineExtras());
items.push({
id: variantId,
quantity: quantity,
selling_plan: sellingPlanId,
properties: properties
});
}
return { ok: true, items: items };
}
/* Regular subscriptions: one Loop line per (dog x recipe), tagged with the
 * same _otto_dog_id / _otto_dog_profile schema the customer portal reads, so
 * each dog lands in the portal as its own profile with its own editable
 * subscription. All of a household's lines share one contract/cadence. */
function buildPerDogLoopItems() {
var plan = buildPerDogRecipePlan();
if (!plan.ok) return { ok: false, error: plan.error, items: [] };
var items = [];
for (var d = 0; d < plan.dogs.length; d++) {
var dog = plan.dogs[d];
var sellingPlanId = resolveLoopSellingPlanId('regular', dog.interval, dog.weeks);
if (!sellingPlanId) {
return { ok: false, error: 'No selling plan mapped for regular every ' + (dog.weeks || dog.interval) + (dog.weeks ? ' week(s)' : ' days') + '.', items: [] };
}
var profileJson = JSON.stringify(dog.profile);
for (var r = 0; r < dog.recipes.length; r++) {
var rec = dog.recipes[r];
var variantId = resolveLoopVariantIdForProtein(rec.protein);
if (!variantId) {
return { ok: false, error: 'Missing variant mapping for "' + rec.protein + '".', items: [] };
}
var qty = Math.max(0, Math.floor(Number(rec.lbs || 0)));
if (!qty) continue;
items.push({
id: variantId,
quantity: qty,
selling_plan: sellingPlanId,
properties: Object.assign({
'_otto_mode': 'regular',
'_otto_engine': 'v2',
'_otto_dog_id': String(dog.dog_id),
'_otto_dog_profile': profileJson,
'_otto_protein': rec.protein,
'_otto_dogs': dog.name,
'_otto_interval_days': String(dog.interval),
'_otto_cadence_weeks': String(dog.weeks || ''),
'_otto_daily_lb': String(dog.daily_lb || '')
}, deliveryWeekdayCartProperty(), foundingCartLineExtras())
});
}
}
if (!items.length) return { ok: false, error: 'Invalid delivery quantity. Please review your plan.', items: [] };
return { ok: true, items: items };
}
/* Look up a protein's per-lb price (cents) from the product selector tiles. */
function resolveProteinPriceCents(protein) {
var key = String(protein || '').trim().toLowerCase();
if (!key) return 0;
var found = 0;
var card = $('[data-cfg-type="product_selector"]');
if (card) {
card.querySelectorAll('.otto-cfg-tile--product[data-cfg-tile-value]').forEach(function (tile) {
if (found) return;
if (String(tile.getAttribute('data-cfg-tile-value') || '').trim().toLowerCase() === key) {
found = parseInt(tile.getAttribute('data-product-price') || '0', 10) || 0;
}
});
}
return found;
}
/* Household (shared / single-dog) recipe set for the "same recipe" path.
 * Multi-recipe aware: returns [{protein, price_cents}]. Falls back to the
 * legacy single selections.protein/product_price so existing reads keep working. */
function getHouseholdProteinList() {
var raw = Array.isArray(selections.household_proteins) ? selections.household_proteins : [];
var out = [];
raw.forEach(function (p) {
var name = String((typeof p === 'string') ? p : (p && p.protein) || '').trim();
if (!name) return;
var price = (typeof p === 'string')
? resolveProteinPriceCents(name)
: (Math.floor(Number(p && (p.price_cents != null ? p.price_cents : p.price))) || resolveProteinPriceCents(name));
out.push({ protein: name, price_cents: price });
});
if (!out.length) {
var single = String(selections.protein || '').trim();
if (single) out.push({ protein: single, price_cents: Math.floor(Number(selections.product_price || 0)) || resolveProteinPriceCents(single) });
}
return out;
}
function ensureSharedProteinFromHousehold() {
var hh = getHouseholdProteinList();
if (!hh.length) return false;
if (!String(selections.protein || '').trim()) {
selections.protein = hh[0].protein;
if (Number(hh[0].price_cents) > 0) selections.product_price = hh[0].price_cents;
}
if (!Array.isArray(selections.household_proteins) || !selections.household_proteins.length) {
selections.household_proteins = hh.slice();
}
return true;
}
function averageRecipePriceCents(recipes) {
if (!Array.isArray(recipes) || !recipes.length) return 0;
var total = 0;
var count = 0;
recipes.forEach(function (r) {
var cents = 0;
if (typeof r === 'string') {
cents = resolveProteinPriceCents(r);
} else if (r) {
cents = Math.floor(Number(r.price_cents != null ? r.price_cents : r.price)) || resolveProteinPriceCents(r.protein);
}
if (cents > 0) {
total += cents;
count++;
}
});
return count > 0 ? (total / count) : 0;
}
function priceCentsForDogProteinRow(row) {
if (!row) return 0;
if (Array.isArray(row.proteins) && row.proteins.length) {
return averageRecipePriceCents(row.proteins);
}
return Math.floor(Number(row.price || 0)) || resolveProteinPriceCents(row.protein);
}
/* Build the per-dog meal plan: each dog's recipes + per-recipe pounds.
 * Household oz is combined first, the tote is rounded once
 * (allocatePackDeliveryLb), then whole pounds are assigned to dogs.
 * Each dog's pounds split evenly across their recipes; any odd pound
 * goes to the cheapest recipe (recipes sorted cheapest-first).
 * Returns { ok, error?, dogs: [{ dog_id, name, profile, interval, weeks,
 * daily_lb, recipes: [{ protein, price_cents, lbs }] }] }. */
function buildPerDogRecipePlan(cadenceOverride) {
if (!Engine || typeof Engine.computeDogPortion !== 'function' || typeof Engine.roundDeliveryLb !== 'function') {
return { ok: false, error: 'Meal plan engine unavailable. Please reload and try again.' };
}
var dogsSource = (Array.isArray(selections.dogs) && selections.dogs.length)
? selections.dogs
: (Array.isArray(selections.dogs_basic) ? selections.dogs_basic : []);
if (!dogsSource.length) return { ok: false, error: 'Please add at least one dog first.' };
var dogIds = ensureDogIds(dogsSource.length);
var subs = Array.isArray(selections.subscriptions) ? selections.subscriptions.filter(function (s) { return s && !s.freezer_program; }) : [];
var meals = getMealsPerDayForDog(dog) || 2;
var freezerProfile = getSelectedFreezerSpaceProfile() || 'standard';
var perDogProtein = !!selections.per_dog_protein;
var householdProtein = String(selections.protein || '').trim();
var householdPrice = Math.floor(Number(selections.product_price || 0)) || 0;
var dogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins : [];
function rowForDog(idx, name) {
for (var i = 0; i < dogProteins.length; i++) {
var r = dogProteins[i] || {};
if (Number(r.dogIdx) === Number(idx)) return r;
}
if (name) {
var lo = String(name).trim().toLowerCase();
for (var j = 0; j < dogProteins.length; j++) {
var r2 = dogProteins[j] || {};
if (String(r2.dogName || '').trim().toLowerCase() === lo) return r2;
}
}
return null;
}
function recipesForDog(idx, name) {
var out = [];
function add(prot, priceCents) {
prot = String(prot || '').trim();
if (!prot) return;
var price = Math.floor(Number(priceCents || 0)) || resolveProteinPriceCents(prot);
out.push({ protein: prot, price_cents: price });
}
/* Shared-recipe mode must ignore leftover per-dog rows. Those stay in
 * selections after a different→same switch and would otherwise keep
 * delivery + summary on the old recipes even after refresh. */
if (!perDogProtein) {
var hh = getHouseholdProteinList();
if (hh.length) {
hh.forEach(function (rec) { add(rec.protein, rec.price_cents); });
} else if (householdProtein) {
add(householdProtein, householdPrice);
}
return out;
}
var row = rowForDog(idx, name);
if (row && Array.isArray(row.proteins) && row.proteins.length) {
row.proteins.forEach(function (p) {
if (typeof p === 'string') add(p, 0);
else if (p) add(p.protein, p.price_cents != null ? p.price_cents : p.price);
});
} else if (row && row.protein) {
add(row.protein, row.price);
}
return out;
}
function cadenceForDog(recipes) {
if (cadenceOverride && Number(cadenceOverride.interval) > 0) {
var overrideInterval = Math.floor(Number(cadenceOverride.interval));
var overrideWeeks = Math.floor(Number(cadenceOverride.weeks || 0));
if (!overrideWeeks) overrideWeeks = Math.max(1, Math.round(overrideInterval / 7));
return { interval: overrideInterval, weeks: overrideWeeks };
}
var primary = recipes.length ? recipes[0].protein : '';
var match = null;
for (var i = 0; i < subs.length; i++) {
if (proteinsMatch(subs[i].protein, primary)) { match = subs[i]; break; }
}
if (!match && subs.length) match = subs[0];
var interval = match ? Math.floor(Number(match.interval || 0)) : Math.floor(Number(selections.delivery_interval || 0));
var weeks = match ? Math.floor(Number(match.weeks || 0)) : Math.floor(Number(selections.delivery_weeks || 0));
if (!weeks && interval > 0) weeks = Math.max(1, Math.round(interval / 7));
return { interval: interval, weeks: weeks };
}
var pending = [];
for (var d = 0; d < dogsSource.length; d++) {
var dog = dogsSource[d] || {};
var name = String(dog.name || '').trim();
if (!name) continue;
var recipes = recipesForDog(d, name);
if (!recipes.length) return { ok: false, error: 'Please choose a recipe for ' + (name || ('Dog ' + (d + 1))) + '.' };
var cad = cadenceForDog(recipes);
if (!(cad.interval > 0)) return { ok: false, error: 'Please choose a delivery cadence first.' };
var snappedOz = resolveDogPortionOz(dog);
var rawPct = dogRawPercent(dog);
var dailyLb = effectivePortionOz(snappedOz, rawPct) / 16;
pending.push({
index: d,
dog: dog,
name: name,
recipes: recipes,
cad: cad,
snappedOz: snappedOz,
rawPct: rawPct,
dailyLb: dailyLb
});
}
if (!pending.length) return { ok: false, error: 'Please complete your dog details first.' };
var householdInterval = pending[0].cad.interval;
if (cadenceOverride && Number(cadenceOverride.interval) > 0) {
householdInterval = Math.floor(Number(cadenceOverride.interval));
}
var shares = pending.map(function (p) {
var stage = (typeof Engine.resolveLifeStage === 'function')
? Engine.resolveLifeStage(p.dog, settings)
: (p.dog.life_stage || p.dog.stage || '');
return {
id: dogIds[p.index],
exactLb: p.dailyLb * householdInterval,
minLb: Math.max(1, p.recipes.length),
isGrowth: isGrowthStageKey(stage)
};
});
var packAlloc = (typeof Engine.allocatePackDeliveryLb === 'function')
? Engine.allocatePackDeliveryLb(shares, settings, householdInterval)
: { allocations: {} };
var plan = [];
pending.forEach(function (p) {
var deliveryLb = packAlloc.allocations[String(dogIds[p.index])];
if (deliveryLb == null) {
deliveryLb = Math.floor(Number(Engine.roundDeliveryLb(p.dailyLb * p.cad.interval, settings)) || 0);
}
deliveryLb = Math.max(p.recipes.length, deliveryLb);
var ordered = p.recipes.slice().sort(function (a, b) { return (a.price_cents || 0) - (b.price_cents || 0); });
var base = Math.floor(deliveryLb / ordered.length);
var rem = deliveryLb - base * ordered.length;
ordered.forEach(function (rec, i) { rec.lbs = base + (i < rem ? 1 : 0); });
plan.push({
dog_id: dogIds[p.index],
name: p.name,
profile: {
name: p.name,
breed: String(p.dog.breed || '').trim(),
sex: String(p.dog.sex || '').trim(),
weight: Number(p.dog.weight || 0) || 0,
life_stage: String(p.dog.life_stage || p.dog.stage || '').trim(),
birthdate: String(p.dog.birthdate || '').trim(),
age_estimated: !!p.dog.age_estimated,
weight_confirmed_at: new Date().toISOString(),
activity: String(p.dog.activity || '').trim(),
goal: String(p.dog.goal || '').trim(),
meals: meals,
portion_oz: p.snappedOz,
raw_percent: p.rawPct,
freezer_profile: freezerProfile
},
interval: p.cad.interval,
weeks: p.cad.weeks,
daily_lb: p.dailyLb,
recipes: ordered
});
});
return { ok: true, dogs: plan };
}
function householdTotalsFromPlan(plan) {
var totalLbs = 0;
var costCents = 0;
if (!plan || !plan.ok || !Array.isArray(plan.dogs)) return { totalLbs: 0, costCents: 0 };
plan.dogs.forEach(function (dog) {
(dog.recipes || []).forEach(function (rec) {
var lbs = Math.max(0, Math.floor(Number(rec.lbs || 0)));
totalLbs += lbs;
costCents += lbs * (Number(rec.price_cents || 0));
});
});
return { totalLbs: totalLbs, costCents: costCents };
}
/* Match Shopify/Loop checkout: discount the per-lb unit price (rounded to the
 * nearest cent), then multiply by quantity — not a lump sum on the subtotal. */
function initialOrderPricingFromPlan(plan, discountPercent) {
var subtotalCents = 0;
var discountedCents = 0;
var pct = Math.max(0, Math.min(100, Math.round(Number(discountPercent) || 0)));
if (!plan || !plan.ok || !Array.isArray(plan.dogs)) {
return { subtotalCents: 0, discountCents: 0, totalCents: 0 };
}
plan.dogs.forEach(function (dog) {
(dog.recipes || []).forEach(function (rec) {
var lbs = Math.max(0, Math.floor(Number(rec.lbs || 0)));
var unitCents = Math.max(0, Math.floor(Number(rec.price_cents || 0)));
if (!lbs || !unitCents) return;
var lineCents = lbs * unitCents;
subtotalCents += lineCents;
if (pct > 0) {
var discountedUnitCents = Math.round(unitCents * (100 - pct) / 100);
discountedCents += lbs * discountedUnitCents;
} else {
discountedCents += lineCents;
}
});
});
return {
subtotalCents: subtotalCents,
discountCents: subtotalCents - discountedCents,
totalCents: discountedCents
};
}
/* Billable delivery pricing for review UI (Pack Totals, comparison table, etc.). */
function checkoutAlignedOttoMetrics(plan) {
var empty = {
perDelivery: 0, weekly: 0, monthly: 0, perMeal: 0,
deliveryLbs: 0, intervalDays: 0, cadenceWeeks: 0, mealsInDelivery: 0
};
var totals = householdTotalsFromPlan(plan);
if (!plan || !plan.ok || !(totals.costCents > 0)) return empty;
var intervalDays = 0;
var weeks = 0;
(plan.dogs || []).forEach(function (dog) {
if (dog && dog.interval > 0) { intervalDays = dog.interval; weeks = dog.weeks; }
});
var cadenceWeeks = cadenceWeeksFrom(intervalDays, weeks);
var subtotal = totals.costCents / 100;
var deliveryLbs = totals.totalLbs;
var mealsPerDay = getMealsPerDay() || 2;
var mealsInDelivery = 0;
(plan.dogs || []).forEach(function (dog) {
if (!dog) return;
var dogLbs = 0;
(dog.recipes || []).forEach(function (rec) {
dogLbs += Math.max(0, Math.floor(Number(rec.lbs || 0)));
});
var daily = Number(dog.daily_lb || 0);
/* Growth-stage dogs eat 3-4 smaller meals a day, so their share of the
 * delivery yields more meals than the household 1x/2x setting implies. */
var dogMeals = mealsPerDayForDogDisplay(dog.profile, mealsPerDay);
if (dogLbs > 0 && daily > 0 && dogMeals > 0) mealsInDelivery += (dogLbs / daily) * dogMeals;
});
return {
perDelivery: subtotal,
weekly: cadenceWeeks > 0 ? (subtotal / cadenceWeeks) : 0,
monthly: intervalDays > 0 ? (subtotal * 30 / intervalDays) : 0,
perMeal: mealsInDelivery > 0 ? (subtotal / mealsInDelivery) : 0,
deliveryLbs: deliveryLbs,
intervalDays: intervalDays,
cadenceWeeks: cadenceWeeks,
mealsInDelivery: mealsInDelivery
};
}
function generateDogId() {
try {
if (window.crypto && typeof window.crypto.randomUUID === 'function') {
return window.crypto.randomUUID();
}
if (window.crypto && window.crypto.getRandomValues) {
var b = new Uint8Array(16);
window.crypto.getRandomValues(b);
b[6] = (b[6] & 0x0f) | 0x40;
b[8] = (b[8] & 0x3f) | 0x80;
var h = [];
for (var i = 0; i < b.length; i++) h.push((b[i] + 0x100).toString(16).slice(1));
return h[0]+h[1]+h[2]+h[3]+'-'+h[4]+h[5]+'-'+h[6]+h[7]+'-'+h[8]+h[9]+'-'+h[10]+h[11]+h[12]+h[13]+h[14]+h[15];
}
} catch (_err) {}
return 'dog-' + Date.now().toString(16) + '-' + Math.floor(Math.random() * 0xffffff).toString(16);
}
function ensureDogIds(count) {
if (!Array.isArray(selections.dog_ids)) selections.dog_ids = [];
while (selections.dog_ids.length < count) selections.dog_ids.push(generateDogId());
if (selections.dog_ids.length > count) selections.dog_ids = selections.dog_ids.slice(0, count);
return selections.dog_ids;
}
function buildOnboardingAttributePayload() {
try {
var dogsSource = Array.isArray(selections.dogs) && selections.dogs.length
? selections.dogs
: (Array.isArray(selections.dogs_basic) ? selections.dogs_basic : []);
if (!dogsSource.length) return null;
var dogIds = ensureDogIds(dogsSource.length);
var dogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins : [];
function findProteinForDog(dogIdx, dogName) {
for (var i = 0; i < dogProteins.length; i++) {
var row = dogProteins[i] || {};
if (Number(row.dogIdx) === Number(dogIdx)) return row;
}
if (dogName) {
var lowered = String(dogName).trim().toLowerCase();
for (var j = 0; j < dogProteins.length; j++) {
var r = dogProteins[j] || {};
if (String(r.dogName || '').trim().toLowerCase() === lowered) return r;
}
}
return null;
}
var householdProtein = String(selections.protein || '').trim();
var perDogProtein = !!selections.per_dog_protein;
/* Per-dog x per-recipe plan: the SAME source of truth that builds the Loop
 * cart lines and the review. Multi-recipe aware, with per-recipe pounds and the
 * full editable profile (meals, portion_oz, freezer_profile, cadence). */
var plan = null;
try { plan = (typeof buildPerDogRecipePlan === 'function') ? buildPerDogRecipePlan() : null; } catch (planErr) { plan = null; }
var planByDogId = {};
var planByName = {};
if (plan && plan.ok && Array.isArray(plan.dogs)) {
plan.dogs.forEach(function (pd) {
if (pd && pd.dog_id) planByDogId[String(pd.dog_id)] = pd;
var nm = String((pd && pd.name) || '').trim().toLowerCase();
if (nm) planByName[nm] = pd;
});
}
var dogs = [];
var perRecipeSubs = [];
for (var d = 0; d < dogsSource.length; d++) {
var dog = dogsSource[d] || {};
var name = String(dog.name || '').trim();
if (!name) continue;
var dogId = dogIds[d];
var planDog = planByDogId[String(dogId)] || planByName[name.toLowerCase()] || null;
var proteinMatch = findProteinForDog(d, name);
/* Recipe list (multi-recipe aware). Prefer the plan recipes (they carry the
 * per-recipe pounds), then the selected proteins[] array, then a single. */
var recipeList = [];
if (planDog && Array.isArray(planDog.recipes) && planDog.recipes.length) {
planDog.recipes.forEach(function (r) {
var pn = String((r && r.protein) || '').trim();
if (!pn) return;
recipeList.push({
protein: pn,
price_cents: Math.max(0, Math.floor(Number(r.price_cents || 0))),
lbs: Math.max(0, Math.floor(Number(r.lbs || 0)))
});
});
} else if (proteinMatch && Array.isArray(proteinMatch.proteins) && proteinMatch.proteins.length) {
proteinMatch.proteins.forEach(function (p) {
var pn = String((typeof p === 'string') ? p : (p && p.protein) || '').trim();
if (!pn) return;
recipeList.push({
protein: pn,
price_cents: Math.max(0, Math.floor(Number((p && (p.price_cents != null ? p.price_cents : p.price)) || 0))),
lbs: 0
});
});
} else {
var single = proteinMatch && proteinMatch.protein
? String(proteinMatch.protein).trim()
: (perDogProtein ? '' : householdProtein);
if (single) recipeList.push({
protein: single,
price_cents: proteinMatch && Number(proteinMatch.price) ? Math.floor(Number(proteinMatch.price)) : 0,
lbs: 0
});
}
var profile = (planDog && planDog.profile) ? planDog.profile : {};
var entry = {
dog_id: dogId,
name: name,
breed: String(dog.breed || '').trim(),
sex: String(dog.sex || '').trim(),
weight: Number(dog.weight || 0) || 0,
life_stage: String(dog.life_stage || '').trim(),
birthdate: String(dog.birthdate || (planDog && planDog.profile && planDog.profile.birthdate) || '').trim(),
age_estimated: !!(dog.age_estimated || (planDog && planDog.profile && planDog.profile.age_estimated)),
weight_confirmed_at: (planDog && planDog.profile && planDog.profile.weight_confirmed_at) || '',
activity: String(dog.activity || '').trim(),
goal: String(dog.goal || '').trim(),
daily_intake: Number(dog.daily_intake || 0) || 0,
meals: Math.max(0, Math.floor(Number(profile.meals || 0))) || 0,
portion_oz: Number(profile.portion_oz || 0) || 0,
raw_percent: normalizeRawPercent(profile.raw_percent || dog.raw_percent),
freezer_profile: String(profile.freezer_profile || '').trim(),
interval_days: planDog ? Math.max(0, Math.floor(Number(planDog.interval || 0))) : 0,
cadence_weeks: planDog ? Math.max(0, Math.floor(Number(planDog.weeks || 0))) : 0,
daily_lb: planDog ? (Number(planDog.daily_lb || 0) || 0) : 0,
proteins: recipeList,
protein: recipeList.length ? recipeList[0].protein : '',
protein_price_cents: recipeList.length ? recipeList[0].price_cents : 0
};
Object.keys(entry).forEach(function (key) {
if (key === 'dog_id' || key === 'proteins') return;
if (entry[key] === '' || entry[key] === 0) delete entry[key];
});
if (entry.age_estimated === false) delete entry.age_estimated;
if (!entry.proteins.length) delete entry.proteins;
dogs.push(entry);
/* One subscription row per dog x recipe (regular mode) so each dog lands as
 * its own profile with its own editable per-recipe subscriptions. */
if (planDog && Array.isArray(planDog.recipes)) {
planDog.recipes.forEach(function (r) {
var pn = String((r && r.protein) || '').trim();
var lbs = Math.max(0, Math.floor(Number(r.lbs || 0)));
if (!pn || lbs <= 0) return;
perRecipeSubs.push({
dog_id: dogId,
dog_name: name,
protein: pn,
price_cents: Math.max(0, Math.floor(Number(r.price_cents || 0))),
lbs: lbs,
interval_days: Math.max(0, Math.floor(Number(planDog.interval || 0))),
cadence_weeks: Math.max(0, Math.floor(Number(planDog.weeks || 0))),
mode: 'regular'
});
});
}
}
if (!dogs.length) return null;
var subscriptions;
if (perRecipeSubs.length && !selections.freezer_program) {
subscriptions = perRecipeSubs;
} else {
var subsRaw = Array.isArray(selections.subscriptions) ? selections.subscriptions.filter(Boolean) : [];
subscriptions = subsRaw.map(function (sub) {
return {
protein: String(sub.protein || '').trim(),
dogs: Array.isArray(sub.dogs)
? sub.dogs.map(function (n) { return String(n || '').trim(); }).filter(Boolean)
: [],
totes: Math.max(0, Math.floor(Number(sub.totes || 0))),
interval_days: Math.max(0, Math.floor(Number(sub.interval || 0))),
lbs: Math.max(0, Math.floor(Number(sub.lbs || 0))),
mode: sub.freezer_program ? 'freezer' : 'regular'
};
});
}
var householdRecipes = [];
if (!perDogProtein && typeof getHouseholdProteinList === 'function') {
getHouseholdProteinList().forEach(function (r) {
var pn = String((r && r.protein) || '').trim();
if (!pn) return;
householdRecipes.push({ protein: pn, price_cents: Math.max(0, Math.floor(Number(r.price_cents || 0))) });
});
}
var household = {
meals_per_day: Math.max(0, Math.floor(Number(selections.meals_per_day || 0))) || 0,
per_dog_protein: perDogProtein,
protein: householdProtein,
household_proteins: householdRecipes,
freezer_program: !!selections.freezer_program,
freezer_space_profile: String(selections.freezer_space_profile || '').trim()
};
if (pickupModeEnabled()) household.fulfillment = 'pickup';
if (!foundingModeEnabled()) {
var cfgWeekday = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
if (cfgWeekdayChosen(cfgWeekday)) household.delivery_weekday = cfgWeekday;
}
Object.keys(household).forEach(function (key) {
var value = household[key];
if (key === 'household_proteins') { if (!value || !value.length) delete household[key]; return; }
if (value === '' || value === 0) delete household[key];
});
var ownerSel = (selections.owner && typeof selections.owner === 'object') ? selections.owner : {};
var owner = {
name: String(ownerSel.name || '').trim(),
familiarity: String(ownerSel.familiarity || '').trim(),
email: String(ownerSel.email || '').trim(),
guide_opt_in: !!ownerSel.guide_opt_in,
terms_accepted: !!ownerSel.terms_accepted,
terms_accepted_at: String(ownerSel.terms_accepted_at || '').trim()
};
if (!owner.terms_accepted) {
delete owner.terms_accepted;
delete owner.terms_accepted_at;
} else if (!owner.terms_accepted_at) {
delete owner.terms_accepted_at;
}
var payload = {
version: 1,
captured_at: new Date().toISOString(),
zip: String(selections.zip || '').trim(),
pricing_zone: checkoutPricingZone(),
owner: owner,
household: household,
dogs: dogs,
subscriptions: subscriptions
};
if (payload.pricing_zone) household.pricing_zone = payload.pricing_zone;
if (!payload.zip) delete payload.zip;
return payload;
} catch (err) {
if (window && window.console && console.warn) {
console.warn('Failed to build onboarding attribute payload:', err);
}
return null;
}
}
function writeOnboardingCartAttributes(options) {
var opts = options || {};
var discount = String(opts.discount || '').trim();
var requireDiscount = !!opts.requireDiscount;
var payload;
try {
payload = buildOnboardingAttributePayload();
} catch (err) {
payload = null;
}
if (!payload) {
if (requireDiscount) {
return Promise.reject(new Error('Unable to save your plan details to the cart. Please try again.'));
}
return Promise.resolve(null);
}
var attributes;
try {
var household = payload.household || {};
var ownerAttr = payload.owner || {};
attributes = {
otto_onboarding_payload: JSON.stringify(payload),
otto_onboarding_version: '1',
otto_zip: payload.zip == null ? '' : String(payload.zip),
otto_owner_name: ownerAttr.name == null ? '' : String(ownerAttr.name),
otto_owner_familiarity: ownerAttr.familiarity == null ? '' : String(ownerAttr.familiarity),
otto_owner_email: ownerAttr.email == null ? '' : String(ownerAttr.email),
otto_owner_guide_opt_in: ownerAttr.guide_opt_in === true ? 'true' : 'false',
otto_owner_terms_accepted: ownerAttr.terms_accepted === true ? 'true' : 'false',
otto_owner_terms_accepted_at: ownerAttr.terms_accepted_at == null ? '' : String(ownerAttr.terms_accepted_at),
otto_meals_per_day: household.meals_per_day == null ? '' : String(household.meals_per_day),
otto_per_dog_protein: household.per_dog_protein === true ? 'true' : 'false',
otto_freezer_program: household.freezer_program === true ? 'true' : 'false',
otto_freezer_space_profile: household.freezer_space_profile == null ? '' : String(household.freezer_space_profile),
otto_dogs_json: JSON.stringify(payload.dogs || [])
};
attributes.otto_founding = foundingModeEnabled() ? '1' : '';
attributes.otto_pricing = checkoutPricingZone();
attributes.otto_fulfillment = pickupModeEnabled() ? 'pickup' : '';
var refCode = '';
try {
  refCode = String(window.__ottoRefCode || '').trim();
} catch (e) {
  refCode = '';
}
if (!refCode) {
  try {
    var cookieParts = (document.cookie || '').split(';');
    for (var ci = 0; ci < cookieParts.length; ci++) {
      var cp = cookieParts[ci].trim();
      if (cp.indexOf('otto_ref=') === 0) {
        try {
          refCode = decodeURIComponent(cp.slice(9));
        } catch (e2) {
          refCode = cp.slice(9);
        }
        break;
      }
    }
  } catch (e3) { /* ignore */ }
}
if (!refCode) {
  try {
    refCode = String(localStorage.getItem('otto_ref') || '').trim();
  } catch (e4) { /* ignore */ }
}
if (refCode) attributes.otto_ref = refCode.toUpperCase().replace(/[^A-Z0-9-]/g, '');
/* Flat per-dog birthdates so Klaviyo can run date-triggered "your pup is
 * growing up" flows without parsing the JSON payload. */
(payload.dogs || []).forEach(function (dogEntry, dogIdx) {
if (dogEntry && dogEntry.birthdate) {
attributes['otto_dog' + (dogIdx + 1) + '_birthdate'] = String(dogEntry.birthdate);
}
});
} catch (err) {
if (requireDiscount) {
return Promise.reject(new Error('Unable to save your plan details to the cart. Please try again.'));
}
return Promise.resolve(null);
}
var update = { attributes: attributes };
if (discount) update.discount = discount;
var body;
try {
body = JSON.stringify(update);
} catch (err) {
if (requireDiscount) {
return Promise.reject(new Error('Unable to save your plan details to the cart. Please try again.'));
}
return Promise.resolve(null);
}
return fetch('/cart/update.js', {
method: 'POST',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/json'
},
credentials: 'same-origin',
body: body
}).then(function (res) {
return res.json().catch(function () { return {}; }).then(function (cart) {
if (!res.ok) {
if (requireDiscount) {
throw new Error('Unable to apply the founding reservation discount. Please try again.');
}
if (window && window.console && console.warn) {
console.warn('Failed to write onboarding cart attributes:', res.status);
}
return cart;
}
if (discount && requireDiscount && !cartHasApplicableDiscount(cart, discount)) {
console.warn('[otto-cfg] founding reservation discount not applicable:', discount);
throw new Error('The founding reservation discount could not be applied, so checkout would not be $0. Please try again or contact support.');
}
return cart;
});
}).catch(function (err) {
if (requireDiscount) throw err;
if (window && window.console && console.warn) {
console.warn('Failed to write onboarding cart attributes:', err);
}
return null;
});
}
function foundingCtaLabel() {
  var copy = (foundingCfg && foundingCfg.copy) || {};
  var val = String(copy.ctaLabel || '').trim();
  return val || 'Reserve Your Plan';
}
function foundingCtaBusyLabel() {
  var copy = (foundingCfg && foundingCfg.copy) || {};
  var val = String(copy.ctaBusyLabel || '').trim();
  return val || 'Reserving…';
}
function rememberCheckoutCtaLabel(reviewCard) {
  if (!reviewCard) return '';
  var stored = String(reviewCard.getAttribute('data-cfg-checkout-cta') || '').trim();
  if (stored) return stored;
  var pre = String(reviewCard.getAttribute('data-cfg-pre-founding-cta') || '').trim();
  var override = String(reviewCard.getAttribute('data-cfg-start-button-override') || '').trim();
  var reserved = foundingCtaLabel();
  var candidate = pre || (override && override !== reserved ? override : '');
  if (!candidate) {
    var btn = $('[data-cfg-start-subscription]');
    var btnText = btn ? String(btn.textContent || '').trim() : '';
    if (btnText && btnText !== reserved && !/reserving/i.test(btnText)) candidate = btnText;
  }
  if (candidate) reviewCard.setAttribute('data-cfg-checkout-cta', candidate);
  return candidate || 'Start subscription';
}
function checkoutCtaLabel() {
  return rememberCheckoutCtaLabel($('[data-cfg-type="review"]'));
}
function shouldUseFoundingCta() {
  return foundingModeEnabled();
}
function setStartButtonBusyState(button, isBusy, defaultLabel) {
if (!button) return;
var shouldDisable = !!isBusy;
button.disabled = shouldDisable;
var busyLabel = shouldUseFoundingCta()
? foundingCtaBusyLabel()
: 'Starting subscription...';
button.textContent = isBusy ? busyLabel : (defaultLabel || getStartButtonDefaultLabel() || button.textContent || 'Start subscription');
}
function getStartButtonDefaultLabel() {
  if (shouldUseFoundingCta()) return foundingCtaLabel();
  return checkoutCtaLabel();
}
function syncStartButtonLabel() {
  var reviewCard = $('[data-cfg-type="review"]');
  var label = getStartButtonDefaultLabel();
  if (reviewCard) {
    rememberCheckoutCtaLabel(reviewCard);
    reviewCard.setAttribute('data-cfg-start-button-override', label);
    if (shouldUseFoundingCta()) reviewCard.setAttribute('data-cfg-founding-cta', '1');
    else reviewCard.removeAttribute('data-cfg-founding-cta');
  }
  var startBtnEl = $('[data-cfg-start-subscription]');
  if (startBtnEl && !startBtnEl.disabled) startBtnEl.textContent = label;
  return label;
}
function applyFoundingModeUi() {
if (!foundingModeEnabled()) return;
delete selections.delivery_weekday;
$$('[data-cfg-type="delivery_day"]').forEach(function (card) {
card.hidden = true;
card.setAttribute('data-cfg-founding-hidden', '1');
card.classList.remove('is-locked', 'is-incomplete');
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
}
if (typeof syncCardInert === 'function') syncCardInert(card);
});
var reviewCardEl = $('[data-cfg-type="review"]');
if (reviewCardEl) rememberCheckoutCtaLabel(reviewCardEl);
if (reviewCardEl && !reviewCardEl.hasAttribute('data-cfg-founding-cta')) {
reviewCardEl.setAttribute(
  'data-cfg-pre-founding-cta',
  String(reviewCardEl.getAttribute('data-cfg-checkout-cta') || reviewCardEl.getAttribute('data-cfg-start-button-override') || '')
);
}
syncStartButtonLabel();
}
function clearFoundingModeUi() {
$$('[data-cfg-type="delivery_day"]').forEach(function (card) {
if (!card.hasAttribute('data-cfg-founding-hidden')) return;
card.hidden = false;
card.removeAttribute('data-cfg-founding-hidden');
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (stepNum) {
var wd = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
if (!cfgWeekdayChosen(wd)) {
delete completedSteps[stepNum];
delete everCompletedSteps[stepNum];
}
}
});
var reviewCardEl = $('[data-cfg-type="review"]');
if (reviewCardEl && reviewCardEl.hasAttribute('data-cfg-founding-cta')) {
var prevCta = String(reviewCardEl.getAttribute('data-cfg-checkout-cta') || reviewCardEl.getAttribute('data-cfg-pre-founding-cta') || '');
reviewCardEl.removeAttribute('data-cfg-founding-cta');
reviewCardEl.removeAttribute('data-cfg-pre-founding-cta');
if (prevCta) reviewCardEl.setAttribute('data-cfg-start-button-override', prevCta);
else reviewCardEl.removeAttribute('data-cfg-start-button-override');
}
syncStartButtonLabel();
}
function deliveryDayIntroHelper(card) {
var helpers = card.querySelectorAll('.otto-cfg-card__helper');
for (var i = 0; i < helpers.length; i++) {
if (!helpers[i].hasAttribute('data-cfg-delivery-day-locked')) return helpers[i];
}
return null;
}
function pickupHoursLabel() {
  return String((pickupCfg && pickupCfg.hours) || 'Monday–Friday 9am–4pm');
}
function pickupWindowLabel() {
  var hours = pickupHoursLabel();
  var match = String(hours || '').match(/(\d{1,2}(?::\d{2})?\s*(?:am|pm)\s*[–-]\s*\d{1,2}(?::\d{2})?\s*(?:am|pm))/i);
  var window = match
    ? match[1].replace(/\s*-\s*/g, '–').replace(/\s+/g, '')
    : '9am–4pm';
  return 'Pickup window ' + window;
}
function pickupAddressLabel() {
  return String((pickupCfg && pickupCfg.address) || '').trim();
}
function pickupAddressBlockHtml() {
  var addr = pickupAddressLabel();
  if (!addr) return '';
  return '<p class="otto-cfg-delivery-day__pickup-address">' +
    esc(addr).replace(/\r\n|\r|\n/g, '<br>') +
    '</p>';
}
function pickupCheckoutNote() {
  return String((pickupCfg && pickupCfg.checkoutNote) || 'At checkout, choose Pick up at our facility. We’re open Monday–Friday 9am–4pm.');
}
function applyFoundingChoiceState(choice) {
  choice = normalizeFoundingChoice(choice);
  selections.founding_choice = choice;
  delete selections.founding_pitch_ack;
  if (choice === 'pickup') {
    if (!pickupOptionEnabled()) return;
    var zip = String(selections.zip || selections.zip_attempted || '').replace(/\D/g, '').slice(0, 5);
    if (zip) {
      selections.zip = zip;
      delete selections.zip_attempted;
    }
    selections.fulfillment = 'pickup';
    applyServiceZone('pickup');
    applyPickupWeekdayPolicy();
    fetchDeliveryWeekdayPolicy(zip);
    var zipCard = $('[data-cfg-type="zip_validator"]');
    if (zipCard) {
      zipCard.classList.remove('is-zip-failed');
      zipCard.classList.add('is-zip-success');
      var zipOut = zipCard.querySelector('[data-cfg-zip-out]');
      if (zipOut) zipOut.hidden = true;
    }
  } else if (choice === 'notify') {
    delete selections.fulfillment;
    var notifyZip = String(selections.zip || selections.zip_attempted || '').replace(/\D/g, '').slice(0, 5);
    if (notifyZip) {
      selections.zip_attempted = notifyZip;
      delete selections.zip;
    }
    applyServiceZone('waitlist');
  }
  syncFoundingChoiceSelection();
  syncFoundingPathUi();
  snapHouseholdRawShareToPackMin();
  var ddCard = $('[data-cfg-type="delivery_day"]');
  if (ddCard && ddCard._renderDeliveryDay) ddCard._renderDeliveryDay();
  updateIncomplete();
  saveProgressState();
  sizeMedia();
}
function foundingChoiceStepNum() {
  var choiceCard = $('[data-cfg-type="founding_choice"]');
  return choiceCard ? parseInt(choiceCard.getAttribute('data-cfg-step'), 10) : 0;
}
function applyPickupPath() {
  if (!pickupOptionEnabled()) return;
  if (
    String(selections.service_zone || '') !== 'founding' &&
    !foundingModeEnabled() &&
    selections.founding_choice !== 'pickup'
  ) return;
  applyFoundingChoiceState('pickup');
  selections.founding_choice_ack = true;
  var choiceStep = foundingChoiceStepNum();
  if (choiceStep) {
    completedSteps[choiceStep] = true;
    everCompletedSteps[choiceStep] = true;
  }
  updateIncomplete();
  saveProgressState();
  var fromStep = choiceStep;
  var zipCard = $('[data-cfg-type="zip_validator"]');
  if (!fromStep && zipCard) fromStep = parseInt(zipCard.getAttribute('data-cfg-step'), 10) || 0;
  var next = fromStep ? getNextVisibleCard(fromStep) : $('[data-cfg-type="product_selector"]');
  if (next) scrollToCard(next);
  sizeMedia();
}
function applyNotifyPath() {
  applyFoundingChoiceState('notify');
  selections.founding_choice_ack = true;
  var choiceStep = foundingChoiceStepNum();
  if (choiceStep) {
    completedSteps[choiceStep] = true;
    everCompletedSteps[choiceStep] = true;
  }
  updateIncomplete();
  saveProgressState();
  if (typeof pushConfiguratorDraftNow === 'function') pushConfiguratorDraftNow();
  var waitlistCard = $('[data-cfg-type="waitlist_pitch"]');
  if (waitlistCard) {
    waitlistCard.hidden = false;
    waitlistCard.removeAttribute('hidden');
    waitlistCard.removeAttribute('data-cfg-path-hidden');
    scrollToCard(waitlistCard);
  } else if (choiceStep) {
    var next = getNextVisibleCard(choiceStep);
    if (next) scrollToCard(next);
  }
  sizeMedia();
}
function swapCardFulfillmentImages(card) {
  if (!card) return;
  var step = parseInt(card.getAttribute('data-cfg-step'), 10);
  var pickup = pickupModeEnabled();
  var pickupSrc = String(card.getAttribute('data-cfg-pickup-desktop-image') || '').trim();
  var pickupSrcset = String(card.getAttribute('data-cfg-pickup-desktop-srcset') || '').trim();
  var pickupMobile = String(card.getAttribute('data-cfg-pickup-mobile-image') || pickupSrc).trim();
  var media = step ? $('[data-cfg-img="' + step + '"]') : null;
  if (media) {
    if (!media.getAttribute('data-cfg-default-src')) {
      media.setAttribute('data-cfg-default-src', media.getAttribute('src') || '');
      media.setAttribute('data-cfg-default-srcset', media.getAttribute('srcset') || '');
    }
    if (pickup && pickupSrc) {
      media.src = pickupSrc;
      if (pickupSrcset) media.setAttribute('srcset', pickupSrcset);
      else media.removeAttribute('srcset');
    } else {
      var defSrc = media.getAttribute('data-cfg-default-src');
      var defSrcset = media.getAttribute('data-cfg-default-srcset');
      if (defSrc) media.src = defSrc;
      if (defSrcset) media.setAttribute('srcset', defSrcset);
    }
  }
  var mobileImg = card.querySelector('.otto-cfg-card__mobile-img img');
  if (mobileImg) {
    if (!mobileImg.getAttribute('data-cfg-default-src')) {
      mobileImg.setAttribute('data-cfg-default-src', mobileImg.getAttribute('src') || '');
    }
    if (pickup && pickupMobile) mobileImg.src = pickupMobile;
    else mobileImg.src = mobileImg.getAttribute('data-cfg-default-src') || mobileImg.src;
  }
}
function syncDeliveryCadenceCopy() {
  $$('[data-cfg-type="delivery_calculator"]').forEach(function (card) {
    var pickup = pickupModeEnabled();
    var headline = card.querySelector('[data-cfg-cadence-headline]') || card.querySelector('.otto-cfg-card__headline');
    if (headline) {
      var accent = pickup
        ? String(card.getAttribute('data-cfg-pickup-heading-accent') || 'Pickup plan.')
        : String(card.getAttribute('data-cfg-heading-accent') || '');
      var heading = pickup
        ? String(card.getAttribute('data-cfg-pickup-heading') || 'How much food and how often you pick up.')
        : String(card.getAttribute('data-cfg-heading') || headline.textContent || '');
      headline.innerHTML = (accent
        ? '<span class="otto-cfg-card__headline-accent">' + esc(accent) + '</span> '
        : '') + esc(heading);
    }
    var helper = card.querySelector('[data-cfg-cadence-helper]');
    if (helper) {
      var helperText = pickup
        ? String(card.getAttribute('data-cfg-pickup-helper-text') || '')
        : String(card.getAttribute('data-cfg-helper-text') || '');
      helper.textContent = helperText;
      helper.hidden = !helperText;
    }
    var tileTitle = card.querySelector('[data-cfg-sizing-title]');
    if (tileTitle) {
      tileTitle.textContent = pickup
        ? String(card.getAttribute('data-cfg-pickup-helper-tile-title') || 'How pickup sizing works')
        : String(card.getAttribute('data-cfg-helper-tile-title') || tileTitle.textContent);
    }
    var locked = card.querySelector('[data-cfg-locked-note]');
    if (locked) {
      locked.textContent = pickup
        ? String(card.getAttribute('data-cfg-pickup-locked-message') || 'Complete the steps above to see your pickup options.')
        : String(card.getAttribute('data-cfg-locked-message') || locked.textContent);
    }
    swapCardFulfillmentImages(card);
  });
}
/** Apply live (block/theme-editor) or founding (theme settings) copy on the delivery-day card. */
function syncDeliveryDayCopy() {
$$('[data-cfg-type="delivery_day"]').forEach(function (card) {
var headlineEl = card.querySelector('.otto-cfg-card__headline');
var helperIntro = deliveryDayIntroHelper(card);
swapCardFulfillmentImages(card);
if (pickupModeEnabled()) {
  var pickupAccent = String(card.getAttribute('data-cfg-pickup-heading-accent') || '').trim() || 'Pick-up day.';
  var pickupHeading = String(card.getAttribute('data-cfg-pickup-heading') || '').trim() || 'Pick a weekday to collect your pack.';
  if (headlineEl) {
    headlineEl.innerHTML = '<span class="otto-cfg-card__headline-accent">' + esc(pickupAccent) + '</span> ' + esc(pickupHeading);
  }
  if (helperIntro) {
    helperIntro.textContent = 'We’ll have your pack ready at our facility, ' + pickupHoursLabel() + '.';
    helperIntro.hidden = false;
  }
  card.classList.remove('is-single-delivery-day');
  return;
}
if (foundingModeEnabled()) {
if (headlineEl) {
var accent = String(card.getAttribute('data-cfg-live-heading-accent') || '').trim();
var foundingHeading = foundingCopy('deliveryDayHeading', 'Pick your preferred delivery day');
headlineEl.innerHTML = (accent
? '<span class="otto-cfg-card__headline-accent">' + esc(accent) + '</span> '
: '') + esc(foundingHeading);
}
if (helperIntro) {
helperIntro.textContent = foundingCopy(
'deliveryDayHelper',
"Choose the weekday you'd like deliveries when Otto launches in your area. You can change this anytime before your first delivery."
);
helperIntro.hidden = !helperIntro.textContent;
}
card.classList.remove('is-single-delivery-day');
return;
}
var allowed = cfgAllowedWeekdayList();
var singleDay = allowed.length === 1;
card.classList.toggle('is-single-delivery-day', singleDay);
var liveAccent = String(card.getAttribute('data-cfg-live-heading-accent') || '').trim() || 'Delivery day.';
var rawHeading = String(card.getAttribute('data-cfg-live-heading') || '').trim();
/* Prefer theme copy that includes {zone}; upgrade legacy headings without it. */
var liveHeading = (rawHeading && rawHeading.indexOf('{zone}') !== -1)
  ? rawHeading
  : "Here's when we're in {zone}.";
var zoneName = cfgDeliveryZoneDisplayName() || 'your neighborhood';
var weekdayName = singleDay ? cfgDeliveryWeekdayLabel(allowed[0].value, false) : '';
var weekdaysLabel = cfgFormatWeekdayList(allowed, false);
var tokens = {
  zone: zoneName,
  weekday: weekdayName,
  weekdays: weekdaysLabel
};
var headingText = cfgFillDeliveryDayTemplate(liveHeading, tokens);
if (headlineEl) {
headlineEl.innerHTML = (liveAccent
? '<span class="otto-cfg-card__headline-accent">' + esc(liveAccent) + '</span> '
: '') + esc(headingText);
}
if (helperIntro) {
if (singleDay) {
var singleMsg = String(card.getAttribute('data-cfg-single-day-message') || '').trim()
  || "We're currently delivering to {zone} on {weekday}s. We'll add more delivery days as they become available.";
helperIntro.textContent = cfgFillDeliveryDayTemplate(singleMsg, tokens);
} else {
var liveHelper = String(card.getAttribute('data-cfg-live-helper') || '');
helperIntro.textContent = cfgFillDeliveryDayTemplate(liveHelper, tokens);
}
helperIntro.hidden = !helperIntro.textContent;
}
});
}
/** Fill {zone} on founding pitch copy; falls back to "your ZIP" when no zone label. */
function syncFoundingPitchCopy() {
var zoneName = cfgDeliveryZoneDisplayName() || 'your ZIP';
var tokens = { zone: zoneName };
$$('[data-cfg-type="founding_pitch"]').forEach(function (card) {
var headlineEl = card.querySelector('.otto-cfg-card__headline');
if (headlineEl) {
var accentTpl = String(headlineEl.getAttribute('data-cfg-founding-accent-template') || '');
var headingTpl = String(headlineEl.getAttribute('data-cfg-founding-heading-template') || '');
var accentHtml = accentTpl ? cfgFillDeliveryDayTemplate(accentTpl, tokens) : '';
var headingHtml = headingTpl ? cfgFillDeliveryDayTemplate(headingTpl, tokens) : '';
headlineEl.innerHTML = (accentHtml
  ? '<span class="otto-cfg-card__headline-accent">' + accentHtml + '</span>' + (headingHtml ? ' ' : '')
  : '') + headingHtml;
}
var subtitleEl = card.querySelector('[data-cfg-founding-subtitle]');
if (subtitleEl) {
var subtitleTpl = String(subtitleEl.getAttribute('data-cfg-founding-subtitle-template') || '');
if (subtitleTpl) subtitleEl.innerHTML = cfgFillDeliveryDayTemplate(subtitleTpl, tokens);
}
});
}
/** Show founding pitch only after they choose to reserve (or when no choice card exists). */
function syncFoundingPitchCardVisibility() {
$$('[data-cfg-type="founding_pitch"]').forEach(function (card) {
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (foundingPitchShouldShow()) {
card.hidden = false;
card.removeAttribute('data-cfg-path-hidden');
if (selections.founding_pitch_ack && stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
} else if (stepNum) {
if (!selections.founding_pitch_ack) {
delete completedSteps[stepNum];
}
}
} else {
card.hidden = true;
card.setAttribute('data-cfg-path-hidden', '1');
card.classList.remove('is-locked', 'is-incomplete');
if (stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
}
if (!foundingModeEnabled()) delete selections.founding_pitch_ack;
if (typeof syncCardInert === 'function') syncCardInert(card);
}
});
}
function syncFoundingChoiceCardVisibility() {
$$('[data-cfg-type="founding_choice"]').forEach(function (card) {
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (foundingChoicePathActive()) {
card.hidden = false;
card.removeAttribute('data-cfg-path-hidden');
if (selections.founding_choice_ack && stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
} else if (stepNum) {
delete completedSteps[stepNum];
}
} else {
card.hidden = true;
card.setAttribute('data-cfg-path-hidden', '1');
card.classList.remove('is-locked', 'is-incomplete');
if (stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
}
if (typeof syncCardInert === 'function') syncCardInert(card);
}
});
}
function syncFoundingChoiceCopy() {
var zoneName = cfgDeliveryZoneDisplayName() || 'your area';
var tokens = {
  zone: zoneName,
  hours: pickupHoursLabel(),
  address: pickupAddressLabel() || String((pickupCfg && pickupCfg.locationName) || 'our facility')
};
$$('[data-cfg-type="founding_choice"]').forEach(function (card) {
var headlineEl = card.querySelector('.otto-cfg-card__headline');
if (headlineEl) {
var accentTpl = String(headlineEl.getAttribute('data-cfg-founding-choice-accent-template') || '');
var headingTpl = String(headlineEl.getAttribute('data-cfg-founding-choice-heading-template') || '');
var accentHtml = accentTpl ? cfgFillDeliveryDayTemplate(accentTpl, tokens) : '';
var headingHtml = headingTpl ? cfgFillDeliveryDayTemplate(headingTpl, tokens) : '';
headlineEl.innerHTML = (accentHtml
  ? '<span class="otto-cfg-card__headline-accent">' + accentHtml + '</span>' + (headingHtml ? ' ' : '')
  : '') + headingHtml;
}
var subtitleEl = card.querySelector('[data-cfg-founding-choice-subtitle]');
if (subtitleEl) {
var subtitleTpl = String(subtitleEl.getAttribute('data-cfg-founding-choice-subtitle-template') || '');
if (subtitleTpl) subtitleEl.innerHTML = cfgFillDeliveryDayTemplate(subtitleTpl, tokens);
}
var pickupHelper = card.querySelector('[data-cfg-founding-pickup-helper]');
if (pickupHelper) {
var pickupTpl = String(pickupHelper.getAttribute('data-cfg-founding-pickup-helper-template') || '');
if (pickupTpl) pickupHelper.innerHTML = cfgFillDeliveryDayTemplate(pickupTpl, tokens);
}
var notifyHelper = card.querySelector('[data-cfg-founding-notify-helper]');
if (notifyHelper) {
var notifyTpl = String(notifyHelper.getAttribute('data-cfg-founding-notify-helper-template') || '');
if (notifyTpl) notifyHelper.innerHTML = cfgFillDeliveryDayTemplate(notifyTpl, tokens);
}
});
syncFoundingChoiceSelection();
}
function foundingChoiceOwnerEmail() {
  return String((selections.owner && selections.owner.email) || '').trim();
}
function setFoundingChoiceOwnerEmail(email) {
  if (!selections.owner) selections.owner = {};
  selections.owner.email = String(email || '').trim();
  var zipEmail = $('[data-cfg-zip-email]');
  if (zipEmail && selections.owner.email) zipEmail.value = selections.owner.email;
}
function formatPickupLocationName(name) {
  return String(name || '').replace(/\bfacility\b/gi, 'Facility');
}
function foundingPickupMapUrl(addr) {
  var query = String(addr || '').replace(/\r\n|\r|\n/g, ', ').replace(/\s+/g, ' ').trim();
  if (!query) return '';
  return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
}
function foundingPickupAddressHtml() {
  var name = formatPickupLocationName(String((pickupCfg && pickupCfg.locationName) || '').trim());
  var addr = pickupAddressLabel();
  var hours = pickupHoursLabel();
  var parts = [];
  if (name) parts.push(esc(name));
  if (addr) {
    var addrHtml = '<strong>' + esc(addr).replace(/\r\n|\r|\n/g, '<br>') + '</strong>';
    var mapUrl = foundingPickupMapUrl(addr);
    if (mapUrl) {
      addrHtml = '<a class="otto-cfg-founding-choice__map-link" href="' + esc(mapUrl) + '" target="_blank" rel="noopener noreferrer">' + addrHtml + '</a>';
    }
    parts.push(addrHtml);
  }
  if (hours) parts.push(esc(hours));
  return parts.join('<br>');
}
function syncFoundingChoiceSelection() {
  $$('[data-cfg-type="founding_choice"]').forEach(function (card) {
    var pickupBtn = card.querySelector('[data-cfg-founding-pickup]');
    var reserveBtn = card.querySelector('[data-cfg-founding-reserve]');
    var notifyPanel = card.querySelector('[data-cfg-founding-notify-panel]');
    var notifyEmail = card.querySelector('[data-cfg-founding-notify-email]');
    var notifyError = card.querySelector('[data-cfg-founding-notify-email-error]');
    var addressTile = card.querySelector('[data-cfg-founding-address-tile]');
    var addressEl = card.querySelector('[data-cfg-founding-address]');
    var continueBtn = card.querySelector('[data-cfg-founding-choice-continue]');
    var continueActions = card.querySelector('[data-cfg-founding-choice-actions]');
    var notifySubmit = card.querySelector('[data-cfg-founding-choice-notify-submit]');
    var choice = normalizeFoundingChoice(selections.founding_choice);
    var pickupOn = choice === 'pickup';
    var notifyOn = choice === 'notify';
    if (pickupBtn) {
      pickupBtn.classList.toggle('is-selected', pickupOn);
      pickupBtn.setAttribute('aria-pressed', pickupOn ? 'true' : 'false');
    }
    if (reserveBtn) {
      reserveBtn.classList.toggle('is-selected', notifyOn);
      reserveBtn.setAttribute('aria-pressed', notifyOn ? 'true' : 'false');
    }
    if (notifyEmail && !notifyEmail.value) {
      var savedEmail = foundingChoiceOwnerEmail();
      if (savedEmail) notifyEmail.value = savedEmail;
    }
    var emailVal = notifyEmail ? notifyEmail.value.trim() : foundingChoiceOwnerEmail();
    var emailOk = isValidOwnerEmail(emailVal);
    if (notifyPanel) notifyPanel.hidden = !notifyOn;
    if (notifyError && (!notifyOn || emailOk || !emailVal)) notifyError.hidden = true;
    var addressHtml = foundingPickupAddressHtml();
    if (addressEl) addressEl.innerHTML = addressHtml;
    if (addressTile) addressTile.hidden = notifyOn || !addressHtml;
    if (continueActions) continueActions.hidden = notifyOn;
    if (continueBtn) continueBtn.disabled = !pickupOn;
    if (notifySubmit) notifySubmit.disabled = !(notifyOn && emailOk);
  });
}
function syncFoundingPathUi() {
if (foundingModeEnabled()) applyFoundingModeUi();
else clearFoundingModeUi();
syncFoundingChoiceCardVisibility();
syncFoundingChoiceCopy();
syncFoundingPitchCardVisibility();
syncFoundingPitchCopy();
syncWaitlistPitchCardVisibility();
syncWaitlistPitchCopy();
if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
if (typeof updateDots === 'function') updateDots(currentStep);
syncDeliveryDayCopy();
syncDeliveryCadenceCopy();
syncProductTileFoundingPrices();
if (typeof renderDeliveryTiles === 'function') renderDeliveryTiles(true);
if (typeof updateMealPrices === 'function') updateMealPrices();
if (typeof updateIncomplete === 'function') updateIncomplete();
if (typeof buildReview === 'function') buildReview();
if (typeof syncStartButtonLabel === 'function') syncStartButtonLabel();
}
function waitlistPathActive() {
if (foundingNotifySelected()) {
  return !!String(selections.zip_attempted || selections.zip || '').trim();
}
return String(selections.service_zone || '') === 'waitlist' && !!String(selections.zip_attempted || '').trim();
}
function waitlistZipToken() {
var z = String(selections.zip_attempted || selections.zip || '').trim();
return z || 'your ZIP';
}
function syncWaitlistPitchCopy() {
var zip = waitlistZipToken();
var tokens = { zip: zip, zone: zip };
$$('[data-cfg-type="waitlist_pitch"]').forEach(function (card) {
var headlineEl = card.querySelector('.otto-cfg-card__headline');
if (headlineEl) {
var accentTpl = String(headlineEl.getAttribute('data-cfg-waitlist-accent-template') || '');
var headingTpl = String(headlineEl.getAttribute('data-cfg-waitlist-heading-template') || '');
var accentHtml = accentTpl ? cfgFillDeliveryDayTemplate(accentTpl, tokens) : '';
var headingHtml = headingTpl ? cfgFillDeliveryDayTemplate(headingTpl, tokens) : '';
headlineEl.innerHTML = (accentHtml
  ? '<span class="otto-cfg-card__headline-accent">' + accentHtml + '</span>' + (headingHtml ? ' ' : '')
  : '') + headingHtml;
}
var subtitleEl = card.querySelector('[data-cfg-waitlist-subtitle]');
if (subtitleEl) {
var subtitleTpl = String(subtitleEl.getAttribute('data-cfg-waitlist-subtitle-template') || '');
if (subtitleTpl) subtitleEl.innerHTML = cfgFillDeliveryDayTemplate(subtitleTpl, tokens);
}
});
}
/** Show waitlist pitch only on waitlist ZIPs; hide downstream plan cards. */
function syncWaitlistPitchCardVisibility() {
var onWaitlist = waitlistPathActive();
var zipCardEl = $('[data-cfg-type="zip_validator"]');
var zipStep = zipCardEl ? parseInt(zipCardEl.getAttribute('data-cfg-step'), 10) : 0;
$$('[data-cfg-type="waitlist_pitch"]').forEach(function (card) {
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (onWaitlist) {
card.hidden = false;
card.removeAttribute('data-cfg-path-hidden');
if (stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
}
} else {
card.hidden = true;
card.setAttribute('data-cfg-path-hidden', '1');
card.classList.remove('is-locked', 'is-incomplete');
if (stepNum) {
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
}
if (typeof syncCardInert === 'function') syncCardInert(card);
}
});
$$('[data-cfg-step]').forEach(function (card) {
var type = card.getAttribute('data-cfg-type');
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (!type || type === 'waitlist_pitch' || type === 'zip_validator' || type === 'founding_pitch' || type === 'founding_choice') return;
if (!zipStep || !stepNum || stepNum <= zipStep) {
if (card.getAttribute('data-cfg-waitlist-hidden') === '1' && !onWaitlist) {
card.removeAttribute('data-cfg-waitlist-hidden');
card.hidden = false;
card.removeAttribute('data-cfg-path-hidden');
if (typeof syncCardInert === 'function') syncCardInert(card);
}
return;
}
if (onWaitlist) {
card.hidden = true;
card.setAttribute('data-cfg-waitlist-hidden', '1');
card.setAttribute('data-cfg-path-hidden', '1');
card.classList.remove('is-locked', 'is-incomplete');
completedSteps[stepNum] = true;
everCompletedSteps[stepNum] = true;
if (typeof syncCardInert === 'function') syncCardInert(card);
} else if (card.getAttribute('data-cfg-waitlist-hidden') === '1') {
card.removeAttribute('data-cfg-waitlist-hidden');
card.hidden = false;
card.removeAttribute('data-cfg-path-hidden');
if (typeof syncCardInert === 'function') syncCardInert(card);
}
});
if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
}
    function updateMealPrices() {
      updateProductMealSummary();
updateDogInfoPortionSummary();
updateProductMealFootnote();
      if (selections.per_dog_protein) {
        var productCard = $('[data-cfg-type="product_selector"]');
        if (productCard && productCard._updatePerDogMealPrices) {
          productCard._updatePerDogMealPrices();
        }
      }
      saveProgressState();
    }
function updateDogInfoPortionSummary() {
var summaryEls = $$('[data-cfg-doginfo-portion-summary]');
if (!summaryEls.length) return;
var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
var perDogPortions = [];
dogs.forEach(function (dog, idx) {
var oz = getDogSnappedPortionOz(dog);
if (!(oz > 0)) return;
var dogName = titleCase((dog && dog.name) ? dog.name : '');
var name = dogName || ('Dog ' + (idx + 1));
var fullOz = Math.round(oz);
var rawPct = Number(dog && dog.raw_percent);
var text = esc(name) + ': ' + fullOz + ' oz / day';
if (rawPct > 0 && normalizeRawPercent(rawPct) < 100) {
var ottoOz = Math.round(effectivePortionOz(oz, rawPct));
var regularOz = Math.max(0, fullOz - ottoOz);
text = esc(name) + ': ' + ottoOz + ' oz <b>otto</b> · ' + regularOz + ' oz regular food';
}
var stageMeals = stageMealsPerDay(dog && dog.life_stage);
if (stageMeals > 0) {
var perFeeding = oz / stageMeals;
var perFeedingText = perFeeding >= 10 ? String(Math.round(perFeeding)) : perFeeding.toFixed(1).replace(/\.0$/, '');
text += ' · ' + stageMeals + ' feedings of ~' + perFeedingText + ' oz';
}
perDogPortions.push(text);
});
summaryEls.forEach(function (el) {
var tile = el.closest('.otto-cfg-product-estimate-tile');
if (!perDogPortions.length) {
el.innerHTML = '';
el.hidden = true;
if (tile) tile.hidden = true;
return;
}
el.innerHTML = perDogPortions.map(function (line) {
return '<div>' + line + '</div>';
}).join('');
el.hidden = false;
if (tile) tile.hidden = false;
});
}
    function updateProductMealSummary() {
      var summaryEls = $$('[data-cfg-product-meal-summary]');
      if (!summaryEls.length) return;
      var mealsPerDay = getMealsPerDay();
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      var perDogCosts = [];
      var isReady = true;
function getDisplayName(rawName, fallbackName) {
        var name = (rawName || '').trim();
        if (!name) name = fallbackName;
return name || '';
      }
      function addPerDogCost(idx, dog, cents) {
        var dailyLb = dogEffectiveDailyLb(dog);
        var priceCents = Number(cents || 0);
        var foundingPct = foundingOngoingPctForDisplay();
        if (foundingPct) priceCents = discountedPriceCents(priceCents, foundingPct);
        /* Young puppies split the day across 3-4 feedings, so their per-meal
         * cost divides by the stage-recommended frequency. */
        var dogMeals = mealsPerDayForDogDisplay(dog, mealsPerDay);
        if (!(dailyLb > 0) || priceCents <= 0 || dogMeals <= 0) return false;
        /* priceCents is the per-lb variant price; use ladder-snapped daily lb */
        var perMeal = (priceCents / 100) * dailyLb / dogMeals;
        var dogName = titleCase((dog && dog.name) ? dog.name : '');
var displayName = getDisplayName(dogName, 'Dog ' + (idx + 1));
        perDogCosts.push({
label: displayName,
          value: perMeal
        });
        return true;
      }
      /* Per-dog meal counts are resolved in addPerDogCost (stage override or
       * household setting), so only require dogs here. */
      if (!dogs.length) {
        isReady = false;
      } else if (selections.per_dog_protein) {
        var dogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins : [];
        if (dogProteins.length !== dogs.length) {
          isReady = false;
        } else {
          var proteinByDogIdx = {};
          dogProteins.forEach(function (dp) {
            var idx = parseInt(dp.dogIdx, 10);
            if (!isNaN(idx)) proteinByDogIdx[idx] = dp;
          });
          dogs.forEach(function (dog, i) {
            if (!isReady) return;
            var dp = proteinByDogIdx[i];
            if (!dp || !addPerDogCost(i, dog, priceCentsForDogProteinRow(dp))) {
              isReady = false;
            }
          });
        }
      } else {
        var hhList = getHouseholdProteinList();
        var cents = averageRecipePriceCents(hhList);
        if (!(cents > 0)) cents = Number(selections.product_price || 0);
        if (cents <= 0) {
          isReady = false;
        } else {
          dogs.forEach(function (dog, i) {
            if (!isReady) return;
            if (!addPerDogCost(i, dog, cents)) isReady = false;
          });
        }
      }
      summaryEls.forEach(function (el) {
        if (isReady && perDogCosts.length) {
          if (perDogCosts.length === 1) {
            var one = perDogCosts[0];
            el.textContent = one.label + ': $' + one.value.toFixed(2) + '/meal';
          } else {
            el.textContent = '';
            perDogCosts.forEach(function (entry) {
              var line = document.createElement('div');
              line.textContent = entry.label + ': $' + entry.value.toFixed(2) + '/meal';
              el.appendChild(line);
            });
          }
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    }
function mealFootnoteCopyFor(meals) {
if (meals === 1) return '¹Feeding one meal per day';
if (meals === 2) return '¹Feeding two meals per day';
return '¹Feeding ' + meals + ' meals per day';
}
function updateProductMealFootnote() {
var copyEls = $$('[data-cfg-product-meal-footnote-copy]');
var toggleBtns = $$('[data-cfg-product-meal-footnote-toggle]');
if (!copyEls.length && !toggleBtns.length) return;
var mealsPerDay = getMealsPerDay() === 1 ? 1 : 2;
/* Growth-stage dogs override the household frequency (4x/day at 8-16 wks,
 * 3x/day at 4-6 mo), so the footnote reflects each dog's effective rate. */
var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
var uniqueMeals = [];
dogs.forEach(function (dog) {
var m = mealsPerDayForDogDisplay(dog, mealsPerDay);
if (m > 0 && uniqueMeals.indexOf(m) === -1) uniqueMeals.push(m);
});
var copy;
if (uniqueMeals.length === 1) {
copy = mealFootnoteCopyFor(uniqueMeals[0]);
} else if (uniqueMeals.length > 1) {
// Mixed household (e.g. a puppy and an adult): name each dog's rate.
copy = '¹' + dogs.map(function (dog, idx) {
var name = titleCase((dog && dog.name) || '') || ('Dog ' + (idx + 1));
return name + ': ' + mealsPerDayForDogDisplay(dog, mealsPerDay) + ' meals/day';
}).join(' \u00b7 ');
} else {
copy = mealFootnoteCopyFor(mealsPerDay);
}
copyEls.forEach(function (el) {
el.textContent = copy;
});
var aria = mealsPerDay === 1 ? 'Switch to twice per day' : 'Switch to once per day';
toggleBtns.forEach(function (btn) {
btn.setAttribute('aria-label', aria);
});
}
/* ---- Lock/unlock logic ---- */
    function syncCardInert(card) {
      if (!card) return;
      var blocked = card.classList.contains('is-locked') || card.classList.contains('is-incomplete');
      if (blocked) card.setAttribute('inert', '');
      else card.removeAttribute('inert');
    }
    function syncAllCardsInert() {
      allCards.forEach(syncCardInert);
    }
    (function initLocks() {
      var lockCards = $$('[data-locks-remaining="true"]');
      lockCards.forEach(function (lockCard) {
        var lockStep = parseInt(lockCard.getAttribute('data-cfg-step'), 10);
        allCards.forEach(function (card) {
          var step = parseInt(card.getAttribute('data-cfg-step'), 10);
          if (step > lockStep) card.classList.add('is-locked');
        });
      });
      syncAllCardsInert();
    })();
    function unlockCardsAfter(stepNum) {
      // Only unlock up to (and including) the next gate card, so sequential gates
      // chain correctly: passing one gate reveals cards up to the next gate, but
      // the cards that gate guards stay locked until it is also satisfied.
      var nextGateStep = Infinity;
      allCards.forEach(function (card) {
        if (!card.hasAttribute('data-locks-remaining')) return;
        var gateStep = parseInt(card.getAttribute('data-cfg-step'), 10);
        if (gateStep > stepNum && gateStep < nextGateStep) nextGateStep = gateStep;
      });
      var toUnlock = [];
      allCards.forEach(function (card) {
        var step = parseInt(card.getAttribute('data-cfg-step'), 10);
        if (step > stepNum && step <= nextGateStep && card.classList.contains('is-locked')) toUnlock.push(card);
      });
      toUnlock.forEach(function (card, i) {
        setTimeout(function () {
          card.classList.remove('is-locked');
          syncCardInert(card);
        }, i * 80);
      });
    }
/* ---- Scroll-driven image and dot switching ---- */
    function updateImage(n) {
      $$('[data-cfg-img]').forEach(function (img) {
        var idx = parseInt(img.getAttribute('data-cfg-img'), 10);
        img.classList.toggle('is-active', idx === n);
      });
var productCard = $('[data-cfg-type="product_selector"]');
var productStep = productCard ? parseInt(productCard.getAttribute('data-cfg-step') || '0', 10) : 0;
var showProteinGallery = !!(productCard && productStep && n === productStep);
if (productCard && productCard._toggleProteinGallery) productCard._toggleProteinGallery(showProteinGallery);
if (showProteinGallery && productCard && productCard._syncProteinGalleryFromSelection) {
productCard._syncProteinGalleryFromSelection();
}
}
function getProteinMediaSlides(card) {
if (!card) return [];
var slides = [];
var seen = {};
card.querySelectorAll('.otto-cfg-tile--product[data-cfg-tile-value]').forEach(function (tile) {
var protein = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
if (!protein) return;
var key = protein.toLowerCase();
if (seen[key]) return;
seen[key] = true;
var src = String(tile.getAttribute('data-product-image-src') || '').trim();
if (!src) return;
slides.push({
protein: protein,
src: src,
alt: String(tile.getAttribute('data-product-image-alt') || protein).trim() || protein
});
});
return slides;
}
function getProductCardSelectedProtein(card) {
if (!card) return '';
if (selections.per_dog_protein) {
var activeGroup = card.querySelector('[data-cfg-protein-dog]:not([hidden])');
var activeGroupSelection = activeGroup ? activeGroup.querySelector('.otto-cfg-tile--product.is-selected') : null;
if (activeGroupSelection) return String(activeGroupSelection.getAttribute('data-cfg-tile-value') || '').trim();
}
var selectedSingle = card.querySelector('[data-cfg-protein-single] .otto-cfg-tile--product.is-selected');
if (selectedSingle) return String(selectedSingle.getAttribute('data-cfg-tile-value') || '').trim();
return String(selections.protein || '').trim();
}
function clearProteinGallerySplit(card) {
if (!card) return;
[card._proteinDesktopGalleryEl, card._proteinMobileGalleryEl].forEach(function (el) {
if (el) el.classList.remove('is-split');
});
function clearImgs(list) {
if (!Array.isArray(list)) return;
list.forEach(function (img) {
img.classList.remove('is-split-pane', 'is-split-left', 'is-split-right');
});
}
function clearLabels(list) {
if (!Array.isArray(list)) return;
list.forEach(function (label) {
label.classList.remove('is-split-left', 'is-split-right');
});
}
clearImgs(card._proteinDesktopSlideEls);
clearImgs(card._proteinMobileSlideEls);
clearLabels(card._proteinDesktopLabelEls);
clearLabels(card._proteinMobileLabelEls);
}
function getSelectedProteinSlideIndexes(card) {
if (!card || !Array.isArray(card._proteinMediaSlides) || !card._proteinMediaSlides.length) return [];
var root = selections.per_dog_protein
? card.querySelector('[data-cfg-protein-dog]:not([hidden])')
: card.querySelector('[data-cfg-protein-single]');
var names = [];
if (root) {
root.querySelectorAll('.otto-cfg-tile--product.is-selected').forEach(function (tile) {
var name = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
if (name) names.push(name);
});
}
if (!names.length) {
var fallback = String(selections.protein || '').trim();
if (fallback) names.push(fallback);
}
var indexes = [];
names.forEach(function (name) {
var key = name.toLowerCase();
for (var i = 0; i < card._proteinMediaSlides.length; i++) {
if (String(card._proteinMediaSlides[i].protein || '').trim().toLowerCase() === key) {
if (indexes.indexOf(i) < 0) indexes.push(i);
break;
}
}
});
return indexes;
}
function applyProteinGallerySplit(card, leftIdx, rightIdx) {
function mark(imgs) {
if (!Array.isArray(imgs)) return;
imgs.forEach(function (img, i) {
var left = i === leftIdx;
var right = i === rightIdx;
img.classList.toggle('is-split-pane', left || right);
img.classList.toggle('is-split-left', left);
img.classList.toggle('is-split-right', right);
img.classList.toggle('is-active', left || right);
});
}
function markLabels(labels) {
if (!Array.isArray(labels)) return;
labels.forEach(function (label, i) {
label.classList.toggle('is-split-left', i === leftIdx);
label.classList.toggle('is-split-right', i === rightIdx);
});
}
[card._proteinDesktopGalleryEl, card._proteinMobileGalleryEl].forEach(function (el) {
if (el) el.classList.add('is-split');
});
mark(card._proteinDesktopSlideEls);
mark(card._proteinMobileSlideEls);
markLabels(card._proteinDesktopLabelEls);
markLabels(card._proteinMobileLabelEls);
}
function setProteinGalleryIndex(card, nextIndex) {
if (!card || !Array.isArray(card._proteinMediaSlides) || !card._proteinMediaSlides.length) return;
clearProteinGallerySplit(card);
var maxIndex = card._proteinMediaSlides.length - 1;
var idx = Number(nextIndex);
if (!isFinite(idx)) idx = 0;
if (idx < 0) idx = maxIndex;
if (idx > maxIndex) idx = 0;
card._proteinMediaIndex = idx;
if (Array.isArray(card._proteinDesktopSlideEls)) {
card._proteinDesktopSlideEls.forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
}
if (Array.isArray(card._proteinDesktopDotEls)) {
card._proteinDesktopDotEls.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
}
if (Array.isArray(card._proteinMobileSlideEls)) {
card._proteinMobileSlideEls.forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
}
if (Array.isArray(card._proteinMobileDotEls)) {
card._proteinMobileDotEls.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
}
}
function setProteinGalleryByProtein(card, proteinName) {
if (!card || !Array.isArray(card._proteinMediaSlides) || !card._proteinMediaSlides.length) return;
var requested = String(proteinName || '').trim().toLowerCase();
if (!requested) return;
for (var i = 0; i < card._proteinMediaSlides.length; i++) {
if (String(card._proteinMediaSlides[i].protein || '').trim().toLowerCase() === requested) {
setProteinGalleryIndex(card, i);
return;
}
}
}
function syncProteinGalleryFromSelection(card) {
if (!card) return;
if (card._ensureProteinGallery) card._ensureProteinGallery();
var indexes = getSelectedProteinSlideIndexes(card);
if (indexes.length === 2) {
applyProteinGallerySplit(card, indexes[0], indexes[1]);
} else {
clearProteinGallerySplit(card);
var protein = indexes.length
? String((card._proteinMediaSlides[indexes[0]] && card._proteinMediaSlides[indexes[0]].protein) || '')
: getProductCardSelectedProtein(card);
if (protein) setProteinGalleryByProtein(card, protein);
}
if (card._toggleProteinGallery) {
var cardStep = parseInt(card.getAttribute('data-cfg-step') || '0', 10);
var isActiveProductStep = !!cardStep && currentStep === cardStep;
card._toggleProteinGallery(isActiveProductStep);
}
}
    function isCardVisible(card) {
if (!card || card.hidden) return false;
var style = window.getComputedStyle(card);
if (!style) return true;
if (style.display === 'none' || style.visibility === 'hidden') return false;
return true;
}
    function getNextVisibleCard(fromStepNum) {
      for (var i = Math.max(1, Number(fromStepNum || 0) + 1); i <= TOTAL_STEPS; i++) {
        var card = $('[data-cfg-step="' + i + '"]');
if (card) {
var cardType = card.getAttribute('data-cfg-type');
if (cardType === 'feeding_setup' && card._syncFeedingSetupUI) card._syncFeedingSetupUI();
if (cardType === 'feeding_protein_mode' && card._syncFeedingProteinModeUI) card._syncFeedingProteinModeUI();
}
        if (isCardVisible(card)) return card;
      }
      return null;
    }
    function getPreviousVisibleStepNum(stepNum) {
      var current = parseInt(stepNum, 10);
      if (!current || current <= 1) return 0;
      for (var i = current - 1; i >= 1; i--) {
        var card = $('[data-cfg-step="' + i + '"]');
        if (isCardVisible(card)) return i;
      }
      return 0;
    }
function getNextRequiredVisibleStepNum() {
for (var i = 1; i <= TOTAL_STEPS; i++) {
var card = $('[data-cfg-step="' + i + '"]');
if (!isCardVisible(card)) continue;
if (!isCanonicalStepComplete(i)) return i;
}
return 0;
}
    function updateDots(n) {
var activeStep = getNextRequiredVisibleStepNum();
if (!activeStep) activeStep = Number(n) || 1;
var visibleStepNums = [];
      for (var i = 1; i <= TOTAL_STEPS; i++) {
        var dot = $('[data-cfg-dot="' + i + '"]');
        if (!dot) continue;
        var card = $('[data-cfg-step="' + i + '"]');
        var stepVisible = isCardVisible(card);
        dot.hidden = !stepVisible;
        /* Visual-only markers; step position is announced via data-cfg-dots-status. */
        dot.setAttribute('aria-hidden', 'true');
var stepCompleted = isCanonicalStepComplete(i);
        dot.classList.remove('is-active', 'is-past');
        if (stepVisible) {
visibleStepNums.push(i);
if (i === activeStep) dot.classList.add('is-active');
else if (stepCompleted) dot.classList.add('is-past');
        }
        if (i > 1) {
          var line = $('[data-cfg-line="' + i + '"]');
          if (line) {
            line.hidden = !stepVisible;
            line.setAttribute('aria-hidden', 'true');
var prevStep = getPreviousVisibleStepNum(i);
var prevCard = prevStep > 0 ? $('[data-cfg-step="' + prevStep + '"]') : null;
var prevVisible = isCardVisible(prevCard);
var prevCompleted = prevStep > 0 && prevVisible && isCanonicalStepComplete(prevStep);
line.classList.toggle('is-filled', stepVisible && prevCompleted);
}
}
}
var statusEl = $('[data-cfg-dots-status]');
if (statusEl && visibleStepNums.length) {
  var ordinal = visibleStepNums.indexOf(activeStep) + 1;
  if (ordinal < 1) ordinal = 1;
  statusEl.textContent = 'Step ' + ordinal + ' of ' + visibleStepNums.length;
}
}
    function updateIncomplete() {
      allCards.forEach(function (card) {
        if (card.hidden) {
          card.classList.remove('is-incomplete');
          syncCardInert(card);
          return;
        }
        var step = parseInt(card.getAttribute('data-cfg-step'), 10);
        if (step === 1) {
          card.classList.remove('is-incomplete');
          syncCardInert(card);
          return;
        }
if (isCanonicalStepComplete(step)) {
markStepCompleted(step);
card.classList.remove('is-incomplete');
syncCardInert(card);
return;
}
        var requiredPrevStep = getPreviousVisibleStepNum(step);
var prevMarkedComplete = requiredPrevStep > 0 && !!completedSteps[requiredPrevStep];
if (!prevMarkedComplete && requiredPrevStep > 0 && isCanonicalStepComplete(requiredPrevStep)) {
markStepCompleted(requiredPrevStep);
prevMarkedComplete = true;
}
if (requiredPrevStep > 0 && !prevMarkedComplete) {
          card.classList.add('is-incomplete');
        } else {
          card.classList.remove('is-incomplete');
        }
        syncCardInert(card);
      });
      updateResetBarVisibility();
      updateZipResetVisibility();
      var ownerCardForReset = $('[data-cfg-type="owner_name"]');
      if (ownerCardForReset && ownerCardForReset._syncOwnerResetVisibility) ownerCardForReset._syncOwnerResetVisibility();
      saveProgressState();
    }
    function hasAnyProgress() {
      if (Object.keys(completedSteps).length > 0) return true;
      if (selections.zip) return true;
      if (Array.isArray(selections.dogs_basic) && selections.dogs_basic.some(function (dog) {
        return !!(dog && (dog.name || dog.breed || dog.weight || dog.sex));
      })) return true;
      if (Array.isArray(selections.dogs) && selections.dogs.length > 0) return true;
      if (selections.protein || selections.per_dog_protein || selections.meals_per_day) return true;
      if (selections.totes || selections.delivery_interval) return true;
      if (cfgWeekdayChosen(normalizeCfgDeliveryWeekday(selections.delivery_weekday))) return true;
      if (Array.isArray(selections.subscriptions) && selections.subscriptions.length > 0) return true;
      return false;
    }
    function updateResetBarVisibility() {
      if (!resetUtilityBar) return;
      var visible = hasAnyProgress() && currentStep > 1;
      var wasVisible = resetUtilityBar.classList.contains('is-visible');
      resetUtilityBar.classList.toggle('is-visible', visible);
      resetUtilityBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible !== wasVisible) {
        sizeMedia();
      }
    }
    /* "Start over" only earns its place once there's real progress to lose —
     * at least two completed cards — not the moment someone starts typing. */
    function startOverVisible() {
      var count = 0;
      for (var key in completedSteps) {
        if (completedSteps[key]) count++;
      }
      return count >= 2;
    }
    function updateZipResetVisibility() {
      if (!zipResetAction) return;
      var visible = startOverVisible();
      zipResetAction.hidden = !visible;
      zipResetAction.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
    function getStepByType(type) {
      var card = $('[data-cfg-type="' + type + '"]');
      return card ? parseInt(card.getAttribute('data-cfg-step'), 10) : 0;
    }
    function clearStepCompletionsAfter(stepNum) {
      if (!stepNum) return;
      for (var i = stepNum + 1; i <= TOTAL_STEPS; i++) {
        delete completedSteps[i];
      }
    }
    function hasValidDogsBasicSelection() {
      if (!Array.isArray(selections.dogs_basic) || !selections.dogs_basic.length) return false;
      for (var i = 0; i < selections.dogs_basic.length; i++) {
        var dog = selections.dogs_basic[i];
        if (!dog) return false;
        if (!String(dog.name || '').trim()) return false;
        if (!String(dog.breed || '').trim()) return false;
        if (!String(dog.sex || '').trim()) return false;
        var weight = Number(dog.weight || 0);
        if (!weight || weight <= 0) return false;
      }
      return true;
    }
function hasValidDogInfoSelection() {
if (!hasValidDogsBasicSelection()) return false;
for (var i = 0; i < selections.dogs_basic.length; i++) {
var dog = selections.dogs_basic[i];
if (!dog) return false;
var stage = String(dog.life_stage || '').trim();
if (!stage) return false;
/* Activity and goal are only asked for non-growth dogs; puppies' growth
 * curve is the goal, and their metabolism runs high regardless. */
if (!isGrowthStageKey(stage)) {
if (!String(dog.activity || '').trim()) return false;
if (!String(dog.goal || '').trim()) return false;
}
}
if (!Array.isArray(selections.dogs) || selections.dogs.length !== selections.dogs_basic.length) return false;
for (var portionIdx = 0; portionIdx < selections.dogs.length; portionIdx++) {
var portionDog = selections.dogs[portionIdx];
if (!(Number(portionDog && portionDog.raw_percent) > 0)) return false;
if (normalizeRawPercent(portionDog.raw_percent) >= 100 && !isRawPortionDogComplete(portionDog)) return false;
}
return true;
}
    function hasValidDietSelection() {
      if (!hasValidDogsBasicSelection()) return false;
      if (!Array.isArray(selections.dogs) || !selections.dogs.length) return false;
      if (selections.dogs.length !== selections.dogs_basic.length) return false;
      for (var i = 0; i < selections.dogs.length; i++) {
        var dog = selections.dogs[i];
        if (!dog) return false;
        var stage = String(dog.life_stage || '').trim();
        if (!stage) return false;
        /* Match the profile card: growth dogs are not asked for activity. */
        if (!isGrowthStageKey(stage) && !String(dog.activity || '').trim()) return false;
        var weight = Number(dog.weight || 0);
        if (!weight || weight <= 0) return false;
      }
      return true;
    }
function getNormalizedPerDogProteinMap(requiredCount, sourceRows, sourceDogs) {
var map = {};
var rows = Array.isArray(sourceRows) ? sourceRows : (Array.isArray(selections.dog_proteins) ? selections.dog_proteins : []);
if (!rows.length) return map;
var dogs = Array.isArray(sourceDogs) ? sourceDogs : (Array.isArray(selections.dogs) ? selections.dogs : []);
var byDogName = {};
dogs.forEach(function (dog, idx) {
var nameKey = String((dog && dog.name) || '').trim().toLowerCase();
if (nameKey) byDogName[nameKey] = idx;
});
var hasZeroBased = rows.some(function (row) {
return Number(row && row.dogIdx) === 0;
});
var hasOneBased = !hasZeroBased && rows.some(function (row) {
return Number(row && row.dogIdx) === 1;
});
rows.forEach(function (row) {
if (!row) return;
var protein = String(row.protein || '').trim();
if (!protein) return;
var rawIdx = Number(row.dogIdx);
var idx = -1;
if (isFinite(rawIdx)) {
idx = hasOneBased ? (rawIdx - 1) : rawIdx;
}
if (idx < 0 || idx >= requiredCount) {
var rowName = String(row.dogName || '').trim().toLowerCase();
if (rowName && typeof byDogName[rowName] === 'number') idx = byDogName[rowName];
}
if (idx < 0 || idx >= requiredCount) return;
if (!map[idx]) map[idx] = protein;
});
return map;
}
    function hasValidProductSelection() {
      if (!hasValidDietSelection()) return false;
      if (selections.per_dog_protein) {
        if (!Array.isArray(selections.dog_proteins) || !selections.dog_proteins.length) return false;
        var requiredCount = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
        if (!requiredCount || selections.dog_proteins.length < requiredCount) return false;
var normalizedMap = getNormalizedPerDogProteinMap(requiredCount);
        for (var i = 0; i < requiredCount; i++) {
if (!String(normalizedMap[i] || '').trim()) return false;
        }
        return true;
      }
      if (String(selections.protein || '').trim()) return true;
      return getHouseholdProteinList().length > 0;
    }
function hasValidFeedingSetupSelection() {
if (!isFeedingSetupCardInteractable()) return true;
var dietDogsCount = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
var infoDogsCount = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
var dogCount = Math.max(dietDogsCount, infoDogsCount);
var dogs = [];
if (dietDogsCount >= dogCount && dietDogsCount > 0) dogs = selections.dogs;
else if (infoDogsCount >= dogCount && infoDogsCount > 0) dogs = selections.dogs_basic;
else if (dietDogsCount > 0) dogs = selections.dogs;
else if (infoDogsCount > 0) dogs = selections.dogs_basic;
if (dogCount > 1) {
for (var i = 0; i < dogs.length; i++) {
if (!isFeedingSetupDogComplete(dogs[i])) return false;
}
return dogs.length >= dogCount;
}
var meals = getMealsPerDay();
if (meals !== 1 && meals !== 2) return false;
return String(selections.meals_per_day_source || '').trim().toLowerCase() === 'user';
}
function isFeedingSetupDogComplete(dog) {
return !!(dog && dog.feeding_meals_user_selected && (parseInt(dog.meals_per_day, 10) === 1 || parseInt(dog.meals_per_day, 10) === 2));
}
function hasValidFeedingProteinModeSelection() {
if (!$('[data-cfg-type="feeding_protein_mode"]')) return true;
var dietDogsCount = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
var infoDogsCount = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
var dogCount = Math.max(dietDogsCount, infoDogsCount);
if (dogCount > 1) return typeof selections.per_dog_protein === 'boolean';
return true;
}
    function hasValidFreezerSpaceSelection() {
      if (!$('[data-cfg-type="freezer_space"]')) return true;
      var profile = String(selections.freezer_space_profile || '').trim();
      return profile === 'standard' || profile === 'extra' || profile === 'large';
    }
    function hasValidDeliverySelection() {
      if (!hasValidFreezerSpaceSelection()) return false;
      if (Array.isArray(selections.subscriptions) && selections.subscriptions.length) {
        return selections.subscriptions.every(function (sub) {
          return Number(sub && (sub.lbs || sub.totes)) > 0 && Number(sub && sub.interval) > 0;
        });
      }
      return Number(selections.delivery_lbs || selections.totes || 0) > 0 && Number(selections.delivery_interval || 0) > 0;
    }
    function hasValidDeliveryDaySelection() {
      if (foundingModeEnabled()) return true;
      var ddCard = $('[data-cfg-type="delivery_day"]');
      if (!ddCard || ddCard.hidden) return true;
      if (!hasValidDeliverySelection()) return false;
      var wd = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
      if (!cfgWeekdayChosen(wd)) return false;
      return cfgAllowedWeekdayList().some(function (w) { return w.value === wd; });
    }
    function hasValidStandardDeliverySelection() {
      if (!hasValidFreezerSpaceSelection()) return false;
      if (selections.freezer_program) return false;
      if (Array.isArray(selections.subscriptions) && selections.subscriptions.length) {
        if (selections.subscriptions.some(function (sub) { return !!(sub && sub.freezer_program); })) return false;
        return selections.subscriptions.every(function (sub) {
          return Number(sub && (sub.lbs || sub.totes)) > 0 && Number(sub && sub.interval) > 0;
        });
      }
      return Number(selections.delivery_lbs || selections.totes || 0) > 0 && Number(selections.delivery_interval || 0) > 0;
    }
function isValidOwnerEmail(value) {
return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}
function submitOwnerGuideToKlaviyo(card, email, familiarity) {
try {
if (!card) return Promise.resolve({ ok: false, skipped: 'no_card' });
var publicKey = String(card.getAttribute('data-cfg-klaviyo-public-key') || '').trim();
var listId = String(card.getAttribute('data-cfg-klaviyo-list-id') || '').trim();
var cleanEmail = String(email || '').trim();
if (!cleanEmail || !isValidOwnerEmail(cleanEmail)) {
return Promise.resolve({ ok: false, skipped: 'invalid_email' });
}
if (!publicKey || !listId) {
return Promise.resolve({ ok: false, skipped: 'not_configured' });
}
var body = {
data: {
type: 'subscription',
attributes: {
custom_source: 'Onboarding Bonus Guide',
profile: {
data: {
type: 'profile',
attributes: {
email: cleanEmail,
properties: { raw_familiarity: String(familiarity || '') },
subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
}
}
}
},
relationships: { list: { data: { type: 'list', id: listId } } }
}
};
return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
method: 'POST',
headers: {
'Content-Type': 'application/json',
revision: '2024-10-15'
},
body: JSON.stringify(body)
}).then(function (res) {
return { ok: res.ok || res.status === 202, status: res.status };
}).catch(function (err) {
if (window && window.console && console.warn) console.warn('Klaviyo bonus-guide submit failed:', err);
return { ok: false, error: true };
});
} catch (err) {
if (window && window.console && console.warn) console.warn('Klaviyo bonus-guide submit error:', err);
return Promise.resolve({ ok: false, error: true });
}
}
function ownerState() {
return (selections.owner && typeof selections.owner === 'object') ? selections.owner : {};
}
function hasValidOwnerName() {
return !!String(ownerState().name || '').trim();
}
function hasValidOwnerFeeding() {
var owner = ownerState();
var hasFamiliarity = !!String(owner.familiarity || '').trim();
var email = String(owner.email || '').trim();
return hasFamiliarity && (!email || isValidOwnerEmail(email));
}
function isCanonicalStepComplete(stepNum) {
if (!stepNum) return false;
var card = $('[data-cfg-step="' + stepNum + '"]');
if (!card) return false;
var type = card.getAttribute('data-cfg-type');
if (type === 'owner_name') return hasValidOwnerName();
if (type === 'owner_feeding') return hasValidOwnerFeeding();
if (type === 'zip_validator') {
  var zipGateCard = $('[data-cfg-type="zip_validator"]');
  var zipNeedsTerms = !!(zipGateCard && zipGateCard.querySelector('[data-cfg-zip-terms]'));
  if (waitlistPathActive()) {
    if (zipNeedsTerms) return !!(selections.owner && selections.owner.terms_accepted);
    return true;
  }
  if (!String(selections.zip || '').trim()) return false;
  if (zipNeedsTerms) {
    return !!(selections.owner && selections.owner.terms_accepted);
  }
  return true;
}
if (type === 'founding_choice') {
  if (!foundingChoicePathActive()) return true;
  return !!selections.founding_choice_ack &&
    (selections.founding_choice === 'pickup' || foundingNotifySelected());
}
if (type === 'founding_pitch') {
  if (!foundingPitchShouldShow()) return true;
  return !!selections.founding_pitch_ack;
}
if (type === 'waitlist_pitch') {
  return true;
}
if (type === 'dog_info') return hasValidDogInfoSelection();
if (type === 'raw_portion_check') return hasValidRawPortionSelection();
if (type === 'raw_share') return hasValidRawShareSelection();
if (type === 'dog_profile') return hasValidDogsBasicSelection();
if (type === 'diet_profile') return hasValidDietSelection();
if (type === 'feeding_setup') return hasValidFeedingSetupSelection();
if (type === 'feeding_protein_mode') return hasValidFeedingProteinModeSelection();
if (type === 'product_selector') return hasValidProductSelection();
if (type === 'freezer_space') return hasValidFreezerSpaceSelection();
if (type === 'delivery_calculator') return hasValidDeliverySelection();
if (type === 'delivery_day') return hasValidDeliveryDaySelection();
if (type === 'freezer_program') return !!selections.freezer_program;
return false;
}
    function hasCompleteFreezerAllocation() {
      var total = 0;
      var allocations = Array.isArray(selections.freezer_allocations) ? selections.freezer_allocations : [];
      allocations.forEach(function (row) {
        total += Math.max(0, Math.floor(Number((row && row.totes) || 0)));
      });
      return total > 0 && total === Math.max(0, Math.floor(Number(FREEZER_CAPACITY.totes || 0)));
    }
    function shouldShowFreezerProgramCard() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return false;
      if (selections.freezer_program) return true;
      if (!hasValidStandardDeliverySelection()) return false;
      var totalDaily = Number(selections.daily_total || 0);
      if (!isFinite(totalDaily) || totalDaily <= 0) return false;
var hasHighVolumeDemand = shouldShowFreezerProgram(totalDaily);
      return hasHighVolumeDemand && isFreezerCadenceEligible(totalDaily);
    }
    function backfillDogsBasicFromDogs() {
      if (!Array.isArray(selections.dogs_basic) || !selections.dogs_basic.length) return;
      if (!Array.isArray(selections.dogs) || selections.dogs.length !== selections.dogs_basic.length) return;
      var changed = false;
      selections.dogs_basic = selections.dogs_basic.map(function (basicDog, idx) {
        var nextDog = (basicDog && typeof basicDog === 'object') ? Object.assign({}, basicDog) : {};
        var fullDog = selections.dogs[idx] || {};
        if (!String(nextDog.name || '').trim() && String(fullDog.name || '').trim()) {
          nextDog.name = String(fullDog.name || '').trim();
          changed = true;
        }
        if (!String(nextDog.breed || '').trim() && String(fullDog.breed || '').trim()) {
          nextDog.breed = String(fullDog.breed || '').trim();
          changed = true;
        }
        if (!String(nextDog.sex || '').trim() && String(fullDog.sex || '').trim()) {
          nextDog.sex = String(fullDog.sex || '').trim();
          changed = true;
        }
        var basicWeight = Number(nextDog.weight || 0);
        var fullWeight = Number(fullDog.weight || 0);
        if ((!basicWeight || basicWeight <= 0) && fullWeight > 0) {
          nextDog.weight = fullWeight;
          changed = true;
        }
        if (!String(nextDog.avatar || '').trim() && String(fullDog.avatar || '').trim()) {
          nextDog.avatar = String(fullDog.avatar || '').trim();
          changed = true;
        }
        if (!String(nextDog.avatar_fallback || '').trim() && String(fullDog.avatar_fallback || '').trim()) {
          nextDog.avatar_fallback = String(fullDog.avatar_fallback || '').trim();
          changed = true;
        }
        return nextDog;
      });
      if (changed) saveProgressState();
    }
    function normalizeCompletedStepsFromSelections() {
      backfillDogsBasicFromDogs();
      var normalizedCompleted = {};
      var normalizedEverCompleted = {};
      Object.keys(completedSteps || {}).forEach(function (key) {
        if (completedSteps[key]) normalizedCompleted[key] = true;
      });
      Object.keys(everCompletedSteps || {}).forEach(function (key) {
        if (everCompletedSteps[key]) normalizedEverCompleted[key] = true;
      });
      completedSteps = normalizedCompleted;
      everCompletedSteps = normalizedEverCompleted;
      if (selections.zip) markStepCompleted(getStepByType('zip_validator'));
      if (selections.founding_choice_ack || !foundingChoicePathActive()) {
        markStepCompleted(getStepByType('founding_choice'));
      }
      if (selections.founding_pitch_ack || !foundingPitchShouldShow()) {
        markStepCompleted(getStepByType('founding_pitch'));
      }
if (hasValidDogInfoSelection()) {
        markStepCompleted(getStepByType('dog_info'));
}
if (hasValidRawPortionSelection()) {
        markStepCompleted(getStepByType('raw_portion_check'));
}
if (hasValidDogsBasicSelection()) {
        markStepCompleted(getStepByType('dog_profile'));
      }
      if (hasValidDietSelection()) markStepCompleted(getStepByType('diet_profile'));
if (hasValidFeedingSetupSelection()) markStepCompleted(getStepByType('feeding_setup'));
if (hasValidFeedingProteinModeSelection()) markStepCompleted(getStepByType('feeding_protein_mode'));
      if (hasValidProductSelection()) markStepCompleted(getStepByType('product_selector'));
      if (hasValidFreezerSpaceSelection()) markStepCompleted(getStepByType('freezer_space'));
      if (hasValidDeliverySelection()) markStepCompleted(getStepByType('delivery_calculator'));
      if ((selections.freezer_program || shouldShowFreezerProgramCard()) && $('[data-cfg-type="freezer_program"]')) {
        markStepCompleted(getStepByType('freezer_program'));
      }
allCards.forEach(function (card) {
if (!card || card.hidden) return;
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
if (!stepNum) return;
if (isCanonicalStepComplete(stepNum)) markStepCompleted(stepNum);
});
      Object.keys(completedSteps).forEach(function (key) {
        if (completedSteps[key]) everCompletedSteps[key] = true;
      });
    }
    function hasProgressedBeyond(stepNum) {
      for (var key in everCompletedSteps) {
        if (!Object.prototype.hasOwnProperty.call(everCompletedSteps, key)) continue;
        if (!everCompletedSteps[key]) continue;
        var completedStep = parseInt(key, 10);
        if (completedStep > stepNum) return true;
      }
      return false;
    }
    function clearStepCompletion(stepNum) {
      if (!stepNum) return;
      delete completedSteps[stepNum];
      delete everCompletedSteps[stepNum];
    }
    function clearProductSelectionsState() {
      delete selections.protein;
      delete selections.product_price;
      selections.household_proteins = [];
      selections.dog_proteins = [];
    }
    function clearProductSelectionsUI() {
      var productCard = $('[data-cfg-type="product_selector"]');
      if (!productCard) return;
      var singleWrap = productCard.querySelector('[data-cfg-protein-single]');
      var perDogWrap = productCard.querySelector('[data-cfg-protein-per-dog]');
      if (singleWrap) {
        singleWrap.hidden = false;
        singleWrap.querySelectorAll('.otto-cfg-tile--product').forEach(function (tile) {
          tile.classList.remove('is-selected');
        });
      }
      if (perDogWrap) {
        perDogWrap.hidden = true;
        perDogWrap.innerHTML = '';
      }
if (productCard._syncProteinModeUI) productCard._syncProteinModeUI();
      if (productCard._syncProductContinueState) productCard._syncProductContinueState();
    }
    function invalidateReviewStep() {
      var reviewStep = getStepByType('review');
      clearStepCompletion(reviewStep);
      updateIncomplete();
      buildReview();
    }
    function invalidateFromDogInfo(stepNum, options) {
      if (isHydratingState) return;
      if (!hasProgressedBeyond(stepNum)) return;
      var opts = options || {};
      var resetProductSelection = opts.resetProductSelection !== false;
if (resetProductSelection) {
      delete selections.dogs;
      delete selections.daily_total;
}
      if (resetProductSelection) {
        clearProductSelectionsState();
        clearProductSelectionsUI();
        clearStepCompletion(getStepByType('diet_profile'));
        clearStepCompletion(getStepByType('product_selector'));
      }
      invalidateDeliverySelections();
      invalidateReviewStep();
      clearStepCompletion(getStepByType('raw_portion_check'));
      clearStepCompletion(getStepByType('raw_share'));
      if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
      if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
      if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
      if (typeof renderRawShareCard === 'function') renderRawShareCard();
      if (resetProductSelection) {
        var dietCard = $('[data-cfg-type="diet_profile"]');
        if (dietCard) renderDietTiles(dietCard, true);
      }
      renderDeliveryTiles(true);
      buildReview();
      updateIncomplete();
    }
    function invalidateFromDietProfile(stepNum, options) {
      if (isHydratingState) return;
      if (!hasProgressedBeyond(stepNum)) return;
      var opts = options || {};
      var resetProductSelection = opts.resetProductSelection !== false;
      if (resetProductSelection) {
        clearProductSelectionsState();
        clearProductSelectionsUI();
        clearStepCompletion(getStepByType('product_selector'));
      }
      invalidateDeliverySelections();
      invalidateReviewStep();
      renderDeliveryTiles(true);
      updateIncomplete();
    }
    function invalidateFromProductSelector(stepNum) {
      if (isHydratingState) return;
      if (!hasProgressedBeyond(stepNum)) return;
      invalidateReviewStep();
    }
function invalidateFromFeedingSetup(stepNum) {
if (isHydratingState) return;
if (!hasProgressedBeyond(stepNum)) return;
if (selections.per_dog_protein) {
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard && productCard._renderPerDogTiles) productCard._renderPerDogTiles();
}
invalidateDeliverySelections();
invalidateReviewStep();
renderDeliveryTiles(true);
updateIncomplete();
}
    function invalidateFromDeliveryCalculator(stepNum) {
      if (isHydratingState) return;
      if (!hasProgressedBeyond(stepNum)) return;
      delete selections.delivery_weekday;
      var ddCard = $('[data-cfg-type="delivery_day"]');
      if (ddCard) {
        var ddStep = parseInt(ddCard.getAttribute('data-cfg-step'), 10);
        if (ddStep) delete completedSteps[ddStep];
      }
      invalidateReviewStep();
    }
    function invalidateFromFreezerProgram(stepNum) {
      if (isHydratingState) return;
var progressed = hasProgressedBeyond(stepNum);
if (!progressed) return;
      invalidateReviewStep();
    }
    function setActiveStep(n) {
      var requestedCard = $('[data-cfg-step="' + n + '"]');
      if (requestedCard && requestedCard.hidden) {
        var fallbackCard = getNextVisibleCard(n - 1) || getNextVisibleCard(n) || $('[data-cfg-step="1"]');
        if (fallbackCard) n = parseInt(fallbackCard.getAttribute('data-cfg-step'), 10) || n;
      }
      if (n === currentStep) return;
      currentStep = n;
      updateImage(n);
      updateDots(n);
      updateIncomplete();
      sizeMedia();
      var dietCard = $('[data-cfg-type="diet_profile"][data-cfg-step="' + n + '"]');
      if (dietCard) renderDietTiles(dietCard);
var feedingCard = $('[data-cfg-type="feeding_setup"][data-cfg-step="' + n + '"]');
if (feedingCard && feedingCard._syncFeedingSetupUI) feedingCard._syncFeedingSetupUI();
var feedingProteinModeCard = $('[data-cfg-type="feeding_protein_mode"][data-cfg-step="' + n + '"]');
if (feedingProteinModeCard && feedingProteinModeCard._syncFeedingProteinModeUI) feedingProteinModeCard._syncFeedingProteinModeUI();
      var productCard = $('[data-cfg-type="product_selector"][data-cfg-step="' + n + '"]');
      if (productCard) {
        updateMealPrices();
        if (productCard._showProteinToggle) productCard._showProteinToggle();
        if (selections.per_dog_protein && productCard._updatePerDogMealPrices) productCard._updatePerDogMealPrices();
        if (productCard._syncProductContinueState) productCard._syncProductContinueState();
if (productCard._syncProteinGalleryFromSelection) productCard._syncProteinGalleryFromSelection();
      }
      var deliveryCard = $('[data-cfg-type="delivery_calculator"][data-cfg-step="' + n + '"]');
      if (deliveryCard) renderDeliveryTiles();
      var deliveryDayCard = $('[data-cfg-type="delivery_day"][data-cfg-step="' + n + '"]');
      if (deliveryDayCard && deliveryDayCard._renderDeliveryDay) deliveryDayCard._renderDeliveryDay();
      var freezerProgramCard = $('[data-cfg-type="freezer_program"][data-cfg-step="' + n + '"]');
      if (freezerProgramCard) renderFreezerProgramCard(true);
      var reviewCard = $('[data-cfg-type="review"][data-cfg-step="' + n + '"]');
      if (reviewCard) buildReview();
    }
    var observer = new IntersectionObserver(function (entries) {
      var best = null;
      var bestRatio = 0;
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
          bestRatio = entry.intersectionRatio;
          best = entry.target;
        }
      });
      if (best) {
        var step = parseInt(best.getAttribute('data-cfg-step'), 10);
        if (step) setActiveStep(step);
      }
    }, {
      root: null,
      rootMargin: '-30% 0px -30% 0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });
    allCards.forEach(function (card) { observer.observe(card); });
    normalizeCompletedStepsFromSelections();
    updateImage(currentStep);
    updateDots(currentStep);
    updateIncomplete();
/* ---- Dot click navigation ---- */
    $$('.otto-cfg__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var step = parseInt(dot.getAttribute('data-cfg-dot'), 10);
        var card = $('[data-cfg-step="' + step + '"]');
        scrollToCard(card);
      });
    });
    $$('[data-cfg-reset]').forEach(function (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var confirmed = window.confirm('Clear all configurator selections and start over?');
        if (!confirmed) return;
        if (resetBtn.getAttribute('data-cfg-resetting') === '1') return;
        resetBtn.setAttribute('data-cfg-resetting', '1');
        clearShopifyCart()
          .then(function () {
            delete selections.meals_per_day;
            delete selections.meals_per_day_source;
            delete selections.per_dog_protein;
            clearProgressState();
            try { sessionStorage.setItem(RESET_JUMP_KEY, '1'); } catch (err) {}
            window.location.reload();
          })
          .catch(function () {
            resetBtn.removeAttribute('data-cfg-resetting');
            window.alert('Could not clear your cart. Please try Start over again.');
          });
      });
    });
/* ---- ZIP validator ---- */
    $$('[data-cfg-type="zip_validator"]').forEach(function (card) {
      var liveSet = parseZipAllowSet(card.getAttribute('data-valid-zips') || '');
      var foundingSet = parseZipAllowSet(card.getAttribute('data-founding-zips') || '');
      var matureSet = parseZipAllowSet(card.getAttribute('data-mature-zips') || '');
      var zipInput = card.querySelector('[data-cfg-zip]');
      var zipEmailInput = card.querySelector('[data-cfg-zip-email]');
      var zipEmailError = card.querySelector('[data-cfg-zip-email-error]');
      var zipTermsInput = card.querySelector('[data-cfg-zip-terms]');
      var zipTermsError = card.querySelector('[data-cfg-zip-terms-error]');
      var zipCheck = card.querySelector('[data-cfg-zip-check]');
      var zipError = card.querySelector('[data-cfg-zip-error]');
      var zipOut   = card.querySelector('[data-cfg-zip-out]');
      var zipOutMessage = card.querySelector('[data-cfg-zip-out-message]');
      var zipSuccess = card.querySelector('[data-cfg-zip-success]');
      var zipWaitlistFields = card.querySelector('[data-cfg-zip-waitlist-fields]');
      var zipWaitlistName = card.querySelector('[data-cfg-zip-waitlist-name]');
      var zipWaitlistEmail = card.querySelector('[data-cfg-zip-waitlist-email]');
      var zipWaitlistZip = card.querySelector('[data-cfg-zip-waitlist-zip]');
      var zipWaitlistJoin = card.querySelector('[data-cfg-zip-waitlist-join]');
      var zipTryAnother = card.querySelector('[data-cfg-zip-try-another]');
      var zipWaitlistFeedback = card.querySelector('[data-cfg-zip-waitlist-feedback]');
      var stepNum  = parseInt(card.getAttribute('data-cfg-step'), 10);
      var zipCheckDefaultText = zipCheck ? zipCheck.textContent : 'Check availability';
      var zipCheckLoadingText = 'Sniffing around';
      var zipCheckSuccessLiveText = 'Delivery available';
      var zipCheckSuccessFoundingText = 'Pick-up available';
      var zipCheckFailedText = "you're ZIP out of luck";
      function zipSuccessButtonLabel(zone) {
        return zone === 'founding' ? zipCheckSuccessFoundingText : zipCheckSuccessLiveText;
      }
      function classifyCurrentZip(val) {
        return classifyServiceZone(val, liveSet, foundingSet, matureSet);
      }
      function advanceAfterZipSuccess() {
        /* Skips hidden cards (founding pitch on live; delivery day on founding). */
        var next = getNextVisibleCard(stepNum);
        if (next) scrollToCard(next);
      }
      var zipDelayTimer = null;
      var zipAdvanceTimer = null;
      var zipLoadingDotsTimer = null;
      var zipLoadingDotsFrame = 0;
      var isZipProcessing = false;
var ZIP_LOADING_DURATION_MS = 2000;
var ZIP_SUCCESS_HOLD_MS = 1200;
      var ZIP_LOADING_DOT_INTERVAL_MS = 320;
      function isValidZipEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
      }
      function hasAcceptedZipTerms() {
        return !zipTermsInput || !!zipTermsInput.checked;
      }
      function storeZipTermsAccepted(isAccepted) {
        if (!selections.owner || typeof selections.owner !== 'object') selections.owner = {};
        selections.owner.terms_accepted = !!isAccepted;
        if (isAccepted) {
          if (!selections.owner.terms_accepted_at) {
            selections.owner.terms_accepted_at = new Date().toISOString();
          }
        } else {
          delete selections.owner.terms_accepted_at;
        }
      }
      function updateZipTermsGate() {
        if (!zipCheck || existingPlanBlocked) return;
        var blocked = !hasAcceptedZipTerms();
        zipCheck.disabled = blocked;
        zipCheck.classList.toggle('is-disabled', blocked);
        if (blocked) zipCheck.setAttribute('aria-disabled', 'true');
        else {
          zipCheck.removeAttribute('aria-disabled');
          zipCheck.classList.remove('is-disabled');
        }
      }
      function storeZipEmail(emailVal) {
        if (!selections.owner || typeof selections.owner !== 'object') selections.owner = {};
        selections.owner.email = String(emailVal || '').trim();
      }
      /* Build the "Manage my pack" link. Always routes to the headless portal,
       * never Shopify's hosted account: logged-in customers go straight there;
       * logged-out customers go through login with return_to=portal (+ the typed
       * email as login_hint) so Shopify lands them back on the portal. */
      function portalManageUrl(emailVal) {
        var portal = (ottoUrls && ottoUrls.portal) || '/pages/manage-subscription';
        if (ottoCustomer && ottoCustomer.loggedIn) return portal;
        var login = (ottoUrls && ottoUrls.login) ||
          ('/customer_authentication/login?return_to=' + encodeURIComponent(portal));
        var email = String(emailVal || '').trim();
        if (isValidZipEmail(email)) login += '&login_hint=' + encodeURIComponent(email);
        return login;
      }
      function currentGateEmail() {
        if (ottoCustomer && ottoCustomer.loggedIn && ottoCustomer.email) return ottoCustomer.email;
        return zipEmailInput ? zipEmailInput.value : '';
      }
      /* Returning-customer banner at the ZIP gate. Soft variant just steers them
       * to the portal; hard variant also disables the gate so they can't start a
       * second, separate checkout. */
      function buildExistingPlanBanner(isHard) {
        var manageUrl = portalManageUrl(currentGateEmail());
        var Modal = window.OttoCfgPlanModal;
        var status = existingPlanStatus || 'ACTIVE';
        var msg = Modal && Modal.bannerCopy
          ? Modal.bannerCopy(status, { firstName: existingPlanFirstName || (ottoCustomer && ottoCustomer.firstName) })
          : 'You already have an Otto plan. Manage it from your account.';
        var existing = card.querySelector('[data-cfg-existing-plan]');
        if (existing) {
          if (isHard) existing.classList.add('otto-cfg-existing-plan--block');
          var existingLink = existing.querySelector('.otto-cfg-existing-plan__link');
          if (existingLink) existingLink.setAttribute('href', manageUrl);
          var existingP = existing.querySelector('p');
          if (existingP) existingP.textContent = msg;
          return existing;
        }
        var nudge = document.createElement('div');
        nudge.className = 'otto-cfg-existing-plan' + (isHard ? ' otto-cfg-existing-plan--block' : '');
        nudge.setAttribute('data-cfg-existing-plan', '1');
        nudge.setAttribute('role', isHard ? 'alert' : 'status');
        var linkLabel = status === 'CANCELLED' ? 'Log in to my account' : 'Manage my pack';
        nudge.innerHTML =
          '<p>' + esc(msg) + '</p>' +
          '<a class="otto-cfg-existing-plan__link" href="' + esc(manageUrl) + '">' + esc(linkLabel) + ' &rarr;</a>';
        var anchor = zipEmailError || zipEmailInput;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(nudge, anchor.nextSibling);
        } else {
          card.appendChild(nudge);
        }
        return nudge;
      }
      function showExistingPlanNudge() {
        buildExistingPlanBanner(false);
      }
      /* Hard block: a returning customer with a live plan cannot advance the gate. */
      function applyExistingPlanHardBlock() {
        existingPlanBlocked = true;
        buildExistingPlanBanner(true);
        card.classList.add('otto-cfg-card--plan-blocked');
        if (zipCheck) {
          zipCheck.disabled = true;
          zipCheck.setAttribute('aria-disabled', 'true');
          zipCheck.classList.add('is-disabled');
        }
      }
      /* Undo a hard block — only for logged-out customers who edit the email to a
       * different address. A logged-in customer's block is permanent (their
       * session already has a live plan). */
      function clearExistingPlanBlock() {
        if (ottoCustomer && ottoCustomer.loggedIn) return;
        existingPlanBlocked = false;
        card.classList.remove('otto-cfg-card--plan-blocked');
        var banner = card.querySelector('[data-cfg-existing-plan]');
        if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
        if (zipCheck) {
          zipCheck.disabled = false;
          zipCheck.removeAttribute('aria-disabled');
          zipCheck.classList.remove('is-disabled');
        }
        updateZipTermsGate();
      }
      /* Authoritative worker check (Loop-backed). Returns a Promise<boolean>:
       * true = email already has a live Otto plan. Caches per email and dedupes
       * in-flight requests. Fails open (false) on any error so it never wrongly
       * blocks a new customer. */
      function checkExistingPlan(emailVal) {
        var email = String(emailVal || '').trim().toLowerCase();
        if (!isValidZipEmail(email)) {
          return Promise.resolve({ existingOttoPlan: false, planStatus: null, firstName: '' });
        }
        return ottoExistingPlanCheck(email);
      }
      /* Fire-and-forget check that hard-blocks the gate on a positive result. */
      function maybeCheckExistingPlan(emailVal) {
        checkExistingPlan(emailVal).then(function (parsed) {
          if (parsed && parsed.existingOttoPlan) {
            existingPlanStatus = parsed.planStatus || 'ACTIVE';
            existingPlanFirstName = parsed.firstName || existingPlanFirstName || '';
            applyExistingPlanHardBlock();
            showExistingPlanModal(emailVal, existingPlanStatus, parsed.firstName);
          }
        });
      }
      function getSelectedGuideName() {
        var selTile = document.querySelector('[data-cfg-type="owner_feeding"] [data-cfg-owner-familiarity-value].is-selected');
        if (selTile) {
          var gn = selTile.getAttribute('data-owner-guide-name');
          if (gn && gn.trim()) return gn.trim();
        }
        return '';
      }
      function setOutOfAreaMessage(zipVal) {
        if (!zipOutMessage) return;
        var guideName = getSelectedGuideName();
        var msg;
        if (guideName) {
          msg = "We'll send over the " + guideName + " guide and you've been added to our interest list — we'll let you know the moment we deliver to " + zipVal + ".";
        } else {
          msg = "You've been added to our interest list — we'll let you know the moment we deliver to " + zipVal + ".";
        }
        zipOutMessage.textContent = msg;
      }
      function stopZipLoadingDots() {
        if (zipLoadingDotsTimer) {
          clearInterval(zipLoadingDotsTimer);
          zipLoadingDotsTimer = null;
        }
        zipLoadingDotsFrame = 0;
      }
      function startZipLoadingDots() {
        if (!zipCheck) return;
        stopZipLoadingDots();
        setZipButtonLabel(zipCheck, zipCheckLoadingText, false);
        zipLoadingDotsTimer = setInterval(function () {
          zipLoadingDotsFrame = (zipLoadingDotsFrame + 1) % 4;
          var suffix = zipLoadingDotsFrame ? new Array(zipLoadingDotsFrame + 1).join('.') : '';
          setZipButtonLabel(zipCheck, zipCheckLoadingText + suffix, false);
        }, ZIP_LOADING_DOT_INTERVAL_MS);
      }
      function setWaitlistFeedback(message, isError) {
        if (!zipWaitlistFeedback) return;
        var text = String(message == null ? '' : message).trim();
        zipWaitlistFeedback.textContent = text;
        zipWaitlistFeedback.hidden = !text;
        zipWaitlistFeedback.classList.toggle('is-error', !!isError && !!text);
      }
      function clearWaitlistFeedback() {
        setWaitlistFeedback('', false);
      }
      function setWaitlistFieldsVisible(isVisible) {
        if (!zipWaitlistFields) return;
        zipWaitlistFields.hidden = !isVisible;
        zipWaitlistFields.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        if (!isVisible) clearWaitlistFeedback();
      }
      function clearWaitlistFields() {
        if (zipWaitlistName) zipWaitlistName.value = '';
        if (zipWaitlistEmail) zipWaitlistEmail.value = '';
        if (zipWaitlistZip) zipWaitlistZip.value = '';
      }
      function resetZipSuccessState() {
        stopZipLoadingDots();
        if (zipDelayTimer) {
          clearTimeout(zipDelayTimer);
          zipDelayTimer = null;
        }
        if (zipAdvanceTimer) {
          clearTimeout(zipAdvanceTimer);
          zipAdvanceTimer = null;
        }
        card.classList.remove('is-zip-loading');
        card.classList.remove('is-zip-success');
        card.classList.remove('is-zip-failed');
        if (zipSuccess) {
          zipSuccess.hidden = true;
          zipSuccess.textContent = '';
        }
        if (zipCheck) {
          zipCheck.classList.remove('is-zip-loading');
          zipCheck.removeAttribute('aria-busy');
          setZipButtonLabel(zipCheck, zipCheckDefaultText, false);
        }
        setWaitlistFieldsVisible(false);
        clearWaitlistFeedback();
        isZipProcessing = false;
      }
      function applyZipSuccessState(zone) {
        stopZipLoadingDots();
        card.classList.remove('is-zip-loading');
        card.classList.remove('is-zip-failed');
        card.classList.add('is-zip-success');
        if (zipCheck) {
          zipCheck.classList.remove('is-zip-loading');
          zipCheck.removeAttribute('aria-busy');
          setZipButtonLabel(zipCheck, zipSuccessButtonLabel(zone), false);
        }
      }
      function applyZipFailedState() {
        stopZipLoadingDots();
        card.classList.remove('is-zip-loading');
        card.classList.remove('is-zip-success');
        card.classList.add('is-zip-failed');
        if (zipCheck) {
          zipCheck.classList.remove('is-zip-loading');
          zipCheck.removeAttribute('aria-busy');
          var hasWaitlistPitch = !!$('[data-cfg-type="waitlist_pitch"]');
          setZipButtonLabel(
            zipCheck,
            hasWaitlistPitch ? 'Check another ZIP' : zipCheckFailedText,
            false
          );
        }
      }
      function clearZipSelectionState(clearDownstream) {
        var hadSelection = !!selections.zip || !!completedSteps[stepNum];
        delete selections.zip;
        delete selections.zip_attempted;
        delete selections.service_zone;
        delete selections.service_eligible;
        delete selections.founding_pitch_ack;
        delete selections.founding_choice;
        delete selections.founding_choice_ack;
        delete selections.fulfillment;
        clearDeliveryWeekdayPolicy();
        clearStepCompletion(stepNum);
        if (clearDownstream) clearStepCompletionsAfter(stepNum);
        syncFoundingPathUi();
        snapHouseholdRawShareToPackMin();
        if (hadSelection || clearDownstream) updateIncomplete();
      }
      function handleCheck() {
        if (existingPlanBlocked) { showExistingPlanNudge(); return; }
        if (isZipProcessing) return;
        var val = zipInput ? zipInput.value.trim() : '';
        resetZipSuccessState();
        clearZipSelectionState(false);
        if (zipError) zipError.hidden = true;
        if (zipOut) zipOut.hidden = true;
        if (zipEmailError) zipEmailError.hidden = true;
        if (zipTermsError) zipTermsError.hidden = true;
        var emailVal = zipEmailInput ? zipEmailInput.value.trim() : '';
        if (!isValidZipEmail(emailVal)) {
          if (zipEmailError) zipEmailError.hidden = false;
          if (zipEmailInput) zipEmailInput.focus();
          return;
        }
        if (!hasAcceptedZipTerms()) {
          if (zipTermsError) zipTermsError.hidden = false;
          if (zipTermsInput) zipTermsInput.focus();
          return;
        }
        if (val.length !== 5) {
          if (zipError) { zipError.textContent = 'Please enter a 5-digit ZIP code.'; zipError.hidden = false; }
          return;
        }
        storeZipEmail(emailVal);
        storeZipTermsAccepted(true);
        // Kick off the existing-account check now; the advance is gated on it
        // below so a returning customer is stopped at the gate (never shown
        // "delivery available" or advanced into a second checkout).
        var planCheck = checkExistingPlan(emailVal);
        saveProgressState();
        isZipProcessing = true;
        card.classList.add('is-zip-loading');
        if (zipCheck) {
          zipCheck.classList.add('is-zip-loading');
          zipCheck.setAttribute('aria-busy', 'true');
          startZipLoadingDots();
        }
        var zone = classifyCurrentZip(val);
        if (zoneAllowsCheckout(zone)) {
          zipDelayTimer = setTimeout(function () {
            zipDelayTimer = null;
            // Wait for the account check before advancing. Existing plan → stop.
            planCheck.then(function (parsed) {
              if (parsed && parsed.existingOttoPlan) {
                existingPlanStatus = parsed.planStatus || 'ACTIVE';
                existingPlanFirstName = parsed.firstName || existingPlanFirstName || '';
                resetZipSuccessState();
                applyExistingPlanHardBlock();
                showExistingPlanModal(emailVal, existingPlanStatus, parsed.firstName);
                return;
              }
              selections.zip = val;
              delete selections.zip_attempted;
              applyServiceZone(zone);
              snapHouseholdRawShareToPackMin();
              if (selections.owner) selections.owner.guide_opt_in = true;
              markStepCompleted(stepNum);
              updateIncomplete();
              saveProgressState();
              pushConfiguratorDraftNow();
              if (card.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
              applyZipSuccessState(zone);
              sizeMedia();
              isZipProcessing = false;
              fetchDeliveryWeekdayPolicy(val, function () {
                var ddCard = $('[data-cfg-type="delivery_day"]');
                if (ddCard && ddCard._renderDeliveryDay) ddCard._renderDeliveryDay();
                var allowed = cfgAllowedWeekdayList();
                var currentWd = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
                if (allowed.length === 1) {
                  selections.delivery_weekday = allowed[0].value;
                } else if (currentWd != null && !allowed.some(function (w) { return w.value === currentWd; })) {
                  delete selections.delivery_weekday;
                }
              });
              /* Founding: next visible card is the Founding Pack pitch. Live: pitch is hidden. */
              zipAdvanceTimer = setTimeout(function () {
                advanceAfterZipSuccess();
                zipAdvanceTimer = null;
              }, ZIP_SUCCESS_HOLD_MS);
            });
          }, ZIP_LOADING_DURATION_MS);
        } else {
          zipDelayTimer = setTimeout(function () {
            if (zipWaitlistZip) zipWaitlistZip.value = val;
            setWaitlistFieldsVisible(false);
            clearWaitlistFeedback();
            delete selections.zip;
            selections.zip_attempted = val;
            delete selections.fulfillment;
            applyServiceZone('waitlist');
            snapHouseholdRawShareToPackMin();
            if (selections.owner) selections.owner.guide_opt_in = true;
            markStepCompleted(stepNum);
            if (card.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
            /* Dedicated waitlist pitch card replaces the inline out-of-area panel. */
            if (zipOut) {
              zipOut.hidden = true;
              zipOut.setAttribute('hidden', '');
            }
            if (zipError) zipError.hidden = true;
            applyZipFailedState();
            syncWaitlistPitchCardVisibility();
            syncWaitlistPitchCopy();
            isZipProcessing = false;
            zipDelayTimer = null;
            updateIncomplete();
            saveProgressState();
            pushConfiguratorDraftNow();
            zipAdvanceTimer = setTimeout(function () {
              var waitlistCard = $('[data-cfg-type="waitlist_pitch"]');
              if (waitlistCard) {
                waitlistCard.hidden = false;
                waitlistCard.removeAttribute('hidden');
                waitlistCard.removeAttribute('data-cfg-path-hidden');
                if (zipOut) {
                  zipOut.hidden = true;
                  zipOut.setAttribute('hidden', '');
                }
                scrollToCard(waitlistCard);
              } else if (zipOut) {
                setOutOfAreaMessage(val);
                zipOut.hidden = false;
                zipOut.removeAttribute('hidden');
              }
              zipAdvanceTimer = null;
              sizeMedia();
            }, ZIP_SUCCESS_HOLD_MS);
          }, ZIP_LOADING_DURATION_MS);
        }
      }
      if (zipEmailInput && selections.owner && selections.owner.email) {
        zipEmailInput.value = String(selections.owner.email);
      }
      if (zipTermsInput && selections.owner && selections.owner.terms_accepted) {
        zipTermsInput.checked = true;
      }
      updateZipTermsGate();
      updateZipResetVisibility();
      // Tier 1: logged-in returning customer — HARD block (can't start a 2nd plan).
      // The otto_dogs metafield flag is a fast positive hint, but it can be a
      // false negative (cross-email checkout, pruning), so we also run the
      // authoritative Loop-backed worker check against the session email.
      if (ottoCustomer && ottoCustomer.loggedIn) {
        if (ottoCustomer.hasOttoPlan) {
          existingPlanStatus = 'ACTIVE';
          applyExistingPlanHardBlock();
        }
        if (ottoCustomer.email) {
          var planPrefetch = window.__ottoPlanPrefetch;
          if (planPrefetch && planPrefetch.done && planPrefetch.result) {
            existingPlanStatus = planPrefetch.planStatus || 'ACTIVE';
            applyExistingPlanHardBlock();
          } else {
            maybeCheckExistingPlan(ottoCustomer.email);
          }
        }
      }
      if (zipEmailInput) {
        var zipEmailPrefetchTimer = null;
        zipEmailInput.addEventListener('input', function () {
          updateZipResetVisibility();
          // A logged-out customer editing the email clears a prior hard block so
          // they aren't stuck if they correct a typo or use a different address.
          if (existingPlanBlocked) clearExistingPlanBlock();
          // Warm the returning-customer check while they type so blur/check feels instant.
          if (zipEmailPrefetchTimer) clearTimeout(zipEmailPrefetchTimer);
          var typedEmail = zipEmailInput.value;
          if (isValidZipEmail(typedEmail)) {
            zipEmailPrefetchTimer = setTimeout(function () {
              ottoExistingPlanCheck(typedEmail);
            }, 250);
          }
        });
        // Tier 2: logged-out — pre-check on blur and HARD block if the email is
        // already an Otto account, so the gate stops them before they advance.
        zipEmailInput.addEventListener('blur', function () {
          maybeCheckExistingPlan(zipEmailInput.value);
        });
      }
      if (zipTermsInput) {
        var zipTermsLink = card.querySelector('[data-cfg-zip-terms-link]');
        zipTermsInput.addEventListener('change', function () {
          if (zipTermsError) zipTermsError.hidden = true;
          storeZipTermsAccepted(zipTermsInput.checked);
          updateZipTermsGate();
          saveProgressState();
        });
        if (zipTermsLink) {
          zipTermsLink.addEventListener('click', function () {
            if (zipTermsInput.checked) return;
            zipTermsInput.checked = true;
            zipTermsInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }
      if (zipCheck) zipCheck.addEventListener('click', handleCheck);
      if (zipInput) zipInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); handleCheck(); } });
      if (zipEmailInput) zipEmailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); handleCheck(); } });
      function tryAnotherZip() {
        if (isZipProcessing) return;
        resetZipSuccessState();
        clearZipSelectionState(true);
        if (zipError) zipError.hidden = true;
        if (zipOut) zipOut.hidden = true;
        clearWaitlistFields();
        if (zipInput) {
          zipInput.value = '';
          zipInput.focus();
        }
        /* Re-lock cards this gate was guarding — ZIP is no longer validated. */
        if (card.hasAttribute('data-locks-remaining')) {
          allCards.forEach(function (lockedCard) {
            var step = parseInt(lockedCard.getAttribute('data-cfg-step'), 10);
            if (step > stepNum) lockedCard.classList.add('is-locked');
            syncCardInert(lockedCard);
          });
        }
        updateZipResetVisibility();
        saveProgressState();
        pushConfiguratorDraftNow();
        scrollToCard(card);
        sizeMedia();
      }
      card._tryAnotherZip = tryAnotherZip;
      if (zipTryAnother) zipTryAnother.addEventListener('click', tryAnotherZip);
      if (zipWaitlistJoin) {
        zipWaitlistJoin.addEventListener('click', function () {
          if (isZipProcessing) return;
          if (zipWaitlistFields && zipWaitlistFields.hidden) {
            setWaitlistFieldsVisible(true);
            if (zipWaitlistName) zipWaitlistName.focus();
            return;
          }
          var nameVal = zipWaitlistName ? zipWaitlistName.value.trim() : '';
          var emailVal = zipWaitlistEmail ? zipWaitlistEmail.value.trim() : '';
          var waitlistZipVal = zipWaitlistZip ? zipWaitlistZip.value.trim() : '';
          var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
          var zipOk = /^\d{5}$/.test(waitlistZipVal);
          if (!nameVal || !emailVal || !waitlistZipVal) {
            setWaitlistFeedback('Please enter your name, email, and ZIP code.', true);
            return;
          }
          if (!emailOk) {
            setWaitlistFeedback('Please enter a valid email address.', true);
            return;
          }
          if (!zipOk) {
            setWaitlistFeedback('Please enter a valid 5-digit ZIP code.', true);
            return;
          }
          setWaitlistFeedback("Thanks! You're on the waitlist.", false);
        });
      }
      if (zipInput) {
        zipInput.addEventListener('input', function () {
          updateZipResetVisibility();
          if (isZipProcessing) return;
          var current = zipInput.value.trim();
          if (!selections.zip && !card.classList.contains('is-zip-success') && !card.classList.contains('is-zip-failed')) return;
          if (current === String(selections.zip || '')) return;
          resetZipSuccessState();
          clearZipSelectionState(true);
          if (zipError) zipError.hidden = true;
          if (zipOut) zipOut.hidden = true;
          clearWaitlistFields();
        });
      }
    });
/* ---- Founding Pack pitch ---- */
    $$('[data-cfg-type="founding_pitch"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var continueBtn = card.querySelector('[data-cfg-founding-continue]');
      function acknowledgeFoundingPitch() {
        if (!foundingModeEnabled()) return;
        selections.founding_pitch_ack = true;
        markStepCompleted(stepNum);
        updateIncomplete();
        saveProgressState();
        pushConfiguratorDraftNow();
        var next = getNextVisibleCard(stepNum);
        if (next) scrollToCard(next);
        sizeMedia();
      }
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          acknowledgeFoundingPitch();
        });
      }
    });
    $$('[data-cfg-type="founding_choice"]').forEach(function (card) {
      var pickupBtn = card.querySelector('[data-cfg-founding-pickup]');
      var reserveBtn = card.querySelector('[data-cfg-founding-reserve]');
      var continueBtn = card.querySelector('[data-cfg-founding-choice-continue]');
      var notifyEmail = card.querySelector('[data-cfg-founding-notify-email]');
      var notifyError = card.querySelector('[data-cfg-founding-notify-email-error]');
      var notifyForm = card.querySelector('[data-cfg-founding-notify-form]');
      function selectFoundingChoice(choice) {
        delete selections.founding_choice_ack;
        applyFoundingChoiceState(choice);
      }
      function submitFoundingNotify(e) {
        if (e) e.preventDefault();
        if (!foundingNotifySelected()) return;
        var emailVal = notifyEmail ? notifyEmail.value.trim() : foundingChoiceOwnerEmail();
        setFoundingChoiceOwnerEmail(emailVal);
        if (!isValidOwnerEmail(emailVal)) {
          if (notifyError) notifyError.hidden = false;
          if (notifyEmail) notifyEmail.focus();
          syncFoundingChoiceSelection();
          return;
        }
        if (notifyError) notifyError.hidden = true;
        applyNotifyPath();
      }
      if (pickupBtn) {
        pickupBtn.addEventListener('click', function () {
          selectFoundingChoice('pickup');
        });
      }
      if (reserveBtn) {
        reserveBtn.addEventListener('click', function () {
          selectFoundingChoice('notify');
          if (notifyEmail) {
            if (!notifyEmail.value) notifyEmail.value = foundingChoiceOwnerEmail();
            notifyEmail.focus();
          }
        });
      }
      if (notifyEmail) {
        if (!notifyEmail.value) notifyEmail.value = foundingChoiceOwnerEmail();
        notifyEmail.addEventListener('input', function () {
          setFoundingChoiceOwnerEmail(notifyEmail.value);
          if (notifyError) notifyError.hidden = !notifyEmail.value.trim() || isValidOwnerEmail(notifyEmail.value);
          syncFoundingChoiceSelection();
          saveProgressState();
        });
      }
      if (notifyForm) {
        notifyForm.addEventListener('submit', submitFoundingNotify);
      }
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (selections.founding_choice === 'pickup') applyPickupPath();
        });
      }
    });
/* ---- Waitlist / out-of-area pitch ---- */
    $$('[data-cfg-type="waitlist_pitch"]').forEach(function (card) {
      var shareBtn = card.querySelector('[data-cfg-waitlist-share]');
      var tryBtn = card.querySelector('[data-cfg-waitlist-try-another]');
      var feedbackEl = card.querySelector('[data-cfg-waitlist-share-feedback]');
      function setShareFeedback(message) {
        if (!feedbackEl) return;
        var text = String(message || '').trim();
        feedbackEl.textContent = text;
        feedbackEl.hidden = !text;
      }
      function buildSharePayload() {
        var zip = waitlistZipToken();
        var tokens = { zip: zip, zone: zip };
        var shareUrl = String(card.getAttribute('data-cfg-waitlist-share-url') || '').trim() || window.location.href;
        var shareTextTpl = String(card.getAttribute('data-cfg-waitlist-share-text') || 'Help bring Otto to {zip} — join the interest list:');
        var shareText = cfgFillDeliveryDayTemplate(shareTextTpl, tokens);
        return { url: shareUrl, text: shareText, zip: zip };
      }
      if (shareBtn) {
        shareBtn.addEventListener('click', function () {
          var payload = buildSharePayload();
          var fullText = payload.text + (payload.url ? (' ' + payload.url) : '');
          if (navigator.share) {
            navigator.share({
              title: 'Help bring Otto to ' + payload.zip,
              text: payload.text,
              url: payload.url
            }).then(function () {
              setShareFeedback('Thanks for sharing!');
            }).catch(function () {});
            return;
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(fullText).then(function () {
              setShareFeedback('Link copied — paste it to your neighbors.');
            }).catch(function () {
              setShareFeedback(fullText);
            });
            return;
          }
          setShareFeedback(fullText);
        });
      }
      if (tryBtn) {
        tryBtn.addEventListener('click', function () {
          var zipCard = $('[data-cfg-type="zip_validator"]');
          if (!zipCard) return;
          var zipInput = zipCard.querySelector('[data-cfg-zip]');
          var zipError = zipCard.querySelector('[data-cfg-zip-error]');
          var zipOut = zipCard.querySelector('[data-cfg-zip-out]');
          var zipCheck = zipCard.querySelector('[data-cfg-zip-check]');
          delete selections.zip;
          delete selections.zip_attempted;
          delete selections.service_zone;
          delete selections.service_eligible;
          delete selections.fulfillment;
          delete selections.founding_pitch_ack;
          delete selections.founding_choice;
          delete selections.founding_choice_ack;
          clearDeliveryWeekdayPolicy();
          var zipStep = parseInt(zipCard.getAttribute('data-cfg-step'), 10);
          clearStepCompletion(zipStep);
          clearStepCompletionsAfter(zipStep);
          zipCard.classList.remove('is-zip-failed', 'is-zip-success', 'is-zip-loading');
          if (zipOut) zipOut.hidden = true;
          if (zipError) zipError.hidden = true;
          if (zipInput) {
            zipInput.value = '';
            zipInput.focus();
          }
          if (zipCheck) {
            zipCheck.classList.remove('is-zip-loading');
            zipCheck.removeAttribute('aria-busy');
            zipCheck.textContent = 'Check availability';
          }
          syncFoundingPathUi();
          snapHouseholdRawShareToPackMin();
          updateIncomplete();
          saveProgressState();
          scrollToCard(zipCard);
          sizeMedia();
        });
      }
    });
/* ---- Dog profile (multi-dog) ---- */
    $$('[data-cfg-type="dog_profile"]').forEach(function (card) {
      var container   = card.querySelector('[data-cfg-dogs-container]');
      var template    = card.querySelector('[data-cfg-dog-entry]');
      var addBtn      = card.querySelector('[data-cfg-add-dog]');
      var continueBtn = card.querySelector('[data-cfg-dog-continue]');
      var totalEl     = card.querySelector('[data-cfg-daily-total]');
      var totalValEl  = card.querySelector('[data-cfg-daily-total-value]');
      var maxDogs     = parseInt(card.getAttribute('data-cfg-max-dogs'), 10) || 5;
      var stepNum     = parseInt(card.getAttribute('data-cfg-step'), 10);
      function getEntries() {
        return container.querySelectorAll('[data-cfg-dog-entry]');
      }
      function updateLabels() {
        var entries = getEntries();
        entries.forEach(function (entry, i) {
          var label = entry.querySelector('[data-cfg-dog-label]');
          if (label) label.textContent = 'Dog ' + (i + 1);
          entry.setAttribute('data-cfg-dog-entry', i + 1);
          var removeBtn = entry.querySelector('[data-cfg-remove-dog]');
          if (removeBtn) removeBtn.hidden = (entries.length <= 1);
        });
        if (addBtn) addBtn.hidden = (entries.length >= maxDogs);
      }
      function recalcAndValidate() {
        var entries = getEntries();
        var dogs = [];
        var totalDaily = 0;
        var allValid = true;
        entries.forEach(function (entry) {
          var weightEl   = entry.querySelector('[data-cfg-weight]');
          var stageEl    = entry.querySelector('[data-cfg-life-stage]');
          var activityEl = entry.querySelector('[data-cfg-activity]');
var goalEl = entry.querySelector('[data-cfg-goal]');
          var w = weightEl ? parseInt(weightEl.value, 10) : 0;
          var s = stageEl ? stageEl.value : 'adult';
          var a = activityEl ? activityEl.value : 'recommended';
var g = goalEl ? goalEl.value : '';
          if (!w || w <= 0) allValid = false;
          if (stageEl && stageEl.hasAttribute('required') && !s) allValid = false;
          if (activityEl && activityEl.hasAttribute('required') && !a) allValid = false;
if (goalEl && goalEl.hasAttribute('required') && !g) allValid = false;
          markOutOfOrderRequired([
            weightEl ? { el: weightEl, valid: !!(w && w > 0) } : null,
            (stageEl && stageEl.hasAttribute('required')) ? { el: stageEl, valid: !!s } : null,
            (activityEl && activityEl.hasAttribute('required')) ? { el: activityEl, valid: !!a } : null,
            (goalEl && goalEl.hasAttribute('required')) ? { el: goalEl, valid: !!g } : null
          ].filter(Boolean));
var daily = (w > 0 && s && a && g) ? getDailyIntake(w, s, a, g) : 0;
          totalDaily += daily;
          var nameEl  = entry.querySelector('[data-cfg-dog-name]');
          var breedEl = entry.querySelector('[data-cfg-breed]');
          var sexEl   = entry.querySelector('[data-cfg-sex]');
          dogs.push({
            name: nameEl ? titleCase(nameEl.value.trim()) : '',
            breed: breedEl ? breedEl.value.trim() : '',
            sex: sexEl ? sexEl.value : '',
            weight: w,
            life_stage: s,
            activity: a,
goal: normalizeGoalValue(g),
            daily_intake: daily
          });
        });
        selections.dogs = dogs;
        selections.daily_total = totalDaily;
        if (totalEl && totalValEl) {
          if (totalDaily > 0) {
            totalValEl.textContent = totalDaily;
            totalEl.hidden = false;
          } else {
            totalEl.hidden = true;
          }
        }
        if (continueBtn) continueBtn.disabled = !allValid;
        updateMealPrices();
      }
      function addDog() {
        if (getEntries().length >= maxDogs) return;
        var clone = template.cloneNode(true);
        clone.querySelectorAll('input').forEach(function (inp) { inp.value = ''; });
        clone.querySelectorAll('select').forEach(function (sel) { sel.selectedIndex = 0; });
        container.appendChild(clone);
        bindEntryEvents(clone);
        updateLabels();
        recalcAndValidate();
      }
      function removeDog(entry) {
        if (getEntries().length <= 1) return;
        entry.remove();
        updateLabels();
        recalcAndValidate();
      }
      function bindEntryEvents(entry) {
        entry.querySelectorAll('input, select').forEach(function (inp) {
          inp.addEventListener('input', recalcAndValidate);
          inp.addEventListener('change', recalcAndValidate);
        });
        var removeBtn = entry.querySelector('[data-cfg-remove-dog]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function () { removeDog(entry); });
        }
      }
      bindEntryEvents(template);
      if (addBtn) addBtn.addEventListener('click', addDog);
      if (continueBtn) continueBtn.addEventListener('click', function () {
        recalcAndValidate();
        if (continueBtn.disabled) return;
        markStepCompleted(stepNum);
        updateIncomplete();
        renderDeliveryTiles(true);
        var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
        scrollToCard(next);
      });
    });
/* ---- Dog Info card (card 1 of split) ---- */
    $$('[data-cfg-type="dog_info"]').forEach(function (card) {
      var container   = card.querySelector('[data-cfg-dogs-container]');
      var template    = card.querySelector('[data-cfg-dog-entry]');
      var addBtn      = card.querySelector('[data-cfg-add-dog]');
      var continueBtn = card.querySelector('[data-cfg-doginfo-continue]');
      var maxDogs     = parseInt(card.getAttribute('data-cfg-max-dogs'), 10) || 5;
      var stepNum     = parseInt(card.getAttribute('data-cfg-step'), 10);
      var breedOther  = card.getAttribute('data-cfg-breed-other-value') || 'Mixed Breed / Other';
      var breedOptions = [];
      try {
        var rawBreedOptions = JSON.parse(card.getAttribute('data-cfg-breed-options') || '[]');
        if (Array.isArray(rawBreedOptions)) {
          breedOptions = rawBreedOptions.map(function (val) { return String(val || '').trim(); }).filter(Boolean);
        }
      } catch (_e) {
        breedOptions = [];
      }
      if (!breedOptions.some(function (val) { return String(val).toLowerCase() === String(breedOther).toLowerCase(); })) {
        breedOptions.push(breedOther);
      }
      var knownBreeds = {};
var knownBreedCanonicalByKey = {};
      breedOptions.forEach(function (val) {
var canonical = String(val || '').trim();
var key = canonical.toLowerCase();
if (!key) return;
knownBreeds[key] = true;
knownBreedCanonicalByKey[key] = canonical;
      });
      try {
        var rawBreedAvatarMap = JSON.parse(card.getAttribute('data-cfg-breed-avatar-map') || '{}');
        if (rawBreedAvatarMap && typeof rawBreedAvatarMap === 'object') {
          Object.keys(rawBreedAvatarMap).forEach(function (breedName) {
            var key = normalizeBreedKey(breedName);
            var url = String(rawBreedAvatarMap[breedName] || '');
            if (!key || !url) return;
            dogBreedExactAvatarByKey[key] = url;
          });
        }
      } catch (_avatarErr) {}
      var breedComboboxIdSeed = 0;
      var weightComboboxIdSeed = 0;
      var WEIGHT_MIN_LBS = 1;
      var WEIGHT_MAX_LBS = 200;
      var MAX_BREED_SUGGESTIONS = 14;
var BREED_SEARCH_SUFFIXES = ['dog', 'terrier', 'spaniel', 'retriever', 'shepherd', 'hound'];
var BREED_SEARCH_EXPLICIT_ALIASES = {
'labrador retriever': ['lab', 'labrador', 'chocolate lab', 'black lab', 'yellow lab', 'english lab', 'american lab'],
'golden retriever': ['golden'],
'german shepherd dog': ['german shepherd', 'gsd', 'alsatian'],
'french bulldog': ['frenchie'],
'american pit bull terrier': ['pitbull', 'pit bull', 'pittie'],
'cavalier king charles spaniel': ['cavalier', 'king charles'],
'english toy spaniel': ['king charles spaniel'],
'yorkshire terrier': ['yorkie'],
'dachshund': ['doxie', 'wiener dog', 'sausage dog'],
'shetland sheepdog': ['sheltie'],
'australian shepherd': ['aussie'],
'siberian husky': ['husky'],
'doberman pinscher': ['doberman'],
'rottweiler': ['rottie'],
'pomeranian': ['pom'],
'miniature schnauzer': ['mini schnauzer'],
'miniature pinscher': ['min pin'],
'west highland white terrier': ['westie'],
'cocker spaniel': ['cocker'],
'english cocker spaniel': ['english cocker'],
'american cocker spaniel': ['american cocker'],
'staffordshire bull terrier': ['staffy'],
'chihuahua': ['chi'],
'great pyrenees': ['pyrenees'],
'belgian malinois': ['malinois'],
'wirehaired pointing griffon': ['griffon'],
'standard poodle': ['poodle standard'],
'miniature poodle': ['mini poodle'],
'toy poodle': ['poodle toy'],
'american staffordshire terrier': ['amstaff'],
'mixed breed other': ['mixed breed', 'mixed', 'mix', 'mutt', 'crossbreed', 'cross breed', 'rescue mix', 'unknown mix']
};
function splitAliasTokens(value) {
var normalized = normalizeForSearch(value);
if (!normalized) return [];
var parts = normalized.split(' ').filter(Boolean);
var out = [normalized];
if (parts.length > 1) out.push(parts.join(''));
if (parts.length >= 2) out.push(parts.slice(0, 2).join(' '));
return out;
}
function buildBreedSearchIndex(options) {
var index = [];
options.forEach(function (breed) {
var canonical = String(breed || '').trim();
if (!canonical) return;
var canonicalNormalized = normalizeForSearch(canonical);
if (!canonicalNormalized) return;
var terms = {};
splitAliasTokens(canonical).forEach(function (term) {
if (term) terms[term] = true;
});
var parts = canonicalNormalized.split(' ').filter(Boolean);
var trimmedParts = parts.slice();
while (trimmedParts.length && BREED_SEARCH_SUFFIXES.indexOf(trimmedParts[trimmedParts.length - 1]) > -1) {
trimmedParts.pop();
}
if (trimmedParts.length) {
var trimmed = trimmedParts.join(' ');
splitAliasTokens(trimmed).forEach(function (term) {
if (term) terms[term] = true;
});
}
if (parts.length > 1) {
parts.forEach(function (token) {
if (token && token.length >= 4 && BREED_SEARCH_SUFFIXES.indexOf(token) === -1) terms[token] = true;
});
}
var explicit = BREED_SEARCH_EXPLICIT_ALIASES[canonicalNormalized] || [];
explicit.forEach(function (alias) {
splitAliasTokens(alias).forEach(function (term) {
if (term) terms[term] = true;
});
});
index.push({
breed: canonical,
terms: Object.keys(terms)
});
});
return index;
}
var breedSearchIndex = buildBreedSearchIndex(breedOptions);
      function getEntries() {
        return container.querySelectorAll('[data-cfg-dog-entry]');
      }
var expandedEntryIndex = 0;
var activeEditEntryIndex = 0;
var explicitDoneEntryIndex = -1;
var entriesViewUpdateScheduled = false;
function scheduleEntriesViewUpdate() {
if (entriesViewUpdateScheduled) return;
entriesViewUpdateScheduled = true;
window.requestAnimationFrame(function () {
entriesViewUpdateScheduled = false;
updateEntriesView();
});
}
function entryIsComplete(entry) {
var nameEl = entry.querySelector('[data-cfg-dog-name]');
if (!nameEl || !nameEl.value.trim()) return false;
var w = parseInt((entry.querySelector('[data-cfg-weight]') || {}).value, 10);
if (!w || w <= 0) return false;
var sexEl = entry.querySelector('[data-cfg-sex]');
if (!sexEl || !String(sexEl.value || '').trim()) return false;
var breedInput = entry.querySelector('[data-cfg-breed]');
var customInput = entry.querySelector('[data-cfg-breed-custom]');
if (!breedInput || !String(breedInput.value || '').trim()) return false;
if (isBreedOtherValue(breedInput.value) && customInput && !customInput.value.trim()) return false;
var lifeStageEl = entry.querySelector('[data-cfg-life-stage]');
if (!lifeStageEl || !String(lifeStageEl.value || '').trim()) return false;
/* Activity and goal are only asked for non-growth dogs. */
if (entryAdultFieldsRequired(entry)) {
var activityEl = entry.querySelector('[data-cfg-activity]');
if (!activityEl || !String(activityEl.value || '').trim()) return false;
var goalEl = entry.querySelector('[data-cfg-goal]');
if (!goalEl || !String(goalEl.value || '').trim()) return false;
}
var rawEl = entry.querySelector('[data-cfg-raw-percent]');
if (!rawEl || !(Number(rawEl.value) > 0)) return false;
return true;
}
function entrySelectedRawPercent(entry) {
var rawEl = entry.querySelector('[data-cfg-raw-percent]');
var n = Number(rawEl && rawEl.value);
return n > 0 ? normalizeRawPercent(n) : 0;
}
function entryPortionReady(entry, idx) {
if (!entryIsComplete(entry)) return false;
if (entrySelectedRawPercent(entry) < 100) return true;
var dog = selections.dogs && selections.dogs[idx];
if (!isRawPortionDogComplete(dog)) return false;
var basis = String(dog.portion_basis || '');
if (basis && basis !== dogPortionBasis(dog)) return false;
return true;
}
function setEntryView(entry, collapsed) {
var idx = Array.prototype.indexOf.call(getEntries(), entry);
var oneBased = idx + 1;
var nameDisplay = entry.querySelector('[data-cfg-dog-name-display]');
var breedDisplay = entry.querySelector('[data-cfg-dog-breed-display]');
var nameInput = entry.querySelector('[data-cfg-dog-name]');
var name = nameInput ? nameInput.value.trim() : '';
var breedValue = getBreedValue(entry);
if (nameDisplay) nameDisplay.textContent = titleCase(name) || ('Dog ' + oneBased);
if (breedDisplay) breedDisplay.textContent = breedValue || 'Breed';
if (collapsed) {
snapshotEntryIdentity(entry);
entry.classList.add('is-collapsed');
} else {
entry.classList.remove('is-collapsed');
}
}
function updateEntriesView(optionalIndex) {
if (optionalIndex !== undefined) {
expandedEntryIndex = Math.max(0, Math.min(optionalIndex, getEntries().length - 1));
activeEditEntryIndex = expandedEntryIndex;
}
var entries = getEntries();
if (entries.length <= 1) {
entries.forEach(function (entry) {
entry.classList.remove('is-collapsed');
});
activeEditEntryIndex = 0;
explicitDoneEntryIndex = -1;
entries.forEach(function (entry) {
var doneBtn = entry.querySelector('[data-cfg-dog-done]');
if (doneBtn) doneBtn.hidden = true;
var removeFormBtn = entry.querySelector('[data-cfg-dog-remove-form]');
if (removeFormBtn) removeFormBtn.hidden = true;
});
return;
}
if (!isFinite(explicitDoneEntryIndex) || explicitDoneEntryIndex >= entries.length) explicitDoneEntryIndex = -1;
if (explicitDoneEntryIndex >= 0) activeEditEntryIndex = explicitDoneEntryIndex;
if (activeEditEntryIndex >= entries.length) activeEditEntryIndex = entries.length - 1;
if (explicitDoneEntryIndex < 0 && activeEditEntryIndex >= 0 && entryPortionReady(entries[activeEditEntryIndex], activeEditEntryIndex) && optionalIndex === undefined) {
activeEditEntryIndex = -1;
}
if (activeEditEntryIndex < 0) {
var firstIncompleteIdx = -1;
for (var incompleteIdx = 0; incompleteIdx < entries.length; incompleteIdx++) {
if (!entryPortionReady(entries[incompleteIdx], incompleteIdx)) {
firstIncompleteIdx = incompleteIdx;
break;
}
}
activeEditEntryIndex = firstIncompleteIdx;
}
for (var i = 0; i < entries.length; i++) {
var entry = entries[i];
setEntryView(entry, i !== activeEditEntryIndex);
var doneBtn = entry.querySelector('[data-cfg-dog-done]');
if (doneBtn) {
var showDone = i === explicitDoneEntryIndex && !entry.classList.contains('is-collapsed');
doneBtn.hidden = !showDone;
}
var removeFormBtn = entry.querySelector('[data-cfg-dog-remove-form]');
if (removeFormBtn) {
var showRemove = !entry.classList.contains('is-collapsed') && entries.length > 1 && i !== explicitDoneEntryIndex;
removeFormBtn.hidden = !showRemove;
}
}
}
      function collectDogsBasic() {
        var dogsBasic = [];
        getEntries().forEach(function (entry, idx) {
          var nameEl  = entry.querySelector('[data-cfg-dog-name]');
          var weightEl = entry.querySelector('[data-cfg-weight]');
var sexEl = entry.querySelector('[data-cfg-sex]');
var lifeStageEl = entry.querySelector('[data-cfg-life-stage]');
var activityEl = entry.querySelector('[data-cfg-activity]');
var goalEl = entry.querySelector('[data-cfg-goal]');
          var breedValue = getBreedValue(entry);
          var avatar = getDogAvatarModel({ name: nameEl ? nameEl.value.trim() : '', breed: breedValue }, idx);
          var birthMeta = getEntryBirthMeta(entry);
          var stageValue = lifeStageEl ? String(lifeStageEl.value || '').trim() : '';
          var goalValue = goalEl ? normalizeGoalValue(goalEl.value) : '';
          var activityValue = activityEl ? String(activityEl.value || '').trim() : '';
          // Growth-stage dogs aren't asked for goal or activity: the growth
          // curve is the goal, and puppy metabolism runs high regardless.
          if (isGrowthStageKey(stageValue)) {
            goalValue = 'maintain';
            activityValue = 'recommended';
          }
          dogsBasic.push({
            name:   nameEl  ? nameEl.value.trim()  : '',
            breed:  breedValue,
            weight: weightEl ? parseInt(weightEl.value, 10) : 0,
sex:    sexEl ? String(sexEl.value || '').trim() : '',
life_stage: stageValue,
birthdate: birthMeta.birthdate || '',
age_estimated: !!birthMeta.estimated,
activity: activityValue,
goal: goalValue,
raw_percent: (function () {
var rawEl = entry.querySelector('[data-cfg-raw-percent]');
var rawPct = Number(rawEl && rawEl.value);
return rawPct > 0 ? normalizeRawPercent(rawPct) : 0;
})(),
            avatar: avatar.src,
            avatar_fallback: avatar.fallback
          });
        });
        return dogsBasic;
      }
      function syncDogInfoState() {
        if (isHydratingState) return;
        var nextDogsBasic = collectDogsBasic();
        var prevState = JSON.stringify(selections.dogs_basic || []);
        var nextState = JSON.stringify(nextDogsBasic);
        selections.dogs_basic = nextDogsBasic;
selections.dogs = nextDogsBasic.map(function (dog, idx) {
var prior = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var weight = Number((dog && dog.weight) || 0);
var stage = String((dog && dog.life_stage) || '').trim().toLowerCase();
var activity = String((dog && dog.activity) || '').trim().toLowerCase();
var goal = normalizeGoalValue((dog && dog.goal) || '');
var daily = (weight > 0 && stage && activity) ? getDailyIntake(weight, stage, activity, goal) : 0;
var nextDog = {
name: String((dog && dog.name) || '').trim(),
breed: String((dog && dog.breed) || '').trim(),
sex: String((dog && dog.sex) || '').trim(),
weight: weight > 0 ? weight : 0,
life_stage: stage,
birthdate: String((dog && dog.birthdate) || '').trim(),
age_estimated: !!(dog && dog.age_estimated),
activity: activity,
goal: goal,
daily_intake: daily
};
var rawPct = Number(dog && dog.raw_percent);
if (rawPct > 0) nextDog.raw_percent = normalizeRawPercent(rawPct);
var fullRaw = rawPct > 0 && normalizeRawPercent(rawPct) >= 100;
if (fullRaw && prior.portion_confirmed && Number(prior.portion_oz) > 0) {
var portionBasis = dogPortionBasis(nextDog);
var priorPortionBasis = String(prior.portion_basis || '') || dogPortionBasis(prior);
if (priorPortionBasis === portionBasis) {
nextDog.portion_oz = Number(prior.portion_oz);
nextDog.portion_confirmed = true;
if (prior.portion_choice_mode) nextDog.portion_choice_mode = prior.portion_choice_mode;
if (prior.portion_user_selected) nextDog.portion_user_selected = true;
nextDog.portion_basis = portionBasis;
}
}
return nextDog;
});
syncPortionDailyTotal();
if (typeof updateMealPrices === 'function') updateMealPrices();
var nextDogCount = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
if (selections.per_dog_protein && Array.isArray(selections.dog_proteins) && selections.dog_proteins.length) {
var priorDogProteins = selections.dog_proteins.slice();
var normalizedProteinByIdx = getNormalizedPerDogProteinMap(nextDogCount, priorDogProteins, selections.dogs);
var normalizedDogProteins = [];
for (var proteinIdx = 0; proteinIdx < nextDogCount; proteinIdx++) {
var normalizedProtein = String(normalizedProteinByIdx[proteinIdx] || '').trim();
if (!normalizedProtein) continue;
var matchingRow = priorDogProteins.find(function (row) {
if (!row) return false;
var rowIdx = Number(row.dogIdx);
if (isFinite(rowIdx) && rowIdx === proteinIdx && String(row.protein || '').trim()) return proteinsMatch(row.protein, normalizedProtein);
return proteinsMatch(row.protein, normalizedProtein);
});
var normalizedPrice = Number((matchingRow && matchingRow.price) || resolveProteinPrice(normalizedProtein) || 0);
var carriedProteins = (matchingRow && Array.isArray(matchingRow.proteins) && matchingRow.proteins.length)
? matchingRow.proteins.slice()
: [{ protein: normalizedProtein, price_cents: normalizedPrice }];
normalizedDogProteins.push({
dogIdx: proteinIdx,
dogName: titleCase((selections.dogs[proteinIdx] && selections.dogs[proteinIdx].name) || '') || ('Dog ' + (proteinIdx + 1)),
protein: normalizedProtein,
price: normalizedPrice,
proteins: carriedProteins,
daily_intake: Number((selections.dogs[proteinIdx] && selections.dogs[proteinIdx].daily_intake) || 0)
});
}
selections.dog_proteins = normalizedDogProteins;
if (nextDogCount <= 1) {
var singleProtein = normalizedDogProteins[0] ? String(normalizedDogProteins[0].protein || '').trim() : '';
if (singleProtein) {
selections.protein = singleProtein;
var singlePrice = Number((normalizedDogProteins[0] && normalizedDogProteins[0].price) || resolveProteinPrice(singleProtein) || 0);
if (singlePrice > 0) selections.product_price = singlePrice;
/* Carry the (multi-)recipe set into the shared household list so a
 * collapsed single dog keeps all of its recipes. */
var carried = (normalizedDogProteins[0] && Array.isArray(normalizedDogProteins[0].proteins) && normalizedDogProteins[0].proteins.length)
? normalizedDogProteins[0].proteins.slice()
: [{ protein: singleProtein, price_cents: singlePrice }];
selections.household_proteins = carried;
}
delete selections.per_dog_protein;
}
} else {
if (!selections.per_dog_protein) selections.dog_proteins = [];
if (nextDogCount <= 1) delete selections.per_dog_protein;
}
        if (prevState !== nextState) invalidateFromDogInfo(stepNum, { resetProductSelection: false });
updateDogInfoPortionSummary();
        if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
        if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
        if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
        syncDogPortionPanels();
        saveProgressState();
      }
      function updateLabels() {
        var entries = getEntries();
        entries.forEach(function (entry, i) {
          entry.setAttribute('data-cfg-dog-entry', i + 1);
updateGoalPrompt(entry);
          updateEntryAvatar(entry, i);
        });
        syncAddDogButton();
      }
      function allEntriesComplete() {
        var entries = getEntries();
        if (!entries.length) return false;
        for (var i = 0; i < entries.length; i++) {
          if (!entryPortionReady(entries[i], i)) return false;
        }
        return true;
      }
      function syncAddDogButton() {
        if (!addBtn) return;
        var entries = getEntries();
        addBtn.hidden = (entries.length >= maxDogs);
        addBtn.disabled = entries.length >= maxDogs || !allEntriesComplete();
      }
      function updateEntryAvatar(entry, idx) {
        var avatarEl = entry.querySelector('[data-cfg-dog-avatar]');
var collapsedAvatarEl = entry.querySelector('[data-cfg-dog-avatar-collapsed]');
if (!avatarEl && !collapsedAvatarEl) return;
        if (!isDogAvatarEnabled) {
if (avatarEl) avatarEl.hidden = true;
if (collapsedAvatarEl) collapsedAvatarEl.hidden = true;
          return;
        }
        var nameInput = entry.querySelector('[data-cfg-dog-name]');
        var breedInput = entry.querySelector('[data-cfg-breed]');
        var committedBreed = '';
        if (breedInput) {
          committedBreed = String(breedInput.getAttribute('data-cfg-committed-breed') || '').trim();
        }
        var resolvedBreed = getBreedValue(entry);
// Keep the currently selected avatar while the user is typing a new query.
        if (!isBreedOtherValue(resolvedBreed) && !isKnownBreedValue(resolvedBreed) && committedBreed && isKnownBreedValue(committedBreed)) {
          resolvedBreed = committedBreed;
        }
        var dog = {
          name: nameInput ? nameInput.value.trim() : '',
          breed: resolvedBreed
        };
        var avatar = getDogAvatarModel(dog, idx);
        if (!dog.breed) {
// Keep a visible default avatar so empty-breed rows still render a placeholder.
          avatar.src = getDogAvatarFallbackUrl('');
          avatar.fallback = getDogAvatarFallbackUrl('');
          avatar.alt = (titleCase(dog.name) || ('Dog ' + (idx + 1))) + ' avatar';
        }
function applyAvatar(el) {
if (!el) return;
el.hidden = false;
el.setAttribute('src', avatar.src);
el.setAttribute('data-fallback-src', avatar.fallback);
el.setAttribute('alt', avatar.alt);
}
applyAvatar(avatarEl);
applyAvatar(collapsedAvatarEl);
}
      function isBreedOtherValue(value) {
        return String(value || '').trim().toLowerCase() === String(breedOther || '').trim().toLowerCase();
      }
      function isKnownBreedValue(value) {
        return !!knownBreeds[String(value || '').trim().toLowerCase()];
      }
function getCanonicalBreedLabel(value) {
return knownBreedCanonicalByKey[String(value || '').trim().toLowerCase()] || '';
}
      function normalizeForSearch(value) {
return String(value || '')
.normalize('NFKD')
.replace(/[\u0300-\u036f]/g, '')
.toLowerCase()
.replace(/[^a-z0-9]+/g, ' ')
.replace(/\s+/g, ' ')
.trim();
}
      function getFilteredBreedOptions(query) {
        var q = normalizeForSearch(query);
        /* Empty fields and committed selections open the full scrollable
           list (click-to-browse, like the portal); typing filters it. */
        var exact = q && breedOptions.some(function (b) { return normalizeForSearch(b) === q; });
        if (q.length < 2 || exact) return breedOptions.slice();
        var startsWithMatches = [];
        var containsMatches = [];
var seen = {};
breedSearchIndex.forEach(function (entry) {
if (!entry || !entry.terms || !entry.terms.length) return;
var matchesPrefix = false;
var matchesContains = false;
entry.terms.forEach(function (term) {
if (term.indexOf(q) === 0) matchesPrefix = true;
else if (term.indexOf(q) > -1) matchesContains = true;
});
if (matchesPrefix && !seen[entry.breed]) {
seen[entry.breed] = true;
startsWithMatches.push(entry.breed);
} else if (matchesContains && !seen[entry.breed]) {
seen[entry.breed] = true;
containsMatches.push(entry.breed);
}
        });
        return startsWithMatches.concat(containsMatches).slice(0, MAX_BREED_SUGGESTIONS);
      }
      function attachBreedCombobox(entry) {
        var combo = entry.querySelector('[data-cfg-breed-combobox]');
        var input = entry.querySelector('[data-cfg-breed]');
        var menu = entry.querySelector('[data-cfg-breed-options]');
        if (!combo || !input || !menu) return;
        if (combo.getAttribute('data-cfg-combobox-bound') === 'true') return;
        combo.setAttribute('data-cfg-combobox-bound', 'true');
        breedComboboxIdSeed += 1;
        var menuId = 'otto-cfg-breed-options-' + stepNum + '-' + breedComboboxIdSeed;
        menu.id = menuId;
        input.setAttribute('aria-controls', menuId);
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
        var state = {
          open: false,
          activeIndex: -1,
          options: []
        };
        function closeMenu() {
          state.open = false;
          state.activeIndex = -1;
          menu.hidden = true;
          combo.classList.remove('is-open');
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
        }
        function renderOptions() {
          menu.innerHTML = '';
          if (!state.options.length) {
            var empty = document.createElement('div');
            empty.className = 'otto-cfg-combobox__empty';
            empty.textContent = 'No matching breeds.';
            menu.appendChild(empty);
            return;
          }
          state.options.forEach(function (opt, idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'otto-cfg-combobox__option';
            btn.setAttribute('role', 'option');
            btn.setAttribute('data-cfg-breed-option', opt);
            btn.id = menuId + '-opt-' + idx;
            btn.textContent = opt;
            menu.appendChild(btn);
          });
        }
        function setActiveIndex(idx) {
          var optionEls = menu.querySelectorAll('[data-cfg-breed-option]');
          if (!optionEls.length) {
            state.activeIndex = -1;
            input.removeAttribute('aria-activedescendant');
            return;
          }
          if (idx < 0) idx = optionEls.length - 1;
          if (idx >= optionEls.length) idx = 0;
          state.activeIndex = idx;
          optionEls.forEach(function (el, i) {
            var active = i === idx;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          input.setAttribute('aria-activedescendant', optionEls[idx].id);
        }
        function openMenu() {
          if (!state.options.length) {
            closeMenu();
            return;
          }
          state.open = true;
          menu.hidden = false;
          combo.classList.add('is-open');
          input.setAttribute('aria-expanded', 'true');
        }
        function refreshMenu(shouldOpen) {
          state.options = getFilteredBreedOptions(input.value);
          renderOptions();
          if (shouldOpen && state.options.length) openMenu();
          else if (!state.options.length) closeMenu();
          else if (state.open) openMenu();
        }
        function chooseOption(value) {
          input.value = value;
          input.setAttribute('data-cfg-committed-breed', value);
          closeMenu();
          toggleBreedCustom(entry);
          validate();
          updateLabels();
          syncDogInfoState();
        }
        input.addEventListener('focus', function () {
          refreshMenu(true);
        });
        // Focus only fires once — reopen on click so a closed menu (e.g.
        // after picking a breed) can be browsed again without blurring.
        input.addEventListener('click', function () {
          if (!state.open) refreshMenu(true);
        });
        input.addEventListener('input', function () {
          refreshMenu(true);
        });
        input.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (!state.open) refreshMenu(true);
            setActiveIndex(state.activeIndex + 1);
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (!state.open) refreshMenu(true);
            setActiveIndex(state.activeIndex - 1);
          } else if (event.key === 'Enter') {
            if (!state.open) return;
            event.preventDefault();
            if (state.activeIndex >= 0 && state.options[state.activeIndex]) {
              chooseOption(state.options[state.activeIndex]);
            }
          } else if (event.key === 'Escape') {
            closeMenu();
          } else if (event.key === 'Tab') {
            closeMenu();
          }
        });
        menu.addEventListener('mousedown', function (event) {
          event.preventDefault();
        });
        menu.addEventListener('click', function (event) {
          var opt = event.target.closest('[data-cfg-breed-option]');
          if (!opt) return;
          chooseOption(opt.getAttribute('data-cfg-breed-option') || '');
        });
        document.addEventListener('click', function (event) {
          if (!combo.contains(event.target) && !menu.contains(event.target)) closeMenu();
        });
      }
      function formatWeightLabel(lbs) {
        return String(lbs) + ' lbs';
      }
      function getAllWeightOptions() {
        var opts = [];
        for (var w = WEIGHT_MIN_LBS; w <= WEIGHT_MAX_LBS; w++) opts.push(w);
        return opts;
      }
      function getFilteredWeightOptions(query) {
        var q = String(query || '').trim().toLowerCase().replace(/\s*lbs\.?\s*$/i, '').trim();
        if (!q) return getAllWeightOptions();
        var digits = q.replace(/[^\d]/g, '');
        if (!digits) return getAllWeightOptions();
        var startsWith = [];
        var contains = [];
        var seen = {};
        getAllWeightOptions().forEach(function (w) {
          var label = String(w);
          if (label.indexOf(digits) === 0 && !seen[w]) {
            seen[w] = true;
            startsWith.push(w);
          } else if (label.indexOf(digits) !== -1 && !seen[w]) {
            seen[w] = true;
            contains.push(w);
          }
        });
        return startsWith.concat(contains);
      }
      function setEntryWeight(entry, lbs) {
        var hidden = entry.querySelector('[data-cfg-weight]');
        var display = entry.querySelector('[data-cfg-weight-display]');
        var n = parseInt(lbs, 10);
        if (hidden) hidden.value = (n >= WEIGHT_MIN_LBS && n <= WEIGHT_MAX_LBS) ? String(n) : '';
        if (display) display.value = (n >= WEIGHT_MIN_LBS && n <= WEIGHT_MAX_LBS) ? formatWeightLabel(n) : '';
      }
      function attachWeightCombobox(entry) {
        var combo = entry.querySelector('[data-cfg-weight-combobox]');
        var input = entry.querySelector('[data-cfg-weight-display]');
        var hidden = entry.querySelector('[data-cfg-weight]');
        var menu = entry.querySelector('[data-cfg-weight-options]');
        if (!combo || !input || !hidden || !menu) return;
        if (combo.getAttribute('data-cfg-weight-combobox-bound') === 'true') return;
        combo.setAttribute('data-cfg-weight-combobox-bound', 'true');
        weightComboboxIdSeed += 1;
        var menuId = 'otto-cfg-weight-options-' + stepNum + '-' + weightComboboxIdSeed;
        menu.id = menuId;
        input.setAttribute('aria-controls', menuId);
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
        var state = {
          open: false,
          activeIndex: -1,
          options: []
        };
        function closeMenu() {
          state.open = false;
          state.activeIndex = -1;
          menu.hidden = true;
          combo.classList.remove('is-open');
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
        }
        function renderOptions() {
          menu.innerHTML = '';
          if (!state.options.length) {
            var empty = document.createElement('div');
            empty.className = 'otto-cfg-combobox__empty';
            empty.textContent = 'No matching weights.';
            menu.appendChild(empty);
            return;
          }
          state.options.forEach(function (opt, idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'otto-cfg-combobox__option';
            btn.setAttribute('role', 'option');
            btn.setAttribute('data-cfg-weight-option', String(opt));
            btn.id = menuId + '-opt-' + idx;
            btn.textContent = formatWeightLabel(opt);
            menu.appendChild(btn);
          });
        }
        function setActiveIndex(idx) {
          var optionEls = menu.querySelectorAll('[data-cfg-weight-option]');
          if (!optionEls.length) {
            state.activeIndex = -1;
            input.removeAttribute('aria-activedescendant');
            return;
          }
          if (idx < 0) idx = optionEls.length - 1;
          if (idx >= optionEls.length) idx = 0;
          state.activeIndex = idx;
          optionEls.forEach(function (el, i) {
            var active = i === idx;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          input.setAttribute('aria-activedescendant', optionEls[idx].id);
        }
        function openMenu() {
          if (!state.options.length) {
            closeMenu();
            return;
          }
          state.open = true;
          menu.hidden = false;
          combo.classList.add('is-open');
          input.setAttribute('aria-expanded', 'true');
        }
        function refreshMenu(shouldOpen) {
          state.options = getFilteredWeightOptions(input.value);
          renderOptions();
          if (shouldOpen && state.options.length) openMenu();
          else if (!state.options.length) closeMenu();
          else if (state.open) openMenu();
        }
        function chooseOption(value) {
          var n = parseInt(value, 10);
          if (!(n >= WEIGHT_MIN_LBS && n <= WEIGHT_MAX_LBS)) return;
          setEntryWeight(entry, n);
          closeMenu();
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
          validate();
          updateLabels();
          syncDogInfoState();
        }
        function commitFromInput() {
          var q = String(input.value || '').trim();
          if (!q) {
            var hiddenN = parseInt(hidden.value, 10);
            if (hiddenN >= WEIGHT_MIN_LBS && hiddenN <= WEIGHT_MAX_LBS) {
              setEntryWeight(entry, hiddenN);
              return;
            }
            var saved = savedDogForEntry(entry);
            var savedN = parseInt(saved && saved.weight, 10);
            if (savedN >= WEIGHT_MIN_LBS && savedN <= WEIGHT_MAX_LBS) {
              setEntryWeight(entry, savedN);
              return;
            }
            setEntryWeight(entry, '');
            hidden.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var digits = q.replace(/[^\d]/g, '');
          var n = parseInt(digits, 10);
          if (n >= WEIGHT_MIN_LBS && n <= WEIGHT_MAX_LBS) {
            chooseOption(n);
            return;
          }
          var current = parseInt(hidden.value, 10);
          setEntryWeight(entry, current >= WEIGHT_MIN_LBS ? current : '');
        }
        input.addEventListener('focus', function () {
          refreshMenu(true);
        });
        input.addEventListener('click', function () {
          if (!state.open) refreshMenu(true);
        });
        input.addEventListener('input', function () {
          refreshMenu(true);
        });
        input.addEventListener('blur', function () {
          commitFromInput();
        });
        input.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (!state.open) refreshMenu(true);
            setActiveIndex(state.activeIndex + 1);
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (!state.open) refreshMenu(true);
            setActiveIndex(state.activeIndex - 1);
          } else if (event.key === 'Enter') {
            if (!state.open) return;
            event.preventDefault();
            if (state.activeIndex >= 0 && state.options[state.activeIndex]) {
              chooseOption(state.options[state.activeIndex]);
            }
          } else if (event.key === 'Escape') {
            closeMenu();
          } else if (event.key === 'Tab') {
            closeMenu();
          }
        });
        menu.addEventListener('mousedown', function (event) {
          event.preventDefault();
        });
        menu.addEventListener('click', function (event) {
          var opt = event.target.closest('[data-cfg-weight-option]');
          if (!opt) return;
          chooseOption(opt.getAttribute('data-cfg-weight-option') || '');
        });
        document.addEventListener('click', function (event) {
          if (!combo.contains(event.target) && !menu.contains(event.target)) closeMenu();
        });
      }
      function toggleBreedCustom(entry) {
        var breedInput = entry.querySelector('[data-cfg-breed]');
        var wrap = entry.querySelector('[data-cfg-breed-custom-wrap]');
        var customInput = entry.querySelector('[data-cfg-breed-custom]');
        if (!breedInput || !wrap) return;
        if (isBreedOtherValue(breedInput.value)) {
          breedInput.value = breedOther;
          wrap.hidden = false;
          if (customInput) customInput.removeAttribute('disabled');
        } else {
          wrap.hidden = true;
          if (customInput) { customInput.value = ''; customInput.setAttribute('disabled', 'disabled'); }
        }
      }
      function getBreedValue(entry) {
        var breedInput = entry.querySelector('[data-cfg-breed]');
        var customInput = entry.querySelector('[data-cfg-breed-custom]');
        if (!breedInput) return '';
        var selected = String(breedInput.value || '').trim();
        if (!selected) return '';
        if (isBreedOtherValue(selected)) {
if (customInput && customInput.value.trim()) return normalizeCustomBreedLabel(customInput.value);
          return breedOther;
        }
var canonical = getCanonicalBreedLabel(selected);
if (canonical) return canonical;
return normalizeCustomBreedLabel(selected);
}
function applyBreedToEntry(entry, breedRaw) {
var breedEl = entry.querySelector('[data-cfg-breed]');
var customWrap = entry.querySelector('[data-cfg-breed-custom-wrap]');
var customInput = entry.querySelector('[data-cfg-breed-custom]');
if (!breedEl) return;
var normalizedBreed = String(breedRaw || '').trim();
if (!normalizedBreed) return;
if (isKnownBreedValue(normalizedBreed) && !isBreedOtherValue(normalizedBreed)) {
var canonical = getCanonicalBreedLabel(normalizedBreed) || normalizedBreed;
breedEl.value = canonical;
breedEl.setAttribute('data-cfg-committed-breed', canonical);
if (customWrap) customWrap.hidden = true;
if (customInput) {
customInput.value = '';
customInput.setAttribute('disabled', 'disabled');
}
} else {
breedEl.value = breedOther;
breedEl.setAttribute('data-cfg-committed-breed', breedOther);
if (customWrap) customWrap.hidden = false;
if (customInput) {
customInput.removeAttribute('disabled');
customInput.value = isBreedOtherValue(normalizedBreed) ? '' : normalizeCustomBreedLabel(normalizedBreed);
}
}
}
function snapshotEntryIdentity(entry) {
if (!entry) return;
var breed = getBreedValue(entry);
if (breed) entry.setAttribute('data-cfg-saved-breed', breed);
var hidden = entry.querySelector('[data-cfg-weight]');
var n = parseInt(hidden && hidden.value, 10);
if (n >= WEIGHT_MIN_LBS && n <= WEIGHT_MAX_LBS) {
entry.setAttribute('data-cfg-saved-weight', String(n));
}
}
function savedDogForEntry(entry) {
var idx = Array.prototype.indexOf.call(getEntries(), entry);
if (idx < 0) return null;
var basic = (Array.isArray(selections.dogs_basic) && selections.dogs_basic[idx]) ? selections.dogs_basic[idx] : {};
var full = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
return {
breed: String(basic.breed || full.breed || entry.getAttribute('data-cfg-saved-breed') || '').trim(),
weight: basic.weight || full.weight || entry.getAttribute('data-cfg-saved-weight') || ''
};
}
/** Fill blank breed/weight only — used after Edit unhides a collapsed row. */
function restoreEntryIdentityFields(entry) {
if (!entry) return;
var saved = savedDogForEntry(entry) || {};
var hidden = entry.querySelector('[data-cfg-weight]');
var display = entry.querySelector('[data-cfg-weight-display]');
var hiddenN = parseInt(hidden && hidden.value, 10);
var savedN = parseInt(saved.weight, 10);
var displayEmpty = !(display && String(display.value || '').trim());
var hiddenValid = hiddenN >= WEIGHT_MIN_LBS && hiddenN <= WEIGHT_MAX_LBS;
var savedValid = savedN >= WEIGHT_MIN_LBS && savedN <= WEIGHT_MAX_LBS;
if (displayEmpty) {
if (savedValid) setEntryWeight(entry, savedN);
else if (hiddenValid) setEntryWeight(entry, hiddenN);
} else if (!hiddenValid && savedValid) {
setEntryWeight(entry, savedN);
}
var breedEl = entry.querySelector('[data-cfg-breed]');
if (breedEl && !String(breedEl.value || '').trim()) {
var committed = String(breedEl.getAttribute('data-cfg-committed-breed') || '').trim();
var breedToApply = saved.breed || (committed && !isBreedOtherValue(committed) ? committed : '');
if (breedToApply) applyBreedToEntry(entry, breedToApply);
}
if (breedEl && breedEl.value) breedEl.value = breedEl.value;
if (display && display.value) display.value = display.value;
}
function restoreEntryIdentityFieldsLater(entry) {
restoreEntryIdentityFields(entry);
window.requestAnimationFrame(function () {
restoreEntryIdentityFields(entry);
window.setTimeout(function () { restoreEntryIdentityFields(entry); }, 300);
});
}
function updateGoalPrompt(entry) {
if (!entry) return;
var goalSelect = entry.querySelector('[data-cfg-goal]');
if (!goalSelect) return;
var promptOption = goalSelect.querySelector('[data-cfg-goal-prompt]');
if (!promptOption) return;
var nameInput = entry.querySelector('[data-cfg-dog-name]');
var dogName = titleCase(String((nameInput && nameInput.value) || '').trim());
var prompt = dogName ? ("What's your goal for " + dogName + '?') : "What's your goal?";
if (promptOption.textContent !== prompt) promptOption.textContent = prompt;
goalSelect.setAttribute('aria-label', prompt);
}
      function requiredFieldsForEntry(entry) {
        var nameEl = entry.querySelector('[data-cfg-dog-name]');
        var breedInput = entry.querySelector('[data-cfg-breed]');
        var customInput = entry.querySelector('[data-cfg-breed-custom]');
        var weightEl = entry.querySelector('[data-cfg-weight]');
        var weightDisplay = entry.querySelector('[data-cfg-weight-display]');
        var sexEl = entry.querySelector('[data-cfg-sex]');
        var ageEl = entry.querySelector('[data-cfg-age-range]');
        var activityEl = entry.querySelector('[data-cfg-activity]');
        var goalEl = entry.querySelector('[data-cfg-goal]');
        var w = parseInt((weightEl || {}).value, 10);
        var fields = [];
        if (nameEl) fields.push({ el: nameEl, valid: !!nameEl.value.trim() });
        if (breedInput) fields.push({ el: breedInput, valid: !!String(breedInput.value || '').trim() });
        if (customInput && breedInput && isBreedOtherValue(breedInput.value)) {
          var customWrap = customInput.closest('[data-cfg-breed-custom-wrap]');
          if (!customWrap || !customWrap.hidden) {
            fields.push({ el: customInput, valid: !!customInput.value.trim() });
          }
        }
        if (weightDisplay || weightEl) {
          fields.push({ el: weightDisplay || weightEl, valid: !!(w && w > 0) });
        }
        if (sexEl) fields.push({ el: sexEl, valid: !!String(sexEl.value || '').trim() });
        if (ageEl) fields.push({ el: ageEl, valid: !!String(ageEl.value || '').trim() });
        if (entryAdultFieldsRequired(entry)) {
          var activityWrap = activityEl && activityEl.closest('[data-cfg-activity-wrap]');
          var goalWrap = goalEl && goalEl.closest('[data-cfg-goal-wrap]');
          if (activityEl && (!activityWrap || !activityWrap.hidden)) {
            fields.push({ el: activityEl, valid: !!String(activityEl.value || '').trim() });
          }
          if (goalEl && (!goalWrap || !goalWrap.hidden)) {
            fields.push({ el: goalEl, valid: !!String(goalEl.value || '').trim() });
          }
        } else {
          setControlNeedsAnswer(activityEl, false);
          setControlNeedsAnswer(goalEl, false);
        }
        var rawEl = entry.querySelector('[data-cfg-raw-percent]');
        if (rawEl) fields.push({ el: rawEl, valid: Number(rawEl.value) > 0 });
        return fields;
      }
      function promptDogInfoGaps(markAllEmpty) {
        getEntries().forEach(function (entry) {
          markOutOfOrderRequired(requiredFieldsForEntry(entry), !!markAllEmpty);
        });
        if (!markAllEmpty) return;
        var firstInvalid = card.querySelector('.otto-cfg-field-input.is-invalid, .input.is-invalid');
        if (firstInvalid && typeof firstInvalid.focus === 'function') {
          try { firstInvalid.focus({ preventScroll: true }); } catch (_e) { firstInvalid.focus(); }
          if (typeof firstInvalid.scrollIntoView === 'function') {
            firstInvalid.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
      }
      function setDogInfoContinueBlocked(blocked) {
        if (!continueBtn) return;
        continueBtn.disabled = false;
        continueBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        continueBtn.classList.toggle('is-blocked', !!blocked);
      }
      function validate() {
        var entries = getEntries();
        var allValid = true;
        entries.forEach(function (entry, idx) {
          var nameEl = entry.querySelector('[data-cfg-dog-name]');
          if (!nameEl || !nameEl.value.trim()) allValid = false;
          var w = parseInt((entry.querySelector('[data-cfg-weight]') || {}).value, 10);
          if (!w || w <= 0) allValid = false;
var sexEl = entry.querySelector('[data-cfg-sex]');
if (!sexEl || !String(sexEl.value || '').trim()) allValid = false;
          var breedInput = entry.querySelector('[data-cfg-breed]');
          var customInput = entry.querySelector('[data-cfg-breed-custom]');
          if (!breedInput || !String(breedInput.value || '').trim()) {
            allValid = false;
          } else if (isBreedOtherValue(breedInput.value) && customInput && !customInput.value.trim()) {
            allValid = false;
          }
var lifeStageEl = entry.querySelector('[data-cfg-life-stage]');
if (!lifeStageEl || !String(lifeStageEl.value || '').trim()) allValid = false;
if (entryAdultFieldsRequired(entry)) {
var activityEl = entry.querySelector('[data-cfg-activity]');
if (!activityEl || !String(activityEl.value || '').trim()) allValid = false;
var goalEl = entry.querySelector('[data-cfg-goal]');
if (!goalEl || !String(goalEl.value || '').trim()) allValid = false;
}
var rawEl = entry.querySelector('[data-cfg-raw-percent]');
if (!rawEl || !(Number(rawEl.value) > 0)) allValid = false;
if (allValid && !entryPortionReady(entry, idx)) allValid = false;
        });
        setDogInfoContinueBlocked(!allValid);
        promptDogInfoGaps(false);
        syncAddDogButton();
      }
      function syncDogPortionPanels() {
        getEntries().forEach(function (entry, idx) {
          var shell = entry.querySelector('[data-cfg-dog-portion-confirm]');
          var choices = entry.querySelector('[data-cfg-dog-portion-choices]');
          if (!shell || !choices) return;
          if (!entryIsComplete(entry) || entrySelectedRawPercent(entry) < 100) {
            shell.classList.remove('is-open');
            shell.setAttribute('aria-hidden', 'true');
            shell.removeAttribute('data-portion-sig');
            choices.innerHTML = '';
            return;
          }
          var dog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
          var recommendedOz = getDogRecommendedPortionOz(dog);
          var helperEl = shell.querySelector('[data-cfg-dog-portion-helper]');
          if (helperEl) {
            helperEl.textContent = 'Based on your dog\u2019s age, weight, and activity level, we recommend ' + Math.round(recommendedOz) + ' oz per day. Please accept or adjust your dog\u2019s daily portion below:';
          }
          var adjusterLadder = getRawPortionAdjusterLadder();
          var stepperOz = (dog.portion_choice_mode === 'custom' && Number(dog.portion_oz) > 0)
            ? Number(dog.portion_oz)
            : Math.max(recommendedOz, adjusterLadder[0] || 0);
          var rungIdx = nearestPortionRungIndex(adjusterLadder, stepperOz);
          var displayOz = adjusterLadder[rungIdx] || stepperOz;
          var sig = [
            Math.round(recommendedOz),
            Math.round(Number(dog.portion_oz) || 0),
            dog.portion_choice_mode || '',
            dog.portion_confirmed ? 1 : 0,
            dog.portion_user_selected ? 1 : 0,
            rungIdx
          ].join('|');
          var wasOpen = shell.classList.contains('is-open');
          if (shell.getAttribute('data-portion-sig') !== sig) {
            shell.setAttribute('data-portion-sig', sig);
            var acceptLabel = 'Use recommended ' + Math.round(recommendedOz) + ' oz/day';
            var customLabel = 'Adjust full daily portion';
            var acceptSelected = !!(dog.portion_user_selected && dog.portion_choice_mode === 'recommended');
            var customSelected = dog.portion_choice_mode === 'custom';
            choices.innerHTML =
              '<div class="otto-cfg-raw-portion-choices">' +
              '<button type="button" class="otto-cfg-tile otto-cfg-tile--product otto-cfg-raw-portion-accept' + (acceptSelected ? ' is-selected' : '') + '" data-cfg-dog-portion-accept>' +
              '<span class="otto-cfg-tile__text"><span class="otto-cfg-tile__label">' + esc(acceptLabel) + '</span></span></button>' +
              '<button type="button" class="otto-cfg-tile otto-cfg-tile--product otto-cfg-raw-portion-different' + (customSelected ? ' is-selected' : '') + '" data-cfg-dog-portion-custom>' +
              '<span class="otto-cfg-tile__text"><span class="otto-cfg-tile__label">' + esc(customLabel) + '</span></span></button>' +
              '</div>' +
              '<div class="otto-cfg-raw-portion-custom"' + (customSelected ? '' : ' hidden') + '>' +
              '<div class="otto-cfg-portion-stepper">' +
              '<button type="button" class="otto-cfg-portion-stepper__btn" data-cfg-dog-portion-step="-1" aria-label="Smaller portion"' + (rungIdx <= 0 ? ' disabled' : '') + '>&minus;</button>' +
              '<div class="otto-cfg-portion-stepper__value">' +
              '<div class="otto-cfg-portion-stepper__oz">' + esc(String(displayOz)) + ' oz</div>' +
              '<div class="otto-cfg-portion-stepper__note">per day</div>' +
              '</div>' +
              '<button type="button" class="otto-cfg-portion-stepper__btn" data-cfg-dog-portion-step="1" aria-label="Larger portion"' + (rungIdx >= adjusterLadder.length - 1 ? ' disabled' : '') + '>&plus;</button>' +
              '</div></div>';
            var acceptBtn = choices.querySelector('[data-cfg-dog-portion-accept]');
            var customBtn = choices.querySelector('[data-cfg-dog-portion-custom]');
            if (acceptBtn) {
              acceptBtn.addEventListener('click', function () {
                var live = selections.dogs && selections.dogs[idx];
                setDogPortionChoice(idx, getDogRecommendedPortionOz(live), true, 'recommended');
                syncDogPortionPanels();
                scheduleEntriesViewUpdate();
              });
            }
            if (customBtn) {
              customBtn.addEventListener('click', function () {
                var live = selections.dogs && selections.dogs[idx];
                if (live && live.portion_choice_mode === 'custom') return;
                var ladder = getRawPortionAdjusterLadder();
                var oz = getDogRecommendedPortionOz(live);
                openDogCustomPortion(idx, Math.max(oz, ladder[0] || oz));
                syncDogPortionPanels();
              });
            }
            choices.querySelectorAll('[data-cfg-dog-portion-step]').forEach(function (btn) {
              btn.addEventListener('click', function () {
                var live = selections.dogs && selections.dogs[idx];
                var ladder = getRawPortionAdjusterLadder();
                var recommended = getDogRecommendedPortionOz(live);
                var currentOz = (live && live.portion_choice_mode === 'custom' && Number(live.portion_oz) > 0)
                  ? Number(live.portion_oz)
                  : Math.max(recommended, ladder[0] || 0);
                var currentIdx = nearestPortionRungIndex(ladder, currentOz);
                var nextIdx = currentIdx + Number(btn.getAttribute('data-cfg-dog-portion-step'));
                if (nextIdx < 0 || nextIdx >= ladder.length) return;
                var nextOz = ladder[nextIdx];
                if (isRawPortionOzDifferentFromRecommended(nextOz, recommended)) {
                  setDogPortionChoice(idx, nextOz, true, 'custom');
                } else {
                  revertDogCustomPortionToUnconfirmed(idx, nextOz);
                }
                syncDogPortionPanels();
                scheduleEntriesViewUpdate();
              });
            });
          }
          shell.setAttribute('aria-hidden', 'false');
          if (!wasOpen) {
            window.requestAnimationFrame(function () {
              shell.classList.add('is-open');
            });
          }
        });
        var portionsReady = true;
        getEntries().forEach(function (entry, idx) {
          if (!entryPortionReady(entry, idx)) portionsReady = false;
        });
        setDogInfoContinueBlocked(!portionsReady);
        syncAddDogButton();
      }
      function addDog() {
        if (getEntries().length >= maxDogs) return;
var hadSingleDog = getEntries().length === 1;
        var clone = template.cloneNode(true);
        clone.querySelectorAll('input').forEach(function (inp) {
          if (inp.type === 'checkbox') { inp.checked = false; }
          else { inp.value = ''; }
          inp.removeAttribute('disabled');
        });
        clone.querySelectorAll('select').forEach(function (sel) { sel.value = ''; });
        var portionShell = clone.querySelector('[data-cfg-dog-portion-confirm]');
        var portionChoices = clone.querySelector('[data-cfg-dog-portion-choices]');
        if (portionShell) {
          portionShell.classList.remove('is-open');
          portionShell.setAttribute('aria-hidden', 'true');
          portionShell.removeAttribute('data-portion-sig');
        }
        if (portionChoices) portionChoices.innerHTML = '';
        var combo = clone.querySelector('[data-cfg-breed-combobox]');
        var comboInput = clone.querySelector('[data-cfg-breed]');
        var comboMenu = clone.querySelector('[data-cfg-breed-options]');
        if (combo && !comboMenu) {
          comboMenu = document.createElement('div');
          comboMenu.className = 'otto-cfg-combobox__menu';
          comboMenu.setAttribute('data-cfg-breed-options', '');
          comboMenu.setAttribute('role', 'listbox');
          comboMenu.hidden = true;
          combo.appendChild(comboMenu);
        }
        if (combo) combo.removeAttribute('data-cfg-combobox-bound');
        if (comboInput) {
          comboInput.removeAttribute('data-cfg-committed-breed');
          comboInput.removeAttribute('aria-controls');
          comboInput.removeAttribute('aria-activedescendant');
          comboInput.setAttribute('aria-expanded', 'false');
        }
        if (comboMenu) {
          comboMenu.removeAttribute('id');
          comboMenu.innerHTML = '';
          comboMenu.hidden = true;
        }
        var weightCombo = clone.querySelector('[data-cfg-weight-combobox]');
        var weightInput = clone.querySelector('[data-cfg-weight-display]');
        var weightHidden = clone.querySelector('[data-cfg-weight]');
        var weightMenu = clone.querySelector('[data-cfg-weight-options]');
        if (weightCombo && !weightMenu) {
          weightMenu = document.createElement('div');
          weightMenu.className = 'otto-cfg-combobox__menu';
          weightMenu.setAttribute('data-cfg-weight-options', '');
          weightMenu.setAttribute('role', 'listbox');
          weightMenu.hidden = true;
          weightCombo.appendChild(weightMenu);
        }
        if (weightCombo) weightCombo.removeAttribute('data-cfg-weight-combobox-bound');
        if (weightInput) {
          weightInput.removeAttribute('aria-controls');
          weightInput.removeAttribute('aria-activedescendant');
          weightInput.setAttribute('aria-expanded', 'false');
        }
        if (weightHidden) weightHidden.value = '';
        if (weightMenu) {
          weightMenu.removeAttribute('id');
          weightMenu.innerHTML = '';
          weightMenu.hidden = true;
        }
        toggleBreedCustom(clone);
        syncEntryBirthday(clone);
        container.appendChild(clone);
        bindEntryEvents(clone);
expandedEntryIndex = getEntries().length - 1;
activeEditEntryIndex = expandedEntryIndex;
explicitDoneEntryIndex = -1;
updateEntriesView(expandedEntryIndex);
        updateLabels();
        validate();
        syncDogInfoState();
var feedingCard = $('[data-cfg-type="feeding_setup"]');
if (feedingCard && feedingCard._syncFeedingSetupUI) feedingCard._syncFeedingSetupUI();
var feedingProteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (feedingProteinModeCard && feedingProteinModeCard._syncFeedingProteinModeUI) feedingProteinModeCard._syncFeedingProteinModeUI();
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard && productCard._syncProteinModeUI) productCard._syncProteinModeUI();
if (hadSingleDog && !getSelectedFreezerSpaceProfile()) {
clearStepCompletion(stepNum);
clearStepCompletionsAfter(stepNum);
}
updateIncomplete();
}
      function removeDog(entry) {
        if (getEntries().length <= 1) return;
var entries = getEntries();
var idx = Array.prototype.indexOf.call(entries, entry);
        entry.remove();
var nextLength = entries.length - 1;
if (explicitDoneEntryIndex === idx) explicitDoneEntryIndex = -1;
else if (idx < explicitDoneEntryIndex) explicitDoneEntryIndex -= 1;
if (explicitDoneEntryIndex >= nextLength) explicitDoneEntryIndex = -1;
if (activeEditEntryIndex >= entries.length - 1) activeEditEntryIndex = Math.max(-1, entries.length - 2);
else if (idx < activeEditEntryIndex) activeEditEntryIndex -= 1;
expandedEntryIndex = Math.max(0, activeEditEntryIndex);
updateEntriesView();
        updateLabels();
        validate();
        syncDogInfoState();
      }
      function entryBirthdayOptedIn(entry) {
        var check = entry.querySelector('[data-cfg-birthday-optin-check]');
        return !!(check && check.checked);
      }
      function getEntryDogContext(entry) {
        var weightEl = entry.querySelector('[data-cfg-weight]');
        return {
          breed: getBreedValue(entry),
          weight: weightEl ? parseInt(weightEl.value, 10) || 0 : 0
        };
      }
      /* Age model: the bucket dropdown is the base answer for everyone; the
       * opt-in exact birthday (day optional) overrides it when complete. */
      function getEntryBirthMeta(entry) {
        var ctx = getEntryDogContext(entry);
        var rangeEl = entry.querySelector('[data-cfg-age-range]');
        var bucket = rangeEl ? String(rangeEl.value || '').trim() : '';
        if (entryBirthdayOptedIn(entry)) {
          var monthEl = entry.querySelector('[data-cfg-birth-month]');
          var yearEl = entry.querySelector('[data-cfg-birth-year]');
          var dayEl = entry.querySelector('[data-cfg-birth-day]');
          var month = monthEl ? parseInt(monthEl.value, 10) : 0;
          var year = yearEl ? parseInt(yearEl.value, 10) : 0;
          var day = dayEl ? parseInt(dayEl.value, 10) : 0;
          if (month >= 1 && month <= 12 && year > 1980) {
            // Day is optional; drop impossible dates (e.g. Feb 31) silently.
            var dayValid = day >= 1 && day <= 31 && new Date(year, month - 1, day).getDate() === day;
            var now = new Date();
            var future = year > now.getFullYear()
              || (year === now.getFullYear() && month > now.getMonth() + 1)
              || (year === now.getFullYear() && month === now.getMonth() + 1 && dayValid && day > now.getDate());
            if (future) return { birthdate: '', estimated: false, stage: '', future: true };
            var birthdate = year + '-' + (month < 10 ? '0' : '') + month + (dayValid ? '-' + (day < 10 ? '0' : '') + day : '');
            return { birthdate: birthdate, estimated: false, stage: deriveStageFromBirthdate(birthdate, ctx.breed, ctx.weight) };
          }
          // Opted in but the birthday is incomplete — the bucket still stands.
        }
        if (!bucket) return { birthdate: '', estimated: true, stage: '' };
        // Size-aware midpoint so the synthetic birthdate maps back to the
        // chosen bucket under this dog's own stage boundaries.
        var synthetic = (Engine && typeof Engine.birthdateForStage === 'function')
          ? Engine.birthdateForStage(bucket, settings, null, sizeClassFor(ctx.breed, ctx.weight, ''))
          : '';
        return { birthdate: synthetic, estimated: true, stage: bucket };
      }
      function syncEntryBirthday(entry) {
        var meta = getEntryBirthMeta(entry);
        var stageInput = entry.querySelector('[data-cfg-life-stage]');
        if (stageInput && stageInput.value !== (meta.stage || '')) stageInput.value = meta.stage || '';
        // An exact birthday is authoritative: snap the bucket dropdown to the
        // derived stage so the two never disagree.
        if (!meta.estimated && meta.stage) {
          var rangeSync = entry.querySelector('[data-cfg-age-range]');
          if (rangeSync && rangeSync.value !== meta.stage) rangeSync.value = meta.stage;
        }
        updateAgeModeView(entry);
        var note = entry.querySelector('[data-cfg-stage-note]');
        if (note) {
          var text = '';
          if (meta.future) {
            text = "That birthday is in the future — double-check the month and year.";
          } else if (meta.stage && !meta.estimated) {
            // Bucket picks speak for themselves; only an exact birthday adds
            // information worth confirming (derived stage + age).
            var nameInput = entry.querySelector('[data-cfg-dog-name]');
            var dogName = titleCase(String((nameInput && nameInput.value) || '').trim()) || 'Your pup';
            var stageName = lifeStageLabel(meta.stage);
            var months = (Engine && typeof Engine.ageMonthsFromBirthdate === 'function')
              ? Engine.ageMonthsFromBirthdate(meta.birthdate)
              : null;
            var ageText = (months != null && Engine && typeof Engine.formatAgeMonths === 'function')
              ? Engine.formatAgeMonths(months)
              : '';
            text = dogName + ' is a ' + stageName + (ageText ? ' (' + ageText + ' old)' : '') + '.';
          }
          note.textContent = text;
          note.hidden = !text;
        }
        // Growth-stage dogs skip the activity + goal questions entirely.
        var growth = isGrowthStageKey(meta.stage);
        var goalWrap = entry.querySelector('[data-cfg-goal-wrap]');
        if (goalWrap) goalWrap.hidden = growth;
        var activityWrap = entry.querySelector('[data-cfg-activity-wrap]');
        if (activityWrap) activityWrap.hidden = growth;
      }
      function updateAgeModeView(entry) {
        var rangeEl = entry.querySelector('[data-cfg-age-range]');
        var hasBucket = !!(rangeEl && String(rangeEl.value || '').trim());
        var optedIn = entryBirthdayOptedIn(entry);
        var optinWrap = entry.querySelector('[data-cfg-birthday-optin]');
        // The invite only appears once the base age question is answered.
        if (optinWrap) optinWrap.hidden = !(hasBucket || optedIn);
        var optinLabel = entry.querySelector('[data-cfg-birthday-optin-label]');
        if (optinLabel) {
          var nameEl = entry.querySelector('[data-cfg-dog-name]');
          var labelName = titleCase(String((nameEl && nameEl.value) || '').trim());
          /* Names ending in s take a bare apostrophe (Dennis' not Dennis's). */
          var nextLabel = 'I know ' + (labelName ? labelName + (/s$/i.test(labelName) ? '\u2019' : '\u2019s') : 'my dog\u2019s') + ' exact birthday';
          if (optinLabel.textContent !== nextLabel) optinLabel.textContent = nextLabel;
        }
        var exactWrap = entry.querySelector('[data-cfg-birthday-exact]');
        if (exactWrap) exactWrap.hidden = !optedIn;
      }
      /* Activity + goal only apply to non-growth dogs: puppy metabolism runs
       * high regardless of activity, and the growth curve is the goal. */
      function entryAdultFieldsRequired(entry) {
        var stageInput = entry.querySelector('[data-cfg-life-stage]');
        return !isGrowthStageKey(stageInput ? stageInput.value : '');
      }
      card._ottoHydrateEntryBirthday = function (entry, birthdate, estimated) {
        if (!entry) return;
        var normalized = String(birthdate || '').trim();
        var hydCtx = getEntryDogContext(entry);
        var rangeEl = entry.querySelector('[data-cfg-age-range]');
        var optinCheck = entry.querySelector('[data-cfg-birthday-optin-check]');
        var derived = deriveStageFromBirthdate(normalized, hydCtx.breed, hydCtx.weight) || '';
        if (rangeEl) rangeEl.value = derived;
        if (estimated) {
          if (optinCheck) optinCheck.checked = false;
        } else if (normalized) {
          if (optinCheck) optinCheck.checked = true;
          var m = normalized.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?/);
          var monthEl = entry.querySelector('[data-cfg-birth-month]');
          var yearEl = entry.querySelector('[data-cfg-birth-year]');
          var dayEl = entry.querySelector('[data-cfg-birth-day]');
          if (m && monthEl) monthEl.value = String(parseInt(m[2], 10));
          if (m && yearEl) yearEl.value = m[1];
          if (dayEl) dayEl.value = (m && m[3]) ? String(parseInt(m[3], 10)) : '';
        }
        syncEntryBirthday(entry);
      };
      function bindEntryEvents(entry) {
        attachBreedCombobox(entry);
        attachWeightCombobox(entry);
        // Weight and breed feed the size class, which shifts stage boundaries,
        // so they re-derive the stage too. Bound before the generic handlers
        // below so the derived stage is current by the time
        // validate()/syncDogInfoState() run.
        ['[data-cfg-birth-month]', '[data-cfg-birth-day]', '[data-cfg-birth-year]', '[data-cfg-age-range]', '[data-cfg-weight]', '[data-cfg-breed]', '[data-cfg-breed-custom]'].forEach(function (selector) {
          var el = entry.querySelector(selector);
          if (!el) return;
          el.addEventListener('change', function () { syncEntryBirthday(entry); });
        });
        var optinCheck = entry.querySelector('[data-cfg-birthday-optin-check]');
        if (optinCheck) {
          optinCheck.addEventListener('change', function () {
            syncEntryBirthday(entry);
            validate();
            syncDogInfoState();
          });
        }
        var dogNameForNote = entry.querySelector('[data-cfg-dog-name]');
        if (dogNameForNote) {
          dogNameForNote.addEventListener('input', function () { syncEntryBirthday(entry); });
        }
        entry.querySelectorAll('input, select').forEach(function (inp) {
          inp.addEventListener('input', function () {
            validate();
scheduleEntriesViewUpdate();
            syncDogInfoState();
          });
          inp.addEventListener('change', function () {
            validate();
scheduleEntriesViewUpdate();
            syncDogInfoState();
          });
        });
        var nameInput = entry.querySelector('[data-cfg-dog-name]');
if (nameInput) nameInput.addEventListener('input', function () {
updateLabels();
scheduleEntriesViewUpdate();
});
if (nameInput) nameInput.addEventListener('blur', function () {
var normalized = String(nameInput.value || '')
.trim()
.toLowerCase()
.replace(/\s+/g, ' ');
var formatted = titleCase(normalized);
if (formatted === nameInput.value) return;
nameInput.value = formatted;
validate();
updateLabels();
syncDogInfoState();
scheduleEntriesViewUpdate();
});
        var breedInput = entry.querySelector('[data-cfg-breed]');
        if (breedInput) {
          breedInput.addEventListener('change', function () {
var normalizedBreedInput = String(breedInput.value || '').trim();
if (!isBreedOtherValue(normalizedBreedInput) && normalizedBreedInput) {
var canonical = getCanonicalBreedLabel(normalizedBreedInput);
var formatted = canonical || normalizeCustomBreedLabel(normalizedBreedInput);
if (formatted && formatted !== breedInput.value) breedInput.value = formatted;
}
            toggleBreedCustom(entry);
            if (isKnownBreedValue(breedInput.value) || isBreedOtherValue(breedInput.value)) {
              breedInput.setAttribute('data-cfg-committed-breed', String(breedInput.value || '').trim());
            }
            validate();
            updateLabels();
scheduleEntriesViewUpdate();
          });
          breedInput.addEventListener('input', function () {
            toggleBreedCustom(entry);
            validate();
updateLabels();
scheduleEntriesViewUpdate();
});
breedInput.addEventListener('blur', function () {
var normalizedBreedInput = String(breedInput.value || '').trim();
if (!normalizedBreedInput || isBreedOtherValue(normalizedBreedInput)) return;
var canonical = getCanonicalBreedLabel(normalizedBreedInput);
var formatted = canonical || normalizeCustomBreedLabel(normalizedBreedInput);
if (!formatted || formatted === breedInput.value) return;
breedInput.value = formatted;
validate();
updateLabels();
syncDogInfoState();
scheduleEntriesViewUpdate();
          });
        }
        var customBreedInput = entry.querySelector('[data-cfg-breed-custom]');
        if (customBreedInput) {
          customBreedInput.addEventListener('input', function () {
            validate();
            updateLabels();
scheduleEntriesViewUpdate();
          });
          customBreedInput.addEventListener('change', function () {
var formattedBreed = normalizeCustomBreedLabel(customBreedInput.value);
if (formattedBreed !== customBreedInput.value) customBreedInput.value = formattedBreed;
            validate();
            updateLabels();
scheduleEntriesViewUpdate();
});
customBreedInput.addEventListener('blur', function () {
var formattedBreed = normalizeCustomBreedLabel(customBreedInput.value);
if (formattedBreed === customBreedInput.value) return;
customBreedInput.value = formattedBreed;
validate();
updateLabels();
syncDogInfoState();
scheduleEntriesViewUpdate();
          });
        }
        var removeBtn = entry.querySelector('[data-cfg-remove-dog]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function () { removeDog(entry); });
        }
var editBtn = entry.querySelector('[data-cfg-dog-edit]');
if (editBtn) {
editBtn.addEventListener('click', function () {
var entries = getEntries();
var idx = Array.prototype.indexOf.call(entries, entry);
if (idx >= 0) {
expandedEntryIndex = idx;
activeEditEntryIndex = idx;
explicitDoneEntryIndex = idx;
updateEntriesView();
restoreEntryIdentityFieldsLater(entry);
}
});
}
var doneBtn = entry.querySelector('[data-cfg-dog-done]');
if (doneBtn) {
doneBtn.addEventListener('click', function () {
var doneIdx = Array.prototype.indexOf.call(getEntries(), entry);
if (!entryPortionReady(entry, doneIdx)) return;
explicitDoneEntryIndex = -1;
activeEditEntryIndex = -1;
updateEntriesView();
});
}
var removeFormBtn = entry.querySelector('[data-cfg-dog-remove-form]');
if (removeFormBtn) {
removeFormBtn.addEventListener('click', function () {
removeDog(entry);
});
}
}
      getEntries().forEach(function (entry) {
        toggleBreedCustom(entry);
        syncEntryBirthday(entry);
      });
      bindEntryEvents(template);
      updateLabels();
updateEntriesView();
card._ottoUpdateEntriesView = function (optionalIndex) { updateEntriesView(optionalIndex); };
      card._ottoSetEntryWeight = setEntryWeight;
      validate();
      syncDogPortionPanels();
      card._ottoAddDog = addDog;
      card._ottoSyncAddDog = syncAddDogButton;
      card._ottoValidateDogInfo = validate;
      card._ottoSyncPortionPanels = syncDogPortionPanels;
      if (addBtn) addBtn.addEventListener('click', function () {
        if (addBtn.disabled || !allEntriesComplete()) return;
        addDog();
      });
      if (continueBtn) continueBtn.addEventListener('click', function () {
        syncDogInfoState();
        validate();
        if (continueBtn.getAttribute('aria-disabled') === 'true') {
          var formsReady = true;
          getEntries().forEach(function (entry) {
            if (!entryIsComplete(entry)) formsReady = false;
          });
          if (!formsReady) promptDogInfoGaps(true);
          else {
            var openPanel = card.querySelector('.otto-cfg-dog-portion-confirm.is-open');
            if (openPanel && typeof openPanel.scrollIntoView === 'function') {
              openPanel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
          }
          return;
        }
        markStepCompleted(stepNum);
        updateIncomplete();
        if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
        if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
        if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
        var dietCard = $('[data-cfg-type="diet_profile"]');
        if (dietCard) renderDietTiles(dietCard, true);
var next = getNextVisibleCard(stepNum);
        if (next) setTimeout(function () { scrollToCard(next); }, 300);
      });
    });
/* ---- Raw portion check (raw feeders only) ---- */
    function applyTemplateTokens(template, tokens) {
      var out = String(template || '');
      Object.keys(tokens || {}).forEach(function (key) {
        out = out.split('[' + key + ']').join(String(tokens[key] == null ? '' : tokens[key]));
      });
      return out;
    }
    function renderRawPortionTileSubtitle(template, tokens) {
      var text = applyTemplateTokens(template, tokens).trim();
      if (!text) return '';
      return '<span class="otto-cfg-tile__ingredients">' + text + '</span>';
    }
    function getRawPortionDogDisplayName(dog, idx) {
      var name = titleCase(String((dog && dog.name) || '').trim());
      return name || ('Dog ' + (idx + 1));
    }
    function isRawPortionOzDifferentFromRecommended(chosenOz, recommendedOz) {
      return Math.round(Number(chosenOz) || 0) !== Math.round(Number(recommendedOz) || 0);
    }
    function isRawPortionDogComplete(dog) {
      if (!dog || !dog.portion_user_selected || !dog.portion_confirmed || !(Number(dog.portion_oz) > 0)) return false;
      if (dog.portion_choice_mode === 'custom') {
        var recommendedOz = getDogRecommendedPortionOz(dog);
        return isRawPortionOzDifferentFromRecommended(resolveDogPortionOz(dog), recommendedOz);
      }
      return true;
    }
    function canAdvanceFromRawPortionDog(dog) {
      return isRawPortionDogComplete(dog);
    }
    function canClickRawPortionTab(dogs, tabIdx) {
      var idxs = rawPortionDogIndexes();
      var pos = idxs.indexOf(tabIdx);
      if (pos <= 0) return true;
      for (var j = 0; j < pos; j++) {
        if (!isRawPortionDogComplete(dogs[idxs[j]])) return false;
      }
      return true;
    }
    function getFirstIncompleteRawPortionDogIdx(dogs) {
      var idxs = rawPortionDogIndexes();
      for (var i = 0; i < idxs.length; i++) {
        if (!isRawPortionDogComplete(dogs[idxs[i]])) return idxs[i];
      }
      return -1;
    }
    function resolveRawPortionActiveIdx(dogs) {
      var idxs = rawPortionDogIndexes();
      if (!idxs.length) return 0;
      if (idxs.length <= 1) return idxs[0];
      var stored = Number(selections.raw_portion_active_idx);
      if (isFinite(stored) && idxs.indexOf(stored) >= 0 && canClickRawPortionTab(dogs, stored)) {
        return stored;
      }
      var firstIncomplete = getFirstIncompleteRawPortionDogIdx(dogs);
      return firstIncomplete >= 0 ? firstIncomplete : idxs[0];
    }
    function setRawPortionActiveIdx(idx) {
      selections.raw_portion_active_idx = idx;
    }
    function advanceRawPortionToNextDog(fromIdx) {
      var idxs = rawPortionDogIndexes();
      if (idxs.length <= 1) return;
      var pos = idxs.indexOf(fromIdx);
      if (pos >= 0 && pos + 1 < idxs.length) {
        setRawPortionActiveIdx(idxs[pos + 1]);
        return;
      }
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      var firstIncomplete = getFirstIncompleteRawPortionDogIdx(dogs);
      if (firstIncomplete >= 0) setRawPortionActiveIdx(firstIncomplete);
    }
    function openDogCustomPortion(dogIdx, oz) {
      if (!Array.isArray(selections.dogs) || !selections.dogs[dogIdx]) return;
      var adjusterLadder = getRawPortionAdjusterLadder();
      var snapped = (Engine && typeof Engine.snapOz === 'function')
        ? Engine.snapOz(Number(oz) || 0, adjusterLadder, 'nearest')
        : Number(oz) || 0;
      var dog = selections.dogs[dogIdx];
      dog.portion_oz = snapped;
      dog.portion_choice_mode = 'custom';
      delete dog.portion_confirmed;
      delete dog.portion_user_selected;
      delete dog.portion_basis;
      saveProgressState();
    }
    function revertDogCustomPortionToUnconfirmed(dogIdx, oz) {
      if (!Array.isArray(selections.dogs) || !selections.dogs[dogIdx]) return;
      var adjusterLadder = getRawPortionAdjusterLadder();
      var snapped = (Engine && typeof Engine.snapOz === 'function')
        ? Engine.snapOz(Number(oz) || 0, adjusterLadder, 'nearest')
        : Number(oz) || 0;
      var dog = selections.dogs[dogIdx];
      dog.portion_oz = snapped;
      dog.portion_choice_mode = 'custom';
      delete dog.portion_confirmed;
      delete dog.portion_user_selected;
      delete dog.portion_basis;
      snapDogRawPercentToFeasible(dogIdx);
      syncPortionDailyTotal();
      updateDogInfoPortionSummary();
      invalidateDeliverySelections();
      invalidateReviewStep();
      renderDeliveryTiles(true);
      renderFreezerProgramCard(true);
      if (typeof renderRawShareCard === 'function') renderRawShareCard();
      saveProgressState();
    }
    function getRawPortionContinueArrowHtml() {
      return '<svg aria-hidden="true" focusable="false" width="10" class="otto-cfg-raw-portion-continue__arrow" viewBox="0 0 10 10">'
        + '<path stroke="currentColor" stroke-width="1.5" d="m4 1 4 4m0 0L4 9m4-4H0"/></svg>';
    }
    function nextDogLabelHasArrow(label) {
      return /(?:→|⟶|➜|➔|➡|►|»|>)\s*$/.test(String(label || ''));
    }
    function nextDogContinueButtonHtml(label) {
      var text = String(label || 'Next Dog');
      var html = '<span class="otto-cfg-raw-portion-continue__label">' + esc(text) + '</span>';
      if (!nextDogLabelHasArrow(text)) html += getRawPortionContinueArrowHtml();
      return html;
    }
    function updateRawPortionContinueButton(card, btn, dogs, activeIdx, multi) {
      if (!btn) return;
      var continueLabel = card.getAttribute('data-cfg-portion-continue-label') || 'Continue';
      var nextDogLabel = card.getAttribute('data-cfg-portion-next-dog-label') || 'Next Dog';
      var allComplete = hasValidRawPortionSelection();
      var activeDog = dogs[activeIdx];
      var portionIdxs = rawPortionDogIndexes();
      var isLastDog = portionIdxs.indexOf(activeIdx) >= portionIdxs.length - 1;
      if (multi && !isLastDog) {
        btn.innerHTML = nextDogContinueButtonHtml(nextDogLabel);
        btn.setAttribute('data-cfg-portion-action', 'next-dog');
        btn.disabled = !canAdvanceFromRawPortionDog(activeDog);
      } else {
        btn.textContent = continueLabel;
        btn.setAttribute('data-cfg-portion-action', 'continue');
        if (multi && allComplete) {
          btn.disabled = false;
        } else {
          btn.disabled = !canAdvanceFromRawPortionDog(activeDog);
        }
      }
    }
    function syncRawShareCardVisibility() {
      var card = $('[data-cfg-type="raw_share"]');
      if (!card) return;
      var show = shouldShowRawShareCard();
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10) || 0;
      card.hidden = !show;
      card.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        card.removeAttribute('data-cfg-path-hidden');
        if (hasValidRawShareSelection()) {
          markStepCompleted(stepNum);
        } else {
          clearStepCompletion(getStepByType('raw_share'));
        }
      } else {
        card.setAttribute('data-cfg-path-hidden', '1');
        card.classList.remove('is-locked', 'is-incomplete');
        if (stepNum) completedSteps[stepNum] = true;
        if (typeof syncCardInert === 'function') syncCardInert(card);
      }
      if (typeof updateDots === 'function') updateDots(currentStep);
    }
    function syncRawPortionCardVisibility() {
      var card = $('[data-cfg-type="raw_portion_check"]');
      if (!card) return;
      var wasVisible = !card.hidden;
      var show = shouldShowRawPortionCard() && hasValidDogInfoSelection();
      if (show && !wasVisible) {
        var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
        var hasStalePortion = dogs.some(function (dog) {
          return dogNeedsRawPortionCheck(dog) && dog.portion_confirmed && !dog.portion_user_selected;
        });
        if (hasStalePortion) clearDogPortionChoices();
      }
      card.hidden = !show;
      card.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        card.removeAttribute('data-cfg-path-hidden');
        clearUnusedRawPortionChoices();
        if (hasValidRawPortionSelection()) {
          markStepCompleted(parseInt(card.getAttribute('data-cfg-step'), 10) || 0);
        } else {
          clearStepCompletion(getStepByType('raw_portion_check'));
        }
      } else {
        card.setAttribute('data-cfg-path-hidden', '1');
        var portionStep = parseInt(card.getAttribute('data-cfg-step'), 10) || 0;
        if (portionStep) {
          completedSteps[portionStep] = true;
          everCompletedSteps[portionStep] = true;
        }
        card.classList.remove('is-locked', 'is-incomplete');
        if (typeof syncCardInert === 'function') syncCardInert(card);
      }
      updateDots(currentStep);
      updateIncomplete();
    }
    function setDogPortionChoice(dogIdx, oz, confirmed, choiceMode) {
      if (!Array.isArray(selections.dogs) || !selections.dogs[dogIdx]) return;
      var ladder = choiceMode === 'custom' ? getRawPortionAdjusterLadder() : getPortionLadder();
      var snapped = (Engine && typeof Engine.snapOz === 'function')
        ? Engine.snapOz(Number(oz) || 0, ladder, 'nearest')
        : Number(oz) || 0;
      selections.dogs[dogIdx].portion_oz = snapped;
      selections.dogs[dogIdx].portion_confirmed = !!confirmed;
      if (confirmed && choiceMode) {
        selections.dogs[dogIdx].portion_choice_mode = choiceMode;
        selections.dogs[dogIdx].portion_user_selected = true;
        selections.dogs[dogIdx].portion_basis = dogPortionBasis(selections.dogs[dogIdx]);
      } else if (!confirmed) {
        delete selections.dogs[dogIdx].portion_choice_mode;
        delete selections.dogs[dogIdx].portion_user_selected;
        delete selections.dogs[dogIdx].portion_basis;
      }
      snapDogRawPercentToFeasible(dogIdx);
      syncPortionDailyTotal();
      updateDogInfoPortionSummary();
      invalidateDeliverySelections();
      invalidateReviewStep();
      renderDeliveryTiles(true);
      renderFreezerProgramCard(true);
      if (typeof renderRawShareCard === 'function') renderRawShareCard();
      saveProgressState();
    }
    function renderRawPortionCard() {
      var card = $('[data-cfg-type="raw_portion_check"]');
      if (!card) return;
      syncRawPortionCardVisibility();
      if (card.hidden) return;
      var container = card.querySelector('[data-cfg-raw-portion-dogs]');
      var continueBtn = card.querySelector('[data-cfg-raw-portion-continue]');
      var headlineTextEl = card.querySelector('[data-cfg-raw-portion-headline-text]');
      if (!container) return;
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      if (!dogs.length || !hasValidDogInfoSelection()) {
        container.innerHTML = '<p class="otto-cfg-card__helper">Complete the dog profile step first.</p>';
        if (continueBtn) continueBtn.disabled = true;
        return;
      }
      var headingTemplate = card.getAttribute('data-cfg-portion-heading-template') || 'How much do you currently feed [dog]?';
      var helperTemplate = card.getAttribute('data-cfg-portion-helper-template') || 'Based on the details provided, we recommend [oz] oz per day.';
      var acceptLabelTemplate = card.getAttribute('data-cfg-portion-accept-label') || '';
      var acceptSubtitleTemplate = card.getAttribute('data-cfg-portion-accept-subtitle') || '';
      var customTileLabelTemplate = card.getAttribute('data-cfg-portion-custom-label') || '';
      var customSubtitleTemplate = card.getAttribute('data-cfg-portion-custom-subtitle') || '';
      var portionIdxs = rawPortionDogIndexes();
      if (!portionIdxs.length) {
        container.innerHTML = '';
        if (continueBtn) continueBtn.disabled = true;
        return;
      }
      var multi = portionIdxs.length > 1;
      var activeIdx = resolveRawPortionActiveIdx(dogs);
      if (portionIdxs.indexOf(activeIdx) < 0) activeIdx = portionIdxs[0];
      if (multi) setRawPortionActiveIdx(activeIdx);
      if (headlineTextEl) {
        headlineTextEl.textContent = applyTemplateTokens(headingTemplate, {
          dog: getRawPortionDogDisplayName(dogs[activeIdx], activeIdx)
        });
      }
      container.innerHTML = '';
      if (multi) {
        var tabsHtml = '<div class="otto-cfg-dog-tabs otto-cfg-dog-tabs--protein" data-cfg-portion-tabs data-cfg-dog-count="' + portionIdxs.length + '">';
        portionIdxs.forEach(function (i) {
          var dog = dogs[i];
          var dogLabel = getRawPortionDogDisplayName(dog, i);
          var complete = isRawPortionDogComplete(dog);
          var tabEnabled = canClickRawPortionTab(dogs, i);
          tabsHtml += '<button type="button" class="otto-cfg-dog-tab otto-cfg-dog-tab--protein'
            + (i === activeIdx ? ' is-active' : '')
            + (complete ? ' is-complete' : '') + '"'
            + ' data-cfg-portion-tab="' + i + '"'
            + (tabEnabled ? '' : ' disabled aria-disabled="true"') + '>'
            + '<span class="otto-cfg-dog-tab__inner otto-cfg-dog-tab__inner--protein">'
            + '<span class="otto-cfg-dog-tab__label">' + esc(dogLabel) + '</span>'
            + '<span class="otto-cfg-dog-tab__check" aria-hidden="true"></span></span></button>';
        });
        tabsHtml += '</div>';
        container.insertAdjacentHTML('beforeend', tabsHtml);
      }
      var panel = document.createElement('div');
      panel.className = 'otto-cfg-raw-portion-dogs-panel';
      panel.setAttribute('data-cfg-portion-dogs-panel', '');
      container.appendChild(panel);
      var adjusterLadder = getRawPortionAdjusterLadder();
      portionIdxs.forEach(function (idx) {
        var dog = dogs[idx];
        var recommendedOz = getDogRecommendedPortionOz(dog);
        var stepperOz = (dog && dog.portion_choice_mode === 'custom' && Number(dog.portion_oz) > 0)
          ? (dog.portion_confirmed ? resolveDogPortionOz(dog) : Number(dog.portion_oz))
          : Math.max(recommendedOz, adjusterLadder[0]);
        var rungIdx = nearestPortionRungIndex(adjusterLadder, stepperOz);
        var displayOz = adjusterLadder[rungIdx] || stepperOz;
        var dogName = getRawPortionDogDisplayName(dog, idx);
        var tileTokens = { oz: String(Math.round(recommendedOz)), dog: dogName };
        var acceptLabel = applyTemplateTokens(acceptLabelTemplate, tileTokens);
        var acceptSubtitleHtml = renderRawPortionTileSubtitle(acceptSubtitleTemplate, tileTokens);
        var customTileLabel = applyTemplateTokens(customTileLabelTemplate, tileTokens);
        var customSubtitleHtml = renderRawPortionTileSubtitle(customSubtitleTemplate, tileTokens);
        var block = document.createElement('div');
        block.className = 'otto-cfg-raw-portion-dog';
        block.setAttribute('data-cfg-portion-dog-idx', String(idx));
        if (multi && idx !== activeIdx) block.hidden = true;
        block.innerHTML =
          '<p class="otto-cfg-raw-portion-dog__helper">' +
          applyTemplateTokens(helperTemplate, { oz: String(Math.round(recommendedOz)) }) +
          '</p>' +
          '<div class="otto-cfg-raw-portion-choices">' +
          '<button type="button" class="otto-cfg-tile otto-cfg-tile--product otto-cfg-raw-portion-accept" data-cfg-portion-accept="' + idx + '">' +
          '<span class="otto-cfg-tile__text">' +
          '<span class="otto-cfg-tile__label">' + acceptLabel + '</span>' +
          acceptSubtitleHtml +
          '</span>' +
          '</button>' +
          '<button type="button" class="otto-cfg-tile otto-cfg-tile--product otto-cfg-raw-portion-different" data-cfg-portion-custom="' + idx + '">' +
          '<span class="otto-cfg-tile__text">' +
          '<span class="otto-cfg-tile__label">' + customTileLabel + '</span>' +
          customSubtitleHtml +
          '</span>' +
          '</button>' +
          '</div>' +
          '<div class="otto-cfg-raw-portion-custom"' + (dog.portion_choice_mode === 'custom' ? '' : ' hidden') + ' data-cfg-portion-custom-panel="' + idx + '">' +
          '<div class="otto-cfg-portion-stepper" data-cfg-portion-stepper="' + idx + '">' +
          '<button type="button" class="otto-cfg-portion-stepper__btn" data-cfg-portion-step="-1" aria-label="Smaller portion"' + (rungIdx <= 0 ? ' disabled' : '') + '>&minus;</button>' +
          '<div class="otto-cfg-portion-stepper__value">' +
          '<div class="otto-cfg-portion-stepper__oz" data-cfg-portion-oz-display>' + displayOz + ' oz</div>' +
          '<div class="otto-cfg-portion-stepper__note">per day</div>' +
          '</div>' +
          '<button type="button" class="otto-cfg-portion-stepper__btn" data-cfg-portion-step="1" aria-label="Larger portion"' + (rungIdx >= adjusterLadder.length - 1 ? ' disabled' : '') + '>&plus;</button>' +
          '</div>' +
          '</div>';
        var acceptBtn = block.querySelector('[data-cfg-portion-accept]');
        var customBtn = block.querySelector('[data-cfg-portion-custom]');
        var customPanel = block.querySelector('[data-cfg-portion-custom-panel]');
        var stepper = block.querySelector('[data-cfg-portion-stepper]');
        function syncTileStates() {
          var liveDog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : dog;
          if (acceptBtn) {
            acceptBtn.classList.toggle(
              'is-selected',
              !!liveDog.portion_user_selected && liveDog.portion_choice_mode === 'recommended'
            );
          }
          if (customBtn) {
            customBtn.classList.toggle(
              'is-selected',
              liveDog.portion_choice_mode === 'custom'
            );
          }
          if (customPanel) {
            customPanel.hidden = liveDog.portion_choice_mode !== 'custom';
          }
        }
        syncTileStates();
        if (acceptBtn) {
          acceptBtn.addEventListener('click', function () {
            setDogPortionChoice(idx, recommendedOz, true, 'recommended');
            renderRawPortionCard();
          });
        }
        if (customBtn) {
          customBtn.addEventListener('click', function () {
            var liveDog = selections.dogs[idx];
            if (liveDog && liveDog.portion_choice_mode === 'custom') {
              renderRawPortionCard();
              return;
            }
            openDogCustomPortion(idx, Math.max(recommendedOz, adjusterLadder[0]));
            renderRawPortionCard();
          });
        }
        if (stepper) {
          stepper.querySelectorAll('[data-cfg-portion-step]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var liveDog = selections.dogs[idx];
              var currentOz = (liveDog && liveDog.portion_choice_mode === 'custom' && Number(liveDog.portion_oz) > 0)
                ? Number(liveDog.portion_oz)
                : Math.max(recommendedOz, adjusterLadder[0]);
              var currentIdx = nearestPortionRungIndex(adjusterLadder, currentOz);
              var nextIdx = currentIdx + Number(btn.getAttribute('data-cfg-portion-step'));
              if (nextIdx < 0 || nextIdx >= adjusterLadder.length) return;
              var nextOz = adjusterLadder[nextIdx];
              if (isRawPortionOzDifferentFromRecommended(nextOz, recommendedOz)) {
                setDogPortionChoice(idx, nextOz, true, 'custom');
              } else {
                revertDogCustomPortionToUnconfirmed(idx, nextOz);
              }
              renderRawPortionCard();
            });
          });
        }
        panel.appendChild(block);
      });
      if (multi) {
        container.querySelectorAll('[data-cfg-portion-tab]').forEach(function (tab) {
          tab.addEventListener('click', function () {
            if (tab.disabled) return;
            var tabIdx = parseInt(tab.getAttribute('data-cfg-portion-tab'), 10);
            if (!isFinite(tabIdx) || !canClickRawPortionTab(dogs, tabIdx)) return;
            setRawPortionActiveIdx(tabIdx);
            renderRawPortionCard();
          });
        });
      }
      updateRawPortionContinueButton(card, continueBtn, dogs, activeIdx, multi);
    }
    $$('[data-cfg-type="raw_portion_check"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var continueBtn = card.querySelector('[data-cfg-raw-portion-continue]');
      card._renderRawPortionCard = renderRawPortionCard;
      card._syncRawPortionCardVisibility = syncRawPortionCardVisibility;
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (continueBtn.disabled) return;
          var action = continueBtn.getAttribute('data-cfg-portion-action');
          var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
          if (action === 'next-dog') {
            var activeIdx = resolveRawPortionActiveIdx(dogs);
            advanceRawPortionToNextDog(activeIdx);
            renderRawPortionCard();
            return;
          }
          renderRawPortionCard();
          if (continueBtn.disabled) return;
          markStepCompleted(stepNum);
          updateIncomplete();
          var next = getNextVisibleCard(stepNum);
          if (next) setTimeout(function () { scrollToCard(next); }, 300);
        });
      }
      renderRawPortionCard();
    });
    function resolveRawShareActiveIdx(dogs) {
      var saved = parseInt(selections.raw_share_active_idx, 10);
      if (isFinite(saved) && saved >= 0 && saved < dogs.length) return saved;
      for (var i = 0; i < dogs.length; i++) {
        if (!isRawShareDogComplete(dogs[i], i)) return i;
      }
      return 0;
    }
    function updateRawShareContinueButton(card, btn, dogs, activeIdx, multi) {
      if (!btn) return;
      var continueLabel = card.getAttribute('data-cfg-raw-share-continue-label') || 'Continue';
      var nextDogLabel = card.getAttribute('data-cfg-raw-share-next-dog-label') || 'Next Dog';
      var allComplete = hasValidRawShareSelection();
      var isLastDog = activeIdx >= dogs.length - 1;
      if (multi && !isLastDog) {
        var activeComplete = isRawShareDogComplete(dogs[activeIdx], activeIdx);
        btn.disabled = !activeComplete;
        btn.setAttribute('data-cfg-portion-action', 'next-dog');
        btn.innerHTML = esc(nextDogLabel);
        return;
      }
      btn.removeAttribute('data-cfg-portion-action');
      btn.disabled = !allComplete;
      btn.textContent = continueLabel;
    }
    function renderRawShareCard() {
      var card = $('[data-cfg-type="raw_share"]');
      if (!card) return;
      syncRawShareCardVisibility();
      if (card.hidden) return;
      var container = card.querySelector('[data-cfg-raw-share-dogs]');
      var continueBtn = card.querySelector('[data-cfg-raw-share-continue]');
      var headlineTextEl = card.querySelector('[data-cfg-raw-share-headline-text]');
      var helperEl = card.querySelector('[data-cfg-raw-share-helper]');
      if (!container) return;
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      if (!dogs.length || !hasValidDogInfoSelection()) {
        container.innerHTML = '<p class="otto-cfg-card__helper">Complete the dog profile step first.</p>';
        if (continueBtn) continueBtn.disabled = true;
        return;
      }
      var headingTemplate = card.getAttribute('data-cfg-raw-share-heading-template') || "How much of [dog]’s bowl should be Otto?";
      var helperTemplate = card.getAttribute('data-cfg-raw-share-helper-template') || '';
      var multi = dogs.length > 1;
      var activeIdx = multi ? resolveRawShareActiveIdx(dogs) : 0;
      if (multi) selections.raw_share_active_idx = activeIdx;
      if (headlineTextEl) {
        headlineTextEl.textContent = applyTemplateTokens(headingTemplate, {
          dog: getRawPortionDogDisplayName(dogs[activeIdx], activeIdx)
        });
      }
      if (helperEl && helperTemplate) {
        helperEl.innerHTML = formatOttoBrand(applyTemplateTokens(helperTemplate, {
          dog: getRawPortionDogDisplayName(dogs[activeIdx], activeIdx)
        }));
      }
      var helperTileText = card.querySelector('.otto-cfg-product-estimate-tile .otto-cfg-product-summary');
      if (helperTileText && helperTileText.getAttribute('data-cfg-otto-branded') !== '1') {
        helperTileText.innerHTML = formatOttoBrand(helperTileText.textContent || '');
        helperTileText.setAttribute('data-cfg-otto-branded', '1');
      }
      container.innerHTML = '';
      if (multi) {
        var tabsHtml = '<div class="otto-cfg-dog-tabs otto-cfg-dog-tabs--protein" data-cfg-raw-share-tabs data-cfg-dog-count="' + dogs.length + '">';
        dogs.forEach(function (dog, i) {
          var dogLabel = getRawPortionDogDisplayName(dog, i);
          var complete = isRawShareDogComplete(dog, i);
          tabsHtml += '<button type="button" class="otto-cfg-dog-tab otto-cfg-dog-tab--protein'
            + (i === activeIdx ? ' is-active' : '')
            + (complete ? ' is-complete' : '') + '"'
            + ' data-cfg-raw-share-tab="' + i + '">'
            + '<span class="otto-cfg-dog-tab__inner otto-cfg-dog-tab__inner--protein">'
            + '<span class="otto-cfg-dog-tab__label">' + esc(dogLabel) + '</span>'
            + '<span class="otto-cfg-dog-tab__check" aria-hidden="true"></span></span></button>';
        });
        tabsHtml += '</div>';
        container.insertAdjacentHTML('beforeend', tabsHtml);
      }
      var panel = document.createElement('div');
      panel.className = 'otto-cfg-raw-share-dogs-panel';
      container.appendChild(panel);
      dogs.forEach(function (dog, idx) {
        if (Number((selections.dogs[idx] || {}).raw_percent) > 0) {
          snapDogRawPercentToFeasible(idx);
        }
        var liveDog = selections.dogs[idx] || dog;
        var feasible = feasibleRawSharePercents(idx);
        var selectedPct = Number(liveDog.raw_percent) > 0 ? normalizeRawPercent(liveDog.raw_percent) : 0;
        var fullOz = resolveDogPortionOz(liveDog);
        var block = document.createElement('div');
        block.className = 'otto-cfg-raw-share-dog';
        if (multi && idx !== activeIdx) block.hidden = true;
        var tiles = RAW_SHARE_DISPLAY_ORDER.map(function (pct) {
          var viable = feasible.indexOf(pct) >= 0;
          var ottoOz = effectivePortionOz(fullOz, pct);
          var selected = viable && selectedPct === pct;
          var helper = rawShareTileHelper(pct, card);
          var rightLabel = viable
            ? (Math.round(ottoOz) + ' oz / day')
            : 'Too small to pack';
          return '<button type="button" class="otto-cfg-tile otto-cfg-tile--product otto-cfg-raw-share-choice'
            + (selected ? ' is-selected' : '')
            + (viable ? '' : ' is-unavailable') + '"'
            + ' data-cfg-raw-share-value="' + pct + '"'
            + (viable ? '' : ' disabled aria-disabled="true"') + '>'
            + '<span class="otto-cfg-tile__text">'
            + '<span class="otto-cfg-tile__label">' + esc(rawShareShortLabel(pct)) + '</span>'
            + (helper ? ('<span class="otto-cfg-tile__ingredients">' + formatOttoBrand(helper) + '</span>') : '')
            + '</span>'
            + '<span class="otto-cfg-tile__price' + (viable ? '' : ' otto-cfg-tile__price--note') + '">'
            + esc(rightLabel)
            + '</span></button>';
        }).join('');
        block.innerHTML = '<div class="otto-cfg-raw-share-choices">' + tiles + '</div>';
        block.querySelectorAll('[data-cfg-raw-share-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var pct = normalizeRawPercent(btn.getAttribute('data-cfg-raw-share-value'));
            if (!rawShareViableAtPercent(idx, pct)) return;
            selections.dogs[idx].raw_percent = pct;
            syncPortionDailyTotal();
            invalidateDeliverySelections();
            invalidateReviewStep();
            renderDeliveryTiles(true);
            renderFreezerProgramCard(true);
            updateMealPrices();
            saveProgressState();
            renderRawShareCard();
            if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
            if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
          });
        });
        panel.appendChild(block);
      });
      if (multi) {
        container.querySelectorAll('[data-cfg-raw-share-tab]').forEach(function (tab) {
          tab.addEventListener('click', function () {
            var tabIdx = parseInt(tab.getAttribute('data-cfg-raw-share-tab'), 10);
            if (!isFinite(tabIdx)) return;
            selections.raw_share_active_idx = tabIdx;
            renderRawShareCard();
          });
        });
      }
      updateRawShareContinueButton(card, continueBtn, selections.dogs, activeIdx, multi);
    }
    $$('[data-cfg-type="raw_share"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var continueBtn = card.querySelector('[data-cfg-raw-share-continue]');
      card._renderRawShareCard = renderRawShareCard;
      card._syncRawShareCardVisibility = syncRawShareCardVisibility;
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (continueBtn.disabled) return;
          var action = continueBtn.getAttribute('data-cfg-portion-action');
          var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
          if (action === 'next-dog') {
            var activeIdx = resolveRawShareActiveIdx(dogs);
            var nextIdx = activeIdx + 1;
            if (nextIdx < dogs.length) selections.raw_share_active_idx = nextIdx;
            renderRawShareCard();
            return;
          }
          markStepCompleted(stepNum);
          renderRawShareCard();
          if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
          if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
          updateIncomplete();
          var next = getNextVisibleCard(stepNum);
          if (next) setTimeout(function () { scrollToCard(next); }, 300);
        });
      }
      renderRawShareCard();
    });
/* ---- Diet Profile card (card 2 of split) ---- */
    function renderDietTiles(card, force) {
      var container = card.querySelector('[data-cfg-diet-container]');
      if (!container || !selections.dogs_basic || !selections.dogs_basic.length) return;
      if (!force && container.children.length > 0) return;
      var totalEl = card.querySelector('[data-cfg-daily-total]');
      if (totalEl) {
        totalEl.hidden = true;
        totalEl.innerHTML = '';
      }
      var previousSelectionsByDog = {};
      if (container.children.length > 0) {
        container.querySelectorAll('[data-cfg-diet-dog]').forEach(function (group) {
          var idx = group.getAttribute('data-cfg-diet-dog');
          var stageSel = group.querySelector('[data-cfg-diet-field="life_stage"].is-selected');
          var actSel = group.querySelector('[data-cfg-diet-field="activity"].is-selected');
          if (stageSel || actSel) {
            previousSelectionsByDog[idx] = {
              stage: stageSel ? stageSel.getAttribute('data-cfg-diet-value') : '',
              activity: actSel ? actSel.getAttribute('data-cfg-diet-value') : ''
            };
          }
        });
      }
      var blurbs = {
        puppy:       card.getAttribute('data-blurb-puppy')       || '',
        adult:       card.getAttribute('data-blurb-adult')       || '',
        senior:      card.getAttribute('data-blurb-senior')      || '',
        light:       card.getAttribute('data-blurb-light')       || '',
        recommended: card.getAttribute('data-blurb-recommended') || '',
        active:      card.getAttribute('data-blurb-active')      || ''
      };
      var lifeStages = [
        { value: 'puppy',  label: 'Puppy',  blurb: blurbs.puppy },
        { value: 'adult',  label: 'Adult',  blurb: blurbs.adult },
        { value: 'senior', label: 'Senior', blurb: blurbs.senior }
      ];
      var activities = [
        { value: 'light',       label: 'Light',       blurb: blurbs.light },
        { value: 'recommended', label: 'Normal',      blurb: blurbs.recommended },
        { value: 'active',      label: 'Active',      blurb: blurbs.active }
      ];
      var html = '';
      var multi = selections.dogs_basic.length > 1;
      if (multi) {
        html += '<div class="otto-cfg-dog-tabs" data-cfg-diet-tabs>';
        selections.dogs_basic.forEach(function (dog, i) {
          html += '<button type="button" class="otto-cfg-dog-tab' + (i === 0 ? ' is-active' : '') + '"'
            + ' data-cfg-diet-tab="' + i + '">'
            + buildDogTabLabelHtml(dog, i) + '</button>';
        });
        html += '</div>';
      }
      selections.dogs_basic.forEach(function (dog, i) {
        html += '<div class="otto-cfg-diet-group" data-cfg-diet-dog="' + i + '"'
          + (multi && i > 0 ? ' hidden' : '') + '>';
        html += '<div class="otto-cfg-diet-group__section-label">Life Stage</div>';
        html += '<div class="otto-cfg-tiles otto-cfg-tiles--diet" data-cfg-diet-stage-group="' + i + '">';
        lifeStages.forEach(function (ls) {
          html += '<button type="button" class="otto-cfg-tile otto-cfg-tile--diet" data-cfg-diet-value="' + ls.value + '" data-cfg-diet-field="life_stage" data-cfg-diet-dog-idx="' + i + '">';
          html += ls.label;
          html += '</button>';
        });
        html += '</div>';
        html += '<div class="otto-cfg-diet-group__section-label">Activity Level</div>';
        html += '<div class="otto-cfg-tiles otto-cfg-tiles--diet" data-cfg-diet-activity-group="' + i + '">';
        activities.forEach(function (act) {
          html += '<button type="button" class="otto-cfg-tile otto-cfg-tile--diet" data-cfg-diet-value="' + act.value + '" data-cfg-diet-field="activity" data-cfg-diet-dog-idx="' + i + '">';
          html += act.label;
          html += '</button>';
        });
        html += '</div>';
        html += '</div>';
      });
      container.innerHTML = html;
      if (multi) {
        container.querySelectorAll('[data-cfg-diet-tab]').forEach(function (tab) {
          tab.addEventListener('click', function () {
            var idx = tab.getAttribute('data-cfg-diet-tab');
            container.querySelectorAll('[data-cfg-diet-tab]').forEach(function (t) { t.classList.remove('is-active'); });
            tab.classList.add('is-active');
            container.querySelectorAll('.otto-cfg-diet-group').forEach(function (g) {
              g.hidden = g.getAttribute('data-cfg-diet-dog') !== idx;
            });
          });
        });
      }
      container.querySelectorAll('.otto-cfg-tile--diet').forEach(function (tile) {
        tile.addEventListener('click', function () {
          var field = tile.getAttribute('data-cfg-diet-field');
          var dogIdx = tile.getAttribute('data-cfg-diet-dog-idx');
          var groupAttr = field === 'life_stage' ? 'data-cfg-diet-stage-group' : 'data-cfg-diet-activity-group';
          var group = container.querySelector('[' + groupAttr + '="' + dogIdx + '"]');
          if (group) {
            group.querySelectorAll('.otto-cfg-tile--diet').forEach(function (t) { t.classList.remove('is-selected'); });
          }
          tile.classList.add('is-selected');
          recalcDiet(card);
        });
      });
      Object.keys(previousSelectionsByDog).forEach(function (dogIdx) {
        var prev = previousSelectionsByDog[dogIdx];
        if (!prev) return;
        if (prev.stage) {
          var prevStageBtn = container.querySelector('[data-cfg-diet-stage-group="' + dogIdx + '"] [data-cfg-diet-value="' + prev.stage + '"]');
          if (prevStageBtn) prevStageBtn.classList.add('is-selected');
        }
        if (prev.activity) {
          var prevActBtn = container.querySelector('[data-cfg-diet-activity-group="' + dogIdx + '"] [data-cfg-diet-value="' + prev.activity + '"]');
          if (prevActBtn) prevActBtn.classList.add('is-selected');
        }
      });
      if (Object.keys(previousSelectionsByDog).length > 0) {
        recalcDiet(card);
      }
    }
    function recalcDiet(card) {
      function getPossessive(name) {
        if (!name) return '';
        var trimmed = name.trim();
        if (!trimmed) return '';
        var last = trimmed.charAt(trimmed.length - 1).toLowerCase();
        return last === 's' ? (trimmed + '\'') : (trimmed + '\'s');
      }
      function getHouseholdLabel(dogs) {
        var names = dogs.map(function (d, idx) {
          return titleCase((d && d.name) ? d.name : '') || ('Dog ' + (idx + 1));
        });
        if (names.length === 1) return getPossessive(names[0]);
        if (names.length === 2) return names[0] + ' and ' + getPossessive(names[1]);
        return names.slice(0, -1).join(', ') + ', and ' + getPossessive(names[names.length - 1]);
      }
      var totalEl    = card.querySelector('[data-cfg-daily-total]');
      var continueBtn = card.querySelector('[data-cfg-diet-continue]');
      var dietStepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      if (!selections.dogs_basic) return;
      var prevDogsState = JSON.stringify(selections.dogs || []);
      var prevDailyTotal = Number(selections.daily_total || 0);
      var multi = selections.dogs_basic.length > 1;
      var totalDaily = 0;
      var dogDailyValues = [];
      var allComplete = true;
      var householdLabel = getHouseholdLabel(selections.dogs_basic);
      var nextDogs = [];
      selections.dogs_basic.forEach(function (dog, i) {
        var stageGroup = card.querySelector('[data-cfg-diet-stage-group="' + i + '"]');
        var actGroup   = card.querySelector('[data-cfg-diet-activity-group="' + i + '"]');
        var stageSel = stageGroup ? stageGroup.querySelector('.is-selected') : null;
        var actSel   = actGroup   ? actGroup.querySelector('.is-selected')   : null;
        var tab = card.querySelector('[data-cfg-diet-tab="' + i + '"]');
        var dogComplete = !!(stageSel && actSel);
        if (tab) {
          if (dogComplete) tab.classList.add('is-complete');
          else tab.classList.remove('is-complete');
        }
        if (!dogComplete) {
          allComplete = false;
          return;
        }
        var stageVal = stageSel.getAttribute('data-cfg-diet-value');
        var actVal   = actSel.getAttribute('data-cfg-diet-value');
var goalVal = normalizeGoalValue((dog && dog.goal) || '');
var daily    = getDailyIntake(dog.weight, stageVal, actVal, goalVal);
        dogDailyValues[i] = daily;
        totalDaily  += daily;
        nextDogs.push({
          name:         dog.name,
          breed:        dog.breed,
          avatar:       dog.avatar || getDogAvatarPrimaryUrl(dog.breed),
          avatar_fallback: dog.avatar_fallback || getDogAvatarFallbackUrl(dog.breed),
          sex:          dog.sex,
          weight:       dog.weight,
          life_stage:   stageVal,
          activity:     actVal,
          daily_intake: daily
        });
      });
      if (allComplete) {
        selections.dogs = nextDogs;
        selections.daily_total = totalDaily;
      } else {
        delete selections.dogs;
        delete selections.daily_total;
      }
      var nextDogsState = JSON.stringify(selections.dogs || []);
      var nextDailyTotal = Number(selections.daily_total || 0);
      if (prevDogsState !== nextDogsState || prevDailyTotal !== nextDailyTotal) {
        invalidateFromDietProfile(dietStepNum, { resetProductSelection: false });
      }
      updateMealPrices();
      if (multi) {
        var nextIncomplete = -1;
        for (var j = 0; j < selections.dogs_basic.length; j++) {
          var sg = card.querySelector('[data-cfg-diet-stage-group="' + j + '"]');
          var ag = card.querySelector('[data-cfg-diet-activity-group="' + j + '"]');
          if (!sg || !ag || !sg.querySelector('.is-selected') || !ag.querySelector('.is-selected')) {
            nextIncomplete = j; break;
          }
        }
        if (nextIncomplete >= 0) {
          var activeTab = card.querySelector('[data-cfg-diet-tab].is-active');
          var activeIdx = activeTab ? parseInt(activeTab.getAttribute('data-cfg-diet-tab'), 10) : 0;
          if (nextIncomplete !== activeIdx) {
            var nextTab = card.querySelector('[data-cfg-diet-tab="' + nextIncomplete + '"]');
            if (nextTab) setTimeout(function () { nextTab.click(); }, 300);
          }
        }
      }
      if (totalEl) {
        var shouldShowTotal = totalDaily > 0 && (!multi || allComplete);
        if (shouldShowTotal) {
          if (multi) {
            totalEl.innerHTML = '';
            selections.dogs_basic.forEach(function (dog, i) {
              var line = document.createElement('div');
              line.className = 'otto-cfg-daily-total__line';
              var label = document.createElement('span');
              var name = titleCase((dog && dog.name) ? dog.name : '') || ('Dog ' + (i + 1));
              label.textContent = getPossessive(name) + ' suggested food: ';
              var value = document.createElement('strong');
              value.textContent = dogDailyValues[i] || 0;
              line.appendChild(label);
              line.appendChild(value);
              line.appendChild(document.createTextNode(' lbs/day'));
              totalEl.appendChild(line);
            });
          } else {
            var totalLabelEl = totalEl.querySelector('[data-cfg-daily-total-label]');
            var totalValEl = totalEl.querySelector('[data-cfg-daily-total-value]');
            if (!totalLabelEl || !totalValEl) {
              totalEl.innerHTML = '<span data-cfg-daily-total-label>Suggested daily food</span>: <strong data-cfg-daily-total-value>--</strong> lbs/day';
              totalLabelEl = totalEl.querySelector('[data-cfg-daily-total-label]');
              totalValEl = totalEl.querySelector('[data-cfg-daily-total-value]');
            }
            if (totalLabelEl) totalLabelEl.textContent = householdLabel + ' suggested food';
            if (totalValEl) totalValEl.textContent = totalDaily;
          }
          totalEl.hidden = false;
        } else {
          totalEl.hidden = true;
        }
      }
      if (continueBtn) continueBtn.disabled = !allComplete;
    }
    $$('[data-cfg-type="diet_profile"]').forEach(function (card) {
      var continueBtn = card.querySelector('[data-cfg-diet-continue]');
      var stepNum     = parseInt(card.getAttribute('data-cfg-step'), 10);
      if (continueBtn) continueBtn.addEventListener('click', function () {
        recalcDiet(card);
        if (continueBtn.disabled) return;
        if (!selections.dogs || !selections.dogs.length) return;
          markStepCompleted(stepNum);
        updateIncomplete();
        updateMealPrices();
        renderDeliveryTiles(true);
        var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
        if (next) setTimeout(function () { scrollToCard(next); }, 300);
      });
    });
    function invalidateDeliverySelections() {
      delete selections.totes;
      delete selections.delivery_interval;
      delete selections.delivery_lbs;
      delete selections.delivery_weekday;
      clearFreezerProgramSelections();
      selections.subscriptions = [];
      var tilesContainer = $('[data-cfg-delivery-tiles]');
      if (tilesContainer) tilesContainer.innerHTML = '';
      var deliveryCard = $('[data-cfg-type="delivery_calculator"]');
      if (deliveryCard) {
        var dStep = parseInt(deliveryCard.getAttribute('data-cfg-step'), 10);
        if (dStep) {
          delete completedSteps[dStep];
          updateIncomplete();
        }
      }
      var ddCard = $('[data-cfg-type="delivery_day"]');
      if (ddCard) {
        var ddStep = parseInt(ddCard.getAttribute('data-cfg-step'), 10);
        if (ddStep) delete completedSteps[ddStep];
        if (ddCard._renderDeliveryDay) ddCard._renderDeliveryDay();
      }
    }
function hasSingleDeliveryOption(totalDaily, totes, interval) {
var options = getValidTotes(totalDaily, getSingleNonFreezerMaxTotes());
return options.some(function (opt) {
return Number(opt && opt.totes) === Number(totes) && Number(opt && opt.days) === Number(interval);
});
}
function hasGroupedDeliveryOption(dailyTotal, totes, interval) {
var options = getValidTotes(dailyTotal, getEffectiveNonFreezerPerProteinMaxTotes());
return options.some(function (opt) {
return Number(opt && opt.totes) === Number(totes) && Number(opt && opt.days) === Number(interval);
});
}
function pickClosestDeliveryOption(options, totes, interval) {
var list = Array.isArray(options) ? options.slice() : [];
if (!list.length) return null;
var targetTotes = Math.max(0, Math.floor(Number(totes || 0)));
var targetInterval = Math.max(0, Math.floor(Number(interval || 0)));
var exact = list.find(function (opt) {
return Number(opt && opt.totes) === targetTotes && Number(opt && opt.days) === targetInterval;
});
if (exact) return { totes: Number(exact.totes || 0), interval: Number(exact.days || 0) };
var best = null;
var bestScore = Infinity;
list.forEach(function (opt) {
var t = Number(opt && opt.totes || 0);
var d = Number(opt && opt.days || 0);
if (!(t > 0 && d > 0)) return;
var score = Math.abs(t - targetTotes) * 1000 + Math.abs(d - targetInterval);
if (score < bestScore) {
bestScore = score;
best = { totes: t, interval: d };
}
});
return best;
}
function tryRetainDeliverySelectionsAfterProductMutation() {
if (selections.freezer_program) return false;
var subs = Array.isArray(selections.subscriptions) ? selections.subscriptions.slice() : [];
if (!subs.length && (!selections.totes || !selections.delivery_interval)) return false;
if (!selections.per_dog_protein) {
var toteCandidate = Number(selections.totes || 0);
var intervalCandidate = Number(selections.delivery_interval || 0);
if ((!toteCandidate || !intervalCandidate) && subs.length) {
toteCandidate = Number(subs[0] && subs[0].totes || 0);
intervalCandidate = Number(subs[0] && subs[0].interval || 0);
}
var totalDaily = Number(selections.daily_total || 0);
if (!(toteCandidate > 0 && intervalCandidate > 0 && totalDaily > 0)) return false;
var singleOptions = getValidTotes(totalDaily, getSingleNonFreezerMaxTotes());
var singleFallback = pickClosestDeliveryOption(singleOptions, toteCandidate, intervalCandidate);
if (!singleFallback) return false;
selections.totes = Math.floor(Number(singleFallback.totes || 0));
selections.delivery_interval = Math.floor(Number(singleFallback.interval || 0));
selections.delivery_lbs = selections.totes * LBS_PER_TOTE;
selections.subscriptions = [{
protein: selections.protein || '',
price: selections.product_price || 0,
dogs: (selections.dogs || []).map(function (d) { return titleCase(d.name) || 'Dog'; }),
dailyTotal: selections.daily_total || 0,
totes: selections.totes,
interval: selections.delivery_interval,
lbs: selections.delivery_lbs
}];
return true;
}
if (!Array.isArray(selections.dog_proteins) || !selections.dog_proteins.length) return false;
var groups = getCurrentDeliveryProteinGroups();
if (!groups.length) return false;
var retained = [];
var retainAudit = [];
var usedSubs = {};
groups.forEach(function (grp) {
var proteinName = String((grp && grp.protein) || '').trim();
if (!proteinName) return;
var matched = null;
var matchedIndex = -1;
for (var si = 0; si < subs.length; si++) {
if (usedSubs[si]) continue;
if (String((subs[si] && subs[si].protein) || '').trim() === proteinName) {
matched = subs[si];
matchedIndex = si;
break;
}
}
if (!matched) {
for (var orphanIdx = 0; orphanIdx < subs.length; orphanIdx++) {
if (usedSubs[orphanIdx]) continue;
matched = subs[orphanIdx];
matchedIndex = orphanIdx;
break;
}
if (!matched) {
retainAudit.push({ protein: proteinName, reason: 'no_matched_subscription' });
return;
}
retainAudit.push({ protein: proteinName, reason: 'fallback_to_orphan_subscription', fromProtein: String((matched && matched.protein) || '').trim() });
}
if (matchedIndex >= 0) usedSubs[matchedIndex] = true;
var totes = Number(matched.totes || 0);
var interval = Number(matched.interval || 0);
if (!(totes > 0 && interval > 0)) {
retainAudit.push({ protein: proteinName, reason: 'invalid_totes_interval', totes: totes, interval: interval });
return;
}
var groupedOptions = getValidTotes(Number(grp.dailyTotal || 0), getEffectiveNonFreezerPerProteinMaxTotes());
var groupedFallback = pickClosestDeliveryOption(groupedOptions, totes, interval);
if (!groupedFallback) {
retainAudit.push({ protein: proteinName, reason: 'not_valid_for_current_group_options', totes: totes, interval: interval, dailyTotal: Number(grp.dailyTotal || 0) });
return;
}
retained.push({
protein: grp.protein,
price: grp.price,
dogs: grp.dogs || [],
dailyTotal: grp.dailyTotal || 0,
totes: Math.floor(Number(groupedFallback.totes || 0)),
interval: Math.floor(Number(groupedFallback.interval || 0)),
lbs: Math.floor(Number(groupedFallback.totes || 0)) * LBS_PER_TOTE
});
retainAudit.push({
protein: proteinName,
reason: (Number(groupedFallback.totes || 0) === Math.floor(totes) && Number(groupedFallback.interval || 0) === Math.floor(interval)) ? 'retained' : 'retained_with_closest_option',
totes: Math.floor(Number(groupedFallback.totes || 0)),
interval: Math.floor(Number(groupedFallback.interval || 0))
});
});
if (!retained.length) {
return false;
}
selections.subscriptions = retained;
delete selections.totes;
delete selections.delivery_interval;
delete selections.delivery_lbs;
return true;
}
/* ---- Generic tile handler (product_selector + tile_selector) ---- */
    $$('[data-cfg-type="product_selector"], [data-cfg-type="tile_selector"]').forEach(function (card) {
      var key = card.getAttribute('data-selection-key') || 'option';
      var singleContainer = card.querySelector('[data-cfg-protein-single]');
      var tiles = singleContainer
        ? singleContainer.querySelectorAll('[data-cfg-tile-value]')
        : card.querySelectorAll('[data-cfg-tile-value]');
      var tileStepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      tiles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isProduct = card.getAttribute('data-cfg-type') === 'product_selector';
          function selectedSig() {
            var s = [];
            tiles.forEach(function (b) { if (b.classList.contains('is-selected')) s.push(b.getAttribute('data-cfg-tile-value')); });
            return s.sort().join('|');
          }
          var prevChoice = selections[key] || '';
          var prevPrice = selections.product_price || 0;
          var prevSig = isProduct ? selectedSig() : '';
          if (isProduct) {
            /* Multi-recipe per household: toggle the recipe on/off. */
            if (btn.classList.contains('is-selected')) {
              btn.classList.remove('is-selected');
            } else {
              btn.classList.add('is-selected');
            }
            var list = [];
            tiles.forEach(function (b) {
              if (!b.classList.contains('is-selected')) return;
              list.push({ protein: b.getAttribute('data-cfg-tile-value'), price_cents: parseInt(b.getAttribute('data-product-price') || '0', 10) });
            });
            if (list.length) {
              selections.household_proteins = list;
              selections[key] = list[0].protein;
              selections.product_price = list[0].price_cents || selections.product_price;
              if (!selections.per_dog_protein) selections.dog_proteins = [];
            } else {
              selections.household_proteins = [];
              delete selections[key];
              delete selections.product_price;
              clearStepCompletion(tileStepNum);
            }
          } else {
            tiles.forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            selections[key] = btn.getAttribute('data-cfg-tile-value');
            var priceCents = parseInt(btn.getAttribute('data-product-price') || '0', 10);
            if (priceCents) selections.product_price = priceCents;
          }
          var nextChoice = selections[key] || '';
          var nextPrice = selections.product_price || 0;
          var setChanged = isProduct ? (selectedSig() !== prevSig) : (prevChoice !== nextChoice || prevPrice !== nextPrice);
          updateMealPrices();
          if (isProduct && setChanged) {
var preservedFromSingleChange = tryRetainDeliverySelectionsAfterProductMutation();
if (!preservedFromSingleChange) {
            invalidateDeliverySelections();
}
            invalidateFromProductSelector(tileStepNum);
if (preservedFromSingleChange) {
renderDeliveryTiles(true);
}
if (typeof buildReview === 'function') buildReview();
          }
          if (isProduct) {
            if (hasValidProductSelection()) markStepCompleted(tileStepNum);
            else clearStepCompletion(tileStepNum);
          } else {
            markStepCompleted(tileStepNum);
          }
          updateIncomplete();
          if (card.getAttribute('data-cfg-type') === 'product_selector') {
if (card._syncProteinGalleryFromSelection) card._syncProteinGalleryFromSelection();
            if (card._syncProductContinueState) card._syncProductContinueState();
          } else {
            var next = $('[data-cfg-step="' + (tileStepNum + 1) + '"]');
            if (next) setTimeout(function () { scrollToCard(next); }, 400);
          }
        });
      });
    });
/* ---- Feeding setup (frequency card) ---- */
$$('[data-cfg-type="feeding_setup"]').forEach(function (card) {
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
var continueBtn = card.querySelector('[data-cfg-feeding-continue]');
var actionsEl = card.querySelector('[data-cfg-feeding-actions]');
var setupEl = card.querySelector('[data-cfg-feeding-setup]');
if (!continueBtn || !setupEl) return;
var singleDogSetupHtml = setupEl.innerHTML;
function getFeedingSetupDogCount() {
var dietDogsCount = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
var infoDogsCount = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
return Math.max(dietDogsCount, infoDogsCount);
}
function getFeedingSetupDogs() {
var dietDogs = Array.isArray(selections.dogs) ? selections.dogs : [];
var infoDogs = Array.isArray(selections.dogs_basic) ? selections.dogs_basic : [];
var count = getFeedingSetupDogCount();
if (count <= 0) return [];
if (dietDogs.length >= count) return dietDogs;
if (infoDogs.length >= count) return infoDogs;
return dietDogs.length >= infoDogs.length ? dietDogs : infoDogs;
}
function getFeedingSetupDogDisplayName(dog, idx) {
return getRawPortionDogDisplayName(dog, idx);
}
function canClickFeedingSetupTab(dogs, tabIdx) {
if (!dogs || tabIdx <= 0) return true;
for (var j = 0; j < tabIdx; j++) {
if (!isFeedingSetupDogComplete(dogs[j])) return false;
}
return true;
}
function resolveFeedingSetupActiveIdx(dogs) {
if (!dogs || dogs.length <= 1) return 0;
var stored = Number(selections.feeding_setup_active_idx);
if (isFinite(stored) && stored >= 0 && stored < dogs.length && canClickFeedingSetupTab(dogs, stored)) {
return stored;
}
for (var i = 0; i < dogs.length; i++) {
if (!isFeedingSetupDogComplete(dogs[i])) return i;
}
return 0;
}
function setFeedingSetupActiveIdx(idx) {
selections.feeding_setup_active_idx = idx;
}
function advanceFeedingSetupToNextDog(fromIdx) {
var dogs = getFeedingSetupDogs();
if (dogs.length <= 1) return;
var nextIdx = fromIdx + 1;
if (nextIdx < dogs.length) setFeedingSetupActiveIdx(nextIdx);
}
function syncHouseholdMealsFromDogs() {
var dogs = getFeedingSetupDogs();
if (!dogs.length) return;
var allComplete = dogs.every(function (dog) { return isFeedingSetupDogComplete(dog); });
if (!allComplete) return;
var maxMeals = 1;
dogs.forEach(function (dog) {
var m = parseInt(dog.meals_per_day, 10);
if (m === 1 || m === 2) maxMeals = Math.max(maxMeals, m);
});
selections.meals_per_day = maxMeals;
selections.meals_per_day_source = 'user';
}
function setDogFeedingMeals(dogIdx, meals, dogs) {
if (!Array.isArray(dogs) || !dogs[dogIdx]) return;
dogs[dogIdx].meals_per_day = meals;
dogs[dogIdx].feeding_meals_user_selected = true;
if (Array.isArray(selections.dogs) && selections.dogs[dogIdx]) {
selections.dogs[dogIdx].meals_per_day = meals;
selections.dogs[dogIdx].feeding_meals_user_selected = true;
}
if (Array.isArray(selections.dogs_basic) && selections.dogs_basic[dogIdx]) {
selections.dogs_basic[dogIdx].meals_per_day = meals;
selections.dogs_basic[dogIdx].feeding_meals_user_selected = true;
}
syncHouseholdMealsFromDogs();
if (dogs.length <= 1) {
selections.meals_per_day = meals;
selections.meals_per_day_source = 'user';
}
saveProgressState();
}
function buildFeedingMealsTilesHtml(dogIdx, dog) {
var twiceHelper = card.getAttribute('data-cfg-feed-meals-twice-helper') || 'Most common feeding practice';
var onceHelper = card.getAttribute('data-cfg-feed-meals-once-helper') || 'Best for dogs that thrive on one larger meal.';
var meals = isFeedingSetupDogComplete(dog) ? parseInt(dog.meals_per_day, 10) : 0;
return '<div class="otto-cfg-feeding-setup__group" data-cfg-feeding-dog-group="' + dogIdx + '">' +
'<div class="otto-cfg-tiles otto-cfg-tiles--feeding">' +
'<button type="button" class="otto-cfg-tile' + (meals === 2 ? ' is-selected' : '') + '" data-cfg-feed-meals="2" data-cfg-feed-meals-dog="' + dogIdx + '">' +
'<span class="otto-cfg-tile__text">' +
'<span class="otto-cfg-feeding-badge-row"><span class="otto-cfg-feeding-badge" aria-hidden="true">' +
'<svg class="otto-cfg-heart-icon" viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
'<path d="M12 21.1l-1.45-1.32C5.4 15.12 2 12.04 2 8.27 2 5.19 4.42 2.8 7.5 2.8c1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09C19.58 2.8 22 5.19 22 8.27c0 3.77-3.4 6.85-8.55 11.51L12 21.1z"></path>' +
'</svg></span></span>' +
'<span class="otto-cfg-tile__label">Twice per day</span>' +
'<span class="otto-cfg-tile__ingredients">' + esc(twiceHelper) + '</span></span></button>' +
'<button type="button" class="otto-cfg-tile' + (meals === 1 ? ' is-selected' : '') + '" data-cfg-feed-meals="1" data-cfg-feed-meals-dog="' + dogIdx + '">' +
'<span class="otto-cfg-tile__text">' +
'<span class="otto-cfg-tile__label">Once per day</span>' +
'<span class="otto-cfg-tile__ingredients">' + esc(onceHelper) + '</span></span></button>' +
'</div></div>';
}
function updateFeedingSetupContinueButton(dogs, activeIdx, multi) {
if (!continueBtn || !actionsEl) return;
var continueLabel = card.getAttribute('data-cfg-feeding-continue-label') || 'Continue';
var nextDogLabel = card.getAttribute('data-cfg-feeding-next-dog-label') || 'Next Dog';
var activeDog = dogs[activeIdx];
var dogComplete = multi ? isFeedingSetupDogComplete(activeDog) : (getMealsPerDay() === 1 || getMealsPerDay() === 2);
var isLastDog = activeIdx >= dogs.length - 1;
if (multi && !isLastDog) {
continueBtn.innerHTML = nextDogContinueButtonHtml(nextDogLabel);
continueBtn.setAttribute('data-cfg-portion-action', 'next-dog');
} else {
continueBtn.textContent = continueLabel;
continueBtn.setAttribute('data-cfg-portion-action', 'continue');
}
actionsEl.hidden = !dogComplete;
actionsEl.setAttribute('aria-hidden', dogComplete ? 'false' : 'true');
if (!dogComplete) {
continueBtn.disabled = true;
return;
}
if (multi && !isLastDog) {
continueBtn.disabled = false;
} else {
continueBtn.disabled = !hasValidFeedingSetupSelection();
}
}
function syncFeedingHeadline(dogs, activeIdx, multi) {
var frequencyLabelEl = card.querySelector('[data-cfg-feeding-frequency-label]');
if (!frequencyLabelEl) return;
var frequencyLabelTextEl = frequencyLabelEl.querySelector('[data-cfg-feeding-frequency-text]');
var nextFrequencyText = '';
if (multi) {
nextFrequencyText = 'How often does ' + getFeedingSetupDogDisplayName(dogs[activeIdx], activeIdx) + ' eat?';
} else {
var dogNames = [];
var seen = {};
dogs.forEach(function (dog) {
var raw = String((dog && dog.name) || '').trim();
if (!raw) return;
var formatted = titleCase(raw);
var key = formatted.toLowerCase();
if (seen[key]) return;
seen[key] = true;
dogNames.push(formatted);
});
if (dogNames.length === 1) nextFrequencyText = 'How often does ' + dogNames[0] + ' eat?';
else if (dogNames.length >= 2) {
nextFrequencyText = 'How often do ' + dogNames.slice(0, -1).join(', ') + ', and ' + dogNames[dogNames.length - 1] + ' eat?';
} else nextFrequencyText = 'How often do your dogs eat?';
}
if (frequencyLabelTextEl) frequencyLabelTextEl.textContent = nextFrequencyText;
else frequencyLabelEl.textContent = nextFrequencyText;
}
function bindFeedingMealTileClicks() {
if (setupEl._feedingMealsBound) return;
setupEl._feedingMealsBound = true;
setupEl.addEventListener('click', function (e) {
var btn = e.target.closest('[data-cfg-feed-meals]');
if (!btn || !setupEl.contains(btn)) return;
var nextMeals = parseInt(btn.getAttribute('data-cfg-feed-meals'), 10);
if (nextMeals !== 1 && nextMeals !== 2) return;
var dogs = getFeedingSetupDogs();
var dogIdxAttr = btn.getAttribute('data-cfg-feed-meals-dog');
if (dogIdxAttr != null && dogIdxAttr !== '') {
setDogFeedingMeals(parseInt(dogIdxAttr, 10), nextMeals, dogs);
} else {
selections.meals_per_day = nextMeals;
selections.meals_per_day_source = 'user';
if (dogs[0]) {
dogs[0].meals_per_day = nextMeals;
dogs[0].feeding_meals_user_selected = true;
}
saveProgressState();
}
applyChoiceAndInvalidateIfNeeded();
});
}
function renderFeedingSetupCard() {
var dogs = getFeedingSetupDogs();
var multi = getFeedingSetupDogCount() > 1;
var activeIdx = multi ? resolveFeedingSetupActiveIdx(dogs) : 0;
if (multi) setFeedingSetupActiveIdx(activeIdx);
var proteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (proteinModeCard) proteinModeCard.hidden = !multi;
if (multi) {
var html = '<div class="otto-cfg-dog-tabs otto-cfg-dog-tabs--protein" data-cfg-feeding-tabs data-cfg-dog-count="' + dogs.length + '">';
dogs.forEach(function (dog, i) {
var dogLabel = getFeedingSetupDogDisplayName(dog, i);
var complete = isFeedingSetupDogComplete(dog);
var tabEnabled = canClickFeedingSetupTab(dogs, i);
html += '<button type="button" class="otto-cfg-dog-tab otto-cfg-dog-tab--protein'
+ (i === activeIdx ? ' is-active' : '')
+ (complete ? ' is-complete' : '') + '"'
+ ' data-cfg-feeding-tab="' + i + '"'
+ (tabEnabled ? '' : ' disabled aria-disabled="true"') + '>'
+ '<span class="otto-cfg-dog-tab__inner otto-cfg-dog-tab__inner--protein">'
+ '<span class="otto-cfg-dog-tab__label">' + esc(dogLabel) + '</span>'
+ '<span class="otto-cfg-dog-tab__check" aria-hidden="true"></span></span></button>';
});
html += '</div><div class="otto-cfg-feeding-dogs-panel" data-cfg-feeding-dogs-panel></div>';
setupEl.innerHTML = html;
var panel = setupEl.querySelector('[data-cfg-feeding-dogs-panel]');
dogs.forEach(function (dog, idx) {
var block = document.createElement('div');
block.className = 'otto-cfg-feeding-dog';
block.setAttribute('data-cfg-feeding-dog-idx', String(idx));
if (idx !== activeIdx) block.hidden = true;
block.innerHTML = buildFeedingMealsTilesHtml(idx, dog);
panel.appendChild(block);
});
bindFeedingMealTileClicks();
setupEl.querySelectorAll('[data-cfg-feeding-tab]').forEach(function (tab) {
tab.addEventListener('click', function () {
if (tab.disabled) return;
var tabIdx = parseInt(tab.getAttribute('data-cfg-feeding-tab'), 10);
if (!isFinite(tabIdx) || !canClickFeedingSetupTab(dogs, tabIdx)) return;
setFeedingSetupActiveIdx(tabIdx);
renderFeedingSetupCard();
applyChoiceAndInvalidateIfNeeded();
});
});
} else if (!setupEl.querySelector('[data-cfg-feed-meals]')) {
setupEl.innerHTML = singleDogSetupHtml;
}
var meals = getMealsPerDay();
setupEl.querySelectorAll('[data-cfg-feed-meals]').forEach(function (btn) {
var value = parseInt(btn.getAttribute('data-cfg-feed-meals'), 10);
var dogIdxAttr = btn.getAttribute('data-cfg-feed-meals-dog');
var selectedMeals = meals;
if (dogIdxAttr != null && dogIdxAttr !== '' && dogs[parseInt(dogIdxAttr, 10)]) {
selectedMeals = parseInt(dogs[parseInt(dogIdxAttr, 10)].meals_per_day, 10);
}
btn.classList.toggle('is-selected', value === selectedMeals);
});
syncFeedingHeadline(dogs, activeIdx, multi);
updateFeedingSetupContinueButton(dogs, activeIdx, multi);
}
function applyChoiceAndInvalidateIfNeeded() {
renderFeedingSetupCard();
if (hasValidFeedingSetupSelection()) {
markStepCompleted(stepNum);
invalidateFromFeedingSetup(stepNum);
}
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard && productCard._syncProteinModeUI) productCard._syncProteinModeUI();
var proteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (proteinModeCard && proteinModeCard._syncFeedingProteinModeUI) proteinModeCard._syncFeedingProteinModeUI();
}
if (!setupEl._feedingMealsBound) bindFeedingMealTileClicks();
continueBtn.addEventListener('click', function () {
if (continueBtn.disabled || (actionsEl && actionsEl.hidden)) return;
var action = continueBtn.getAttribute('data-cfg-portion-action');
var dogs = getFeedingSetupDogs();
if (action === 'next-dog') {
var activeIdx = resolveFeedingSetupActiveIdx(dogs);
advanceFeedingSetupToNextDog(activeIdx);
renderFeedingSetupCard();
return;
}
if (!hasValidFeedingSetupSelection()) return;
markStepCompleted(stepNum);
updateIncomplete();
var next = getNextVisibleCard(stepNum);
if (next) setTimeout(function () { scrollToCard(next); }, 250);
});
renderFeedingSetupCard();
card._syncFeedingSetupUI = renderFeedingSetupCard;
card._renderFeedingSetupCard = renderFeedingSetupCard;
});
/* ---- Feeding setup (protein mode card) ---- */
$$('[data-cfg-type="feeding_protein_mode"]').forEach(function (card) {
var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
var continueBtn = card.querySelector('[data-cfg-protein-mode-continue]');
var modeBtns = card.querySelectorAll('[data-cfg-protein-mode]');
if (!continueBtn || !modeBtns.length) return;
function getDogCount() {
var dietDogsCount = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
var infoDogsCount = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
return Math.max(dietDogsCount, infoDogsCount);
}
function syncUI() {
var isMultiDog = getDogCount() > 1;
card.hidden = !isMultiDog;
var mode = '';
if (typeof selections.per_dog_protein === 'boolean') mode = selections.per_dog_protein ? 'different' : 'same';
modeBtns.forEach(function (btn) {
btn.classList.toggle('is-selected', btn.getAttribute('data-cfg-protein-mode') === mode);
});
continueBtn.disabled = !hasValidFeedingProteinModeSelection();
if (isMultiDog && typeof selections.per_dog_protein !== 'boolean') {
if (completedSteps[stepNum]) {
clearStepCompletion(stepNum);
clearStepCompletionsAfter(stepNum);
}
}
}
function applyChoiceAndInvalidateIfNeeded() {
syncUI();
if (hasValidFeedingProteinModeSelection()) {
markStepCompleted(stepNum);
invalidateFromFeedingSetup(stepNum);
}
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard && productCard._syncProteinModeUI) productCard._syncProteinModeUI();
}
modeBtns.forEach(function (btn) {
btn.addEventListener('click', function () {
var mode = btn.getAttribute('data-cfg-protein-mode');
if (mode !== 'same' && mode !== 'different') return;
selections.per_dog_protein = mode === 'different';
if (!selections.per_dog_protein) {
selections.dog_proteins = [];
ensureSharedProteinFromHousehold();
}
if (selections.per_dog_protein) {
var currentDogs = Array.isArray(selections.dogs) && selections.dogs.length ? selections.dogs : (Array.isArray(selections.dogs_basic) ? selections.dogs_basic : []);
var singleProtein = String(selections.protein || '').trim();
var singlePrice = Number(selections.product_price || 0);
if ((!Array.isArray(selections.dog_proteins) || !selections.dog_proteins.length) && currentDogs.length && singleProtein && singlePrice > 0) {
selections.dog_proteins = currentDogs.map(function (dog, idx) {
return {
dogIdx: idx,
dogName: titleCase((dog && dog.name) ? dog.name : '') || ('Dog ' + (idx + 1)),
protein: singleProtein,
price: singlePrice,
daily_intake: Number((dog && dog.daily_intake) || 0)
};
});
}
}
applyChoiceAndInvalidateIfNeeded();
});
});
continueBtn.addEventListener('click', function () {
syncUI();
if (continueBtn.disabled) return;
if (selections.per_dog_protein === false) {
selections.dog_proteins = [];
ensureSharedProteinFromHousehold();
}
markStepCompleted(stepNum);
updateIncomplete();
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard && productCard._syncProteinModeUI) productCard._syncProteinModeUI();
var next = getNextVisibleCard(stepNum);
if (next) setTimeout(function () { scrollToCard(next); }, 250);
});
syncUI();
card._syncFeedingProteinModeUI = syncUI;
});
/* ---- Per-dog protein toggle ---- */
    $$('[data-cfg-type="product_selector"]').forEach(function (card) {
var footnoteToggleBtn = card.querySelector('[data-cfg-product-meal-footnote-toggle]');
      var continueBtn  = card.querySelector('[data-cfg-product-continue]');
      var singleWrap   = card.querySelector('[data-cfg-protein-single]');
      var perDogWrap   = card.querySelector('[data-cfg-protein-per-dog]');
if (!continueBtn || !singleWrap || !perDogWrap) return;
      var key          = card.getAttribute('data-selection-key') || 'protein';
      var tileStepNum  = parseInt(card.getAttribute('data-cfg-step'), 10);
      var products = [];
      singleWrap.querySelectorAll('.otto-cfg-tile--product').forEach(function (t) {
        products.push({
          title: t.getAttribute('data-cfg-tile-value'),
          price: parseInt(t.getAttribute('data-product-price') || '0', 10),
          ingredients: t.getAttribute('data-product-ingredients') || '',
imageSrc: t.getAttribute('data-product-image-src') || '',
imageAlt: t.getAttribute('data-product-image-alt') || t.getAttribute('data-cfg-tile-value') || '',
          imgHtml: (t.querySelector('.otto-cfg-tile__img') || { outerHTML: '' }).outerHTML
        });
      });
function ensureProteinGallery() {
if (card._proteinGalleryInitialized) return;
var slides = getProteinMediaSlides(card);
if (!slides.length) return;
card._proteinGalleryInitialized = true;
card._proteinMediaSlides = slides;
card._proteinMediaIndex = 0;

if (cfgMedia) {
var desktopGallery = document.createElement('div');
desktopGallery.className = 'otto-cfg-protein-gallery otto-cfg-protein-gallery--desktop';
var desktopTrack = document.createElement('div');
desktopTrack.className = 'otto-cfg-protein-gallery__track';
var desktopDots = document.createElement('div');
desktopDots.className = 'otto-cfg-protein-gallery__dots';
var desktopPrev = document.createElement('button');
desktopPrev.type = 'button';
desktopPrev.className = 'otto-cfg-protein-gallery__nav otto-cfg-protein-gallery__nav--prev';
desktopPrev.setAttribute('aria-label', 'Previous protein image');
desktopPrev.innerHTML = '&#8249;';
var desktopNext = document.createElement('button');
desktopNext.type = 'button';
desktopNext.className = 'otto-cfg-protein-gallery__nav otto-cfg-protein-gallery__nav--next';
desktopNext.setAttribute('aria-label', 'Next protein image');
desktopNext.innerHTML = '&#8250;';
var desktopSlideEls = [];
var desktopLabelEls = [];
var desktopDotEls = [];
slides.forEach(function (slide, idx) {
var img = document.createElement('img');
img.className = 'otto-cfg-protein-gallery__image' + (idx === 0 ? ' is-active' : '');
img.src = slide.src;
img.alt = slide.alt || slide.protein || '';
img.loading = idx === 0 ? 'eager' : 'lazy';
desktopTrack.appendChild(img);
desktopSlideEls.push(img);
var label = document.createElement('span');
label.className = 'otto-cfg-protein-gallery__label';
label.textContent = slide.protein || '';
desktopTrack.appendChild(label);
desktopLabelEls.push(label);

var dot = document.createElement('button');
dot.type = 'button';
dot.className = 'otto-cfg-protein-gallery__dot' + (idx === 0 ? ' is-active' : '');
dot.setAttribute('aria-label', 'View ' + (slide.protein || ('protein image ' + (idx + 1))));
dot.addEventListener('click', function () { setProteinGalleryIndex(card, idx); });
desktopDots.appendChild(dot);
desktopDotEls.push(dot);
});
desktopPrev.addEventListener('click', function () { setProteinGalleryIndex(card, (card._proteinMediaIndex || 0) - 1); });
desktopNext.addEventListener('click', function () { setProteinGalleryIndex(card, (card._proteinMediaIndex || 0) + 1); });
desktopGallery.appendChild(desktopTrack);
desktopGallery.appendChild(desktopPrev);
desktopGallery.appendChild(desktopNext);
desktopGallery.appendChild(desktopDots);
cfgMedia.appendChild(desktopGallery);
card._proteinDesktopGalleryEl = desktopGallery;
card._proteinDesktopSlideEls = desktopSlideEls;
card._proteinDesktopLabelEls = desktopLabelEls;
card._proteinDesktopDotEls = desktopDotEls;
}

var mobileHost = card.querySelector('.otto-cfg-card__mobile-img');
if (mobileHost) {
mobileHost.classList.add('otto-cfg-card__mobile-img--protein-gallery');
var mobileLegacy = mobileHost.querySelector('img');
if (mobileLegacy) mobileLegacy.classList.add('otto-cfg-card__mobile-img-legacy');
var mobileGallery = document.createElement('div');
mobileGallery.className = 'otto-cfg-protein-gallery otto-cfg-protein-gallery--mobile';
var mobileTrack = document.createElement('div');
mobileTrack.className = 'otto-cfg-protein-gallery__track';
var mobileDots = document.createElement('div');
mobileDots.className = 'otto-cfg-protein-gallery__dots';
var mobileSlideEls = [];
var mobileLabelEls = [];
var mobileDotEls = [];
slides.forEach(function (slide, idx) {
var img = document.createElement('img');
img.className = 'otto-cfg-protein-gallery__image' + (idx === 0 ? ' is-active' : '');
img.src = slide.src;
img.alt = slide.alt || slide.protein || '';
img.loading = idx === 0 ? 'eager' : 'lazy';
mobileTrack.appendChild(img);
mobileSlideEls.push(img);
var label = document.createElement('span');
label.className = 'otto-cfg-protein-gallery__label';
label.textContent = slide.protein || '';
mobileTrack.appendChild(label);
mobileLabelEls.push(label);

var dot = document.createElement('button');
dot.type = 'button';
dot.className = 'otto-cfg-protein-gallery__dot' + (idx === 0 ? ' is-active' : '');
dot.setAttribute('aria-label', 'View ' + (slide.protein || ('protein image ' + (idx + 1))));
dot.addEventListener('click', function () { setProteinGalleryIndex(card, idx); });
mobileDots.appendChild(dot);
mobileDotEls.push(dot);
});
mobileGallery.appendChild(mobileTrack);
mobileGallery.appendChild(mobileDots);
mobileHost.appendChild(mobileGallery);
card._proteinMobileGalleryEl = mobileGallery;
card._proteinMobileSlideEls = mobileSlideEls;
card._proteinMobileLabelEls = mobileLabelEls;
card._proteinMobileDotEls = mobileDotEls;
}
}
function toggleProteinGallery(visible) {
ensureProteinGallery();
var keepMobileVisible = false;
var hasProteinSelection = !!getProductCardSelectedProtein(card);
var desktopVisible = !!visible && hasProteinSelection;
if (cfgMedia) cfgMedia.classList.toggle('is-protein-gallery-active', desktopVisible && !!card._proteinDesktopGalleryEl);
if (card._proteinDesktopGalleryEl) card._proteinDesktopGalleryEl.classList.toggle('is-visible', desktopVisible);
if (window.innerWidth < 1000) {
keepMobileVisible = hasProteinSelection;
}
var mobileVisible = window.innerWidth < 1000
? ((!!visible && hasProteinSelection) || keepMobileVisible)
: (!!visible || keepMobileVisible);
if (card._proteinMobileGalleryEl) card._proteinMobileGalleryEl.classList.toggle('is-visible', mobileVisible);
if (card._proteinMobileGalleryEl && card._proteinMobileGalleryEl.parentElement) {
card._proteinMobileGalleryEl.parentElement.classList.toggle('is-protein-gallery-active', mobileVisible);
}
}
function isMultiDog() {
return getProductDogs().length > 1;
}
function getProductDogs() {
if (Array.isArray(selections.dogs) && selections.dogs.length) return selections.dogs;
if (Array.isArray(selections.dogs_basic) && selections.dogs_basic.length) {
return selections.dogs_basic.map(function (dog) {
return {
name: dog && dog.name ? dog.name : '',
daily_intake: Number((dog && dog.daily_intake) || 0)
};
});
}
return [];
}
      function showToggleIfNeeded() {
var productDogs = getProductDogs();
var hasResolvedSingleDog = productDogs.length === 1;
var shouldUsePerDog = productDogs.length > 1 && !!selections.per_dog_protein;
if (productDogs.length <= 1) delete selections.per_dog_protein;
singleWrap.hidden = shouldUsePerDog;
perDogWrap.hidden = !shouldUsePerDog;
if (shouldUsePerDog) renderPerDogTiles();
else {
perDogWrap.innerHTML = '';
if (productDogs.length > 1) selections.dog_proteins = [];
/* Multi-recipe aware: preselect every recipe in the shared household set
 * (falls back to the legacy single selections.protein). */
var hhList = getHouseholdProteinList();
var hhNames = hhList.map(function (r) { return String(r.protein || '').trim(); }).filter(Boolean);
singleWrap.querySelectorAll('.otto-cfg-tile--product').forEach(function (tile) {
var tileValue = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
var on = false;
for (var hi = 0; hi < hhNames.length; hi++) { if (proteinsMatch(tileValue, hhNames[hi])) { on = true; break; } }
tile.classList.toggle('is-selected', on);
});
}
        syncProductContinueState();
syncProteinGalleryFromSelection(card);
      }
      function getActiveProductDogIdx() {
        var activeTab = perDogWrap.querySelector('[data-cfg-protein-tab].is-active');
        if (activeTab) {
          var idx = parseInt(activeTab.getAttribute('data-cfg-protein-tab') || '0', 10);
          if (!isNaN(idx) && idx >= 0) return idx;
        }
        return 0;
      }
      function isProductDogCompleteFromMap(dogIdx, selectedProteinByDog) {
        var list = selectedProteinByDog && selectedProteinByDog[dogIdx];
        return !!(list && list.length);
      }
      function canClickProductDogTabFromMap(tabIdx, selectedProteinByDog) {
        if (tabIdx <= 0) return true;
        for (var j = 0; j < tabIdx; j++) {
          if (!isProductDogCompleteFromMap(j, selectedProteinByDog)) return false;
        }
        return true;
      }
      function isProductDogComplete(dogIdx) {
        var group = perDogWrap.querySelector('[data-cfg-protein-dog="' + dogIdx + '"]');
        if (!group) return false;
        return group.querySelectorAll('.otto-cfg-tile--product.is-selected').length > 0;
      }
      function canClickProductDogTab(tabIdx) {
        if (tabIdx <= 0) return true;
        for (var j = 0; j < tabIdx; j++) {
          if (!isProductDogComplete(j)) return false;
        }
        return true;
      }
      function getFirstIncompleteProductDogIdx() {
        var productDogs = getProductDogs();
        for (var i = 0; i < productDogs.length; i++) {
          if (!isProductDogComplete(i)) return i;
        }
        return -1;
      }
      function resolveProductActiveIdx(selectedProteinByDog) {
        var productDogs = getProductDogs();
        if (productDogs.length <= 1) return 0;
        var stored = Number(selections.product_selector_active_idx);
        if (isFinite(stored) && stored >= 0 && stored < productDogs.length) {
          if (selectedProteinByDog) {
            if (canClickProductDogTabFromMap(stored, selectedProteinByDog)) return stored;
          } else if (canClickProductDogTab(stored)) {
            return stored;
          }
        }
        if (selectedProteinByDog) {
          for (var k = 0; k < productDogs.length; k++) {
            if (!isProductDogCompleteFromMap(k, selectedProteinByDog)) return k;
          }
          return 0;
        }
        var firstIncomplete = getFirstIncompleteProductDogIdx();
        return firstIncomplete >= 0 ? firstIncomplete : 0;
      }
      function applyActiveProductDogIdx(idx) {
        selections.product_selector_active_idx = idx;
        perDogWrap.querySelectorAll('[data-cfg-protein-tab]').forEach(function (tab) {
          var tabIdx = parseInt(tab.getAttribute('data-cfg-protein-tab') || '0', 10);
          tab.classList.toggle('is-active', tabIdx === idx);
        });
        perDogWrap.querySelectorAll('[data-cfg-protein-dog]').forEach(function (group) {
          var groupIdx = parseInt(group.getAttribute('data-cfg-protein-dog') || '0', 10);
          group.hidden = groupIdx !== idx;
        });
        syncProteinGalleryFromSelection(card);
      }
      function syncProductDogTabs() {
        var productDogs = getProductDogs();
        if (productDogs.length <= 1 || !selections.per_dog_protein) return;
        perDogWrap.querySelectorAll('[data-cfg-protein-tab]').forEach(function (tab) {
          var idx = parseInt(tab.getAttribute('data-cfg-protein-tab') || '0', 10);
          var complete = isProductDogComplete(idx);
          var enabled = canClickProductDogTab(idx);
          tab.classList.toggle('is-complete', complete);
          tab.disabled = !enabled;
          if (enabled) tab.removeAttribute('aria-disabled');
          else tab.setAttribute('aria-disabled', 'true');
        });
        applyActiveProductDogIdx(resolveProductActiveIdx());
      }
      function setActiveProductDogIdx(idx) {
        if (!canClickProductDogTab(idx)) return;
        applyActiveProductDogIdx(idx);
        syncProductContinueState();
      }
      function advanceProductToNextDog(fromIdx) {
        var productDogs = getProductDogs();
        if (productDogs.length <= 1) return;
        var nextIdx = fromIdx + 1;
        if (nextIdx < productDogs.length) setActiveProductDogIdx(nextIdx);
      }
      function syncProductContinueState() {
        var productDogs = getProductDogs();
        var multi = productDogs.length > 1;
        var perDog = multi && !!selections.per_dog_protein;
        var continueLabel = card.getAttribute('data-cfg-product-continue-label') || 'Continue';
        if (!perDog) {
          continueBtn.textContent = continueLabel;
          continueBtn.removeAttribute('data-cfg-portion-action');
          continueBtn.disabled = !hasValidProductSelection();
          return;
        }
        syncProductDogTabs();
        var nextDogLabel = card.getAttribute('data-cfg-product-next-dog-label') || 'Next Dog';
        var activeIdx = getActiveProductDogIdx();
        var isLastDog = activeIdx >= productDogs.length - 1;
        if (!isLastDog) {
          continueBtn.innerHTML = nextDogContinueButtonHtml(nextDogLabel);
          continueBtn.setAttribute('data-cfg-portion-action', 'next-dog');
          continueBtn.disabled = !isProductDogComplete(activeIdx);
        } else {
          continueBtn.textContent = continueLabel;
          continueBtn.setAttribute('data-cfg-portion-action', 'continue');
          continueBtn.disabled = !hasValidProductSelection();
        }
      }
      function clearDeliverySelections() {
var preserved = tryRetainDeliverySelectionsAfterProductMutation();
if (preserved) {
renderDeliveryTiles(true);
invalidateFromProductSelector(tileStepNum);
return;
}
        invalidateDeliverySelections();
        invalidateFromProductSelector(tileStepNum);
      }
      function enterPerDogMode() {
        selections.per_dog_protein = true;
if (!isHydratingState) {
        selections.dog_proteins = [];
        delete selections[key];
        delete selections.product_price;
        delete completedSteps[tileStepNum];
        clearDeliverySelections();
        updateIncomplete();
}
        singleWrap.hidden = true;
        perDogWrap.hidden = false;
        renderPerDogTiles();
        updateMealPrices();
        syncProductContinueState();
      }
      function exitPerDogMode() {
        selections.per_dog_protein = false;
        selections.dog_proteins = [];
        delete completedSteps[tileStepNum];
        clearDeliverySelections();
        updateIncomplete();
        singleWrap.hidden = false;
        perDogWrap.hidden = true;
        perDogWrap.innerHTML = '';
        singleWrap.querySelectorAll('.otto-cfg-tile--product').forEach(function (t) {
          t.classList.remove('is-selected');
        });
        updateMealPrices();
        syncProductContinueState();
      }
      function renderPerDogTiles() {
var productDogs = getProductDogs();
if (!productDogs.length) return;
var existingGroups = perDogWrap.querySelectorAll('[data-cfg-protein-dog]');
if (perDogWrap.children.length > 0 && existingGroups.length === productDogs.length) {
syncProductDogTabs();
return;
}
var multi = productDogs.length > 1;
var selectedProteinByDog = {};
if (Array.isArray(selections.dog_proteins)) {
selections.dog_proteins.forEach(function (row) {
var idx = Number(row && row.dogIdx);
if (isNaN(idx) || idx < 0) return;
var list = [];
if (Array.isArray(row.proteins) && row.proteins.length) {
row.proteins.forEach(function (p) {
var n = String((typeof p === 'string') ? p : (p && p.protein) || '').trim();
if (n) list.push(n);
});
} else {
var single = String((row && row.protein) || '').trim();
if (single) list.push(single);
}
if (list.length) selectedProteinByDog[idx] = list;
});
}
        var html = '';
        var activeIdx = multi ? resolveProductActiveIdx(selectedProteinByDog) : 0;
        if (multi) {
html += '<div class="otto-cfg-dog-tabs otto-cfg-dog-tabs--protein" data-cfg-protein-tabs data-cfg-dog-count="' + productDogs.length + '">';
productDogs.forEach(function (dog, i) {
var dogLabel = titleCase((dog && dog.name) ? dog.name : '') || ('Dog ' + (i + 1));
var complete = isProductDogCompleteFromMap(i, selectedProteinByDog);
var tabEnabled = canClickProductDogTabFromMap(i, selectedProteinByDog);
html += '<button type="button" class="otto-cfg-dog-tab otto-cfg-dog-tab--protein'
+ (i === activeIdx ? ' is-active' : '')
+ (complete ? ' is-complete' : '') + '"'
+ ' data-cfg-protein-tab="' + i + '"'
+ (tabEnabled ? '' : ' disabled aria-disabled="true"') + '>'
+ '<span class="otto-cfg-dog-tab__inner otto-cfg-dog-tab__inner--protein"><span class="otto-cfg-dog-tab__label">' + esc(dogLabel) + '</span><span class="otto-cfg-dog-tab__check" aria-hidden="true"></span></span></button>';
          });
          html += '</div>';
        }
productDogs.forEach(function (dog, i) {
          html += '<div class="otto-cfg-diet-group" data-cfg-protein-dog="' + i + '"'
            + (multi && i !== activeIdx ? ' hidden' : '') + '>';
          html += '<div class="otto-cfg-tiles otto-cfg-tiles--products">';
          products.forEach(function (prod) {
            html += '<button type="button" class="otto-cfg-tile otto-cfg-tile--product"'
              + ' data-cfg-perdog-protein="' + i + '"'
              + ' data-cfg-tile-value="' + prod.title.replace(/"/g, '&quot;') + '"'
              + ' data-product-price="' + prod.price + '"'
+ ' data-product-ingredients="' + (prod.ingredients || '').replace(/"/g, '&quot;') + '"'
+ ' data-product-image-src="' + (prod.imageSrc || '').replace(/"/g, '&quot;') + '"'
+ ' data-product-image-alt="' + (prod.imageAlt || prod.title || '').replace(/"/g, '&quot;') + '">';
            if (prod.imgHtml) html += prod.imgHtml;
            html += '<div class="otto-cfg-tile__text"><span class="otto-cfg-tile__label">' + esc(prod.title) + '</span>';
            if (prod.ingredients) {
              html += '<span class="otto-cfg-tile__ingredients">' + esc(prod.ingredients) + '</span>';
            }
            html += '</div>';
            html += proteinTilePriceHtml(prod.price);
            html += '</button>';
          });
          html += '</div>';
          html += '</div>';
        });
        perDogWrap.innerHTML = html;
        if (multi) {
          perDogWrap.querySelectorAll('[data-cfg-protein-tab]').forEach(function (tab) {
            tab.addEventListener('click', function () {
              if (tab.disabled) return;
              var idx = parseInt(tab.getAttribute('data-cfg-protein-tab') || '0', 10);
              if (isNaN(idx) || idx < 0 || !canClickProductDogTab(idx)) return;
              setActiveProductDogIdx(idx);
            });
          });
        }
        perDogWrap.querySelectorAll('.otto-cfg-tile--product').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dogIdx = parseInt(btn.getAttribute('data-cfg-perdog-protein'), 10);
            var group = perDogWrap.querySelector('[data-cfg-protein-dog="' + dogIdx + '"]');
            /* Multi-recipe per dog: toggle the recipe on/off. */
            if (btn.classList.contains('is-selected')) {
              btn.classList.remove('is-selected');
            } else {
              btn.classList.add('is-selected');
            }
            syncPerDogSelections();
          });
        });
productDogs.forEach(function (_dog, i) {
var selectedList = selectedProteinByDog[i];
if (!selectedList || !selectedList.length) return;
var group = perDogWrap.querySelector('[data-cfg-protein-dog="' + i + '"]');
if (!group) return;
var matched = 0;
group.querySelectorAll('.otto-cfg-tile--product').forEach(function (candidate) {
var val = String(candidate.getAttribute('data-cfg-tile-value') || '');
if (selectedList.indexOf(val) !== -1) {
candidate.classList.add('is-selected');
matched++;
}
});
if (matched) {
var tab = perDogWrap.querySelector('[data-cfg-protein-tab="' + i + '"]');
if (tab) tab.classList.add('is-complete');
}
});
if (multi) {
selections.product_selector_active_idx = activeIdx;
}
syncPerDogSelections();
}
      function syncPerDogSelections() {
var productDogs = getProductDogs();
if (!productDogs.length) return;
var multi = productDogs.length > 1;
        var allSelected = true;
        var dogProteins = [];
        var prevDogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins : [];
        var prevByDogIdx = {};
        prevDogProteins.forEach(function (dp) {
          prevByDogIdx[dp.dogIdx] = dp;
        });
function proteinSig(row) {
var arr = (row && Array.isArray(row.proteins) && row.proteins.length)
? row.proteins.map(function (p) { return String((typeof p === 'string') ? p : (p && p.protein) || '').trim(); })
: ((row && row.protein) ? [String(row.protein).trim()] : []);
return arr.filter(Boolean).sort().join('|');
}
var proteinsChanged = prevDogProteins.length !== productDogs.length;
productDogs.forEach(function (dog, i) {
          var group = perDogWrap.querySelector('[data-cfg-protein-dog="' + i + '"]');
          var selTiles = group ? group.querySelectorAll('.otto-cfg-tile--product.is-selected') : [];
          var tab = perDogWrap.querySelector('[data-cfg-protein-tab="' + i + '"]');
          if (!selTiles.length) {
            allSelected = false;
            if (tab) tab.classList.remove('is-complete');
            if (prevByDogIdx[i]) proteinsChanged = true;
          } else {
            if (tab) tab.classList.add('is-complete');
            /* Collect every recipe selected for this dog. The cart/engine split
             * the dog's pounds across these recipes (cheapest-first remainder). */
            var proteins = [];
            Array.prototype.forEach.call(selTiles, function (t) {
              proteins.push({
                protein: t.getAttribute('data-cfg-tile-value'),
                price_cents: parseInt(t.getAttribute('data-product-price') || '0', 10)
              });
            });
            var prev = prevByDogIdx[i];
            var nextSig = proteins.map(function (p) { return String(p.protein || '').trim(); }).filter(Boolean).sort().join('|');
            if (!prev || proteinSig(prev) !== nextSig) proteinsChanged = true;
            dogProteins.push({
              dogIdx: i,
              dogName: titleCase(dog.name) || ('Dog ' + (i + 1)),
              protein: proteins[0].protein,
              price: proteins[0].price_cents,
              proteins: proteins,
              daily_intake: dog.daily_intake || 0
            });
          }
        });
        selections.dog_proteins = dogProteins;
        updateMealPrices();
        if (allSelected) {
          markStepCompleted(tileStepNum);
          updateIncomplete();
        } else {
if (!isHydratingState) {
          delete completedSteps[tileStepNum];
          updateIncomplete();
        }
}
if (proteinsChanged && !isHydratingState) {
clearDeliverySelections();
}
        syncProductContinueState();
syncProteinGalleryFromSelection(card);
      }
      function updatePerDogMealPrices() {
        updateProductMealSummary();
      }
if (footnoteToggleBtn) {
footnoteToggleBtn.addEventListener('click', function () {
var prevMeals = getMealsPerDay() === 1 ? 1 : 2;
var nextMeals = prevMeals === 1 ? 2 : 1;
          selections.meals_per_day = nextMeals;
selections.meals_per_day_source = 'user';
          updateMealPrices();
          if (prevMeals !== nextMeals) {
            clearDeliverySelections();
          }
var feedingCard = $('[data-cfg-type="feeding_setup"]');
if (feedingCard && feedingCard._syncFeedingSetupUI) feedingCard._syncFeedingSetupUI();
var feedingProteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (feedingProteinModeCard && feedingProteinModeCard._syncFeedingProteinModeUI) feedingProteinModeCard._syncFeedingProteinModeUI();
          syncProductContinueState();
        });
}
      continueBtn.addEventListener('click', function () {
        syncProductContinueState();
        if (continueBtn.disabled) return;
        var action = continueBtn.getAttribute('data-cfg-portion-action');
        if (action === 'next-dog') {
          advanceProductToNextDog(getActiveProductDogIdx());
          return;
        }
        var next = $('[data-cfg-step="' + (tileStepNum + 1) + '"]');
        if (next) setTimeout(function () { scrollToCard(next); }, 400);
      });
      card._showProteinToggle = showToggleIfNeeded;
card._syncProteinModeUI = showToggleIfNeeded;
      card._renderPerDogTiles = renderPerDogTiles;
      card._updatePerDogMealPrices = updatePerDogMealPrices;
      card._syncProductContinueState = syncProductContinueState;
card._ensureProteinGallery = ensureProteinGallery;
card._toggleProteinGallery = toggleProteinGallery;
card._syncProteinGalleryFromSelection = function () { syncProteinGalleryFromSelection(card); };
showToggleIfNeeded();
      updateMealPrices();
      syncProductContinueState();
syncProteinGalleryFromSelection(card);
    });
    function syncOwnerFeedingGreeting() {
      var feedingCard = $('[data-cfg-type="owner_feeding"]');
      if (!feedingCard) return;
      var headline = feedingCard.querySelector('[data-cfg-owner-feeding-headline]');
      if (!headline) return;
      var greetingEl = headline.querySelector('[data-cfg-owner-greeting]');
      if (!greetingEl) return;
      var template = headline.getAttribute('data-cfg-accent-template') || '';
      var name = String((selections.owner && selections.owner.name) || '').trim();
      var hasToken = /\[name\]/i.test(template);
      if (!template) {
        greetingEl.textContent = '';
        greetingEl.hidden = true;
      } else if (hasToken) {
        if (name) {
          greetingEl.textContent = template.replace(/\[name\]/gi, name);
          greetingEl.hidden = false;
        } else {
          greetingEl.textContent = '';
          greetingEl.hidden = true;
        }
      } else {
        greetingEl.textContent = template;
        greetingEl.hidden = false;
      }
    }
/* ---- Owner name card ---- */
    $$('[data-cfg-type="owner_name"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var nameInput = card.querySelector('[data-cfg-owner-name]');
      var continueBtn = card.querySelector('[data-cfg-owner-name-continue]');
      var ownerResetWrap = card.querySelector('[data-cfg-owner-reset]');
      function ensureOwner() {
        if (!selections.owner || typeof selections.owner !== 'object') selections.owner = {};
        return selections.owner;
      }
      function syncOwnerResetVisibility() {
        if (!ownerResetWrap) return;
        var visible = startOverVisible();
        ownerResetWrap.hidden = !visible;
        ownerResetWrap.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      card._syncOwnerResetVisibility = syncOwnerResetVisibility;
      function syncOwnerNameUI() {
        if (continueBtn) continueBtn.disabled = !hasValidOwnerName();
        syncOwnerResetVisibility();
        if (hasValidOwnerName() && card.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
      }
      var savedOwner = ensureOwner();
      if (nameInput && savedOwner.name) nameInput.value = savedOwner.name;
      syncOwnerNameUI();
      syncOwnerFeedingGreeting();
      if (nameInput) {
        nameInput.addEventListener('input', function () {
          ensureOwner().name = titleCase(nameInput.value.trim());
          if (hasValidOwnerName()) markStepCompleted(stepNum);
          syncOwnerNameUI();
          syncOwnerFeedingGreeting();
          updateIncomplete();
          saveProgressState();
        });
        nameInput.addEventListener('blur', function () {
          var formatted = titleCase(nameInput.value.trim());
          if (formatted && nameInput.value !== formatted) nameInput.value = formatted;
          ensureOwner().name = formatted;
          syncOwnerFeedingGreeting();
          saveProgressState();
        });
      }
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (nameInput) {
            var formatted = titleCase(nameInput.value.trim());
            if (formatted && nameInput.value !== formatted) nameInput.value = formatted;
            ensureOwner().name = formatted;
          }
          syncOwnerNameUI();
          syncOwnerFeedingGreeting();
          if (continueBtn.disabled) return;
          markStepCompleted(stepNum);
          updateIncomplete();
          saveProgressState();
          var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
          if (next) setTimeout(function () { scrollToCard(next); }, 250);
        });
      }
    });
/* ---- Owner feeding-style card ---- */
    $$('[data-cfg-type="owner_feeding"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var emailInput = card.querySelector('[data-cfg-owner-email]');
      var emailError = card.querySelector('[data-cfg-owner-email-error]');
      var tiles = card.querySelectorAll('[data-cfg-owner-familiarity-value]');
      var continueBtn = card.querySelector('[data-cfg-owner-feeding-continue]');
      var acceptBtn = card.querySelector('[data-cfg-owner-feeding-accept]');
      var declineBtn = card.querySelector('[data-cfg-owner-feeding-decline]');
      var feedbackEl = card.querySelector('[data-cfg-owner-feeding-feedback]');
      var emailTile = card.querySelector('[data-cfg-owner-email-tile]');
      var emailTileTitle = card.querySelector('[data-cfg-owner-tile-title]');
      var emailTileText = card.querySelector('[data-cfg-owner-tile-text]');
      var defaultTileTitle = emailTileTitle ? emailTileTitle.textContent : '';
      var defaultTileText = emailTileText ? emailTileText.textContent : '';
      function ensureOwner() {
        if (!selections.owner || typeof selections.owner !== 'object') selections.owner = {};
        return selections.owner;
      }
      function syncOwnerFeedingUI() {
        var owner = ensureOwner();
        var selectedTile = null;
        tiles.forEach(function (tile) {
          var value = tile.getAttribute('data-cfg-owner-familiarity-value');
          var isSelected = value === owner.familiarity;
          tile.classList.toggle('is-selected', isSelected);
          if (isSelected) selectedTile = tile;
        });
        if (emailTile) emailTile.hidden = !selectedTile;
        if (emailTileTitle) {
          var offerTitle = selectedTile ? selectedTile.getAttribute('data-owner-offer-title') : '';
          emailTileTitle.textContent = offerTitle ? offerTitle : defaultTileTitle;
        }
        if (emailTileText) {
          var offerText = selectedTile ? selectedTile.getAttribute('data-owner-offer-text') : '';
          emailTileText.textContent = offerText ? offerText : defaultTileText;
        }
        if (continueBtn) continueBtn.disabled = !hasValidOwnerFeeding();
      }
      var savedOwner = ensureOwner();
      if (emailInput && savedOwner.email) emailInput.value = savedOwner.email;
      syncOwnerFeedingUI();
      syncOwnerFeedingGreeting();
      if (emailInput) {
        emailInput.addEventListener('input', function () {
          var val = emailInput.value.trim();
          ensureOwner().email = val;
          if (emailError) emailError.hidden = (!val || isValidOwnerEmail(val));
          if (hasValidOwnerFeeding()) markStepCompleted(stepNum);
          syncOwnerFeedingUI();
          updateIncomplete();
          saveProgressState();
        });
      }
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          var value = tile.getAttribute('data-cfg-owner-familiarity-value');
          if (!value) return;
          ensureOwner().familiarity = value;
          if (hasValidOwnerFeeding()) markStepCompleted(stepNum);
          syncOwnerFeedingUI();
          if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
          if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
          if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
          updateIncomplete();
          saveProgressState();
        });
      });
      function setFeedback(message) {
        if (!feedbackEl) return;
        var text = String(message == null ? '' : message).trim();
        feedbackEl.textContent = text;
        feedbackEl.hidden = !text;
      }
      function advanceToNext() {
        markStepCompleted(stepNum);
        updateIncomplete();
        saveProgressState();
        var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
        if (next) setTimeout(function () { scrollToCard(next); }, 250);
      }
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          syncOwnerFeedingUI();
          if (continueBtn.disabled) return;
          advanceToNext();
        });
      }
      if (acceptBtn) {
        acceptBtn.addEventListener('click', function () {
          if (!hasValidOwnerFeeding()) return;
          var owner = ensureOwner();
          var emailVal = emailInput ? emailInput.value.trim() : String(owner.email || '').trim();
          owner.email = emailVal;
          if (!emailVal || !isValidOwnerEmail(emailVal)) {
            if (emailError) emailError.hidden = false;
            if (emailInput) emailInput.focus();
            return;
          }
          if (emailError) emailError.hidden = true;
          owner.guide_opt_in = true;
          saveProgressState();
          submitOwnerGuideToKlaviyo(card, emailVal, owner.familiarity);
          advanceToNext();
        });
      }
      if (declineBtn) {
        declineBtn.addEventListener('click', function () {
          if (!hasValidOwnerFeeding()) return;
          ensureOwner().guide_opt_in = false;
          setFeedback('');
          advanceToNext();
        });
      }
    });
/* ---- Freezer space card ---- */
    $$('[data-cfg-type="freezer_space"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var tiles = card.querySelectorAll('[data-cfg-freezer-space-value]');
      var continueBtn = card.querySelector('[data-cfg-freezer-space-continue]');
      if (!tiles.length) return;
      function syncSelectionUI() {
        var selected = getSelectedFreezerSpaceProfile();
        tiles.forEach(function (tile) {
          var value = tile.getAttribute('data-cfg-freezer-space-value');
          tile.classList.toggle('is-selected', value === selected);
        });
        if (continueBtn) continueBtn.disabled = !selected;
      }
      syncSelectionUI();
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          var nextProfile = tile.getAttribute('data-cfg-freezer-space-value');
          if (!nextProfile) return;
          var prevProfile = getSelectedFreezerSpaceProfile();
          selections.freezer_space_profile = nextProfile;
          syncSelectionUI();
          markStepCompleted(stepNum);
          updateIncomplete();
          if (prevProfile && prevProfile !== nextProfile) {
            invalidateDeliverySelections();
          }
          renderDeliveryTiles(true);
        });
      });
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          syncSelectionUI();
          if (continueBtn.disabled) return;
          var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
          if (next) setTimeout(function () { scrollToCard(next); }, 250);
        });
      }
    });
    $$('[data-cfg-type="delivery_calculator"]').forEach(function (card) {
      var continueBtn = card.querySelector('[data-cfg-delivery-continue]');
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      if (!continueBtn) return;
      continueBtn.addEventListener('click', function () {
        if (continueBtn.disabled) return;
var hasSelectedTile = !!card.querySelector('[data-cfg-delivery-tiles] .is-selected[data-cfg-tile-value]');
if (selections.freezer_program && hasSelectedTile) {
clearFreezerProgramSelections();
renderDeliveryTiles(true);
}
        markStepCompleted(stepNum);
        updateIncomplete();
        var freezerStep = getStepByType('freezer_program');
        var freezerCard = freezerStep ? $('[data-cfg-step="' + freezerStep + '"]') : null;
        var next = isCardVisible(freezerCard) ? freezerCard : getNextVisibleCard(stepNum);
        if (next) setTimeout(function () { scrollToCard(next); }, 250);
      });
      syncDeliveryContinueState();
    });
    $$('[data-cfg-type="freezer_program"]').forEach(function (card) {
      var continueBtn = card.querySelector('[data-cfg-freezer-continue]');
      var skipBtn = card.querySelector('[data-cfg-freezer-skip]');
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      if (!continueBtn) return;
      function syncFreezerContinueState() {
        var hasRenderedFreezerTile = !!card.querySelector('[data-cfg-freezer-program]');
        var canJoinFreezer = !!selections.freezer_program || (hasRenderedFreezerTile && hasCompleteFreezerAllocation());
        continueBtn.disabled = !canJoinFreezer;
        if (skipBtn) {
var canSkipToStandard = hasValidStandardDeliverySelection() || (!!selections.freezer_program && hasStandardDeliverySnapshot());
var defaultSkipText = String(card.getAttribute('data-cfg-freezer-skip-text') || '').trim() || 'No thanks, continue with standard subscription';
skipBtn.textContent = (selections.freezer_program && hasStandardDeliverySnapshot())
? 'Go back to my original subscription'
: defaultSkipText;
          skipBtn.disabled = !canSkipToStandard;
          skipBtn.setAttribute('aria-disabled', canSkipToStandard ? 'false' : 'true');
        }
      }
      card._syncFreezerContinueState = syncFreezerContinueState;
      syncFreezerContinueState();
      continueBtn.addEventListener('click', function () {
        if (continueBtn.disabled) return;
if (card._applyFreezerProgram) {
if (card._applyFreezerProgram() !== true) return;
          return;
        }
        markStepCompleted(stepNum);
        updateIncomplete();
        invalidateFromFreezerProgram(stepNum);
        var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
        if (next) setTimeout(function () { scrollToCard(next); }, 250);
      });
      if (skipBtn) {
        skipBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          if (skipBtn.disabled) return;
if (selections.freezer_program) {
if (!restoreStandardDeliverySnapshot()) clearFreezerProgramSelections();
renderDeliveryTiles(true);
renderFreezerProgramCard(true);
syncDeliveryContinueState();
}
          markStepCompleted(stepNum);
          updateIncomplete();
          invalidateFromFreezerProgram(stepNum);
updateMealPrices();
buildReview();
saveProgressState();
          var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
          if (next) setTimeout(function () { scrollToCard(next); }, 250);
        });
      }
    });
/* ---- Delivery calculator ---- */
function buildToteHtml(opt, price, dailyForGroup, copyOpts) {
      var detailHtml = '';
      var weeks = Math.max(1, Math.floor(Number(opt.weeks || Math.round((opt.days || 7) / 7))));
      var cadenceLabel = opt.label || (weeks === 1 ? 'Weekly' : ('Every ' + weeks + ' weeks'));
      if (price > 0 || (opt && Number(opt.deliveryCostCents) > 0)) {
        var deliveryCost = Number(opt && opt.deliveryCostCents) > 0
          ? (Number(opt.deliveryCostCents) / 100)
          : ((price / 100) * opt.lbs);
        var foundingPct = foundingOngoingPctForDisplay();
        var deliveryTotalLabel;
        if (foundingPct > 0) {
          var saleCost = discountedPriceCents(Math.round(deliveryCost * 100), foundingPct) / 100;
          deliveryTotalLabel =
            '<span class="otto-cfg-tile__delivery-meta otto-cfg-tile__delivery-meta--founding">' +
            memberOffPillHtml(foundingPct) +
            '<span class="otto-cfg-tile__delivery-meta-sale-row">' +
            '<span class="otto-cfg-tile__price-retail">$' + deliveryCost.toFixed(2) + '</span>' +
            '<span class="otto-cfg-tile__delivery-meta-price">$' + saleCost.toFixed(2) + '</span>' +
            '<span class="otto-cfg-tile__delivery-meta-suffix"> / ' + fulfillmentDropLabel() + '</span>' +
            '</span></span>';
        } else {
          deliveryTotalLabel =
            '<span class="otto-cfg-tile__delivery-meta-price">$' + deliveryCost.toFixed(2) + '</span>' +
            '<span class="otto-cfg-tile__delivery-meta-suffix"> / ' + fulfillmentDropLabel() + '</span>';
        }
        detailHtml = '<div class="otto-cfg-tile__delivery-detail">'
+ (foundingPct > 0
  ? deliveryTotalLabel
  : ('<span class="otto-cfg-tile__delivery-meta">' + deliveryTotalLabel + '</span>'))
          + '</div>';
      }
      return '<button type="button" class="otto-cfg-tile otto-cfg-tile--delivery"'
        + ' data-cfg-tile-value="' + opt.lbs + '"'
        + ' data-cfg-delivery-days="' + opt.days + '"'
        + ' data-cfg-delivery-weeks="' + weeks + '">'
        + '<div class="otto-cfg-tile__delivery-left">'
        + '<span class="otto-cfg-tile__interval">' + cadenceLabel + '</span>'
        + '<span class="otto-cfg-tile__totes">' + opt.lbs + ' lb per delivery</span>'
        + '</div>'
        + detailHtml
        + '</button>';
    }
    function syncDeliveryContinueState() {
      var deliveryCard = $('[data-cfg-type="delivery_calculator"]');
      if (!deliveryCard) return;
      var continueBtn = deliveryCard.querySelector('[data-cfg-delivery-continue]');
      if (!continueBtn) return;
var hasSelectedTile = !!deliveryCard.querySelector('[data-cfg-delivery-tiles] .is-selected[data-cfg-tile-value]');
continueBtn.disabled = !(hasValidStandardDeliverySelection() || (!!selections.freezer_program && hasSelectedTile));
    }
    function getFreezerProgramCard() {
      return $('[data-cfg-type="freezer_program"]');
    }
    function getFreezerQualifiedCopy() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return 'Good news. You qualify for our freezer program.';
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-qualified-copy') || '').trim();
      return copy || 'Good news. You qualify for our freezer program.';
    }
    function getFreezerIneligibleCopy() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return 'Based on your current plan details, the freezer program is not available right now.';
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-ineligible-copy') || '').trim();
      return copy || 'Based on your current plan details, the freezer program is not available right now.';
    }
    function getCurrentDeliveryProteinGroups() {
      if (selections.per_dog_protein && selections.dog_proteins && selections.dog_proteins.length > 0) {
        var groups = {};
        selections.dog_proteins.forEach(function (dp) {
          var key = dp.protein;
          if (!groups[key]) groups[key] = { protein: key, price: dp.price, dogs: [], dailyTotal: 0 };
          groups[key].dogs.push(dp.dogName);
          var groupedDog = (Array.isArray(selections.dogs) && selections.dogs[dp.dogIdx]) ? selections.dogs[dp.dogIdx] : null;
          groups[key].dailyTotal += groupedDog ? dogEffectiveDailyLb(groupedDog) : Number(dp.daily_intake || 0);
        });
var grouped = Object.keys(groups).map(function (k) { return groups[k]; });
return grouped;
      }
var singleGroup = [{
        protein: selections.protein || 'Selected protein',
        price: selections.product_price || 0,
        dogs: (selections.dogs || []).map(function (d) { return titleCase(d.name) || 'Dog'; }),
dailyTotal: getEffectiveDailyTotal()
}];
return singleGroup;
}
function getEffectiveDailyTotal() {
var fromSelection = Number(selections.daily_total || 0);
if (isFinite(fromSelection) && fromSelection > 0) return fromSelection;
if (Array.isArray(selections.dogs) && selections.dogs.length) {
var fromDogs = selections.dogs.reduce(function (sum, dog) {
return sum + dogEffectiveDailyLb(dog);
}, 0);
if (isFinite(fromDogs) && fromDogs > 0) return fromDogs;
}
if (Array.isArray(selections.dog_proteins) && selections.dog_proteins.length) {
var fromDogProteins = selections.dog_proteins.reduce(function (sum, row) {
return sum + Number((row && row.daily_intake) || 0);
}, 0);
if (isFinite(fromDogProteins) && fromDogProteins > 0) return fromDogProteins;
}
if (Array.isArray(selections.dogs_basic) && selections.dogs_basic.length) {
var fromDogsBasic = selections.dogs_basic.reduce(function (sum, dog) {
var weight = Number((dog && dog.weight) || 0);
var stage = String((dog && dog.life_stage) || '').trim().toLowerCase();
var activity = String((dog && dog.activity) || '').trim().toLowerCase();
var goal = normalizeGoalValue((dog && dog.goal) || '');
if (!(weight > 0 && stage && activity)) return sum;
return sum + Number(getDailyIntake(weight, stage, activity, goal) || 0);
}, 0);
if (isFinite(fromDogsBasic) && fromDogsBasic > 0) return fromDogsBasic;
}
return 0;
}
    function syncDeliverySizingSummary() {
      var summaryEl = $('[data-cfg-sizing-summary]');
      if (!summaryEl) return;
      var count = Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0;
      var pickup = pickupModeEnabled();
      var text = (count > 1)
        ? summaryEl.getAttribute(pickup ? 'data-cfg-pickup-sizing-multi' : 'data-cfg-sizing-multi')
        : summaryEl.getAttribute(pickup ? 'data-cfg-pickup-sizing-single' : 'data-cfg-sizing-single');
      if (text != null) summaryEl.textContent = text;
    }
    function renderDeliveryTiles(force) {
      syncDeliverySizingSummary();
      var tilesContainer = $('[data-cfg-delivery-tiles]');
      if (!tilesContainer) return;
      if (!force && tilesContainer.children.length > 0) return;
      var deliveryCard = $('[data-cfg-type="delivery_calculator"]');
      var deliveryStepNum = deliveryCard ? parseInt(deliveryCard.getAttribute('data-cfg-step'), 10) : 0;
var totalDaily = getEffectiveDailyTotal();
if (totalDaily > 0 && !(Number(selections.daily_total || 0) > 0)) {
selections.daily_total = totalDaily;
}
      if (totalDaily <= 0) {
        tilesContainer.innerHTML = '<p class="otto-cfg-card__helper">Complete the dog profile step to see ' + fulfillmentDropLabel() + ' options.</p>';
        syncDeliveryContinueState();
        renderFreezerProgramCard(true);
        return;
      }
      if (!hasValidFreezerSpaceSelection()) {
        tilesContainer.innerHTML = '<p class="otto-cfg-card__helper">Select your freezer space above to see ' + fulfillmentDropLabel() + ' options.</p>';
        syncDeliveryContinueState();
        renderFreezerProgramCard(true);
        return;
      }
      /* One unified household cadence for every case (single dog, shared recipe,
       * or per-dog recipes). The engine computes each dog's pounds and the cart
       * splits them per recipe, so each dog still lands as its own subscription. */
      renderHouseholdCadence(tilesContainer, deliveryStepNum);
      syncDeliveryContinueState();
      renderFreezerProgramCard(true);
    }
    function renderFreezerProgramCard(force) {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return;
      var tilesContainer = freezerCard.querySelector('[data-cfg-freezer-program-tiles]');
      if (!tilesContainer) return;
      var shouldShow = shouldShowFreezerProgramCard();
      freezerCard.hidden = !shouldShow;
      freezerCard.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (!shouldShow) {
        tilesContainer.innerHTML = '';
        clearStepCompletion(getStepByType('freezer_program'));
        if (freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
        updateDots(currentStep);
        updateIncomplete();
        return;
      }
      var proteinGroups = getCurrentDeliveryProteinGroups();
      var totalDaily = selections.daily_total || 0;
      var freezerProteinGroups = getFreezerProgramProteinGroups(proteinGroups);
      tilesContainer.innerHTML = buildFreezerProgramHtml(freezerProteinGroups, totalDaily);
      var freezerStepNum = parseInt(freezerCard.getAttribute('data-cfg-step'), 10) || 0;
      initFreezerProgramUI(tilesContainer, freezerStepNum, freezerProteinGroups, totalDaily);
      if (freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
      updateDots(currentStep);
      updateIncomplete();
    }
    function getFreezerProgramTitle() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_PROGRAM_TITLE;
      var title = String(freezerCard.getAttribute('data-cfg-freezer-program-title') || '').trim();
      return title || FREEZER_PROGRAM_TITLE;
    }
    function getFreezerProgramTileExplainer() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return '';
      var explainer = String(freezerCard.getAttribute('data-cfg-freezer-program-tile-explainer') || '').trim();
      return explainer;
    }
    function getFreezerBuilderTitle() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_BUILDER_TITLE;
      var title = String(freezerCard.getAttribute('data-cfg-freezer-builder-title') || '').trim();
      return title || FREEZER_BUILDER_TITLE;
    }
function getFreezerDetailsTitle() {
var freezerCard = getFreezerProgramCard();
if (!freezerCard) return 'How it works';
var title = String(freezerCard.getAttribute('data-cfg-freezer-details-title') || '').trim();
return title || 'How it works';
}
function getFreezerPricingTitle() {
var freezerCard = getFreezerProgramCard();
if (!freezerCard) return 'Pricing & savings';
var title = String(freezerCard.getAttribute('data-cfg-freezer-pricing-title') || '').trim();
return title || 'Pricing & savings';
}
function getFreezerProgramColumnLabel() {
var freezerCard = getFreezerProgramCard();
if (!freezerCard) return 'Freezer';
var label = String(freezerCard.getAttribute('data-cfg-freezer-program-label') || '').trim();
return label || 'Freezer';
}
function getFreezerStandardColumnLabel() {
var freezerCard = getFreezerProgramCard();
if (!freezerCard) return 'Standard';
var label = String(freezerCard.getAttribute('data-cfg-freezer-standard-label') || '').trim();
return label || 'Standard';
}
    function getFreezerHowItWorksBullet1() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_HOW_IT_WORKS_BULLET_1;
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-how-it-works-1') || '').trim();
      return copy || FREEZER_HOW_IT_WORKS_BULLET_1;
    }
    function getFreezerHowItWorksBullet2() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_HOW_IT_WORKS_BULLET_2;
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-how-it-works-2') || '').trim();
      return copy || FREEZER_HOW_IT_WORKS_BULLET_2;
    }
    function getFreezerHowItWorksBullet3() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_HOW_IT_WORKS_BULLET_3;
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-how-it-works-3') || '').trim();
      return copy || FREEZER_HOW_IT_WORKS_BULLET_3;
    }
    function getFreezerHowItWorksBullet4() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_HOW_IT_WORKS_BULLET_4;
      var copy = String(freezerCard.getAttribute('data-cfg-freezer-how-it-works-4') || '').trim();
      return copy || FREEZER_HOW_IT_WORKS_BULLET_4;
    }
    function interpolateFreezerHowItWorksTemplate(template, values) {
      var text = String(template || '');
      var out = text;
      Object.keys(values || {}).forEach(function (key) {
        var replacement = String(values[key] || '');
        out = out.split('{' + key + '}').join(replacement);
      });
      return out;
    }
    function getFreezerProgramDiscountPercent() {
      var freezerCard = getFreezerProgramCard();
      if (!freezerCard) return FREEZER_PROGRAM_DISCOUNT_PERCENT;
      var value = Number(freezerCard.getAttribute('data-cfg-freezer-program-discount-percent'));
      if (!isFinite(value)) return FREEZER_PROGRAM_DISCOUNT_PERCENT;
      if (value < 0) return 0;
      if (value > 100) return 100;
      return Math.round(value);
    }
    function getInitialOrderDiscountPercent() {
      /* Regular summary only — founding Pack Totals uses its own display path. */
      var fromTheme = Number(pricingCfg && pricingCfg.introFirstPercent);
      if (isFinite(fromTheme) && fromTheme > 0) return clampDiscountPct(fromTheme, 40);
      var reviewCard = $('[data-cfg-type="review"]');
      if (!reviewCard) return 0;
      var value = Number(reviewCard.getAttribute('data-cfg-initial-order-discount-percent'));
      if (!isFinite(value)) return 0;
      if (value < 0) return 0;
      if (value > 100) return 100;
      return Math.round(value);
    }
    function foundingLaunchDiscountPercent() {
      return clampDiscountPct(foundingCfg.launchDiscountPercent, 40);
    }
    function foundingOngoingDiscountPercent() {
      return clampDiscountPct(foundingCfg.ongoingDiscountPercent, 20);
    }
    function introOngoingDiscountPercent() {
      return clampDiscountPct(pricingCfg && pricingCfg.introOngoingPercent, 20);
    }
    function matureFirstDiscountPercent() {
      return clampDiscountPct(pricingCfg && pricingCfg.matureFirstPercent, 40);
    }
    function formatFreezerMetricValue(value, isCurrency) {
      var numeric = Number(value || 0);
      if (!isFinite(numeric) || numeric <= 0) return '';
      if (isCurrency) return '$' + numeric.toFixed(2);
      return Math.round(numeric).toString();
    }
    function getFreezerPricingMetrics(proteinGroups, allocationMap, totalDaily) {
      var totalCost = 0;
      var totalTotes = 0;
var totalMeals = 0;
/* Stage-aware: puppies eating 3-4x/day yield more, smaller meals. */
var mealsPerDay = effectiveMealsPerDayForDogs(selections.dogs);
var dogCount = Array.isArray(selections.dogs) && selections.dogs.length
? selections.dogs.length
: (Array.isArray(selections.dogs_basic) ? selections.dogs_basic.length : 0);
var groups = Array.isArray(proteinGroups) ? proteinGroups : [];
      (proteinGroups || []).forEach(function (grp, idx) {
        var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
        var totes = Number(allocationMap[proteinName] || 0);
        var priceCents = Number((grp && grp.price) || 0);
        if (!isFinite(totes) || totes <= 0) totes = 0;
        if (!isFinite(priceCents) || priceCents <= 0) priceCents = 0;
var lbs = totes * LBS_PER_TOTE;
var dailyTotalForGroup = Number((grp && grp.dailyTotal) || 0);
var baseMealCount = (lbs > 0 && dailyTotalForGroup > 0 && mealsPerDay > 0)
? ((lbs / dailyTotalForGroup) * mealsPerDay)
: 0;
var shareCount = 1;
if (Array.isArray(grp && grp.dogs) && grp.dogs.length) {
shareCount = Math.max(1, grp.dogs.length);
} else if (groups.length === 1 && dogCount > 1) {
shareCount = dogCount;
}
        totalTotes += totes;
        totalCost += (priceCents / 100) * lbs;
totalMeals += baseMealCount > 0 ? (baseMealCount * shareCount) : 0;
      });
      var bundleLbs = totalTotes * LBS_PER_TOTE;
if (totalMeals <= 0 && bundleLbs > 0 && totalDaily > 0 && mealsPerDay > 0) {
        totalMeals = (bundleLbs / totalDaily) * mealsPerDay;
      }
      var costPerMeal = totalMeals > 0 ? (totalCost / totalMeals) : 0;
      return {
        totalCost: totalCost,
        totalMeals: totalMeals,
costPerMeal: costPerMeal,
perMealLabel: dogCount > 1 ? 'per meal, per dog' : 'per meal'
      };
    }
    function buildFreezerPricingComparisonRowsHtml(metrics, discountPercent) {
      var percent = Number(discountPercent || 0);
      if (!isFinite(percent) || percent < 0) percent = 0;
      if (percent > 100) percent = 100;
      var multiplier = 1 - (percent / 100);
      function formatCurrencyAllowZero(value) {
        var numeric = Number(value);
        if (!isFinite(numeric)) numeric = 0;
        return '$' + Math.max(0, numeric).toFixed(2);
      }
function renderHeaderRow() {
var programLabel = getFreezerProgramColumnLabel();
var standardLabel = getFreezerStandardColumnLabel();
return '<div class="otto-cfg-freezer-program__pricing-row otto-cfg-freezer-program__pricing-row--info otto-cfg-freezer-program__pricing-grid">'
+ '<span class="otto-cfg-freezer-program__pricing-cell otto-cfg-freezer-program__pricing-cell--program"><strong class="otto-cfg-freezer-program__pricing-value">' + esc(programLabel) + '</strong></span>'
+ '<span class="otto-cfg-freezer-program__pricing-cell otto-cfg-freezer-program__pricing-cell--regular"><strong class="otto-cfg-freezer-program__pricing-value">' + esc(standardLabel) + '</strong></span>'
          + '</div>';
      }
function renderPricingRow(label, value, isCurrency, applyDiscount, rowClass, formatter) {
        var regularText = formatFreezerMetricValue(value, isCurrency);
        if (!regularText) return '';
        var shouldDiscount = applyDiscount !== false;
        var programValue = shouldDiscount ? Number(value || 0) * multiplier : Number(value || 0);
        var programText = formatFreezerMetricValue(programValue, isCurrency) || regularText;
if (typeof formatter === 'function') {
regularText = formatter(regularText, true);
programText = formatter(programText, false);
}
        return '<div class="otto-cfg-freezer-program__pricing-row' + (rowClass ? (' ' + rowClass) : '') + ' otto-cfg-freezer-program__pricing-grid">'
+ '<span class="otto-cfg-freezer-program__pricing-cell otto-cfg-freezer-program__pricing-cell--program"><strong class="otto-cfg-freezer-program__pricing-value">' + esc(programText) + '</strong><span class="otto-cfg-freezer-program__pricing-sub-label">' + esc(label) + '</span></span>'
+ '<span class="otto-cfg-freezer-program__pricing-cell otto-cfg-freezer-program__pricing-cell--regular"><strong class="otto-cfg-freezer-program__pricing-value">' + esc(regularText) + '</strong><span class="otto-cfg-freezer-program__pricing-sub-label">' + esc(label) + '</span></span>'
          + '</div>';
      }
      var rows = '';
rows += renderHeaderRow();
rows += renderPricingRow(String(metrics.perMealLabel || 'per meal'), metrics.costPerMeal, true, true, 'otto-cfg-freezer-program__pricing-row--metric otto-cfg-freezer-program__pricing-row--primary');
rows += renderPricingRow('per delivery', metrics.totalCost, true, true, 'otto-cfg-freezer-program__pricing-row--metric');
var mealsPerDay = Number(effectiveMealsPerDayForDogs(selections.dogs) || 0);
if (!isFinite(mealsPerDay) || mealsPerDay < 0) mealsPerDay = 0;
var dogCount = 0;
if (Array.isArray(selections.dogs) && selections.dogs.length) dogCount = selections.dogs.length;
else if (Array.isArray(selections.dogs_basic) && selections.dogs_basic.length) dogCount = selections.dogs_basic.length;
if (!isFinite(dogCount) || dogCount < 1) dogCount = 1;
var totalPerMonth = Number(metrics.costPerMeal || 0) * mealsPerDay * dogCount * 30;
rows += renderPricingRow('per month', totalPerMonth, true, true, 'otto-cfg-freezer-program__pricing-row--metric otto-cfg-freezer-program__pricing-row--savings');
      return rows;
    }
    function buildFreezerPricingComparisonInnerHtml(metrics, discountPercent) {
      var percent = Number(discountPercent || 0);
      if (!isFinite(percent) || percent < 0) percent = 0;
      if (percent > 100) percent = 100;
var standardPerMeal = Number((metrics && metrics.costPerMeal) || 0);
if (!isFinite(standardPerMeal) || standardPerMeal < 0) standardPerMeal = 0;
var freezerPerMeal = standardPerMeal * (1 - (percent / 100));
var savingsPerMeal = Math.max(0, standardPerMeal - freezerPerMeal);
var mealsPerDay = Number(effectiveMealsPerDayForDogs(selections.dogs) || 0);
if (!isFinite(mealsPerDay) || mealsPerDay < 0) mealsPerDay = 0;
var dogCount = 0;
if (Array.isArray(selections.dogs) && selections.dogs.length) dogCount = selections.dogs.length;
else if (Array.isArray(selections.dogs_basic) && selections.dogs_basic.length) dogCount = selections.dogs_basic.length;
if (!isFinite(dogCount) || dogCount < 1) dogCount = 1;
var savingsPerMonth = Math.max(0, savingsPerMeal * mealsPerDay * dogCount * 30);
var perMealText = '$' + savingsPerMeal.toFixed(2);
var perMonthText = '$' + savingsPerMonth.toFixed(2);
return '<div class="otto-cfg-freezer-program__pricing-banner">You\'ll save <span class="otto-cfg-freezer-program__pricing-banner-amount">' + esc(perMealText) + '</span> per meal and <span class="otto-cfg-freezer-program__pricing-banner-amount">' + esc(perMonthText) + '</span> per month with the Otto Freezer Program.</div>'
+ '<div class="otto-cfg-freezer-program__pricing-rows">'
+ buildFreezerPricingComparisonRowsHtml(metrics, percent)
+ '</div>';
}
    function buildFreezerPricingHtml(metrics, discountPercent) {
      var rows = buildFreezerPricingComparisonRowsHtml(metrics, discountPercent);
      if (!rows) return '';
      return '<div class="otto-cfg-freezer-program__pricing-compare" data-cfg-freezer-pricing aria-label="Freezer program pricing comparison">'
        + buildFreezerPricingComparisonInnerHtml(metrics, discountPercent)
        + '</div>';
    }
    function getFreezerProteinVisualMap() {
      var map = {};
      var productTiles = $$('[data-cfg-type="product_selector"] .otto-cfg-tile--product[data-cfg-tile-value]');
      productTiles.forEach(function (tile) {
        var protein = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
        if (!protein || map[protein]) return;
        var img = tile.querySelector('.otto-cfg-tile__img');
        if (!img) return;
        map[protein] = {
          src: String(img.getAttribute('src') || '').trim(),
          alt: String(img.getAttribute('alt') || protein).trim()
        };
      });
      return map;
    }
    function getFreezerCatalogProducts() {
      var list = [];
      var productTiles = $$('[data-cfg-type="product_selector"] .otto-cfg-tile--product[data-cfg-tile-value]');
      productTiles.forEach(function (tile) {
        var protein = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
        if (!protein) return;
        if (list.some(function (row) { return row.protein === protein; })) return;
        var price = parseInt(tile.getAttribute('data-product-price') || '0', 10);
        if (!isFinite(price) || price < 0) price = 0;
        list.push({ protein: protein, price: price });
      });
      return list;
    }
    function getFreezerProgramProteinGroups(baseGroups) {
      var groups = Array.isArray(baseGroups) ? baseGroups.slice() : [];
      var catalogProducts = getFreezerCatalogProducts();
      if (!catalogProducts.length) return groups;
var byProtein = {};
groups.forEach(function (grp, idx) {
var proteinName = String((grp && grp.protein) || '').trim();
if (!proteinName) proteinName = 'Protein ' + (idx + 1);
if (!byProtein[proteinName]) {
byProtein[proteinName] = {
protein: proteinName,
price: Number((grp && grp.price) || 0),
dogs: Array.isArray(grp && grp.dogs) ? grp.dogs.slice() : [],
dailyTotal: Number((grp && grp.dailyTotal) || 0)
};
}
});
catalogProducts.forEach(function (prod) {
var proteinName = String((prod && prod.protein) || '').trim();
if (!proteinName) return;
if (!byProtein[proteinName]) {
byProtein[proteinName] = {
protein: proteinName,
price: Number((prod && prod.price) || 0),
dogs: [],
dailyTotal: 0
};
}
});
return Object.keys(byProtein).map(function (key) { return byProtein[key]; });
}
    function getFreezerSlotThumbHtml(proteinName, visual) {
      if (visual && visual.src) {
        return '<img class="otto-cfg-freezer-program__slot-thumb" src="' + esc(visual.src) + '" alt="' + esc(visual.alt || proteinName) + '" loading="lazy">';
      }
      var fallback = (proteinName || '?').charAt(0).toUpperCase() || '?';
      return '<span class="otto-cfg-freezer-program__slot-thumb--fallback">' + esc(fallback) + '</span>';
    }
    function getFreezerSlotOptionThumbHtml(proteinName, visual) {
      if (visual && visual.src) {
        return '<img class="otto-cfg-freezer-program__slot-option-thumb" src="' + esc(visual.src) + '" alt="' + esc(visual.alt || proteinName) + '" loading="lazy">';
      }
      var fallback = (proteinName || '?').charAt(0).toUpperCase() || '?';
      return '<span class="otto-cfg-freezer-program__slot-option-thumb otto-cfg-freezer-program__slot-thumb--fallback">' + esc(fallback) + '</span>';
    }
    function getFreezerSlotAlternativeProteins(proteinGroups, currentProteinName) {
      var out = [];
      (proteinGroups || []).forEach(function (grp, idx) {
        var optionName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
        if (!optionName || optionName === currentProteinName) return;
        if (out.indexOf(optionName) >= 0) return;
        out.push(optionName);
      });
      return out;
    }
    function buildFreezerSlotOptionsHtml(alternativeProteins, slotIdx, visualMap) {
      var html = '';
      (alternativeProteins || []).forEach(function (optionName) {
        var optionVisual = (visualMap && visualMap[optionName]) ? visualMap[optionName] : null;
        var optionThumb = getFreezerSlotOptionThumbHtml(optionName, optionVisual);
        html += '<button type="button" class="otto-cfg-freezer-program__slot-option"'
          + ' data-cfg-freezer-slot-option'
          + ' data-cfg-freezer-slot-index="' + slotIdx + '"'
          + ' data-cfg-freezer-protein="' + esc(optionName) + '"'
          + ' data-cfg-freezer-protein-image-src="' + esc(optionVisual && optionVisual.src ? optionVisual.src : '') + '"'
          + ' data-cfg-freezer-protein-image-alt="' + esc(optionVisual && optionVisual.alt ? optionVisual.alt : optionName) + '">'
          + optionThumb
          + '<span class="otto-cfg-freezer-program__slot-option-name">' + esc(optionName) + '</span>'
          + '</button>';
      });
      return html;
    }
    function getFreezerSlotProteinShortName(proteinName) {
      var label = String(proteinName || '').trim();
      if (!label) return 'Protein';
      return label.replace(/\s+blend\s*$/i, '').trim() || label;
    }
    function buildFreezerSlotTriggerInnerHtml(proteinName, visual, hasAlternatives, slotIdx) {
      var swapOverlay = hasAlternatives
        ? ('<span class="otto-cfg-freezer-program__slot-swap-overlay" aria-hidden="true">'
          + '<svg class="otto-cfg-freezer-program__slot-swap-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">'
          + '<path d="M4 5.5H12L10.3 3.8L11.2 2.9L14.4 6.1L11.2 9.3L10.3 8.4L12 6.7H4V5.5Z" fill="currentColor"/>'
          + '<path d="M12 10.5H4L5.7 12.2L4.8 13.1L1.6 9.9L4.8 6.7L5.7 7.6L4 9.3H12V10.5Z" fill="currentColor"/>'
          + '</svg>'
          + '<span>Swap</span>'
          + '</span>')
        : '';
      return '<span class="otto-cfg-freezer-program__slot-media">'
        + getFreezerSlotThumbHtml(proteinName, visual)
        + swapOverlay
        + '</span>'
        + '<span class="otto-cfg-freezer-program__slot-name" data-cfg-freezer-slot-name>Tote ' + (slotIdx + 1) + ': ' + esc(getFreezerSlotProteinShortName(proteinName)) + '</span>';
    }
    function buildFreezerSlotsFromAllocations(proteinGroups, allocations) {
      var groups = Array.isArray(proteinGroups) ? proteinGroups : [];
      var totalSlots = Math.max(0, Math.floor(Number(FREEZER_CAPACITY.totes || 0)));
      if (!groups.length || totalSlots <= 0) return [];
      var slots = [];
      var allocationMap = {};
      (allocations || []).forEach(function (row) {
        if (!row || !row.protein) return;
        var totes = Math.floor(Number(row.totes || 0));
        if (!isFinite(totes) || totes <= 0) return;
        allocationMap[String(row.protein)] = totes;
      });
      groups.forEach(function (grp, idx) {
        var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
        var count = Math.floor(Number(allocationMap[proteinName] || 0));
        if (!isFinite(count) || count < 0) count = 0;
        for (var i = 0; i < count; i++) slots.push(proteinName);
      });
      var fallbackProtein = (groups[0] && groups[0].protein) ? String(groups[0].protein) : 'Protein 1';
      while (slots.length < totalSlots) slots.push(fallbackProtein);
      if (slots.length > totalSlots) slots = slots.slice(0, totalSlots);
      return slots;
    }
    function buildFreezerSlotGridHtml(proteinGroups, allocations) {
      var groups = Array.isArray(proteinGroups) ? proteinGroups : [];
      var slots = buildFreezerSlotsFromAllocations(groups, allocations);
      if (!groups.length || !slots.length) return '';
      var visualMap = getFreezerProteinVisualMap();
      var grid = '';
      slots.forEach(function (proteinName, slotIdx) {
        var activeVisual = visualMap[proteinName] || null;
        var alternativeProteins = getFreezerSlotAlternativeProteins(groups, proteinName);
        var hasAlternatives = alternativeProteins.length > 0;
        var optionsHtml = buildFreezerSlotOptionsHtml(alternativeProteins, slotIdx, visualMap);
        grid += '<div class="otto-cfg-freezer-program__slot' + (hasAlternatives ? '' : ' is-no-swap') + '" data-cfg-freezer-slot-index="' + slotIdx + '" data-cfg-freezer-slot-protein="' + esc(proteinName) + '">'
          + '<button type="button" class="otto-cfg-freezer-program__slot-trigger" data-cfg-freezer-slot-trigger aria-label="Slot ' + (slotIdx + 1) + ' protein: ' + esc(proteinName) + '"' + (hasAlternatives ? ' aria-haspopup="menu" aria-expanded="false"' : ' disabled') + '>'
          + buildFreezerSlotTriggerInnerHtml(proteinName, activeVisual, hasAlternatives, slotIdx)
          + '</button>'
          + '<div class="otto-cfg-freezer-program__slot-menu" data-cfg-freezer-slot-menu role="menu" aria-label="Swap slot ' + (slotIdx + 1) + ' protein">'
          + optionsHtml
          + '</div>'
          + '</div>';
      });
      return '<div class="otto-cfg-freezer-program__builder-grid" data-cfg-freezer-builder-grid>' + grid + '</div>';
    }
    function buildFreezerProgramHtml(proteinGroups, totalDaily) {
      if (!proteinGroups || !proteinGroups.length || FREEZER_CAPACITY.totes <= 0) return '';
      var cadenceDays = getFreezerCadenceDays(totalDaily);
      var discountPercent = getFreezerProgramDiscountPercent();
      var allocations = getFreezerAllocationsForDisplay(proteinGroups);
      var allocationMap = {};
      allocations.forEach(function (row) {
        if (!row || !row.protein) return;
        allocationMap[row.protein] = Number(row.totes || 0);
      });
      var pricingMetrics = getFreezerPricingMetrics(proteinGroups, allocationMap, totalDaily);
      var refillDaysCopy = cadenceDays > 0 ? ('~' + Math.max(1, Math.round(cadenceDays / 7)) + ' weeks') : 'a custom cadence';
      var detail1 = getFreezerHowItWorksBullet1();
      var detail2 = getFreezerHowItWorksBullet2();
      var detail3 = interpolateFreezerHowItWorksTemplate(getFreezerHowItWorksBullet3(), {
        totes: FREEZER_CAPACITY.totes
      });
      var detail4 = interpolateFreezerHowItWorksTemplate(getFreezerHowItWorksBullet4(), {
        days: refillDaysCopy
      });
var detailsIntro = getFreezerProgramTileExplainer() || 'Freezer plans are designed to simplify bulk feeding for your whole household.';
function buildFreezerDetailRow(copy) {
return '<li class="otto-cfg-freezer-program__detail">'
+ '<span class="otto-cfg-freezer-program__detail-check" aria-hidden="true"></span>'
+ '<span class="otto-cfg-freezer-program__detail-text">' + esc(copy) + '</span>'
+ '</li>';
}
var detailsHtml = '<p class="otto-cfg-freezer-program__details-intro">' + esc(detailsIntro) + '</p>'
+ '<ul class="otto-cfg-freezer-program__details" aria-label="How the freezer program works">'
+ buildFreezerDetailRow(detail1)
+ buildFreezerDetailRow(detail2)
+ buildFreezerDetailRow(detail3)
+ buildFreezerDetailRow(detail4)
        + '</ul>';
      var builderHtml = buildFreezerSlotGridHtml(proteinGroups, allocations);
      var pricingHtml = buildFreezerPricingHtml(pricingMetrics, discountPercent);
      if (!pricingHtml) pricingHtml = '<p class="otto-cfg-card__helper">Pricing appears after selecting your proteins.</p>';
var detailsTitleIcon = '<span class="otto-cfg-freezer-program__accordion-title-icon" aria-hidden="true">'
+ '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M15.5001 3L13.6226 7.12304L9.5 9.00018L13.6226 10.877L15.5001 15L17.3773 10.877L21.5 9.00018L17.3773 7.12304L15.5001 3Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.50004 3L4.03066 4.03076L3 4.50005L4.03066 4.96924L4.50004 6L4.96933 4.96924L6 4.50005L4.96933 4.03076L4.50004 3Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5001 13.5L5 16L2.5 17.5001L5 19L6.5001 21.5L8 19L10.5 17.5001L8 16L6.5001 13.5Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
+ '</span>';
var builderTitleIcon = '<span class="otto-cfg-freezer-program__accordion-title-icon" aria-hidden="true">'
+ '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M22.5 14V16C22.5 16.9319 22.1336 17.8268 21.4792 18.4879C20.8247 19.1491 19.939 19.5234 19.0071 19.5328L5 19.5C4.07392 19.5 3.18573 19.1321 2.53048 18.4768C1.87522 17.8216 1.50734 16.9334 1.50734 16.0073L1.50004 11.5C1.49972 10.5738 1.86737 9.68549 2.52249 9.02995C3.1776 8.37441 4.06569 8.00614 4.99189 8.0055L8 8M16 8H18.9997C19.9316 7.99608 20.8266 8.36142 21.4883 9.01502C22.1499 9.66862 22.526 10.5591 22.5333 11.491L22.54 13.25M15 5V4.50005C15 2.56705 13.433 1.00005 11.5 1.00005V1.00005C9.56704 1.00005 8.00004 2.56705 8.00004 4.50005V8.00005M9.12504 13.2501L10.625 14.7501L14.125 11.2501" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
+ '</span>';
var pricingTitleIcon = '<span class="otto-cfg-freezer-program__accordion-title-icon" aria-hidden="true">'
+ '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M11.9997 1.40503L9.79483 3.60988L6.78295 2.80285L5.97591 5.81474L2.82433 6.70251L3.63137 9.71439L1.40479 12.0001L3.60963 14.2049L2.82419 17.2978L5.83607 18.1048L6.70213 21.1757L9.71402 20.3687L11.9997 22.595L14.2045 20.3902L17.3779 21.1539L18.185 18.142L21.1754 17.2975L20.3684 14.2856L22.5948 12.0001L20.3899 9.79521L21.1753 6.70279L18.1634 5.89575L17.2971 2.82463L14.2852 3.63166L11.9997 1.40503Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.50122 16.5447L16.5012 7.54468" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.25122 8.79468L8.75122 8.29468L9.25122 8.79468L8.75122 9.29468L8.25122 8.79468Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.7512 15.2947L15.2512 14.7947L15.7512 15.2947L15.2512 15.7947L14.7512 15.2947Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
+ '</span>';
      var detailsSection = '<section class="otto-cfg-freezer-program__accordion-item is-open" data-cfg-freezer-accordion-item="details">'
        + '<button type="button" class="otto-cfg-freezer-program__accordion-toggle" data-cfg-freezer-accordion-toggle data-cfg-freezer-accordion-target="details" aria-expanded="true" aria-controls="cfg-freezer-accordion-details">'
+ '<span class="otto-cfg-freezer-program__accordion-title-wrap">' + detailsTitleIcon + '<span>' + esc(getFreezerDetailsTitle()) + '</span></span><span class="otto-cfg-freezer-program__accordion-chevron" aria-hidden="true">&#9662;</span>'
        + '</button>'
        + '<div class="otto-cfg-freezer-program__accordion-panel" id="cfg-freezer-accordion-details" data-cfg-freezer-accordion-panel="details">'
        + detailsHtml
+ '<button type="button" class="otto-cfg-freezer-program__cta" data-cfg-freezer-accordion-next="builder">Choose your proteins &#8595;</button>'
        + '</div>'
        + '</section>';
      var builderSection = '<section class="otto-cfg-freezer-program__accordion-item" data-cfg-freezer-accordion-item="builder">'
        + '<button type="button" class="otto-cfg-freezer-program__accordion-toggle" data-cfg-freezer-accordion-toggle data-cfg-freezer-accordion-target="builder" aria-expanded="false" aria-controls="cfg-freezer-accordion-builder">'
+ '<span class="otto-cfg-freezer-program__accordion-title-wrap">' + builderTitleIcon + '<span>' + esc(getFreezerBuilderTitle()) + '</span></span><span class="otto-cfg-freezer-program__accordion-chevron" aria-hidden="true">&#9662;</span>'
        + '</button>'
        + '<div class="otto-cfg-freezer-program__accordion-panel" id="cfg-freezer-accordion-builder" data-cfg-freezer-accordion-panel="builder" hidden>'
        + '<div class="otto-cfg-freezer-program__module otto-cfg-freezer-program__module--builder">'
        + builderHtml
        + '<button type="button" class="otto-cfg-freezer-program__cta" data-cfg-freezer-accordion-next="pricing">Next: review pricing & savings &#8595;</button>'
        + '</div>'
        + '</div>'
        + '</section>';
      var pricingSection = '<section class="otto-cfg-freezer-program__accordion-item" data-cfg-freezer-accordion-item="pricing">'
        + '<button type="button" class="otto-cfg-freezer-program__accordion-toggle" data-cfg-freezer-accordion-toggle data-cfg-freezer-accordion-target="pricing" aria-expanded="false" aria-controls="cfg-freezer-accordion-pricing">'
+ '<span class="otto-cfg-freezer-program__accordion-title-wrap">' + pricingTitleIcon + '<span>' + esc(getFreezerPricingTitle()) + '</span></span><span class="otto-cfg-freezer-program__accordion-chevron" aria-hidden="true">&#9662;</span>'
        + '</button>'
        + '<div class="otto-cfg-freezer-program__accordion-panel" id="cfg-freezer-accordion-pricing" data-cfg-freezer-accordion-panel="pricing" hidden>'
        + '<div class="otto-cfg-freezer-program__module otto-cfg-freezer-program__module--pricing">'
        + pricingHtml
        + '</div>'
        + '</div>'
        + '</section>';
      return '<div class="otto-cfg-freezer-program" data-cfg-freezer-program>'
        + '<div class="otto-cfg-freezer-program__accordion" data-cfg-freezer-accordion>'
        + detailsSection
        + builderSection
        + pricingSection
        + '</div>'
        + '</div>';
    }
    function initFreezerProgramUI(tilesContainer, deliveryStepNum, proteinGroups, totalDaily) {
      var freezerWrap = tilesContainer.querySelector('[data-cfg-freezer-program]');
      if (!freezerWrap) return;
      var freezerCard = getFreezerProgramCard();
      var slots = freezerWrap.querySelectorAll('.otto-cfg-freezer-program__slot[data-cfg-freezer-slot-index]');
      var pricingEl = freezerWrap.querySelector('[data-cfg-freezer-pricing]');
      if (!slots.length) return;
      var cadenceDays = getFreezerCadenceDays(totalDaily);
      var cadenceLabel = getFreezerCadenceLabel(cadenceDays);
      var discountPercent = getFreezerProgramDiscountPercent();
      var visualMap = getFreezerProteinVisualMap();
      var accordionItems = freezerWrap.querySelectorAll('[data-cfg-freezer-accordion-item]');
function isValidFreezerAccordionSection(sectionKey) {
return sectionKey === 'details' || sectionKey === 'builder' || sectionKey === 'pricing';
}
var activeAccordionSection = (freezerCard && isValidFreezerAccordionSection(freezerCard._activeAccordionSection))
? freezerCard._activeAccordionSection
: 'details';
      function setActiveAccordionSection(sectionKey, shouldScrollIntoView) {
if (!isValidFreezerAccordionSection(sectionKey)) return;
activeAccordionSection = sectionKey;
if (freezerCard) freezerCard._activeAccordionSection = sectionKey;
        accordionItems.forEach(function (item) {
          var itemKey = String(item.getAttribute('data-cfg-freezer-accordion-item') || '');
          var isActive = itemKey === sectionKey;
          item.classList.toggle('is-open', isActive);
          var toggle = item.querySelector('[data-cfg-freezer-accordion-toggle]');
          var panel = item.querySelector('[data-cfg-freezer-accordion-panel]');
          if (toggle) toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          if (panel) panel.hidden = !isActive;
          if (isActive && shouldScrollIntoView && panel) {
            setTimeout(function () {
              panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }, 20);
          }
        });
      }
      function closeAllSlotMenus(openSlotIdx) {
        slots.forEach(function (slot) {
          var idx = parseInt(slot.getAttribute('data-cfg-freezer-slot-index'), 10);
          var shouldOpen = isFinite(openSlotIdx) && idx === openSlotIdx;
          slot.classList.toggle('is-open', shouldOpen);
          var trigger = slot.querySelector('[data-cfg-freezer-slot-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        });
      }
function buildFreezerSubscriptionsFromAllocationMap(allocationMap) {
        var subs = [];
        proteinGroups.forEach(function (grp, idx) {
          var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
var totes = Math.floor(Number(allocationMap[proteinName] || 0));
          if (!grp || totes <= 0) return;
          subs.push({
            protein: grp.protein || '',
            price: grp.price || 0,
            dogs: grp.dogs || [],
            dailyTotal: grp.dailyTotal || 0,
            totes: totes,
            interval: cadenceDays,
            lbs: totes * LBS_PER_TOTE,
            freezer_program: true
          });
        });
        return subs;
      }
      function syncAllocationState() {
        var assigned = 0;
        var allocationMap = {};
        proteinGroups.forEach(function (grp, idx) {
          var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
          allocationMap[proteinName] = 0;
        });
        var nextAllocations = [];
        slots.forEach(function (slot) {
          var proteinName = String(slot.getAttribute('data-cfg-freezer-slot-protein') || '').trim();
          if (!proteinName) return;
          if (!isFinite(allocationMap[proteinName])) allocationMap[proteinName] = 0;
          allocationMap[proteinName] += 1;
          assigned += 1;
        });
        proteinGroups.forEach(function (grp, idx) {
          var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
          nextAllocations.push({ protein: proteinName, totes: Math.max(0, Math.floor(Number(allocationMap[proteinName] || 0))) });
        });
        selections.freezer_allocations = nextAllocations;
if (selections.freezer_program) {
selections.subscriptions = buildFreezerSubscriptionsFromAllocationMap(allocationMap);
}
        if (pricingEl) {
          var pricingMetrics = getFreezerPricingMetrics(proteinGroups, allocationMap, totalDaily);
          pricingEl.innerHTML = buildFreezerPricingComparisonInnerHtml(pricingMetrics, discountPercent);
        }
        var remaining = FREEZER_CAPACITY.totes - assigned;
        if (freezerCard && freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
        return remaining;
      }
      freezerWrap.addEventListener('click', function (evt) {
        var nextAccordionBtn = evt.target.closest('[data-cfg-freezer-accordion-next]');
        if (nextAccordionBtn && freezerWrap.contains(nextAccordionBtn)) {
          evt.preventDefault();
          evt.stopPropagation();
          setActiveAccordionSection(String(nextAccordionBtn.getAttribute('data-cfg-freezer-accordion-next') || ''), true);
          return;
        }
        var accordionToggleBtn = evt.target.closest('[data-cfg-freezer-accordion-toggle]');
        if (accordionToggleBtn && freezerWrap.contains(accordionToggleBtn)) {
          evt.preventDefault();
          evt.stopPropagation();
          setActiveAccordionSection(String(accordionToggleBtn.getAttribute('data-cfg-freezer-accordion-target') || ''), false);
          return;
        }
        var optionBtn = evt.target.closest('[data-cfg-freezer-slot-option]');
        if (optionBtn && freezerWrap.contains(optionBtn)) {
          evt.preventDefault();
          evt.stopPropagation();
          var slotIdx = parseInt(optionBtn.getAttribute('data-cfg-freezer-slot-index'), 10);
          var slot = freezerWrap.querySelector('.otto-cfg-freezer-program__slot[data-cfg-freezer-slot-index="' + slotIdx + '"]');
          if (!slot) return;
          var proteinName = String(optionBtn.getAttribute('data-cfg-freezer-protein') || '').trim();
          if (!proteinName) return;
          slot.setAttribute('data-cfg-freezer-slot-protein', proteinName);
          var alternativeProteins = getFreezerSlotAlternativeProteins(proteinGroups, proteinName);
          var hasAlternatives = alternativeProteins.length > 0;
          slot.classList.toggle('is-no-swap', !hasAlternatives);
          var trigger = slot.querySelector('.otto-cfg-freezer-program__slot-trigger');
          if (trigger) {
            trigger.setAttribute('aria-label', 'Slot ' + (slotIdx + 1) + ' protein: ' + proteinName);
            trigger.disabled = !hasAlternatives;
            trigger.innerHTML = buildFreezerSlotTriggerInnerHtml(proteinName, visualMap[proteinName] || null, hasAlternatives, slotIdx);
          }
          var menu = slot.querySelector('[data-cfg-freezer-slot-menu]');
          if (menu) {
            menu.innerHTML = buildFreezerSlotOptionsHtml(alternativeProteins, slotIdx, visualMap);
          }
          closeAllSlotMenus(null);
var remainingAfterOptionSync = syncAllocationState();
if (selections.freezer_program) {
invalidateReviewStep();
}
          return;
        }
        var triggerBtn = evt.target.closest('[data-cfg-freezer-slot-trigger]');
        if (triggerBtn && freezerWrap.contains(triggerBtn)) {
          evt.preventDefault();
          evt.stopPropagation();
          if (triggerBtn.disabled) return;
          var triggerSlot = triggerBtn.closest('.otto-cfg-freezer-program__slot[data-cfg-freezer-slot-index]');
          if (!triggerSlot) return;
          var triggerIdx = parseInt(triggerSlot.getAttribute('data-cfg-freezer-slot-index'), 10);
          var isOpen = triggerSlot.classList.contains('is-open');
          closeAllSlotMenus(isOpen ? null : triggerIdx);
          return;
        }
        closeAllSlotMenus(null);
      });
      freezerWrap.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') closeAllSlotMenus(null);
      });
      var outsideClickHandler = function (evt) {
        if (!document.body.contains(freezerWrap)) {
          document.removeEventListener('click', outsideClickHandler, true);
          return;
        }
        if (!freezerWrap.contains(evt.target)) closeAllSlotMenus(null);
      };
      document.addEventListener('click', outsideClickHandler, true);
      function applyFreezerProgramSelection() {
        closeAllSlotMenus(null);
var remainingAfterSync = syncAllocationState();
if (remainingAfterSync !== 0) {
return false;
}
if (!selections.freezer_program) saveStandardDeliverySnapshot();
var subs = [];
var groupedAllocations = {};
slots.forEach(function (slot) {
var proteinName = String(slot.getAttribute('data-cfg-freezer-slot-protein') || '').trim();
if (!proteinName) return;
if (!isFinite(groupedAllocations[proteinName])) groupedAllocations[proteinName] = 0;
groupedAllocations[proteinName] += 1;
});
proteinGroups.forEach(function (grp, idx) {
var proteinName = (grp && grp.protein) ? String(grp.protein) : ('Protein ' + (idx + 1));
var totes = Math.floor(Number(groupedAllocations[proteinName] || 0));
if (!grp || totes <= 0) return;
subs.push({
protein: grp.protein || '',
price: grp.price || 0,
dogs: grp.dogs || [],
dailyTotal: grp.dailyTotal || 0,
totes: totes,
interval: cadenceDays,
lbs: totes * LBS_PER_TOTE,
freezer_program: true
});
});
if (!subs.length) {
return false;
}
        selections.freezer_program = true;
        selections.freezer_fixed_totes = FREEZER_CAPACITY.totes;
        selections.freezer_fixed_pods = FREEZER_CAPACITY.pods;
        selections.freezer_fixed_lbs = FREEZER_CAPACITY.lbs;
        selections.freezer_cadence_days = cadenceDays;
        selections.freezer_cadence_label = cadenceLabel;
        selections.freezer_allocations = subs.map(function (sub) {
          return { protein: sub.protein, totes: sub.totes };
        });
        selections.totes = FREEZER_CAPACITY.totes;
        selections.delivery_interval = cadenceDays;
        selections.delivery_lbs = FREEZER_CAPACITY.lbs;
        selections.subscriptions = subs;
        freezerWrap.classList.add('is-selected');
        if (deliveryStepNum) {
          markStepCompleted(deliveryStepNum);
          updateIncomplete();
        }
invalidateReviewStep();
        renderDeliveryTiles(true);
        renderFreezerProgramCard(true);
        var freezerCard = getFreezerProgramCard();
        if (freezerCard && freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
        if (!isHydratingState) {
          var next = $('[data-cfg-step="' + (deliveryStepNum + 1) + '"]');
          if (next) setTimeout(function () { scrollToCard(next); }, 400);
        }
        return true;
      }
      if (freezerCard) freezerCard._applyFreezerProgram = applyFreezerProgramSelection;
      if (selections.freezer_program) freezerWrap.classList.add('is-selected');
setActiveAccordionSection(activeAccordionSection, false);
      syncAllocationState();
    }
    /* Per-dog snapped daily pounds from the shared engine. */
    function getHouseholdDogPortions() {
      if (!Engine || typeof Engine.computeDogPortion !== 'function') return [];
      var dogsSource = (Array.isArray(selections.dogs) && selections.dogs.length)
        ? selections.dogs
        : (Array.isArray(selections.dogs_basic) ? selections.dogs_basic : []);
      var out = [];
      for (var d = 0; d < dogsSource.length; d++) {
        var dog = dogsSource[d] || {};
        if (!(Number(dog.weight || 0) > 0)) continue;
        out.push({
          name: String(dog.name || '').trim(),
          dailyLb: dogEffectiveDailyLb(dog)
        });
      }
      return out;
    }
    /* One unified household cadence list. Per cadence, pounds + price come from
     * buildPerDogRecipePlan (per-recipe split, same as review/cart/portal). */
    function getHouseholdCadenceOptions() {
      var perDog = getHouseholdDogPortions();
      if (!perDog.length || !Engine || typeof Engine.buildCadenceList !== 'function' || typeof Engine.roundDeliveryLb !== 'function') {
        return { options: [], perDog: perDog };
      }
      var cadences = Engine.buildCadenceList(settings) || [];
      var minLb = cfgMinPackLb();
      var maxDays = settingNum(settings.max_delivery_interval_days, 70);
      var profile = getSelectedFreezerSpaceProfile() || 'standard';
      var cap = (typeof Engine.freezerCapLb === 'function') ? Engine.freezerCapLb(settings, profile) : Infinity;
      var bagCap = settingNum(settings.bag_capacity_lb, 20);
      var feasible = [];
      cadences.forEach(function (c) {
        if (!c || !(c.days > 0)) return;
        if (c.days > maxDays) return;
        var plan = buildPerDogRecipePlan({ interval: c.days, weeks: c.weeks });
        if (!plan || !plan.ok) return;
        var totals = householdTotalsFromPlan(plan);
        var total = totals.totalLbs;
        var costCents = totals.costCents;
        if (!(total > 0)) return;
        if (total > cap) return;
        var split = (typeof Engine.bagSplit === 'function') ? Engine.bagSplit(total, bagCap) : { count: 0, sizes: [] };
        feasible.push({
          key: c.key,
          label: c.label,
          weeks: c.weeks,
          days: c.days,
          lbs: total,
          bags: split.count,
          bagSizes: split.sizes,
          deliveryCostCents: costCents,
          blendedPriceCents: total > 0 ? Math.round(costCents / total) : 0
        });
      });
      var atMin = feasible.filter(function (o) { return o.lbs >= minLb; });
      var options = atMin.length ? atMin : (feasible.length ? [feasible[feasible.length - 1]] : []);
      /* Display policy: min viable cadence + 2/4/8-week anchors (single option
       * when the minimum is past 8 weeks). Same rule as the portal. */
      var curator = (CadenceEngine && CadenceEngine.curateCadenceChoices) ||
        (Engine && Engine.curateCadenceChoices);
      if (typeof curator === 'function') options = curator(options);
      return { options: options, perDog: perDog };
    }
    /* Unified household delivery cadence card (replaces the per-recipe grouped
     * card and the legacy single card). The customer picks ONE cadence for the
     * whole household; the engine computes each dog's pounds and the cart splits
     * them across each dog's recipes. */
    function renderHouseholdCadence(tilesContainer, deliveryStepNum) {
      var result = getHouseholdCadenceOptions();
      var options = result.options;
      if (!options.length) {
        tilesContainer.innerHTML = '<p class="otto-cfg-card__helper">No standard ' + fulfillmentDropLabel() + ' options fit this combination. Please contact us for custom arrangements.</p>';
        return;
      }
      var dogCount = result.perDog.length;
      var totalDaily = result.perDog.reduce(function (s, pd) { return s + pd.dailyLb; }, 0);
      var html = options.map(function (opt) {
        return buildToteHtml(opt, opt.blendedPriceCents, totalDaily, {
          sharedDogCount: dogCount,
          mealsPerDayEffective: effectiveMealsPerDayForDogs(selections.dogs)
        });
      }).join('');
      tilesContainer.innerHTML = html;
      var existingSub = (Array.isArray(selections.subscriptions) && selections.subscriptions.length === 1) ? selections.subscriptions[0] : null;
      var preLbs = existingSub ? Number(existingSub.lbs || 0) : Number(selections.delivery_lbs || 0);
      var preInt = existingSub ? Number(existingSub.interval || 0) : Number(selections.delivery_interval || 0);
      if (preInt > 0) {
        var preBtn = tilesContainer.querySelector('[data-cfg-tile-value="' + preLbs + '"][data-cfg-delivery-days="' + preInt + '"]')
          || tilesContainer.querySelector('[data-cfg-delivery-days="' + preInt + '"]');
        if (preBtn) preBtn.classList.add('is-selected');
      }
      tilesContainer.querySelectorAll('[data-cfg-tile-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          tilesContainer.querySelectorAll('[data-cfg-tile-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          clearFreezerProgramSelections();
          selections.delivery_lbs = parseInt(btn.getAttribute('data-cfg-tile-value'), 10);
          selections.delivery_interval = parseInt(btn.getAttribute('data-cfg-delivery-days'), 10);
          selections.delivery_weeks = parseInt(btn.getAttribute('data-cfg-delivery-weeks'), 10) || Math.max(1, Math.round(selections.delivery_interval / 7));
          selections.totes = 0;
          /* Blended per-lb price (cents) for this cadence so the review's pricing
           * transparency reflects the household's mixed recipes, not a single one. */
          var chosenOpt = null;
          for (var oi = 0; oi < options.length; oi++) {
            if (String(options[oi].lbs) === String(selections.delivery_lbs) && Number(options[oi].days) === Number(selections.delivery_interval)) {
              chosenOpt = options[oi];
              break;
            }
          }
          var blendedPrice = chosenOpt ? Number(chosenOpt.blendedPriceCents || 0) : Number(selections.product_price || 0);
          selections.subscriptions = [{
            protein: selections.per_dog_protein ? '' : (selections.protein || ''),
            price: blendedPrice,
            dogs: result.perDog.map(function (pd) { return titleCase(pd.name) || 'Dog'; }),
            dailyTotal: totalDaily,
            daily_lb: totalDaily,
            totes: 0,
            interval: selections.delivery_interval,
            weeks: selections.delivery_weeks,
            lbs: selections.delivery_lbs
          }];
          saveStandardDeliverySnapshot();
          if (deliveryStepNum) {
            markStepCompleted(deliveryStepNum);
            updateIncomplete();
          }
          invalidateFromDeliveryCalculator(deliveryStepNum);
          syncDeliveryContinueState();
          renderFreezerProgramCard(true);
          var freezerCard = getFreezerProgramCard();
          if (freezerCard && freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
          var ddCardAfterCadence = $('[data-cfg-type="delivery_day"]');
          if (ddCardAfterCadence && ddCardAfterCadence._renderDeliveryDay) ddCardAfterCadence._renderDeliveryDay();
        });
      });
    }
    function renderSingleDelivery(tilesContainer, deliveryStepNum) {
      var totalDaily = selections.daily_total || 0;
      var options = getValidTotes(totalDaily, getSingleNonFreezerMaxTotes());
      if (options.length === 0) {
        tilesContainer.innerHTML = '<p class="otto-cfg-card__helper">No standard ' + fulfillmentDropLabel() + ' options fit this combination. Please contact us for custom arrangements.</p>';
        return;
      }
      var productPrice = selections.product_price || 0;
var isSharedHousehold = Array.isArray(selections.dogs) && selections.dogs.length > 1;
      var html = options.map(function (opt) {
return buildToteHtml(opt, productPrice, totalDaily, {
sharedDogCount: isSharedHousehold ? selections.dogs.length : 1,
mealsPerDayEffective: effectiveMealsPerDayForDogs(selections.dogs)
});
      }).join('');
      tilesContainer.innerHTML = html;
var existingSub = (Array.isArray(selections.subscriptions) && selections.subscriptions.length === 1) ? selections.subscriptions[0] : null;
var preselectLbs = existingSub ? Number(existingSub.lbs || existingSub.totes || 0) : Number(selections.delivery_lbs || selections.totes || 0);
var preselectInterval = existingSub ? Number(existingSub.interval || 0) : Number(selections.delivery_interval || 0);
if (preselectLbs > 0 && preselectInterval > 0) {
var preBtn = tilesContainer.querySelector('[data-cfg-tile-value="' + preselectLbs + '"][data-cfg-delivery-days="' + preselectInterval + '"]');
if (preBtn) preBtn.classList.add('is-selected');
}
      tilesContainer.querySelectorAll('[data-cfg-tile-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          tilesContainer.querySelectorAll('[data-cfg-tile-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          clearFreezerProgramSelections();
          selections.delivery_lbs = parseInt(btn.getAttribute('data-cfg-tile-value'), 10);
          selections.delivery_interval = parseInt(btn.getAttribute('data-cfg-delivery-days'), 10);
          selections.delivery_weeks = parseInt(btn.getAttribute('data-cfg-delivery-weeks'), 10) || Math.max(1, Math.round(selections.delivery_interval / 7));
          selections.totes = 0;
          selections.subscriptions = [{
            protein: selections.protein || '',
            price: selections.product_price || 0,
            dogs: (selections.dogs || []).map(function (d) { return titleCase(d.name) || 'Dog'; }),
            dailyTotal: selections.daily_total || 0,
            daily_lb: selections.daily_total || 0,
            totes: 0,
            interval: selections.delivery_interval,
            weeks: selections.delivery_weeks,
            lbs: selections.delivery_lbs
          }];
saveStandardDeliverySnapshot();
          if (deliveryStepNum) {
            markStepCompleted(deliveryStepNum);
            updateIncomplete();
          }
          invalidateFromDeliveryCalculator(deliveryStepNum);
          syncDeliveryContinueState();
          renderFreezerProgramCard(true);
          var freezerCard = getFreezerProgramCard();
          if (freezerCard && freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
          var ddCardAfterSingle = $('[data-cfg-type="delivery_day"]');
          if (ddCardAfterSingle && ddCardAfterSingle._renderDeliveryDay) ddCardAfterSingle._renderDeliveryDay();
        });
      });
    }
    function getGroupedSelectionsFromSubscriptions(groupList) {
      var map = {};
      var subs = Array.isArray(selections.subscriptions) ? selections.subscriptions : [];
      if (!subs.length) return map;
      if (selections.freezer_program) return map;
      groupList.forEach(function (grp, gi) {
        var sub = null;
        for (var si = 0; si < subs.length; si++) {
          var next = subs[si];
          if (next && next.freezer_program) continue;
          if (String((next && next.protein) || '').trim() === String((grp && grp.protein) || '').trim()) {
            sub = next;
            break;
          }
        }
        if (!sub) return;
        var totes = Math.floor(Number(sub.totes || 0));
        var interval = Math.floor(Number(sub.interval || 0));
        if (totes > 0 && interval > 0) {
          map[gi] = { totes: totes, interval: interval };
        }
      });
      return map;
    }
    function getGroupedSelectionsFromTiles(tilesContainer) {
      var map = {};
      if (!tilesContainer) return map;
      tilesContainer.querySelectorAll('[data-cfg-delivery-group-tiles]').forEach(function (groupTiles) {
        var gi = parseInt(groupTiles.getAttribute('data-cfg-delivery-group-tiles'), 10);
        if (isNaN(gi)) return;
        var sel = groupTiles.querySelector('.is-selected');
        if (!sel) return;
        var totes = parseInt(sel.getAttribute('data-cfg-tile-value'), 10);
        var interval = parseInt(sel.getAttribute('data-cfg-delivery-days'), 10);
        if (totes > 0 && interval > 0) {
          map[gi] = { totes: totes, interval: interval };
        }
      });
      return map;
    }
    function cloneGroupedSelectionMap(source) {
      var out = {};
      if (!source || typeof source !== 'object') return out;
      Object.keys(source).forEach(function (key) {
        var row = source[key];
        var totes = Math.floor(Number(row && row.totes || 0));
        var interval = Math.floor(Number(row && row.interval || 0));
        if (totes > 0 && interval > 0) out[key] = { totes: totes, interval: interval };
      });
      return out;
    }
    function renderGroupedDelivery(tilesContainer, deliveryStepNum, selectedByGroupInput, activeDogTabIdxInput) {
      var groups = {};
var sourceDogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins.slice() : [];
var productCardForGroups = $('[data-cfg-type="product_selector"]');
var perDogWrapForGroups = productCardForGroups ? productCardForGroups.querySelector('[data-cfg-protein-per-dog]') : null;
if (perDogWrapForGroups && !perDogWrapForGroups.hidden) {
var domRows = [];
perDogWrapForGroups.querySelectorAll('[data-cfg-protein-dog]').forEach(function (groupEl, idx) {
var selectedBtn = groupEl.querySelector('.otto-cfg-tile--product.is-selected[data-cfg-tile-value]');
if (!selectedBtn) return;
var protein = String(selectedBtn.getAttribute('data-cfg-tile-value') || '').trim();
if (!protein) return;
var price = parseInt(selectedBtn.getAttribute('data-product-price') || '0', 10) || 0;
var dog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
domRows.push({
dogIdx: idx,
dogName: titleCase((dog && dog.name) || '') || ('Dog ' + (idx + 1)),
protein: protein,
price: price,
daily_intake: Number((dog && dog.daily_intake) || 0)
});
});
if (domRows.length && Array.isArray(selections.dogs) && domRows.length === selections.dogs.length) {
sourceDogProteins = domRows;
}
}
sourceDogProteins.forEach(function (dp) {
        var key = dp.protein;
        if (!groups[key]) {
          groups[key] = { protein: key, price: dp.price, dogs: [], dailyTotal: 0 };
        }
        groups[key].dogs.push(dp.dogName);
        var groupedDog = (Array.isArray(selections.dogs) && selections.dogs[dp.dogIdx]) ? selections.dogs[dp.dogIdx] : null;
        groups[key].dailyTotal += groupedDog ? dogEffectiveDailyLb(groupedDog) : Number(dp.daily_intake || 0);
      });
      var groupList = Object.keys(groups).map(function (k) { return groups[k]; });
function formatPossessiveMealPlanLabelLocal(name) {
var value = String(name || '').trim();
if (!value) return 'Dog Meal Plan';
var last = value.charAt(value.length - 1).toLowerCase();
return last === 's' ? (value + '\' Meal Plan') : (value + '\'s Meal Plan');
}
function formatSharedMealPlanLabelLocal(names) {
var list = Array.isArray(names) ? names.filter(function (name) {
return !!String(name || '').trim();
}) : [];
if (!list.length) return 'Shared Meal Plan';
if (list.length === 1) return formatPossessiveMealPlanLabelLocal(list[0]);
var combined = '';
if (list.length === 2) combined = list[0] + ' and ' + list[1];
else combined = list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
var lastName = String(list[list.length - 1] || '').trim();
var endsWithS = lastName && lastName.charAt(lastName.length - 1).toLowerCase() === 's';
return combined + (endsWithS ? '\' Shared Meal Plan' : '\'s Shared Meal Plan');
}
      var householdMax = getEffectiveNonFreezerHouseholdMaxTotes();
      var perProteinMax = getEffectiveNonFreezerPerProteinMaxTotes();
      var selectedByGroup = cloneGroupedSelectionMap(selectedByGroupInput);
      if (!Object.keys(selectedByGroup).length) {
        selectedByGroup = getGroupedSelectionsFromTiles(tilesContainer);
      }
      if (!Object.keys(selectedByGroup).length) {
        selectedByGroup = getGroupedSelectionsFromSubscriptions(groupList);
      }
      var groupIdxByProtein = {};
      groupList.forEach(function (grp, idx) {
        var proteinName = String((grp && grp.protein) || '').trim();
        if (!proteinName || isFinite(groupIdxByProtein[proteinName])) return;
        groupIdxByProtein[proteinName] = idx;
      });
function formatDeliveryTabLabel(names, fallbackLabel) {
var list = Array.isArray(names) ? names.filter(function (name) {
return !!String(name || '').trim();
}).map(function (name) {
return titleCase(String(name || '').trim());
}) : [];
if (!list.length) return fallbackLabel || 'Dog';
if (list.length === 1) return list[0];
if (list.length === 2) return list[0] + ' & ' + list[1];
return list.slice(0, -1).join(', ') + ' & ' + list[list.length - 1];
}
var firstDogIdxByGroup = {};
sourceDogProteins.slice().sort(function (a, b) {
          return Math.floor(Number((a && a.dogIdx) || 0)) - Math.floor(Number((b && b.dogIdx) || 0));
}).forEach(function (row) {
          var proteinName = String((row && row.protein) || '').trim();
var groupIdx = isFinite(groupIdxByProtein[proteinName]) ? groupIdxByProtein[proteinName] : -1;
if (groupIdx < 0) return;
var dogIdx = Math.floor(Number((row && row.dogIdx) || 0));
if (!isFinite(firstDogIdxByGroup[groupIdx]) || dogIdx < firstDogIdxByGroup[groupIdx]) {
firstDogIdxByGroup[groupIdx] = dogIdx;
}
});
var tabRows = groupList.map(function (grp, gi) {
var names = Array.isArray(grp && grp.dogs) ? grp.dogs.slice() : [];
var firstDogIdx = isFinite(firstDogIdxByGroup[gi]) ? firstDogIdxByGroup[gi] : (1000 + gi);
          return {
groupIdx: gi,
dogCount: Math.max(1, names.length),
label: formatDeliveryTabLabel(names, 'Plan ' + (gi + 1)),
sortKey: firstDogIdx
};
}).sort(function (a, b) {
if (a.sortKey !== b.sortKey) return a.sortKey - b.sortKey;
return a.groupIdx - b.groupIdx;
});
var showDogTabs = tabRows.length > 1;
      var activeDogTabIdx = Math.floor(Number(activeDogTabIdxInput));
      if (!isFinite(activeDogTabIdx)) {
        var activeTabEl = tilesContainer.querySelector('[data-cfg-delivery-tab].is-active');
        activeDogTabIdx = activeTabEl ? Math.floor(Number(activeTabEl.getAttribute('data-cfg-delivery-tab'))) : 0;
      }
if (!isFinite(activeDogTabIdx) || activeDogTabIdx < 0 || activeDogTabIdx >= tabRows.length) activeDogTabIdx = 0;
var activeGroupIdx = showDogTabs && tabRows[activeDogTabIdx] ? tabRows[activeDogTabIdx].groupIdx : 0;
      if (!isFinite(activeGroupIdx) || activeGroupIdx < 0) activeGroupIdx = 0;
      function getUsedOtherTotes(excludeIdx) {
        var sum = 0;
        Object.keys(selectedByGroup).forEach(function (key) {
          var idx = parseInt(key, 10);
          if (isNaN(idx) || idx === excludeIdx) return;
          var row = selectedByGroup[key];
          sum += Math.max(0, Math.floor(Number(row && row.totes || 0)));
        });
        return sum;
      }
      function hasSelectionForGroup(groupIdx) {
        var row = selectedByGroup[groupIdx];
        var totes = Math.max(0, Math.floor(Number(row && row.totes || 0)));
        var interval = Math.max(0, Math.floor(Number(row && row.interval || 0)));
        return totes > 0 && interval > 0;
      }
      function countUnselectedOtherGroups(excludeIdx) {
        var count = 0;
        for (var i = 0; i < groupList.length; i++) {
          if (i === excludeIdx) continue;
          if (!hasSelectionForGroup(i)) count++;
        }
        return count;
      }
      var html = '';
      if (showDogTabs) {
html += '<div class="otto-cfg-dog-tabs otto-cfg-dog-tabs--protein" data-cfg-delivery-tabs data-cfg-dog-count="' + tabRows.length + '">';
tabRows.forEach(function (row, idx) {
html += '<button type="button" class="otto-cfg-dog-tab otto-cfg-dog-tab--protein' + (idx === activeDogTabIdx ? ' is-active' : '') + '"'
            + ' data-cfg-delivery-tab="' + idx + '"'
+ ' data-cfg-delivery-tab-group="' + row.groupIdx + '"'
+ ' style="flex: ' + row.dogCount + ' 1 0;">'
+ '<span class="otto-cfg-dog-tab__inner otto-cfg-dog-tab__inner--protein"><span class="otto-cfg-dog-tab__label">' + esc(row.label) + '</span><span class="otto-cfg-dog-tab__check" aria-hidden="true"></span></span></button>';
        });
        html += '</div>';
      }
      groupList.forEach(function (grp, gi) {
try {
        var usedOther = getUsedOtherTotes(gi);
        var maxForGroup = perProteinMax;
        if (householdMax > 0) {
          var remainingAfterOtherSelections = Math.max(0, householdMax - usedOther);
          var unselectedOthers = countUnselectedOtherGroups(gi);
          // Reserve one tote for as many other unselected groups as the household cap can still support.
          var reserveForOthers = Math.min(
            unselectedOthers,
            Math.max(0, remainingAfterOtherSelections - 1)
          );
          maxForGroup = Math.min(perProteinMax, Math.max(0, remainingAfterOtherSelections - reserveForOthers));
        }
        var existingSelection = selectedByGroup[gi];
        if (existingSelection && existingSelection.totes > maxForGroup) {
          delete selectedByGroup[gi];
          existingSelection = null;
        }
        var options = getValidTotes(grp.dailyTotal, maxForGroup);
var groupProtein = String((grp && grp.protein) || '').trim();
var groupDogs = Array.isArray(grp.dogs) ? grp.dogs.filter(function (name) {
return !!String(name || '').trim();
}) : [];
var titleLabel = groupDogs.length > 1 ? formatSharedMealPlanLabelLocal(groupDogs) : formatPossessiveMealPlanLabelLocal(groupDogs[0] || 'Dog');
var dailyNumeric = Number(grp.dailyTotal || 0);
var dailyRounded = Math.round(dailyNumeric * 10) / 10;
var dailyText = String(dailyRounded);
if (dailyText.slice(-2) === '.0') dailyText = dailyText.slice(0, -2);
var dayUnit = dailyRounded === 1 ? 'lb/day' : 'lbs/day';
        html += '<div class="otto-cfg-delivery-group" data-cfg-delivery-group="' + gi + '"'
          + (showDogTabs && gi !== activeGroupIdx ? ' hidden' : '')
+ ' data-cfg-delivery-group-protein="' + esc(groupProtein) + '"'
          + ' data-cfg-delivery-panel="' + gi + '">';
html += '<div class="otto-cfg-delivery-group__label">' + esc(titleLabel) + '</div>';
html += '<div class="otto-cfg-delivery-group__meta">' + esc((groupProtein || 'Selected protein') + ' - ' + dailyText + ' ' + dayUnit) + '</div>';
        if (options.length === 0) {
          if (householdMax > 0 && maxForGroup <= 0) {
            html += '<p class="otto-cfg-card__helper">Household tote max reached. Reduce another protein selection to include this one.</p>';
          } else {
            html += '<p class="otto-cfg-card__helper">No standard delivery options for this protein. Please contact us.</p>';
          }
        } else {
          html += '<div class="otto-cfg-tiles" data-cfg-delivery-group-tiles="' + gi + '">';
          /* Resolve this group's dog objects by name so stage-aware meal
           * frequencies (puppies at 3-4x/day) flow into the meal counts. */
          var groupDogObjs = (Array.isArray(selections.dogs) ? selections.dogs : []).filter(function (d) {
            var dogName = String((d && d.name) || '').trim().toLowerCase();
            return groupDogs.some(function (n) { return String(n || '').trim().toLowerCase() === dogName; });
          });
          var groupMealsEffective = effectiveMealsPerDayForDogs(groupDogObjs.length ? groupDogObjs : selections.dogs);
          options.forEach(function (opt) {
html += buildToteHtml(opt, grp.price, grp.dailyTotal, {
sharedDogCount: Math.max(1, groupDogs.length),
mealsPerDayEffective: groupMealsEffective
});
          });
          html += '</div>';
        }
        html += '</div>';
} catch (err) {
throw err;
}
      });
      tilesContainer.innerHTML = html;
      function syncDeliveryDogTabCompletionUI() {
        if (!showDogTabs) return;
tabRows.forEach(function (row, idx) {
          var tab = tilesContainer.querySelector('[data-cfg-delivery-tab="' + idx + '"]');
          if (!tab) return;
          var groupTiles = tilesContainer.querySelector('[data-cfg-delivery-group-tiles="' + row.groupIdx + '"]');
          var sel = groupTiles ? groupTiles.querySelector('.is-selected') : null;
          tab.classList.toggle('is-complete', !!sel);
        });
      }
      function hasSelectionInMap(selectionMap, groupIdx) {
        var row = selectionMap && selectionMap[groupIdx];
        var totes = Math.max(0, Math.floor(Number(row && row.totes || 0)));
        var interval = Math.max(0, Math.floor(Number(row && row.interval || 0)));
        return totes > 0 && interval > 0;
      }
      if (showDogTabs) {
        tilesContainer.querySelectorAll('[data-cfg-delivery-tab]').forEach(function (tab) {
          tab.addEventListener('click', function () {
            var tabIdx = Math.floor(Number(tab.getAttribute('data-cfg-delivery-tab')));
            var groupIdx = Math.floor(Number(tab.getAttribute('data-cfg-delivery-tab-group')));
            tilesContainer.querySelectorAll('[data-cfg-delivery-tab]').forEach(function (t) { t.classList.remove('is-active'); });
            tab.classList.add('is-active');
            tilesContainer.querySelectorAll('[data-cfg-delivery-panel]').forEach(function (panel) {
              panel.hidden = Math.floor(Number(panel.getAttribute('data-cfg-delivery-panel'))) !== groupIdx;
            });
            activeDogTabIdx = isFinite(tabIdx) ? tabIdx : activeDogTabIdx;
          });
        });
      }
      groupList.forEach(function (grp, gi) {
        var groupTiles = tilesContainer.querySelector('[data-cfg-delivery-group-tiles="' + gi + '"]');
        if (!groupTiles) return;
        var preselect = selectedByGroup[gi];
        if (preselect) {
          var preBtn = groupTiles.querySelector('[data-cfg-tile-value="' + preselect.totes + '"][data-cfg-delivery-days="' + preselect.interval + '"]');
          if (preBtn) preBtn.classList.add('is-selected');
          else delete selectedByGroup[gi];
        }
        groupTiles.querySelectorAll('[data-cfg-tile-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            groupTiles.querySelectorAll('[data-cfg-tile-value]').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
if (selections.freezer_program) {
clearFreezerProgramSelections();
}
            var currentActiveTab = tilesContainer.querySelector('[data-cfg-delivery-tab].is-active');
            var currentActiveTabIdx = currentActiveTab ? Math.floor(Number(currentActiveTab.getAttribute('data-cfg-delivery-tab'))) : activeDogTabIdx;
            var nextMap = cloneGroupedSelectionMap(selectedByGroup);
            nextMap[gi] = {
              totes: parseInt(btn.getAttribute('data-cfg-tile-value'), 10),
              interval: parseInt(btn.getAttribute('data-cfg-delivery-days'), 10)
            };
            var nextActiveTabIdx = currentActiveTabIdx;
if (showDogTabs && tabRows.length > 1) {
for (var step = 1; step <= tabRows.length; step++) {
var probeIdx = (currentActiveTabIdx + step) % tabRows.length;
var probeGroupIdx = tabRows[probeIdx] ? tabRows[probeIdx].groupIdx : -1;
                if (!hasSelectionInMap(nextMap, probeGroupIdx)) {
                  nextActiveTabIdx = probeIdx;
                  break;
                }
              }
            }
            renderGroupedDelivery(tilesContainer, deliveryStepNum, nextMap, nextActiveTabIdx);
          });
        });
      });
      syncDeliveryDogTabCompletionUI();
      syncGroupedDelivery(tilesContainer, groupList, deliveryStepNum);
    }
    function syncGroupedDelivery(tilesContainer, groupList, deliveryStepNum) {
if (selections.freezer_program) {
syncDeliveryContinueState();
return;
}
      var allSelected = true;
      var totalSelectedTotes = 0;
      var subs = [];
      groupList.forEach(function (grp, gi) {
        var groupTiles = tilesContainer.querySelector('[data-cfg-delivery-group-tiles="' + gi + '"]');
        var sel = groupTiles ? groupTiles.querySelector('.is-selected') : null;
        if (!sel) {
          allSelected = false;
        } else {
          var lbs = parseInt(sel.getAttribute('data-cfg-tile-value'), 10);
          var intervalDays = parseInt(sel.getAttribute('data-cfg-delivery-days'), 10);
          var weeks = parseInt(sel.getAttribute('data-cfg-delivery-weeks'), 10) || Math.max(1, Math.round(intervalDays / 7));
          totalSelectedTotes += Math.max(0, lbs || 0);
          subs.push({
            protein: grp.protein,
            price: grp.price,
            dogs: grp.dogs,
            dailyTotal: grp.dailyTotal,
            daily_lb: grp.dailyTotal,
            totes: 0,
            interval: intervalDays,
            weeks: weeks,
            lbs: lbs
          });
        }
      });
      clearFreezerProgramSelections();
      selections.subscriptions = subs;
      var effectiveHouseholdMax = getEffectiveNonFreezerHouseholdMaxTotes();
      var completeByHouseholdCap = effectiveHouseholdMax > 0 && totalSelectedTotes >= effectiveHouseholdMax;
if (allSelected || completeByHouseholdCap) saveStandardDeliverySnapshot();
      if (allSelected || completeByHouseholdCap) {
        if (deliveryStepNum) {
          markStepCompleted(deliveryStepNum);
          updateIncomplete();
        }
        invalidateFromDeliveryCalculator(deliveryStepNum);
      } else {
        delete completedSteps[deliveryStepNum];
        updateIncomplete();
      }
      syncDeliveryContinueState();
      renderFreezerProgramCard(true);
      var freezerCard = getFreezerProgramCard();
      if (freezerCard && freezerCard._syncFreezerContinueState) freezerCard._syncFreezerContinueState();
    }
/* ---- Delivery day ---- */
    $$('[data-cfg-type="delivery_day"]').forEach(function (card) {
      var stepNum = parseInt(card.getAttribute('data-cfg-step'), 10);
      var continueBtn = card.querySelector('[data-cfg-delivery-day-continue]');
      var root = card.querySelector('[data-cfg-delivery-day-root]');
      if (!root) return;

      function cardCopy(key, fallback) {
        if (foundingModeEnabled()) {
          var foundingMap = {
            'selected-headline': 'deliverySelectedHeadline',
            'first-delivery-template': 'deliveryFirstTemplate',
            'cadence-template': 'deliveryCadenceTemplate',
            'change-day-note': 'deliveryChangeNote'
          };
          var foundingKey = foundingMap[key];
          if (foundingKey) {
            var foundingVal = foundingCopy(foundingKey, '');
            if (foundingVal) return foundingVal;
          }
        }
        var val = String(card.getAttribute('data-cfg-' + key) || '').trim();
        return val || fallback;
      }

      function syncContinueState() {
        if (!continueBtn) return;
        continueBtn.disabled = !hasValidDeliveryDaySelection();
      }

      function renderDeliveryDayHelper(selected) {
        var helper = card.querySelector('[data-cfg-delivery-day-helper]');
        var helperTitle = card.querySelector('[data-cfg-delivery-day-helper-title]');
        if (!helper) return;
        var wd = normalizeCfgDeliveryWeekday(selected);
        var singleDay = cfgIsSingleDeliveryDayMode();
        var pickup = pickupModeEnabled();
        var pickupAddr = pickup ? pickupAddressBlockHtml() : '';
        if (!cfgWeekdayChosen(wd)) {
          helper.innerHTML = pickupAddr + esc(pickup
            ? 'Complete your plan size above to choose a pickup day.'
            : (singleDay
            ? 'Complete your delivery size above to see your delivery day.'
            : 'Pick your first delivery above — options are sorted soonest first. You can change your day anytime in your account.'));
          if (helperTitle) helperTitle.textContent = pickup ? 'Your pickup schedule' : 'Your delivery schedule';
          return;
        }
        var deliveryD = cfgNextDeliveryOnWeekday(wd);
        var weeks = cfgCadenceWeeksForDeliveryDay();
        var weekdayName = cfgDeliveryWeekdayLabel(wd, false);
        if (helperTitle) {
          helperTitle.textContent = cfgFillDeliveryDayTemplate(
            pickup
              ? 'Your pickup day: {weekday}'
              : cardCopy('selected-headline', 'Your otto delivery day: {weekday}'),
            { weekday: weekdayName }
          );
        }
        var cadenceLine = cfgDeliveryDayCadenceSubline(
          wd,
          weeks,
          pickup
            ? 'Then every {weeks} weeks on {weekday}s'
            : cardCopy('cadence-template', 'Then every {weeks} weeks on {weekday}s')
        );
        var changeDayNote = pickup
          ? pickupCheckoutNote()
          : (singleDay
          ? cardCopy(
              'single-day-helper-tile-text',
              'Same weekday every delivery. More days may open in your area later — you can update anytime in your account.'
            )
          : cardCopy(
              'change-day-note',
              'You can change your delivery day anytime in your account.'
            ));
        helper.innerHTML =
          pickupAddr +
          '<ul class="otto-cfg-delivery-day__confirm-list">' +
          '<li>' + esc(cfgFillDeliveryDayTemplate(
            pickup
              ? 'First pickup: {date}'
              : cardCopy('first-delivery-template', 'First delivery: {date}'),
            { date: cfgFormatDeliveryDate(deliveryD) }
          )) + '</li>' +
          (cadenceLine ? ('<li>' + esc(cadenceLine) + '</li>') : '') +
          '</ul>' +
          '<p class="otto-cfg-delivery-day__footnote">' + esc(changeDayNote) + '</p>';
      }

      function renderDeliveryDay() {
        if (!hasValidDeliverySelection()) {
          root.innerHTML = '<p class="otto-cfg-card__helper" data-cfg-delivery-day-locked>' +
            esc(pickupModeEnabled()
              ? 'Complete your pickup size above to choose a day.'
              : (cfgIsSingleDeliveryDayMode()
              ? 'Complete your delivery size above to see your delivery day.'
              : 'Complete your delivery size above to choose a day.')) + '</p>';
          var helperLocked = card.querySelector('[data-cfg-delivery-day-helper]');
          if (helperLocked) {
            helperLocked.innerHTML = (pickupModeEnabled() ? pickupAddressBlockHtml() : '') +
              esc(pickupModeEnabled()
              ? 'Pick your first pickup above after you choose your pickup size and cadence.'
              : (cfgIsSingleDeliveryDayMode()
              ? 'Complete your delivery size above to see your delivery day.'
              : 'Pick your first delivery above after you choose your delivery size and cadence.'));
          }
          syncDeliveryDayCopy();
          syncContinueState();
          return;
        }

        var today = new Date();
        today.setHours(9, 0, 0, 0);
        var todayDay = today.getDay();

        var sortedWeekdays = cfgDeliveryWeekdaysBySoonest();
        if (sortedWeekdays.length === 1) {
          selections.delivery_weekday = sortedWeekdays[0].value;
        }

        var selected = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
        var hasSelection = cfgWeekdayChosen(selected);
        if (hasSelection && sortedWeekdays.length && !sortedWeekdays.some(function (w) {
          return w.value === selected;
        })) {
          delete selections.delivery_weekday;
          selected = null;
          hasSelection = false;
          if (sortedWeekdays.length === 1) {
            selections.delivery_weekday = sortedWeekdays[0].value;
            selected = sortedWeekdays[0].value;
            hasSelection = true;
          }
        }

        var weeks = cfgCadenceWeeksForDeliveryDay();
        var cadenceTemplate = cardCopy('cadence-template', 'Then every {weeks} weeks on {weekday}s');
        var tomorrowLabel = cardCopy('tomorrow-label', 'Tomorrow');
        var earliestLabel = cardCopy('earliest-label', 'Earliest');
        var singleDayMode = sortedWeekdays.length === 1;

        var weekdayTiles = sortedWeekdays.map(function (w, idx) {
          var isSelected = hasSelection && w.value === selected;
          var isToday = todayDay === w.value;
          var firstDeliveryMulti = cfgNextDeliveryOnWeekday(w.value);
          var title = firstDeliveryMulti
            ? cfgFormatFirstDeliveryTileTitle(firstDeliveryMulti, today, w.value, tomorrowLabel)
            : cfgDeliveryWeekdayLabel(w.value, true);
          var subline = cfgDeliveryDayCadenceSubline(w.value, weeks, cadenceTemplate);
          var dayBadge = '';
          if (idx === 0) {
            dayBadge = '<span class="otto-cfg-tile__price otto-cfg-tile__day-badge otto-cfg-tile__day-badge--earliest">' +
              esc(earliestLabel) + '</span>';
          }
          var ariaLabel = title + (subline ? ('. ' + subline) : '');
          return '<button type="button" class="otto-cfg-tile otto-cfg-tile--product' +
            (isSelected ? ' is-selected' : '') +
            (isToday ? ' is-today' : '') +
            (singleDayMode ? ' is-single-day' : '') +
            '" data-cfg-delivery-weekday="' + w.value + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '"' +
            (singleDayMode ? ' aria-disabled="true"' : '') +
            ' aria-label="' + esc(ariaLabel) + '">' +
            '<div class="otto-cfg-tile__text">' +
            '<span class="otto-cfg-tile__label">' + esc(title) + '</span>' +
            (subline ? ('<span class="otto-cfg-tile__ingredients">' + esc(subline) + '</span>') : '') +
            '</div>' +
            dayBadge +
            '</button>';
        }).join('');

        root.innerHTML =
          '<div class="otto-cfg-tiles otto-cfg-tiles--products" role="group" aria-label="Delivery weekday">' +
          weekdayTiles +
          '</div>';

        if (!singleDayMode) {
          root.querySelectorAll('[data-cfg-delivery-weekday]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var wd = normalizeCfgDeliveryWeekday(btn.getAttribute('data-cfg-delivery-weekday'));
              if (!cfgWeekdayChosen(wd)) return;
              selections.delivery_weekday = wd;
              renderDeliveryDay();
              syncContinueState();
              invalidateReviewStep();
            });
          });
        }
        renderDeliveryDayHelper(selected);
        syncDeliveryDayCopy();
        syncContinueState();
      }

      card._renderDeliveryDay = renderDeliveryDay;
      renderDeliveryDay();

      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (continueBtn.disabled) return;
          if (!hasValidDeliveryDaySelection()) return;
          if (stepNum) {
            markStepCompleted(stepNum);
            updateIncomplete();
          }
          invalidateReviewStep();
          var next = $('[data-cfg-step="' + (stepNum + 1) + '"]');
          if (next) setTimeout(function () { scrollToCard(next); }, 300);
        });
      }
    });
/* ---- Review ---- */
    applyFoundingModeUi();
    syncDeliveryDayCopy();
    var startBtn = $('[data-cfg-start-subscription]');
var startBtnDefaultLabel = startBtn ? getStartButtonDefaultLabel() : '';
if (startBtn) startBtn.textContent = startBtnDefaultLabel;
    if (startBtn) startBtn.addEventListener('click', function () {
if (startBtn.disabled) return;
var payload = buildLoopCartItemsFromSelections();
if (!payload.ok) {
window.alert(payload.error || 'Please complete your plan details before continuing.');
return;
}
setStartButtonBusyState(startBtn, true, startBtnDefaultLabel);
var reservationCode = foundingModeEnabled() ? foundingReservationDiscountCode() : '';
if (foundingModeEnabled() && !reservationCode) {
window.alert('Founding reservation discount is not configured. Please contact support.');
setStartButtonBusyState(startBtn, false, startBtnDefaultLabel);
return;
}
clearShopifyCart()
.then(function () {
return stripReservationDiscount().catch(function () { return null; });
})
.then(function () {
return fetch('/cart/add.js', {
method: 'POST',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/json'
},
credentials: 'same-origin',
body: JSON.stringify({ items: payload.items })
});
})
.then(function (response) {
if (response.ok) return response.json();
return response.json().catch(function () { return {}; }).then(function (body) {
var message = String((body && body.description) || (body && body.message) || 'Unable to start subscription. Please try again.');
throw new Error(message);
});
})
.then(function () {
return writeOnboardingCartAttributes({
discount: reservationCode,
requireDiscount: !!reservationCode
});
})
.then(function (cart) {
if (reservationCode) return cart;
return stripReservationDiscount(cart);
})
.then(function () {
window.location.href = foundingCheckoutUrl(reservationCode);
})
.catch(function (err) {
console.error('Failed to start Loop subscription cart:', err);
window.alert((err && err.message) ? err.message : 'Unable to start subscription right now. Please try again.');
setStartButtonBusyState(startBtn, false, startBtnDefaultLabel);
});
});
if (startBtn) {
window.addEventListener('pageshow', function () {
setStartButtonBusyState(startBtn, false, startBtnDefaultLabel);
});
}
    function buildReview() {
      var body = $('[data-cfg-review-body]');
      if (!body) return;
var reviewCardEl = body.closest('[data-cfg-type="review"]') || $('[data-cfg-type="review"]');
var freezerIconUrl = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-freezer-icon-url') || '').trim() : '';
var reviewVersion = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-review-version') || '').trim().toLowerCase() : '';
var useReviewV3 = REVIEW_V3_EXPERIMENT_ENABLED || reviewVersion === 'v3';
var useReviewV2 = !useReviewV3 && (REVIEW_V2_EXPERIMENT_ENABLED || reviewVersion === 'v2');
if (startBtn) {
startBtnDefaultLabel = getStartButtonDefaultLabel();
setStartButtonBusyState(startBtn, false, startBtnDefaultLabel);
}
var competitorRawCostPerLb = Math.max(0, Number(reviewCardEl ? reviewCardEl.getAttribute('data-cfg-comp-raw-cost-per-lb') : 0) || 0);
var competitorCookedCostPerLb = Math.max(0, Number(reviewCardEl ? reviewCardEl.getAttribute('data-cfg-comp-cooked-cost-per-lb') : 0) || 0);
var competitorKibbleCostPerLb = Math.max(0, Number(reviewCardEl ? reviewCardEl.getAttribute('data-cfg-comp-kibble-cost-per-lb') : 0) || 0);
var competitorRawLabel = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-comp-raw-label') || '').trim() : '';
var competitorCookedLabel = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-comp-cooked-label') || '').trim() : '';
var competitorKibbleLabel = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-comp-kibble-label') || '').trim() : '';
var pricingDisclaimer = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-pricing-disclaimer') || '').trim() : '';
var comparisonLinkLabel = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-comparison-link-label') || '').trim() : '';
var comparisonPanelHeading = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-comparison-panel-heading') || '').trim() : '';
var reviewSummaryTitle = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-review-summary-title') || '').trim() : '';
var packTotalsTaxValue = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-pack-totals-tax-note') || '').trim() : '';
if (!packTotalsTaxValue || /calculated at checkout/i.test(packTotalsTaxValue)) {
packTotalsTaxValue = 'At checkout';
}
var startBtnOverrideLabel = reviewCardEl ? String(reviewCardEl.getAttribute('data-cfg-start-button-override') || '').trim() : '';
function getProteinChoices() {
var productCard = $('[data-cfg-type="product_selector"]');
if (!productCard) return [];
var seen = {};
var out = [];
productCard.querySelectorAll('[data-cfg-protein-single] .otto-cfg-tile--product').forEach(function (tile) {
var title = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
if (!title) return;
var key = normalizeName(title);
if (seen[key]) return;
seen[key] = true;
out.push({
title: title,
price: parseInt(tile.getAttribute('data-product-price') || '0', 10) || 0
});
});
return out;
}
function resolveProteinPrice(protein) {
var key = normalizeName(protein);
if (!key) return 0;
var found = getProteinChoices().find(function (choice) {
return normalizeName(choice && choice.title) === key;
});
return found ? Number(found.price || 0) : 0;
}
function buildProteinOptionsHtml(selectedProtein) {
var selectedKey = normalizeName(selectedProtein);
var options = getProteinChoices();
if (!options.length) return '';
return options.map(function (choice) {
var title = String(choice && choice.title || '').trim();
if (!title) return '';
var isSelected = normalizeName(title) === selectedKey;
return '<option value="' + esc(title) + '"' + (isSelected ? ' selected' : '') + '>' + esc(title) + '</option>';
}).join('');
}
function line(label, value, rowClass) {
var cls = 'otto-cfg-review-tile__line' + (rowClass ? (' ' + rowClass) : '');
return '<div class="' + cls + '"><span class="otto-cfg-review-tile__label">' + esc(label) + '</span><span class="otto-cfg-review-tile__value">' + esc(value) + '</span></div>';
}
function lineHtml(label, valueHtml, rowClass) {
var cls = 'otto-cfg-review-tile__line' + (rowClass ? (' ' + rowClass) : '');
return '<div class="' + cls + '"><span class="otto-cfg-review-tile__label">' + esc(label) + '</span><span class="otto-cfg-review-tile__value">' + valueHtml + '</span></div>';
}
function packTotalsDeliveryValue(valueText) {
return String(valueText || '') + '<span class="otto-cfg-review-dog-single__cadence"> / ' + fulfillmentDropLabel() + '</span>';
}
function recipeDisplayName(protein) {
var name = String(protein || '').trim();
if (!name) return '';
var titles = [];
document.querySelectorAll('[data-cfg-type="product_selector"] .otto-cfg-tile--product[data-cfg-tile-value]').forEach(function (tile) {
var title = String(tile.getAttribute('data-cfg-tile-value') || '').trim();
if (title) titles.push(title);
});
var lower = name.toLowerCase();
var exact = titles.filter(function (title) { return title.toLowerCase() === lower; })[0];
if (exact) return exact;
var prefix = lower.replace(/\s+(blend|recipe)$/i, '');
var prefixMatch = titles.filter(function (title) {
var current = title.toLowerCase();
return current === prefix || current.indexOf(prefix + ' ') === 0;
})[0];
if (prefixMatch) return prefixMatch;
return name.replace(/\bBlend\b/g, 'Recipe');
}
function buildPackTotalsRecipeRowHtml(rec) {
var lbs = Math.max(0, Number(rec && rec.lbs || 0));
if (!(lbs > 0)) return '';
var protein = recipeDisplayName(rec && rec.protein);
if (!protein) return '';
var lbLabel = (lbs % 1 === 0 ? String(Math.floor(lbs)) : lbs.toFixed(1)) + ' lbs';
return '<div class="otto-cfg-review-tile__line otto-cfg-review-tile__line--recipe">' +
'<span class="otto-cfg-review-tile__label">' + esc(protein) + '</span>' +
'<span class="otto-cfg-review-tile__value">' + esc(lbLabel) + '</span>' +
'</div>';
}
function buildPackTotalsScheduleMeta(interval, weeks) {
var cadenceWeeks = cadenceWeeksFrom(interval, weeks);
if (foundingModeEnabled()) {
if (!(cadenceWeeks > 0)) return '';
return '<div class="otto-cfg-review-pack__schedule-meta">' +
'<span class="otto-cfg-review-pack__schedule-meta-cadence">' +
esc('Every ' + cadenceWeeks + ' week' + (cadenceWeeks === 1 ? '' : 's') + ' once deliveries start') +
'</span></div>';
}
var weekday = normalizeCfgDeliveryWeekday(selections.delivery_weekday);
var firstDelivery = cfgWeekdayChosen(weekday) ? cfgNextDeliveryOnWeekday(weekday) : null;
var dateText = firstDelivery ? cfgFormatFirstDeliverySubline(firstDelivery) : '';
var pickup = pickupModeEnabled();
var cadenceText = (cfgWeekdayChosen(weekday) && cadenceWeeks > 0)
  ? cfgDeliveryDayCadenceSubline(weekday, cadenceWeeks)
  : '';
if (!dateText && !cadenceText && !pickup) return '';
var html = '<div class="otto-cfg-review-pack__schedule-meta' +
  (pickup ? ' otto-cfg-review-pack__schedule-meta--pickup' : '') + '">';
if (dateText) html += '<span class="otto-cfg-review-pack__schedule-meta-date">' + esc(dateText) + '</span>';
if (cadenceText) html += '<span class="otto-cfg-review-pack__schedule-meta-cadence">' + esc(cadenceText) + '</span>';
if (pickup) {
  var windowLabel = pickupWindowLabel();
  var addr = pickupAddressLabel();
  html += '<span class="otto-cfg-review-pack__schedule-meta-hours">' + esc(windowLabel);
  if (addr) html += '<br>' + esc(addr);
  html += '</span>';
}
html += '</div>';
return html;
}
function pricedPlanAmount(plan, pct) {
var priced = initialOrderPricingFromPlan(plan, pct);
return (priced.discountCents > 0 ? priced.totalCents : priced.subtotalCents) / 100;
}
function struckRateValueHtml(listAmount, saleAmount) {
if (!(listAmount > saleAmount + 0.009)) return esc(money(saleAmount));
return '<span class="otto-cfg-review-tile__value-was">' + esc(money(listAmount)) + '</span>' +
  '<span class="otto-cfg-review-tile__value-now">' + esc(money(saleAmount)) + '</span>';
}
function discountRateRow(label, listAmount, saleAmount, rowClass) {
return lineHtml(label, struckRateValueHtml(listAmount, saleAmount), rowClass || 'otto-cfg-review-tile__line--household-discount');
}
function reviewTrustIcon(kind) {
if (kind === 'pause') {
return '<svg class="otto-cfg-review-trust__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="4" width="4" height="16" rx="1"></rect><rect x="14" y="4" width="4" height="16" rx="1"></rect></svg>';
}
if (kind === 'pickup') {
return '<svg class="otto-cfg-review-trust__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';
}
return '<svg class="otto-cfg-review-trust__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>';
}
function setReviewTrust(show) {
var trust = reviewCardEl ? reviewCardEl.querySelector('[data-cfg-review-trust]') : null;
if (!trust) return;
if (!show) {
trust.hidden = true;
trust.textContent = '';
return;
}
var pickup = fulfillmentDropLabel() === 'pickup';
trust.hidden = false;
trust.innerHTML = '<span class="otto-cfg-review-trust__item">' + reviewTrustIcon(pickup ? 'pickup' : 'delivery') + (pickup ? 'Free Pickup' : 'Free Delivery') + '</span>' +
'<span class="otto-cfg-review-trust__item">' + reviewTrustIcon('pause') + 'Pause or Cancel Anytime</span>';
}
function buildFoundingPackTotalsPriceSummaryRows(plan, interval, weeks) {
var pricing = initialOrderPricingFromPlan(plan, 0);
if (!(pricing.subtotalCents > 0)) return '';
var subtotal = pricing.subtotalCents / 100;
var launchPct = foundingLaunchDiscountPercent();
var ongoingPct = foundingOngoingDiscountPercent();
var launchTotal = launchPct > 0 ? pricedPlanAmount(plan, launchPct) : subtotal;
var ongoingTotal = ongoingPct > 0 ? pricedPlanAmount(plan, ongoingPct) : subtotal;
var title = foundingCopy('reviewSummaryTitle', 'Founding Pack Reservation');
var dueLabel = foundingCopy('reviewDueLabel', 'Due today');
var dueValue = foundingCopy('reviewDueValue', '$0 — Reservation only');
var instructions = foundingCopy(
'reviewInstructions',
'To complete your reservation, enter your payment details at checkout. You will not be charged today. You’ll only be charged when Otto launches deliveries, and we’ll email you before that happens.'
);
var hasDiscount = launchPct > 0 || ongoingPct > 0;
var rows = '';
rows += '<p class="otto-cfg-review-pack__founding-title">' + esc(title) + '</p>';
if (!hasDiscount) {
rows += line('Plan Value', money(subtotal), 'otto-cfg-review-tile__line--household-subtotal');
}
if (launchPct > 0) {
rows += discountRateRow('First Delivery at Launch (' + launchPct + '% off)', subtotal, launchTotal);
}
if (ongoingPct > 0) {
rows += discountRateRow('Then Founding Member Rate (' + ongoingPct + '% off)', subtotal, ongoingTotal);
}
rows += line('Delivery', 'FREE', 'otto-cfg-review-tile__line--household-delivery');
rows += lineHtml(
dueLabel,
esc(dueValue),
'otto-cfg-review-tile__line--first-delivery-total otto-cfg-review-tile__line--founding-due'
);
rows += buildPackTotalsScheduleMeta(interval, weeks);
if (instructions) {
rows += '<p class="otto-cfg-review-pack__founding-instructions">' + esc(instructions) + '</p>';
}
return rows;
}
function packTotalsPricedRateRow(label, plan, pct, rowClass) {
var priced = initialOrderPricingFromPlan(plan, pct);
var amount = (priced.discountCents > 0 ? priced.totalCents : priced.subtotalCents) / 100;
return line(label, money(amount), rowClass || 'otto-cfg-review-tile__line--household-discount');
}
function buildIntroPackTotalsPriceSummaryRows(plan, interval, weeks) {
var pricing = initialOrderPricingFromPlan(plan, 0);
if (!(pricing.subtotalCents > 0)) return '';
var subtotal = pricing.subtotalCents / 100;
var firstPct = getInitialOrderDiscountPercent();
var ongoingPct = introOngoingDiscountPercent();
var dueTotal = firstPct > 0 ? pricedPlanAmount(plan, firstPct) : subtotal;
var ongoingTotal = ongoingPct > 0 ? pricedPlanAmount(plan, ongoingPct) : subtotal;
var hasDiscount = firstPct > 0 || ongoingPct > 0;
var pickup = pickupModeEnabled();
var rows = '';
if (!hasDiscount) {
rows += line('Plan Value', money(subtotal), 'otto-cfg-review-tile__line--household-subtotal');
}
if (firstPct > 0) {
rows += discountRateRow((pickup ? 'First Pickup (' : 'First Delivery (') + firstPct + '% off)', subtotal, dueTotal);
}
if (ongoingPct > 0) {
rows += discountRateRow('Then Member Rate (' + ongoingPct + '% off)', subtotal, ongoingTotal);
}
rows += line(pickup ? 'Pickup' : 'Delivery', 'FREE', 'otto-cfg-review-tile__line--household-delivery');
rows += line('Taxes', packTotalsTaxValue, 'otto-cfg-review-tile__line--household-tax');
rows += lineHtml(
pickup ? 'First Pickup' : 'First Delivery',
packTotalsDeliveryValue(money(dueTotal)),
'otto-cfg-review-tile__line--first-delivery-total'
);
rows += buildPackTotalsScheduleMeta(interval, weeks);
return rows;
}
function buildMaturePackTotalsPriceSummaryRows(plan, interval, weeks) {
var pricing = initialOrderPricingFromPlan(plan, 0);
if (!(pricing.subtotalCents > 0)) return '';
var subtotal = pricing.subtotalCents / 100;
var firstPct = matureFirstDiscountPercent();
var dueTotal = firstPct > 0 ? pricedPlanAmount(plan, firstPct) : subtotal;
var rows = '';
if (!(firstPct > 0)) {
rows += line('Plan Value', money(subtotal), 'otto-cfg-review-tile__line--household-subtotal');
}
if (firstPct > 0) {
rows += discountRateRow('First Delivery (' + firstPct + '% off)', subtotal, dueTotal);
}
rows += line('Then Regular Rate', money(subtotal), 'otto-cfg-review-tile__line--household-discount');
rows += line('Delivery', 'FREE', 'otto-cfg-review-tile__line--household-delivery');
rows += line('Taxes', packTotalsTaxValue, 'otto-cfg-review-tile__line--household-tax');
rows += lineHtml(
'First Delivery',
packTotalsDeliveryValue(money(dueTotal)),
'otto-cfg-review-tile__line--first-delivery-total'
);
rows += buildPackTotalsScheduleMeta(interval, weeks);
return rows;
}
function buildPackTotalsPriceSummaryRows(plan, interval, weeks) {
if (foundingModeEnabled()) return buildFoundingPackTotalsPriceSummaryRows(plan, interval, weeks);
if (matureModeEnabled()) return buildMaturePackTotalsPriceSummaryRows(plan, interval, weeks);
return buildIntroPackTotalsPriceSummaryRows(plan, interval, weeks);
}
function tile(title, contentHtml, showTitle) {
var titleHtml = (showTitle === false) ? '' : ('<h3 class="otto-cfg-review-tile__title">' + esc(title) + '</h3>');
return '<section class="otto-cfg-review-tile-group">' + titleHtml + '<div class="otto-cfg-review-tile">' + contentHtml + '</div></section>';
}
      function formatChoice(value) {
        if (!value) return '';
        var v = String(value);
        return v.charAt(0).toUpperCase() + v.slice(1);
      }
      function formatActivityLevel(value) {
        var key = String(value || '').trim().toLowerCase();
        if (!key) return '';
        if (key === 'recommended') return 'Normal';
        if (key === 'light') return 'Light';
        if (key === 'active') return 'High';
        return formatChoice(key);
      }
      function money(amount) {
        return '$' + Number(amount || 0).toFixed(2);
      }
      function formatLbs(amount) {
        var rounded = Math.round(Number(amount || 0) * 100) / 100;
        if (rounded <= 0) return '';
        return String(rounded).replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
      }
      function formatQuantityValue(totalLbs, mealCount) {
        var mealsText = mealCount > 0 ? (Math.round(mealCount) + ' Meals') : '';
        var lbsNumber = Number(totalLbs || 0);
        var lbsText = lbsNumber > 0 ? (lbsNumber + ' lbs') : '';
        if (mealsText && lbsText) return mealsText + ' (' + lbsText + ')';
        if (lbsText) return lbsText;
        return mealsText;
      }
      var reviewDogPlanCache = null;
      function getReviewDogPlan() {
        if (reviewDogPlanCache !== null) return reviewDogPlanCache;
        try { reviewDogPlanCache = buildPerDogRecipePlan(); } catch (planErr) { reviewDogPlanCache = { ok: false }; }
        return reviewDogPlanCache;
      }
      function buildDogBreedMetaHtml(dogIdx, currentDog) {
        var dogBreed = '';
        if (Array.isArray(selections.dogs_basic) && selections.dogs_basic[dogIdx] && selections.dogs_basic[dogIdx].breed) {
          dogBreed = String(selections.dogs_basic[dogIdx].breed || '').trim();
        } else if (currentDog && currentDog.breed) {
          dogBreed = String(currentDog.breed || '').trim();
        }
        if (!dogBreed) return '';
        return '<p class="otto-cfg-review-dog-single__meta otto-cfg-review-dog-single__breed">' + esc(dogBreed) + '</p>';
      }
      function buildDogOzMetaHtml(dogIdx, currentDog) {
        var oz = 0;
        var rawPct = 100;
        var plan = getReviewDogPlan();
        if (plan && plan.ok && Array.isArray(plan.dogs) && plan.dogs[dogIdx]) {
          var dogPlan = plan.dogs[dogIdx];
          rawPct = normalizeRawPercent(dogPlan.profile && dogPlan.profile.raw_percent);
          oz = Number(dogPlan.daily_lb || 0) * 16;
        }
        if (!(oz > 0)) {
          var source = (Array.isArray(selections.dogs) && selections.dogs[dogIdx]) || currentDog || {};
          rawPct = dogRawPercent(source);
          oz = dogEffectiveDailyLb(source) * 16;
        }
        if (!(oz > 0)) return '';
        var mixNote = rawPct < 100 ? (' · ' + rawShareShortLabel(rawPct)) : '';
        return '<p class="otto-cfg-review-dog-single__meta otto-cfg-review-dog-single__portion">' +
          oz.toFixed(0) + ' oz <strong class="otto-cfg-review-dog-single__brand">otto</strong>' +
          '<span class="otto-cfg-review-dog-single__cadence"> / day</span>' +
          esc(mixNote) + '</p>';
      }
      function getReviewDogSelections(dogIdx, currentDog) {
        var basic = (Array.isArray(selections.dogs_basic) && selections.dogs_basic[dogIdx]) ? selections.dogs_basic[dogIdx] : {};
        var full = (Array.isArray(selections.dogs) && selections.dogs[dogIdx]) ? selections.dogs[dogIdx] : {};
        var dog = currentDog || {};
        return {
          sex: String(basic.sex || full.sex || dog.sex || '').trim(),
          weight: Number(basic.weight || full.weight || dog.weight || 0),
          life_stage: String(full.life_stage || basic.life_stage || dog.life_stage || dog.stage || '').trim(),
          activity: String(full.activity || basic.activity || dog.activity || '').trim(),
          goal: normalizeGoalValue(full.goal || basic.goal || dog.goal || '')
        };
      }
      function buildDogSelectionBulletsHtml(dogIdx, currentDog) {
        var info = getReviewDogSelections(dogIdx, currentDog);
        var items = [];
        var sex = String(info.sex || '').trim().toLowerCase();
        if (sex) items.push(formatChoice(sex));
        if (info.weight > 0) items.push(info.weight + ' lbs');
        var lifeStage = String(info.life_stage || '').trim();
        if (lifeStage) items.push(lifeStageLabel(lifeStage));
        if (!items.length) return '';
        var rows = items.map(function (item) {
          return '<li class="otto-cfg-review-dog-single__selection">' + esc(item) + '</li>';
        }).join('');
        return '<ul class="otto-cfg-review-dog-single__selections">' + rows + '</ul>';
      }
      function buildDogSummaryMainHtml(currentDog, idx) {
        var dogName = titleCase(currentDog.name) || ('Dog ' + (idx + 1));
        var html = '';
        html += '<div class="otto-cfg-review-dog-single__name">';
        html += '<span class="otto-cfg-review-dog-single__name-text">' + esc(dogName) + '</span>';
        html += '</div>';
        html += buildDogBreedMetaHtml(idx, currentDog);
        html += buildDogOzMetaHtml(idx, currentDog);
        html += buildDogSelectionBulletsHtml(idx, currentDog);
        return html;
      }
      var REVIEW_AGE_BUCKETS = [
        ['young_puppy', 'Young Puppy (8\u201316 weeks)'],
        ['growing_puppy', 'Growing Puppy (4\u20136 months)'],
        ['juvenile', 'Juvenile (6\u201312 months)'],
        ['young_adult', 'Young Adult (1\u20132 years)'],
        ['adult', 'Adult (2\u20137 years)'],
        ['senior', 'Senior (7+ years)']
      ];
      function buildReviewBirthdayFieldsHtml(currentDog, idx) {
        var estimated = !!(currentDog && currentDog.age_estimated);
        var birth = (!estimated) ? String((currentDog && currentDog.birthdate) || '').trim() : '';
        var match = birth.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?/);
        var birthMonth = match ? parseInt(match[2], 10) : 0;
        var birthYear = match ? parseInt(match[1], 10) : 0;
        var birthDay = (match && match[3]) ? parseInt(match[3], 10) : 0;
        var stageKey = String((currentDog && currentDog.life_stage) || '').trim().toLowerCase();
        var bucketOptions = '<option value=""' + (REVIEW_AGE_BUCKETS.some(function (b) { return b[0] === stageKey; }) ? '' : ' selected') + ' disabled>Age</option>';
        REVIEW_AGE_BUCKETS.forEach(function (bucket) {
          bucketOptions += '<option value="' + bucket[0] + '"' + (stageKey === bucket[0] ? ' selected' : '') + '>' + bucket[1] + '</option>';
        });
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var monthOptions = '<option value=""' + (birthMonth ? '' : ' selected') + ' disabled>Month</option>';
        monthNames.forEach(function (label, i) {
          var value = i + 1;
          monthOptions += '<option value="' + value + '"' + (birthMonth === value ? ' selected' : '') + '>' + label + '</option>';
        });
        var dayOptions = '<option value=""' + (birthDay ? '' : ' selected') + '>Day</option>';
        for (var d = 1; d <= 31; d++) {
          dayOptions += '<option value="' + d + '"' + (birthDay === d ? ' selected' : '') + '>' + d + '</option>';
        }
        var nowYear = new Date().getFullYear();
        var yearOptions = '<option value=""' + (birthYear ? '' : ' selected') + ' disabled>Year</option>';
        for (var y = nowYear; y >= nowYear - 24; y--) {
          yearOptions += '<option value="' + y + '"' + (birthYear === y ? ' selected' : '') + '>' + y + '</option>';
        }
        var stageCaption = '';
        if (stageKey) {
          stageCaption = '<span class="otto-cfg-review-v2-note">' + esc(lifeStageLabel(stageKey)) + (estimated ? ' (estimated age)' : '') + '</span>';
        }
        var html = '';
        html += '<label class="otto-cfg-review-dog-edit__field"><span>Age</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="age_bucket">' + bucketOptions + '</select>' + stageCaption + '</label>';
        html += '<label class="otto-cfg-review-dog-edit__field"><span>Birthday month (optional)</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="birth_month">' + monthOptions + '</select></label>';
        html += '<label class="otto-cfg-review-dog-edit__field"><span>Birthday day</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="birth_day">' + dayOptions + '</select></label>';
        html += '<label class="otto-cfg-review-dog-edit__field"><span>Birthday year</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="birth_year">' + yearOptions + '</select></label>';
        return html;
      }
      function buildDogBlockHtml(dog, idx) {
        var currentDog = dog || {};
        var dogBreed = '';
        if (Array.isArray(selections.dogs_basic) && selections.dogs_basic[idx] && selections.dogs_basic[idx].breed) {
          dogBreed = String(selections.dogs_basic[idx].breed || '').trim();
        } else if (currentDog.breed) {
          dogBreed = String(currentDog.breed || '').trim();
        }
        var tileHtml = '';
tileHtml += '<div class="otto-cfg-review-dog-item">';
        tileHtml += '<div class="otto-cfg-review-dog-single">';
        tileHtml += buildDogAvatarHtml(currentDog, idx, 'otto-cfg-dog-avatar--review otto-cfg-dog-avatar--review-single');
        tileHtml += '<div class="otto-cfg-review-dog-single__content">';
        tileHtml += buildDogSummaryMainHtml(currentDog, idx);
if (useReviewV2) {
        tileHtml += '</div>';
tileHtml += '</div>';
tileHtml += '<details class="otto-cfg-review-dog-edit-details">';
tileHtml += '<summary class="otto-cfg-review-dog-edit-details__summary"><span>Edit details</span><span class="otto-cfg-review-dog-edit-details__chevron" aria-hidden="true">&#9662;</span></summary>';
tileHtml += '<div class="otto-cfg-review-dog-edit-details__body">';
tileHtml += '<div class="otto-cfg-review-v2-grid">';
tileHtml += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Dog identity</h4><div class="otto-cfg-review-dog-edit__grid">';
tileHtml += '<label class="otto-cfg-review-dog-edit__field"><span>Name</span><input class="input" type="text" value="' + esc(String(currentDog.name || '')) + '" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="name"></label>';
tileHtml += '<label class="otto-cfg-review-dog-edit__field"><span>Breed</span><input class="input" type="text" value="' + esc(dogBreed) + '" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="breed"></label>';
tileHtml += '<label class="otto-cfg-review-dog-edit__field"><span>Sex</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="sex"><option value="male"' + (String(currentDog.sex || '').toLowerCase() === 'male' ? ' selected' : '') + '>Male</option><option value="female"' + (String(currentDog.sex || '').toLowerCase() === 'female' ? ' selected' : '') + '>Female</option></select></label>';
tileHtml += '</div></section>';
tileHtml += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Dog metabolism</h4><div class="otto-cfg-review-dog-edit__grid">';
tileHtml += '<label class="otto-cfg-review-dog-edit__field"><span>Weight (lb)</span><input class="input" type="number" min="1" step="1" value="' + esc(String(currentDog.weight || '')) + '" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="weight"></label>';
tileHtml += buildReviewBirthdayFieldsHtml(currentDog, idx);
// Growth-stage dogs aren't asked about activity — puppy metabolism runs high regardless.
if (!isGrowthStageKey(currentDog.life_stage)) {
tileHtml += '<label class="otto-cfg-review-dog-edit__field"><span>Activity</span><select class="input" data-cfg-review-edit-dog data-cfg-review-dog-idx="' + idx + '" data-cfg-review-dog-field="activity"><option value="light"' + (String(currentDog.activity || '').toLowerCase() === 'light' ? ' selected' : '') + '>Light activity</option><option value="recommended"' + (String(currentDog.activity || '').toLowerCase() === 'recommended' ? ' selected' : '') + '>Normal activity</option><option value="active"' + (String(currentDog.activity || '').toLowerCase() === 'active' ? ' selected' : '') + '>High activity</option></select></label>';
}
tileHtml += '</div></section>';
var reviewDogMeals = mealsPerDayForDogDisplay(currentDog, mealsPerDayForReview);
var reviewMealsNote = stageMealsPerDay(currentDog.life_stage) > 0 ? ' (recommended for this age)' : '';
tileHtml += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-12"><h4 class="otto-cfg-review-v2-tile__title">Portion output</h4><div class="otto-cfg-review-v2-kv"><span>Daily intake</span><strong>' + esc(String(currentDog.daily_intake || 0)) + ' lbs/day</strong></div><div class="otto-cfg-review-v2-kv"><span>Meals per day</span><strong>' + esc(String(reviewDogMeals || 0)) + esc(reviewMealsNote) + '</strong></div><p class="otto-cfg-review-v2-note">Changes here will automatically recalculate cadence and pricing tiles.</p></section>';
tileHtml += '</div>';
tileHtml += '</div>';
tileHtml += '</details>';
}
if (!useReviewV2) {
tileHtml += '</div>';
tileHtml += '</div>';
}
        tileHtml += '</div>';
        return tileHtml;
      }
      var tiles = [];
      var hasSummaryData = false;
      var mealsPerDayForReview = getMealsPerDay();
      var dogs = Array.isArray(selections.dogs) ? selections.dogs : [];
      /* Daily-intake-weighted household rate for total meal counts: puppies
       * eating 3-4x/day yield more, smaller meals than the flat setting. */
      var effectiveMealsForReview = effectiveMealsPerDayForDogs(dogs, mealsPerDayForReview);
      /* Same weighting scoped to one subscription's dogs (falls back to the
       * whole household when the group can't be resolved). */
      function reviewMealsPerDayForDogIndexes(dogIndexes) {
        var safe = Array.isArray(dogIndexes) ? dogIndexes.filter(function (idx) {
          return isFinite(idx) && idx >= 0 && idx < dogs.length;
        }) : [];
        var group = safe.length ? safe.map(function (idx) { return dogs[idx]; }) : dogs;
        return effectiveMealsPerDayForDogs(group, mealsPerDayForReview);
      }
      var subscriptions = Array.isArray(selections.subscriptions) ? selections.subscriptions : [];
      function packTile(contentHtml) {
return '<section class="otto-cfg-review-tile-group otto-cfg-review-tile-group--accordion"><div class="otto-cfg-review-tile otto-cfg-review-tile--accordion">' + contentHtml + '</div></section>';
}
function buildReviewSectionHeader(title, collapsible) {
var chevron = collapsible ? '<span class="otto-cfg-review-pack__section-chevron" aria-hidden="true">&#9662;</span>' : '';
return '<span class="otto-cfg-review-pack__section-title">' + esc(title) + '</span>' + chevron;
}
function embedComparisonInSubscriptions(subscriptionsHtml, comparisonHtml) {
if (!String(subscriptionsHtml || '').trim() || !String(comparisonHtml || '').trim()) return subscriptionsHtml;
var block = '<div class="otto-cfg-review-pack__comparison">' + comparisonHtml + '</div>';
if (subscriptionsHtml.indexOf('otto-cfg-review-pack__subscriptions') !== -1) {
var tileClose = subscriptionsHtml.lastIndexOf('</div></section>');
if (tileClose !== -1) {
return subscriptionsHtml.slice(0, tileClose) + block + subscriptionsHtml.slice(tileClose);
}
var wrapperOpen = subscriptionsHtml.indexOf('<div class="otto-cfg-review-pack__subscriptions">');
if (wrapperOpen !== -1) {
var wrapperClose = subscriptionsHtml.lastIndexOf('</div>');
if (wrapperClose > wrapperOpen) {
return subscriptionsHtml.slice(0, wrapperClose) + block + subscriptionsHtml.slice(wrapperClose);
}
}
}
if (subscriptionsHtml.indexOf('otto-cfg-review-pack__sub') !== -1) {
var subBodyClose = subscriptionsHtml.lastIndexOf('</div></details>');
if (subBodyClose !== -1) {
return subscriptionsHtml.slice(0, subBodyClose) + block + subscriptionsHtml.slice(subBodyClose);
}
}
var wrapperClose = subscriptionsHtml.lastIndexOf('</div>');
if (wrapperClose !== -1) {
return subscriptionsHtml.slice(0, wrapperClose) + block + subscriptionsHtml.slice(wrapperClose);
}
return subscriptionsHtml + block;
}
function buildReviewAccordion(dogsHtml, subscriptionsHtml, pricingHtml, comparisonHtml) {
var hasSubscriptions = !!String(subscriptionsHtml || '').trim();
var hasComparison = !!String(comparisonHtml || '').trim();
var accordionHtml = '<div class="otto-cfg-review-pack__accordion">';
accordionHtml += '<div class="otto-cfg-review-pack__dogs-block">' + (dogsHtml || '<p class="otto-cfg-card__helper">No dog details available yet.</p>') + '</div>';
if (hasSubscriptions) {
accordionHtml += '<div class="otto-cfg-review-pack__totals">' + subscriptionsHtml + '</div>';
}
if (hasComparison && String(subscriptionsHtml || '').indexOf('otto-cfg-review-pack__comparison') === -1) {
var comparisonAccordionLabel = comparisonLinkLabel || 'How Otto compares';
accordionHtml += '<details class="otto-cfg-review-pack__section otto-cfg-review-pack__section--comparison"><summary class="otto-cfg-review-pack__section-header">' + buildReviewSectionHeader(comparisonAccordionLabel, true) + '</summary><div class="otto-cfg-review-pack__section-body"><div class="otto-cfg-review-pack__comparison">' + comparisonHtml + '</div></div></details>';
}
if (useReviewV2 && String(pricingHtml || '').trim()) {
accordionHtml += '<details class="otto-cfg-review-pack__section otto-cfg-review-pack__section--pricing" open><summary class="otto-cfg-review-pack__section-header">' + buildReviewSectionHeader('Otto Pricing Transparency', true) + '</summary><div class="otto-cfg-review-pack__section-body">' + pricingHtml + '</div></details>';
}
accordionHtml += '</div>';
return accordionHtml;
}
      function normalizeName(value) {
        return String(value || '').trim().toLowerCase();
      }
function formatPossessiveLabel(name) {
var value = String(name || '').trim();
if (!value) return 'Dog\'s Portion';
var last = value.charAt(value.length - 1).toLowerCase();
return last === 's' ? (value + '\' Portion') : (value + '\'s Portion');
}
function formatPossessivePlanLabel(name) {
var value = String(name || '').trim();
if (!value) return 'Dog Meal Plan';
var last = value.charAt(value.length - 1).toLowerCase();
return last === 's' ? (value + '\' Meal Plan') : (value + '\'s Meal Plan');
}
function formatSharedPlanLabel(names) {
var list = Array.isArray(names) ? names.filter(function (name) {
return !!String(name || '').trim();
}) : [];
if (!list.length) return 'Shared Meal Plan';
if (list.length === 1) return formatPossessivePlanLabel(list[0]);
var combined = '';
if (list.length === 2) combined = list[0] + ' and ' + list[1];
else combined = list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
var lastName = String(list[list.length - 1] || '').trim();
var endsWithS = lastName && lastName.charAt(lastName.length - 1).toLowerCase() === 's';
return combined + (endsWithS ? '\' Shared Meal Plan' : '\'s Shared Meal Plan');
}
function buildSubscriptionSummary(sub, dogIndexes) {
if (!sub) return '';
var safeDogIndexes = Array.isArray(dogIndexes) ? dogIndexes : [];
var mealCount = 0;
var totalLbs = Number(sub.lbs || 0);
var interval = Number(sub.interval || 0);
var price = Number(sub.price || 0);
var deliveryCost = (price > 0 && totalLbs > 0) ? (price / 100) * totalLbs : 0;
var daily = Number(sub.dailyTotal || 0);
var summaryMeals = reviewMealsPerDayForDogIndexes(safeDogIndexes);
if (totalLbs > 0 && daily > 0 && summaryMeals > 0) {
mealCount = (totalLbs / daily) * summaryMeals;
}
var roundedMeals = mealCount > 0 ? Math.round(mealCount) : 0;
var lbsPart = totalLbs > 0 ? (totalLbs + ' lbs') : '';
var mealsPart = roundedMeals > 0 ? (roundedMeals + ' meals') : '';
var protein = String(sub.protein || '').trim();
var cadence = formatCadenceText(interval, sub.weeks, { lowercase: true });
var costPart = deliveryCost > 0 ? ('for ' + money(deliveryCost) + ' per delivery') : '';
var proteinPart = protein ? ('of our ' + protein) : 'of your selected plan';
var introParts = [];
if (lbsPart) introParts.push(lbsPart);
if (mealsPart) introParts.push(mealsPart);
var intro = introParts.length === 2 ? (introParts[0] + ' (' + introParts[1] + ')') : (introParts[0] || introParts[1] || '');
var sentence = 'We will deliver ' + (intro || 'your plan') + ' ' + proteinPart;
if (cadence) sentence += ' ' + cadence;
if (costPart) sentence += ' ' + costPart;
        sentence += '.';
return sentence;
}
      function buildSubscriptionLines(sub, includeFreezerMeta, dogIndexes) {
        var rows = [];
        if (includeFreezerMeta && selections.freezer_program) {
          rows.push(line('Program', 'Freezer program'));
          if (selections.freezer_fixed_totes) {
rows.push(line('Bundle', selections.freezer_fixed_totes + ' totes (' + (selections.freezer_fixed_lbs || 0) + ' lbs)'));
}
if (selections.freezer_cadence_label) {
rows.push(line('Auto cadence', selections.freezer_cadence_label));
          }
        }
        if (!sub) return rows;
        var price = Number(sub.price || 0);
        var daily = Number(sub.dailyTotal || 0);
        var deliveryCost = (price > 0 && Number(sub.lbs || 0) > 0) ? (price / 100) * Number(sub.lbs) : 0;
var safeDogIndexes = Array.isArray(dogIndexes) ? dogIndexes.filter(function (idx) {
return isFinite(idx) && idx >= 0 && idx < dogs.length;
}) : [];
        /* Single-dog subscriptions divide by that dog's own feeding
         * frequency (young puppies eat 3-4 smaller meals per day). */
        var soloDog = safeDogIndexes.length === 1 ? dogs[safeDogIndexes[0]] : (dogs.length === 1 ? dogs[0] : null);
        var subMealsPerDay = soloDog ? mealsPerDayForDogDisplay(soloDog, mealsPerDayForReview) : reviewMealsPerDayForDogIndexes(safeDogIndexes);
        var lbsPerMeal = (daily > 0 && subMealsPerDay > 0) ? (daily / subMealsPerDay) : 0;
        var pricePerLb = price > 0 ? (price / 100) : 0;
        var perMeal = (pricePerLb > 0 && lbsPerMeal > 0) ? pricePerLb * lbsPerMeal : 0;
        var mealCount = (Number(sub.lbs || 0) > 0 && daily > 0 && subMealsPerDay > 0)
          ? (Number(sub.lbs) / daily) * subMealsPerDay
          : 0;
        var quantity = formatQuantityValue(sub.lbs, mealCount);
        if (sub.protein) rows.push(line('Protein', sub.protein));
        if (quantity) rows.push(line('Quantity', quantity));
if (!sub.freezer_program && sub.interval) rows.push(line('Frequency', formatCadenceText(sub.interval, sub.weeks)));
        if (perMeal > 0) {
var totalCostLabel = safeDogIndexes.length > 1 ? 'Total Cost Per Meal' : 'Cost per meal';
var soloMealsNote = (soloDog && stageMealsPerDay(soloDog.life_stage) > 0) ? ' at ' + subMealsPerDay + ' meals/day' : '';
rows.push(line(totalCostLabel, money(perMeal) + ' (' + formatLbs(lbsPerMeal) + ' lbs)' + soloMealsNote));
if (safeDogIndexes.length > 1 && mealsPerDayForReview > 0 && pricePerLb > 0) {
            safeDogIndexes.forEach(function (idx) {
              var dog = dogs[idx] || {};
var dailyIntake = dogEffectiveDailyLb(dog);
if (dailyIntake <= 0) return;
var dogMealsPerDay = mealsPerDayForDogDisplay(dog, mealsPerDayForReview);
var dogLbsPerMeal = dailyIntake / dogMealsPerDay;
var dogPerMeal = pricePerLb * dogLbsPerMeal;
              if (dogPerMeal <= 0) return;
              var dogName = titleCase(dog.name) || ('Dog ' + (idx + 1));
var dogMealsNote = stageMealsPerDay(dog.life_stage) > 0 ? ' at ' + dogMealsPerDay + ' meals/day' : '';
              rows.push(line(
formatPossessiveLabel(dogName),
                money(dogPerMeal) + ' (' + formatLbs(dogLbsPerMeal) + ' lbs)' + dogMealsNote,
'otto-cfg-review-tile__line--portion'
              ));
            });
          }
        }
        if (deliveryCost > 0) rows.push(line('Total Cost Per Delivery', money(deliveryCost)));
        return rows;
      }
function buildFreezerAggregateSubscriptionLines(subs, dogIndexes, options) {
        var rows = [];
var list = Array.isArray(subs) ? subs : [];
        if (!list.length) return rows;
var opts = options || {};
var includeOverviewRows = opts.includeOverviewRows !== false;
var includeProteinRows = opts.includeProteinRows !== false;
var safeDogIndexes = Array.isArray(dogIndexes) ? dogIndexes.filter(function (idx) {
return isFinite(idx) && idx >= 0 && idx < dogs.length;
}) : [];
        var totalTotes = 0;
var totalLbs = 0;
var regularCost = 0;
var cadence = 0;
var proteinRows = [];
        list.forEach(function (sub) {
var totes = Math.max(0, Math.floor(Number(sub && sub.totes || 0)));
var lbs = Number(sub && sub.lbs || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
var price = Number(sub && sub.price || 0);
          totalTotes += totes;
totalLbs += Math.max(0, lbs);
if (price > 0 && lbs > 0) regularCost += (price / 100) * lbs;
cadence = cadence || Math.max(0, Math.floor(Number(sub && sub.interval || 0)));
var protein = String(sub && sub.protein || '').trim();
if (protein && totes > 0) {
proteinRows.push({ protein: protein, totes: totes });
}
});
proteinRows.sort(function (a, b) { return b.totes - a.totes; });
var totalDaily = Number(selections.daily_total || 0);
        /* Single-dog households divide by that dog's own feeding frequency
         * (young puppies eat 3-4 smaller meals per day). */
        var aggSoloDog = safeDogIndexes.length === 1 ? dogs[safeDogIndexes[0]] : (dogs.length === 1 ? dogs[0] : null);
        var aggMealsPerDay = aggSoloDog ? mealsPerDayForDogDisplay(aggSoloDog, mealsPerDayForReview) : reviewMealsPerDayForDogIndexes(safeDogIndexes);
var mealCount = (totalLbs > 0 && totalDaily > 0 && aggMealsPerDay > 0)
          ? (totalLbs / totalDaily) * aggMealsPerDay
          : 0;
var quantity = formatQuantityValue(totalLbs, mealCount);
var discountPercent = getFreezerProgramDiscountPercent();
var discountAmount = regularCost * (discountPercent / 100);
var netCost = Math.max(0, regularCost - discountAmount);
        var lbsPerMeal = (totalDaily > 0 && aggMealsPerDay > 0) ? (totalDaily / aggMealsPerDay) : 0;
var totalPerMeal = (mealCount > 0) ? (netCost / mealCount) : 0;
if (includeOverviewRows) rows.push(line('Program', 'Freezer program'));
if (includeOverviewRows && (totalTotes > 0 || totalLbs > 0)) rows.push(line('Protein Bundle', totalTotes + ' totes (' + totalLbs + ' lbs)'));
if (includeProteinRows) {
proteinRows.forEach(function (row) {
          rows.push(line(
row.protein,
row.totes + ' tote' + (row.totes > 1 ? 's' : ''),
'otto-cfg-review-tile__line--portion'
));
});
}
if (quantity) rows.push(line('Quantity', quantity));
var aggMealsNote = (aggSoloDog && stageMealsPerDay(aggSoloDog.life_stage) > 0) ? ' at ' + aggMealsPerDay + ' meals/day' : '';
if (totalPerMeal > 0) rows.push(line('Total Cost Per Meal', money(totalPerMeal) + ' (' + formatLbs(lbsPerMeal) + ' lbs)' + aggMealsNote));
if (safeDogIndexes.length > 1 && mealsPerDayForReview > 0 && netCost > 0 && totalLbs > 0) {
var netPricePerLb = netCost / totalLbs;
            safeDogIndexes.forEach(function (idx) {
              var dog = dogs[idx] || {};
var dailyIntake = dogEffectiveDailyLb(dog);
if (dailyIntake <= 0) return;
var dogMealsPerDay = mealsPerDayForDogDisplay(dog, mealsPerDayForReview);
var dogLbsPerMeal = dailyIntake / dogMealsPerDay;
var dogPerMeal = netPricePerLb * dogLbsPerMeal;
              var dogName = titleCase(dog.name) || ('Dog ' + (idx + 1));
var dogMealsNote = stageMealsPerDay(dog.life_stage) > 0 ? ' at ' + dogMealsPerDay + ' meals/day' : '';
              rows.push(line(
formatPossessiveLabel(dogName),
                money(dogPerMeal) + ' (' + formatLbs(dogLbsPerMeal) + ' lbs)' + dogMealsNote,
'otto-cfg-review-tile__line--portion'
              ));
            });
          }
if (regularCost > 0) rows.push(line('Regular Cost Per Delivery', money(regularCost)));
if (discountAmount > 0) rows.push(line('Freezer Program Discount (' + discountPercent + '%)', '-' + money(discountAmount), 'otto-cfg-review-tile__line--portion'));
if (netCost > 0) rows.push(line('Total Cost Per Delivery', money(netCost)));
        return rows;
      }
function buildFreezerAggregateMetrics(subs) {
var list = Array.isArray(subs) ? subs : [];
var totalTotes = 0;
var totalLbs = 0;
var regularCost = 0;
var cadence = 0;
var byProtein = {};
list.forEach(function (sub) {
var totes = Math.max(0, Math.floor(Number(sub && sub.totes || 0)));
var lbs = Number(sub && sub.lbs || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
var price = Number(sub && sub.price || 0);
var protein = String(sub && sub.protein || '').trim();
totalTotes += totes;
totalLbs += Math.max(0, lbs);
if (price > 0 && lbs > 0) regularCost += (price / 100) * lbs;
cadence = cadence || Math.max(0, Math.floor(Number(sub && sub.interval || 0)));
if (protein && totes > 0) {
if (!isFinite(byProtein[protein])) byProtein[protein] = 0;
byProtein[protein] += totes;
}
});
var totalDaily = Number(selections.daily_total || 0);
var mealCount = (totalLbs > 0 && totalDaily > 0 && effectiveMealsForReview > 0)
? (totalLbs / totalDaily) * effectiveMealsForReview
: 0;
var quantity = formatQuantityValue(totalLbs, mealCount);
var discountPercent = getFreezerProgramDiscountPercent();
var discountAmount = regularCost * (discountPercent / 100);
var netCost = Math.max(0, regularCost - discountAmount);
var proteinRows = Object.keys(byProtein).map(function (protein) {
return { protein: protein, totes: Math.max(0, Math.floor(Number(byProtein[protein] || 0))) };
}).filter(function (row) { return row.totes > 0; });
proteinRows.sort(function (a, b) {
if (a.totes !== b.totes) return b.totes - a.totes;
return String(a.protein || '').localeCompare(String(b.protein || ''), undefined, { sensitivity: 'base' });
});
return {
totalTotes: totalTotes,
totalLbs: totalLbs,
cadence: cadence,
regularCost: regularCost,
discountPercent: discountPercent,
discountAmount: discountAmount,
netCost: netCost,
quantity: quantity,
proteinRows: proteinRows
};
}
function buildFreezerProteinAllocationRows(proteinRows, visualMap) {
var rows = Array.isArray(proteinRows) ? proteinRows : [];
if (!rows.length) return '';
var html = '<div class="otto-cfg-review-pack__allocations">';
rows.forEach(function (row) {
var proteinName = String(row && row.protein || '').trim() || 'Protein';
var visual = visualMap[normalizeName(proteinName)] || null;
var imageHtml = visual && visual.src
? ('<img class="otto-cfg-review-pack__allocation-image" src="' + esc(visual.src) + '" alt="' + esc(visual.alt || proteinName) + '" loading="lazy">')
: '<span class="otto-cfg-review-pack__allocation-image otto-cfg-review-pack__allocation-image--placeholder" aria-hidden="true"></span>';
html += '<div class="otto-cfg-review-pack__allocation-row">';
html += '<span class="otto-cfg-review-pack__allocation-left">' + imageHtml + '<span class="otto-cfg-review-pack__allocation-title">' + esc(proteinName) + '</span></span>';
html += '<span class="otto-cfg-review-pack__allocation-value">' + esc(String(row.totes)) + ' tote' + (row.totes > 1 ? 's' : '') + '</span>';
html += '</div>';
});
html += '</div>';
return html;
}
function buildFreezerAggregateSubscriptionRow(subs, dogIndexes, visualMap) {
var list = Array.isArray(subs) ? subs : [];
if (!list.length) return '';
var metrics = buildFreezerAggregateMetrics(list);
var quantityText = metrics.quantity || 'Quantity pending';
var cadenceText = metrics.cadence > 0 ? formatCadenceText(metrics.cadence) : 'Delivery cadence pending';
var priceText = metrics.netCost > 0 ? money(metrics.netCost) : 'TBD';
var discountPillText = Math.max(0, Math.round(Number(metrics.discountPercent || 0))) + '% off';
var totalDaily = Number(selections.daily_total || 0);
var freezerMealCount = (metrics.totalLbs > 0 && totalDaily > 0 && effectiveMealsForReview > 0)
? (metrics.totalLbs / totalDaily) * effectiveMealsForReview
: 0;
var freezerPerMeal = (metrics.netCost > 0 && freezerMealCount > 0) ? (metrics.netCost / freezerMealCount) : 0;
var perMealText = freezerPerMeal > 0 ? (money(freezerPerMeal) + '/meal') : 'TBD';
var detailsRows = buildFreezerAggregateSubscriptionLines(list, dogIndexes, {
includeOverviewRows: false,
includeProteinRows: false
});
if (!detailsRows.length) detailsRows.push('<p class="otto-cfg-card__helper">No additional details yet.</p>');
var allocationHtml = buildFreezerProteinAllocationRows(metrics.proteinRows, visualMap);
var freezerImageHtml = freezerIconUrl
? ('<img class="otto-cfg-review-pack__sub-image" src="' + esc(freezerIconUrl) + '" alt="Freezer Program icon" loading="lazy">')
: '<span class="otto-cfg-review-pack__sub-image otto-cfg-review-pack__sub-image--placeholder" aria-hidden="true"></span>';
var html = '';
html += '<details class="otto-cfg-review-pack__sub">';
html += '<summary class="otto-cfg-review-pack__sub-summary otto-cfg-review-pack__sub-summary--freezer">';
html += '<span class="otto-cfg-review-pack__sub-left">' + freezerImageHtml + '<span class="otto-cfg-review-pack__sub-copy"><span class="otto-cfg-review-pack__sub-title">Freezer Program</span><span class="otto-cfg-review-pack__sub-meta">' + esc(quantityText) + '</span></span></span>';
html += '<span class="otto-cfg-review-pack__sub-right"><span class="otto-cfg-review-pack__sub-discount-pill">' + esc(discountPillText) + '</span><span class="otto-cfg-review-pack__sub-price">' + esc(priceText) + '</span><span class="otto-cfg-review-pack__sub-permeal">' + esc(perMealText) + '</span><span class="otto-cfg-review-pack__sub-cadence">' + esc(cadenceText) + '</span></span>';
html += '<span class="otto-cfg-review-pack__sub-chevron" aria-hidden="true">&#9662;</span>';
html += '</summary>';
html += '<div class="otto-cfg-review-pack__sub-body">' + allocationHtml + detailsRows.join('') + '</div>';
html += '</details>';
return html;
}
function buildFreezerAggregateSummary(subs) {
var list = Array.isArray(subs) ? subs : [];
if (!list.length) return '';
var totalTotes = 0;
var totalLbs = 0;
var cadence = 0;
var regularCost = 0;
var names = [];
list.forEach(function (sub) {
var totes = Math.max(0, Math.floor(Number(sub && sub.totes || 0)));
var lbs = Number(sub && sub.lbs || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
totalTotes += totes;
totalLbs += Math.max(0, lbs);
cadence = cadence || Math.max(0, Math.floor(Number(sub && sub.interval || 0)));
var price = Number(sub && sub.price || 0);
if (price > 0 && lbs > 0) regularCost += (price / 100) * lbs;
var protein = String(sub && sub.protein || '').trim();
if (protein && names.indexOf(protein) === -1) names.push(protein);
});
var totalDaily = Number(selections.daily_total || 0);
var mealCount = (totalLbs > 0 && totalDaily > 0 && effectiveMealsForReview > 0)
? Math.round((totalLbs / totalDaily) * effectiveMealsForReview)
: 0;
var discountPercent = getFreezerProgramDiscountPercent();
var netCost = Math.max(0, regularCost * (1 - (discountPercent / 100)));
var mix = names.length ? names.join(' + ') + ' mix' : 'selected blend mix';
var qty = totalLbs > 0 ? (totalLbs + ' lbs') : (totalTotes + ' totes');
var meals = mealCount > 0 ? (' (' + mealCount + ' meals)') : '';
var cadenceText = cadence > 0 ? (' ' + formatCadenceText(cadence, 0, { lowercase: true })) : '';
var costText = netCost > 0 ? (' for ' + money(netCost) + ' per delivery') : '';
var discountText = discountPercent > 0 ? (' after a ' + discountPercent + '% freezer discount') : '';
return 'We will deliver ' + qty + meals + ' of a ' + mix + cadenceText + costText + discountText + '.';
}
function getProteinVisualMap() {
var out = {};
var productCard = $('[data-cfg-type="product_selector"]');
if (!productCard) return out;
productCard.querySelectorAll('.otto-cfg-tile--product').forEach(function (btn) {
var key = normalizeName(btn.getAttribute('data-cfg-tile-value'));
if (!key || out[key]) return;
var img = btn.querySelector('.otto-cfg-tile__img');
if (!img) return;
var src = img.getAttribute('src') || '';
if (!src) return;
out[key] = {
src: src,
alt: img.getAttribute('alt') || btn.getAttribute('data-cfg-tile-value') || 'Subscription image'
};
});
return out;
}
function resolveSubscriptionDogIndexes(sub, subIdx, dogIndexByName, currentSubs) {
            var matchedIndexes = [];
            var seen = {};
            if (sub && Array.isArray(sub.dogs) && sub.dogs.length) {
              sub.dogs.forEach(function (dogName) {
                var mappedIdx = dogIndexByName[normalizeName(dogName)];
                if (mappedIdx != null && !seen[mappedIdx]) {
                  seen[mappedIdx] = true;
                  matchedIndexes.push(mappedIdx);
                }
              });
            }
            if (!matchedIndexes.length) {
if (currentSubs.length === dogs.length && dogs[subIdx]) {
                matchedIndexes = [subIdx];
} else if (currentSubs.length === 1) {
                matchedIndexes = dogs.map(function (_dog, idx) { return idx; });
              }
            }
return matchedIndexes;
}
function buildSubscriptionRow(sub, subIdx, dogIndexes, visualMap) {
var currentSub = sub || {};
var proteinName = String(currentSub.protein || '').trim() || 'Subscription';
var visual = visualMap[normalizeName(proteinName)] || null;
var totes = Math.max(0, Math.floor(Number(currentSub.totes || 0)));
var totalLbs = Number(currentSub.lbs || 0);
if (!totalLbs && totes > 0) totalLbs = totes * LBS_PER_TOTE;
var daily = Number(currentSub.dailyTotal || selections.daily_total || 0);
var rowMealsPerDay = reviewMealsPerDayForDogIndexes(dogIndexes);
var mealCount = (totalLbs > 0 && daily > 0 && rowMealsPerDay > 0)
? Math.round((totalLbs / daily) * rowMealsPerDay)
: 0;
var quantityText = formatQuantityValue(totalLbs, mealCount) || 'Quantity pending';
var interval = Math.max(0, Math.floor(Number(currentSub.interval || 0)));
var cadenceText = interval > 0 ? formatCadenceText(interval, currentSub.weeks) : 'Delivery cadence pending';
var unitPrice = Number(currentSub.price || 0);
var deliveryCost = (unitPrice > 0 && totalLbs > 0) ? (unitPrice / 100) * totalLbs : 0;
var priceText = deliveryCost > 0 ? money(deliveryCost) : 'TBD';
var lbsPerMeal = (daily > 0 && rowMealsPerDay > 0) ? (daily / rowMealsPerDay) : 0;
var pricePerLb = unitPrice > 0 ? (unitPrice / 100) : 0;
var perMeal = (pricePerLb > 0 && lbsPerMeal > 0) ? pricePerLb * lbsPerMeal : 0;
var perMealText = perMeal > 0 ? (money(perMeal) + '/meal') : 'TBD';
var detailsRows = buildSubscriptionLines(currentSub, selections.freezer_program && subIdx === 0, dogIndexes);
if (!detailsRows.length) {
detailsRows.push('<p class="otto-cfg-card__helper">No additional details yet.</p>');
}
var imageHtml = visual && visual.src
? ('<img class="otto-cfg-review-pack__sub-image" src="' + esc(visual.src) + '" alt="' + esc(visual.alt || proteinName) + '" loading="lazy">')
: '<span class="otto-cfg-review-pack__sub-image otto-cfg-review-pack__sub-image--placeholder" aria-hidden="true"></span>';
var html = '';
html += '<details class="otto-cfg-review-pack__sub">';
html += '<summary class="otto-cfg-review-pack__sub-summary">';
html += '<span class="otto-cfg-review-pack__sub-left">' + imageHtml + '<span class="otto-cfg-review-pack__sub-copy"><span class="otto-cfg-review-pack__sub-title">' + esc(proteinName) + '</span><span class="otto-cfg-review-pack__sub-meta">' + esc(quantityText) + '</span></span></span>';
html += '<span class="otto-cfg-review-pack__sub-right"><span class="otto-cfg-review-pack__sub-price">' + esc(priceText) + '</span><span class="otto-cfg-review-pack__sub-permeal">' + esc(perMealText) + '</span><span class="otto-cfg-review-pack__sub-cadence">' + esc(cadenceText) + '</span></span>';
html += '<span class="otto-cfg-review-pack__sub-chevron" aria-hidden="true">&#9662;</span>';
html += '</summary>';
html += '<div class="otto-cfg-review-pack__sub-body">';
if (useReviewV2) {
var deliveredText = interval > 0 ? ('Delivered ' + formatCadenceText(interval, currentSub.weeks, { lowercase: true }) + '.') : 'Delivery cadence pending.';
var proteinTileThumb = visual && visual.src
? ('<img class="otto-cfg-review-v2-protein__thumb" src="' + esc(visual.src) + '" alt="' + esc(visual.alt || proteinName) + '" loading="lazy">')
: '<span class="otto-cfg-review-v2-protein__thumb otto-cfg-review-v2-protein__thumb--placeholder" aria-hidden="true"></span>';
html += '<div class="otto-cfg-review-v2-grid">';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Protein Selection</h4><button type="button" class="otto-cfg-review-v2-protein" data-cfg-review-v2-protein-swap data-cfg-review-sub-idx="' + subIdx + '" aria-label="Swap protein selection"><span class="otto-cfg-review-v2-protein__media">' + proteinTileThumb + '<span class="otto-cfg-review-v2-protein__swap" aria-hidden="true">Swap</span></span><span class="otto-cfg-review-v2-protein__label">' + esc(proteinName) + '</span></button></section>';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Plan</h4><div class="otto-cfg-review-v2-plan"><span class="otto-cfg-review-v2-plan__icon" aria-hidden="true">&#9719;</span><strong>' + esc(quantityText) + '</strong></div><p class="otto-cfg-review-v2-note">' + esc(deliveredText) + '</p></section>';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-12"><h4 class="otto-cfg-review-v2-tile__title">Cost snapshot</h4><div class="otto-cfg-review-v2-cost-grid otto-cfg-review-v2-cost-grid--compact"><div><span>Cost per meal</span><strong>' + esc(perMealText) + '</strong></div><div><span>Cost per delivery</span><strong>' + esc(priceText) + '</strong></div></div></section>';
html += '</div>';
}
html += detailsRows.join('');
html += '</div>';
html += '</details>';
return html;
}
function buildReviewSubscriptions() {
var currentSubs = Array.isArray(subscriptions) ? subscriptions.slice() : [];
if (!currentSubs.length) {
var fallbackTotes = Math.max(0, Math.floor(Number(selections.totes || 0)));
var fallbackLbs = Number(selections.delivery_lbs || 0) || (fallbackTotes > 0 ? (fallbackTotes * LBS_PER_TOTE) : 0);
if (fallbackTotes > 0 || fallbackLbs > 0 || selections.delivery_interval || selections.protein || selections.product_price) {
currentSubs.push({
protein: selections.protein || '',
price: selections.product_price || 0,
dogs: (dogs || []).map(function (d) { return titleCase(d.name) || 'Dog'; }),
dailyTotal: selections.daily_total || 0,
totes: fallbackTotes,
interval: selections.delivery_interval || 0,
lbs: fallbackLbs
});
}
}
if (!currentSubs.length) {
return '<p class="otto-cfg-card__helper">Complete ' + fulfillmentDropLabel() + ' selections to see your subscriptions.</p>';
}
var dogIndexByName = {};
dogs.forEach(function (dog, idx) {
var key = normalizeName(dog && dog.name);
if (key && dogIndexByName[key] == null) dogIndexByName[key] = idx;
});
var visualMap = getProteinVisualMap();
if (selections.freezer_program || currentSubs.some(function (sub) { return !!(sub && sub.freezer_program); })) {
var allDogIndexes = dogs.map(function (_dog, idx) { return idx; });
return '<div class="otto-cfg-review-pack__subscriptions">' + buildFreezerAggregateSubscriptionRow(currentSubs, allDogIndexes, visualMap) + '</div>';
}
var rowsHtml = currentSubs.map(function (sub, subIdx) {
var matchedIndexes = resolveSubscriptionDogIndexes(sub, subIdx, dogIndexByName, currentSubs);
return buildSubscriptionRow(sub, subIdx, matchedIndexes, visualMap);
}).join('');
return '<div class="otto-cfg-review-pack__subscriptions">' + rowsHtml + '</div>';
}
function computeOttoScenarioMetrics(mode) {
var currentSubs = Array.isArray(subscriptions) ? subscriptions.slice() : [];
var freezerDiscount = Math.max(0, Number(getFreezerProgramDiscountPercent() || 0));
var totalPerDelivery = 0;
var totalMealsPerDelivery = 0;
var monthly = 0;
var totalDeliveryLbs = 0;
currentSubs.forEach(function (sub) {
if (!sub) return;
var totes = Math.max(0, Math.floor(Number(sub.totes || 0)));
var lbs = Number(sub.lbs || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
var interval = Math.max(1, Math.floor(Number(sub.interval || 0)));
var price = Number(sub.price || 0);
var regularDelivery = (price > 0 && lbs > 0) ? (price / 100) * lbs : 0;
var scenarioDelivery = mode === 'freezer' ? (regularDelivery * (1 - (freezerDiscount / 100))) : regularDelivery;
var daily = Number(sub.dailyTotal || 0);
var baseMealCount = (lbs > 0 && daily > 0 && effectiveMealsForReview > 0) ? ((lbs / daily) * effectiveMealsForReview) : 0;
var shareCount = 1;
if (Array.isArray(sub.dogs) && sub.dogs.length) {
shareCount = Math.max(1, sub.dogs.length);
} else if (currentSubs.length === 1 && Array.isArray(dogs) && dogs.length > 1) {
shareCount = dogs.length;
}
var mealCount = baseMealCount > 0 ? (baseMealCount * shareCount) : 0;
totalPerDelivery += scenarioDelivery;
monthly += scenarioDelivery * (30 / interval);
totalMealsPerDelivery += mealCount;
totalDeliveryLbs += lbs;
});
var perMeal = totalMealsPerDelivery > 0 ? (totalPerDelivery / totalMealsPerDelivery) : 0;
if (!(perMeal > 0) && totalPerDelivery > 0 && totalDeliveryLbs > 0) {
var fallbackDailyTotal = Math.max(0, Number(selections.daily_total || 0));
var fallbackMeals = (fallbackDailyTotal > 0 && effectiveMealsForReview > 0)
? ((totalDeliveryLbs / fallbackDailyTotal) * effectiveMealsForReview)
: 0;
if (fallbackMeals > 0) perMeal = totalPerDelivery / fallbackMeals;
}
return {
mode: mode,
perMeal: perMeal,
perDelivery: totalPerDelivery,
monthly: monthly,
yearly: monthly * 12,
deliveryLbs: totalDeliveryLbs
};
}
function buildPricingTransparency() {
if (!useReviewV2) return '';
if (!Array.isArray(subscriptions) || !subscriptions.length) {
return '<p class="otto-cfg-card__helper">Complete ' + fulfillmentDropLabel() + ' selections to unlock pricing transparency.</p>';
}
var mode = String(selections.review_pricing_mode || '').trim().toLowerCase();
if (mode !== 'regular' && mode !== 'freezer') mode = (selections.freezer_program ? 'freezer' : 'regular');
var ottoRetail = computeOttoScenarioMetrics(mode);
var foundingPct = foundingOngoingPctForDisplay();
var foundingFactor = foundingPct ? ((100 - foundingPct) / 100) : 1;
var otto = {
mode: ottoRetail.mode,
perMeal: ottoRetail.perMeal * foundingFactor,
perDelivery: ottoRetail.perDelivery * foundingFactor,
monthly: ottoRetail.monthly * foundingFactor,
yearly: ottoRetail.yearly * foundingFactor,
deliveryLbs: ottoRetail.deliveryLbs
};
function ottoCostHtml(metricKey) {
var sale = Number(otto[metricKey] || 0);
if (!foundingPct) return '<strong>' + esc(money(sale)) + '</strong>';
var retail = Number(ottoRetail[metricKey] || 0);
return '<span class="otto-cfg-tile__price--founding"><span class="otto-cfg-tile__price-retail">' + esc(money(retail)) + '</span><strong>' + esc(money(sale)) + '</strong></span>';
}
var dailyTotal = Math.max(0, Number(selections.daily_total || 0));
var monthlyLbs = dailyTotal * 30;
var yearlyLbs = dailyTotal * 365;
var lbsPerMeal = (dailyTotal > 0 && effectiveMealsForReview > 0) ? (dailyTotal / effectiveMealsForReview) : 0;
function competitorMetrics(costPerLb) {
var rate = Math.max(0, Number(costPerLb || 0));
return {
perMeal: rate * lbsPerMeal,
perDelivery: rate * Number(otto.deliveryLbs || 0),
monthly: rate * monthlyLbs,
yearly: rate * yearlyLbs
};
}
function compareCopy(name, competitorMonthly) {
var delta = competitorMonthly - Number(otto.monthly || 0);
var sign = delta >= 0 ? 'less' : 'more';
return 'Otto is ' + money(Math.abs(delta)) + ' ' + sign + ' per month vs ' + name + '.';
}
var rawComp = competitorMetrics(competitorRawCostPerLb);
var cookedComp = competitorMetrics(competitorCookedCostPerLb);
var kibbleComp = competitorMetrics(competitorKibbleCostPerLb);
var rawLabel = competitorRawLabel || 'Standard Raw';
var cookedLabel = competitorCookedLabel || 'Fresh (Cooked)';
var kibbleLabel = competitorKibbleLabel || 'Air-Dried';
var freezerDisabled = mode === 'freezer' && !selections.freezer_program;
var html = '';
html += '<div class="otto-cfg-review-v2-pricing">';
html += '<div class="otto-cfg-review-v2-pill" role="tablist" aria-label="Pricing comparison mode">';
html += '<button type="button" class="otto-cfg-review-v2-pill__btn' + (mode === 'regular' ? ' is-active' : '') + '" data-cfg-review-pricing-mode="regular">Regular</button>';
html += '<button type="button" class="otto-cfg-review-v2-pill__btn' + (mode === 'freezer' ? ' is-active' : '') + '" data-cfg-review-pricing-mode="freezer">Freezer Program</button>';
html += '</div>';
if (freezerDisabled) {
html += '<p class="otto-cfg-review-v2-note">Freezer comparison is available once your current plan is enrolled in the freezer program.</p>';
}
html += '<div class="otto-cfg-review-v2-grid">';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Otto cost stack</h4><div class="otto-cfg-review-v2-cost-grid"><div><span>Per meal</span>' + ottoCostHtml('perMeal') + '</div><div><span>Per delivery</span>' + ottoCostHtml('perDelivery') + '</div><div><span>Per month</span>' + ottoCostHtml('monthly') + '</div><div><span>Per year</span>' + ottoCostHtml('yearly') + '</div></div></section>';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-6"><h4 class="otto-cfg-review-v2-tile__title">Market comparison</h4><div class="otto-cfg-review-v2-compare"><div><strong>' + esc(rawLabel) + '</strong><span>' + esc(money(rawComp.monthly)) + '/mo</span><small>' + esc(compareCopy(rawLabel.toLowerCase(), rawComp.monthly)) + '</small></div><div><strong>' + esc(cookedLabel) + '</strong><span>' + esc(money(cookedComp.monthly)) + '/mo</span><small>' + esc(compareCopy(cookedLabel.toLowerCase(), cookedComp.monthly)) + '</small></div><div><strong>' + esc(kibbleLabel) + '</strong><span>' + esc(money(kibbleComp.monthly)) + '/mo</span><small>' + esc(compareCopy(kibbleLabel.toLowerCase(), kibbleComp.monthly)) + '</small></div></div></section>';
html += '<section class="otto-cfg-review-v2-tile otto-cfg-review-v2-tile--span-12"><h4 class="otto-cfg-review-v2-tile__title">Assumptions</h4><p class="otto-cfg-review-v2-note">Calculations use your current household intake (' + esc(formatLbs(dailyTotal)) + ' lbs/day) and selected cadence.</p>' + (pricingDisclaimer ? ('<p class="otto-cfg-review-v2-note">' + esc(pricingDisclaimer) + '</p>') : '') + '</section>';
html += '</div>';
html += '</div>';
return html;
}
function iconSvg(kind) {
if (kind === 'protein') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 6c0-2.2 1.8-4 4-4h6v6c0 5-4 9-9 9-2.2 0-4-1.8-4-4V8h3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11 13l7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
if (kind === 'cadence') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2.5" stroke="currentColor" stroke-width="1.5"></rect><path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
if (kind === 'meals') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 11h16c0 5-3 8-8 8s-8-3-8-8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.5 11h19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
if (kind === 'price_meal') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3v18M16 7.5c0-1.7-1.8-3-4-3s-4 1.3-4 3 1.8 3 4 3 4 1.3 4 3-1.8 3-4 3-4-1.3-4-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
if (kind === 'price_delivery') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h3l3 3v3h-6z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><circle cx="8" cy="18" r="1.5" stroke="currentColor" stroke-width="1.5"></circle><circle cx="18" cy="18" r="1.5" stroke="currentColor" stroke-width="1.5"></circle></svg>';
}
if (kind === 'freezer_program') {
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="3.5" width="14" height="17" rx="2.5" stroke="currentColor" stroke-width="1.5"></rect><path d="M9 7h6M10 12h4M10 15h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16l-1.5 10h-13z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M8 7V5a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
}
function statCell(icon, label, value, extraClass) {
var cls = 'otto-cfg-review-v3-stat' + (extraClass ? (' ' + extraClass) : '');
return '<div class="' + cls + '"><span class="otto-cfg-review-v3-stat__icon">' + iconSvg(icon) + '</span><span class="otto-cfg-review-v3-stat__label">' + esc(label) + '</span><strong class="otto-cfg-review-v3-stat__value">' + esc(value) + '</strong></div>';
}
function buildFreezerTypePill() {
return '<div class="otto-cfg-review-v3-freezer-type">'
+ '<span class="otto-cfg-review-v3-freezer-type__icon">' + iconSvg('freezer_program') + '</span>'
+ '<span class="otto-cfg-review-v3-freezer-type__label">Subscription Type</span>'
+ '<span class="otto-cfg-review-v3-freezer-type__title">Otto Freezer Program</span>'
+ '</div>';
}
function buildFreezerRecipeAllocationStat(subs) {
var counts = {};
var labels = {};
(Array.isArray(subs) ? subs : []).forEach(function (sub) {
var protein = String((sub && sub.protein) || '').trim();
var totes = Math.max(0, Math.floor(Number((sub && sub.totes) || 0)));
if (!protein || totes <= 0) return;
var key = normalizeName(protein);
counts[key] = (counts[key] || 0) + totes;
labels[key] = protein;
});
var rows = Object.keys(counts).map(function (key) {
return { key: key, protein: labels[key] || key, totes: counts[key] };
});
rows.sort(function (a, b) {
if (b.totes !== a.totes) return b.totes - a.totes;
return String(a.protein).localeCompare(String(b.protein));
});
var pills = rows.map(function (row) {
var toteLabel = row.totes === 1 ? '1 tote' : (String(row.totes) + ' totes');
return '<span class="otto-cfg-review-v3-recipe-pill">' + esc(row.protein) + ' · ' + esc(toteLabel) + '</span>';
}).join('');
if (!pills) pills = '<span class="otto-cfg-review-v3-recipe-pill">Pending</span>';
return '<div class="otto-cfg-review-v3-stat otto-cfg-review-v3-stat--recipe-pills">'
+ '<span class="otto-cfg-review-v3-stat__icon">' + iconSvg('protein') + '</span>'
+ '<span class="otto-cfg-review-v3-stat__label">Recipe allocation</span>'
+ '<strong class="otto-cfg-review-v3-stat__value"><span class="otto-cfg-review-v3-recipe-pill-list">' + pills + '</span></strong>'
+ '</div>';
}
function buildV3PriceRow(perDelivery, perMeal, isAvg, opts) {
var options = opts || {};
var isFreezerPricing = !!options.freezerProgram;
var discountPercent = Math.max(0, Number(options.discountPercent || 0));
var subtotal = Math.max(0, Number(perDelivery || 0));
var discountAmount = subtotal > 0 ? (subtotal * (discountPercent / 100)) : 0;
var totalPerDelivery = isFreezerPricing ? Math.max(0, subtotal - discountAmount) : subtotal;
var priceValue = totalPerDelivery > 0 ? money(totalPerDelivery) : 'Pending';
var effectivePerMeal = perMeal;
if (isFreezerPricing && subtotal > 0 && totalPerDelivery >= 0 && perMeal > 0) {
effectivePerMeal = perMeal * (totalPerDelivery / subtotal);
}
var perMealLine = '';
var perMealLabel = isAvg ? 'Per Dog (Average)' : 'Per Meal';
if (effectivePerMeal > 0) {
var perMealValue = money(effectivePerMeal) + (isAvg ? '/meal' : '');
perMealLine = '<span class="otto-cfg-review-v3-price-hero__meta-label">' + esc(perMealLabel) + '</span><span class="otto-cfg-review-v3-price-hero__meta-value">' + esc(perMealValue) + '</span>';
}
if (!isFreezerPricing) {
return '<div class="otto-cfg-review-v3-price-hero otto-cfg-review-v3-price-hero--subcard"><span class="otto-cfg-review-v3-price-hero__label">' + esc(pickupModeEnabled() ? 'Total Per Pickup' : 'Total Per Delivery') + '</span><strong class="otto-cfg-review-v3-price-hero__value">' + esc(priceValue) + '</strong>' + perMealLine + '</div>';
}
var subtotalValue = subtotal > 0 ? money(subtotal) : 'Pending';
var discountValue = discountAmount > 0 ? ('-' + money(discountAmount)) : money(0);
return '<div class="otto-cfg-review-v3-price-hero otto-cfg-review-v3-price-hero--subcard otto-cfg-review-v3-price-hero--freezer">'
+ '<span class="otto-cfg-review-v3-price-hero__breakdown-label">Subtotal</span><span class="otto-cfg-review-v3-price-hero__breakdown-value">' + esc(subtotalValue) + '</span>'
+ '<span class="otto-cfg-review-v3-price-hero__breakdown-label">Discounts</span><span class="otto-cfg-review-v3-price-hero__breakdown-value otto-cfg-review-v3-price-hero__breakdown-value--discount">' + esc(discountValue) + '</span>'
+ '<span class="otto-cfg-review-v3-price-hero__label">' + (pickupModeEnabled() ? 'Total Per Pickup' : 'Total Per Delivery') + '</span><strong class="otto-cfg-review-v3-price-hero__value">' + esc(priceValue) + '</strong>'
+ perMealLine
+ '</div>';
}
function buildV3ComparisonShell(currentSubs, options) {
var opts = options || {};
var embedInAccordion = opts.embedInAccordion === true;
if (!Array.isArray(currentSubs) || !currentSubs.length) return '';
var mode = selections.freezer_program ? 'freezer' : 'regular';
var packSize = Array.isArray(selections.dogs) ? selections.dogs.length : 0;
var perMealSuffix = packSize > 1 ? 'per meal (avg.)' : 'per meal';
var plan = (typeof buildPerDogRecipePlan === 'function') ? buildPerDogRecipePlan() : { ok: false };
var metrics = checkoutAlignedOttoMetrics(plan);
if (!(metrics.perDelivery > 0)) {
var subMetrics = computeOttoScenarioMetrics(mode);
var intervalDays = Math.max(1, Math.floor(Number((currentSubs[0] && currentSubs[0].interval) || selections.delivery_interval || 0)));
var weeks = Math.floor(Number((currentSubs[0] && currentSubs[0].weeks) || selections.delivery_weeks || 0));
var cadenceWeeks = cadenceWeeksFrom(intervalDays, weeks);
metrics = {
perDelivery: subMetrics.perDelivery,
weekly: cadenceWeeks > 0 ? (subMetrics.perDelivery / cadenceWeeks) : 0,
monthly: subMetrics.monthly,
perMeal: subMetrics.perMeal,
deliveryLbs: subMetrics.deliveryLbs,
intervalDays: intervalDays,
cadenceWeeks: cadenceWeeks,
mealsInDelivery: 0
};
}
var ottoRetail = {
perMeal: metrics.perMeal,
weekly: metrics.weekly,
monthly: metrics.monthly,
deliveryLbs: metrics.deliveryLbs
};
var foundingPct = foundingOngoingPctForDisplay();
var foundingFactor = foundingPct ? ((100 - foundingPct) / 100) : 1;
var otto = {
perMeal: ottoRetail.perMeal * foundingFactor,
weekly: ottoRetail.weekly * foundingFactor,
monthly: ottoRetail.monthly * foundingFactor,
deliveryLbs: ottoRetail.deliveryLbs
};
function competitorMetrics(costPerLb) {
var rate = Math.max(0, Number(costPerLb || 0));
var lbs = Math.max(0, Number(metrics.deliveryLbs || 0));
var cadenceWeeks = Math.max(0, Number(metrics.cadenceWeeks || 0));
var intervalDays = Math.max(0, Number(metrics.intervalDays || 0));
var meals = Math.max(0, Number(metrics.mealsInDelivery || 0));
return {
perMeal: (rate > 0 && lbs > 0 && meals > 0) ? (rate * lbs / meals) : 0,
weekly: (rate > 0 && lbs > 0 && cadenceWeeks > 0) ? (rate * lbs / cadenceWeeks) : 0,
monthly: (rate > 0 && lbs > 0 && intervalDays > 0) ? (rate * lbs * 30 / intervalDays) : 0
};
}
function priceText(value) {
return value > 0 ? money(value) : 'TBD';
}
function ottoPriceHtml(metricKey) {
var sale = Number(otto[metricKey] || 0);
if (!foundingPct) return '<strong>' + esc(priceText(sale)) + '</strong>';
var retail = Number(ottoRetail[metricKey] || 0);
return (
'<span class="otto-cfg-review-v3-comparison-shell__value-founding">' +
'<span class="otto-cfg-review-v3-comparison-shell__value-retail">' + esc(priceText(retail)) + '</span>' +
'<strong>' + esc(priceText(sale)) + '</strong></span>'
);
}
function formatSavingsAmount(value) {
var amount = Number(value || 0);
if (!isFinite(amount) || amount < 0) amount = 0;
return '$' + amount.toFixed(2);
}
function buildComparisonSavingsTitleHtml(competitorKey, competitorLabel, valuesByBrand) {
var safeLabel = String(competitorLabel || '').trim() || 'this option';
var ottoPerMeal = Number(valuesByBrand && valuesByBrand.otto ? valuesByBrand.otto.perMeal : 0);
var ottoPerMonth = Number(valuesByBrand && valuesByBrand.otto ? valuesByBrand.otto.monthly : 0);
var competitorPerMeal = Number(valuesByBrand && valuesByBrand[competitorKey] ? valuesByBrand[competitorKey].perMeal : 0);
var competitorPerMonth = Number(valuesByBrand && valuesByBrand[competitorKey] ? valuesByBrand[competitorKey].monthly : 0);
var perMealSavings = Math.max(0, competitorPerMeal - ottoPerMeal);
var perMonthSavings = Math.max(0, competitorPerMonth - ottoPerMonth);
return 'You\'ll save <span class="otto-cfg-review-v3-comparison-shell__title-amount">' + esc(formatSavingsAmount(perMealSavings)) + '</span>'
+ ' per meal and <span class="otto-cfg-review-v3-comparison-shell__title-amount">' + esc(formatSavingsAmount(perMonthSavings)) + '</span>'
+ ' per month by feeding <span class="otto-cfg-review-v3-comparison-shell__title-brand">otto</span> vs. ' + esc(safeLabel) + '.';
}
var raw = competitorMetrics(competitorRawCostPerLb);
var cooked = competitorMetrics(competitorCookedCostPerLb);
var kibble = competitorMetrics(competitorKibbleCostPerLb);
var linkLabel = comparisonLinkLabel || 'See cost comparison';
var competitorColumns = [
{ label: (competitorRawLabel || 'Standard Raw'), key: 'raw', cls: '' },
{ label: (competitorCookedLabel || 'Fresh (Cooked)'), key: 'cooked', cls: '' },
{ label: (competitorKibbleLabel || 'Air-Dried'), key: 'kibble', cls: '' }
];
var valuesByBrand = {
otto: { perMeal: otto.perMeal, weekly: otto.weekly, monthly: otto.monthly },
raw: raw,
cooked: cooked,
kibble: kibble
};
var persistedCompetitorIdx = reviewCardEl ? Math.floor(Number(reviewCardEl._comparisonShellCompetitorIdx)) : 0;
if (!isFinite(persistedCompetitorIdx) || persistedCompetitorIdx < 0 || persistedCompetitorIdx >= competitorColumns.length) persistedCompetitorIdx = 0;
var competitorIdx = persistedCompetitorIdx;
var activeCompetitor = competitorColumns[competitorIdx];
var shellShouldBeOpen = !!(reviewCardEl && reviewCardEl._comparisonShellOpen === true);
var metricRows = [
{ key: 'perMeal', suffix: perMealSuffix },
{ key: 'weekly', suffix: 'per week' },
{ key: 'monthly', suffix: 'per month' }
];
var panelHeadingHtml = buildComparisonSavingsTitleHtml(activeCompetitor.key, activeCompetitor.label, valuesByBrand);
var shellAttrs = ' data-cfg-comp-label-0="' + esc(competitorColumns[0].label) + '"'
+ ' data-cfg-comp-label-1="' + esc(competitorColumns[1].label) + '"'
+ ' data-cfg-comp-label-2="' + esc(competitorColumns[2].label) + '"'
+ ' data-cfg-comp-permeal-otto="' + esc(String(Number(valuesByBrand.otto.perMeal || 0))) + '"'
+ ' data-cfg-comp-permonth-otto="' + esc(String(Number(valuesByBrand.otto.monthly || 0))) + '"'
+ ' data-cfg-comp-permeal-0="' + esc(String(Number(valuesByBrand.raw.perMeal || 0))) + '"'
+ ' data-cfg-comp-permeal-1="' + esc(String(Number(valuesByBrand.cooked.perMeal || 0))) + '"'
+ ' data-cfg-comp-permeal-2="' + esc(String(Number(valuesByBrand.kibble.perMeal || 0))) + '"'
+ ' data-cfg-comp-permonth-0="' + esc(String(Number(valuesByBrand.raw.monthly || 0))) + '"'
+ ' data-cfg-comp-permonth-1="' + esc(String(Number(valuesByBrand.cooked.monthly || 0))) + '"'
+ ' data-cfg-comp-permonth-2="' + esc(String(Number(valuesByBrand.kibble.monthly || 0))) + '"';
var panelHtml = '';
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__panel">';
panelHtml += '<h5 class="otto-cfg-review-v3-comparison-shell__title" data-cfg-comp-savings-title>' + panelHeadingHtml + '</h5>';
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__matrix-viewport">';
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__matrix-scroll">';
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__matrix">';
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__matrix-head">';
panelHtml += '<span class="otto-cfg-review-v3-comparison-shell__brand-head is-otto">otto</span>';
panelHtml += '<span class="otto-cfg-review-v3-comparison-shell__brand-head otto-cfg-review-v3-comparison-shell__brand-head--competitor">'
+ '<button type="button" class="otto-cfg-review-v3-comparison-shell__brand-toggle" data-cfg-comp-prev aria-label="Show previous competitor">&#8249;</button>'
+ '<span class="otto-cfg-review-v3-comparison-shell__brand-toggle-label" data-cfg-comp-label>' + esc(activeCompetitor.label) + '</span>'
+ '<button type="button" class="otto-cfg-review-v3-comparison-shell__brand-toggle" data-cfg-comp-next aria-label="Show next competitor">&#8250;</button>'
+ '</span>';
panelHtml += '</div>';
metricRows.forEach(function (metric) {
panelHtml += '<div class="otto-cfg-review-v3-comparison-shell__matrix-row">';
var rawValue = valuesByBrand.raw && valuesByBrand.raw[metric.key];
var cookedValue = valuesByBrand.cooked && valuesByBrand.cooked[metric.key];
var kibbleValue = valuesByBrand.kibble && valuesByBrand.kibble[metric.key];
var competitorValue = valuesByBrand[activeCompetitor.key] && valuesByBrand[activeCompetitor.key][metric.key];
panelHtml += '<span class="otto-cfg-review-v3-comparison-shell__value-cell is-otto"><span class="otto-cfg-review-v3-comparison-shell__value-brand">otto</span>' + ottoPriceHtml(metric.key) + '<span class="otto-cfg-review-v3-comparison-shell__value-suffix">' + esc(metric.suffix) + '</span></span>';
panelHtml += '<span class="otto-cfg-review-v3-comparison-shell__value-cell" data-cfg-comp-value-cell'
+ ' data-cfg-comp-value-0="' + esc(String(Number(rawValue || 0))) + '"'
+ ' data-cfg-comp-value-1="' + esc(String(Number(cookedValue || 0))) + '"'
+ ' data-cfg-comp-value-2="' + esc(String(Number(kibbleValue || 0))) + '">'
+ '<span class="otto-cfg-review-v3-comparison-shell__value-brand" data-cfg-comp-value-brand>' + esc(activeCompetitor.label) + '</span>'
+ '<strong data-cfg-comp-value-amount>' + esc(priceText(Number(competitorValue || 0))) + '</strong><span class="otto-cfg-review-v3-comparison-shell__value-suffix">' + esc(metric.suffix) + '</span></span>';
panelHtml += '</div>';
});
panelHtml += '</div>';
panelHtml += '</div>';
panelHtml += '</div>';
if (pricingDisclaimer) {
panelHtml += '<p class="otto-cfg-review-v3-comparison-shell__disclaimer">' + esc(pricingDisclaimer) + '</p>';
}
panelHtml += '</div>';
var html = '';
html += '<div class="otto-cfg-review-v3-section otto-cfg-review-v3-section--comparison">';
if (embedInAccordion) {
/* Outer "How Otto compares" accordion is the only toggle — show matrix directly. */
html += '<div class="otto-cfg-review-v3-comparison-shell is-expanded"' + shellAttrs + '>';
html += panelHtml;
html += '</div>';
} else {
html += '<details class="otto-cfg-review-v3-comparison-shell"' + (shellShouldBeOpen ? ' open' : '') + shellAttrs + '>';
html += '<summary class="otto-cfg-review-v3-comparison-shell__summary"><span class="otto-cfg-review-v3-comparison-shell__link">' + esc(linkLabel) + '</span><span class="otto-cfg-review-v3-comparison-shell__chevron" aria-hidden="true">&#9662;</span></summary>';
html += panelHtml;
html += '</details>';
}
html += '</div>';
return html;
}
function getCurrentReviewSubscriptions() {
var currentSubs = Array.isArray(subscriptions) ? subscriptions.slice() : [];
if (!currentSubs.length) {
var fallbackTotes = Math.max(0, Math.floor(Number(selections.totes || 0)));
var fallbackLbs = Number(selections.delivery_lbs || 0) || (fallbackTotes > 0 ? (fallbackTotes * LBS_PER_TOTE) : 0);
if (fallbackTotes > 0 || fallbackLbs > 0 || selections.delivery_interval || selections.protein || selections.product_price) {
currentSubs.push({
protein: selections.protein || '',
price: selections.product_price || 0,
dogs: (dogs || []).map(function (d) { return titleCase(d.name) || 'Dog'; }),
dailyTotal: selections.daily_total || 0,
totes: fallbackTotes,
interval: selections.delivery_interval || 0,
lbs: fallbackLbs
});
}
}
return currentSubs;
}
function buildV3ReviewCard() {
var currentSubs = getCurrentReviewSubscriptions();
if (startBtn) {
var v3Label = getStartButtonDefaultLabel() || startBtnOverrideLabel ||
  (currentSubs.length > 1 ? 'Start Meal Plans' : 'Start Meal Plan');
startBtnDefaultLabel = v3Label;
setStartButtonBusyState(startBtn, false, v3Label);
}
if (!dogs.length && !currentSubs.length) {
return '<p class="otto-cfg-card__helper">Complete the steps above to see your summary.</p>';
}
var html = '<section class="otto-cfg-review-v3-card">';
html += '<header class="otto-cfg-review-v3-card__header"><h3 class="otto-cfg-review-v3-card__title">' + esc(reviewSummaryTitle || 'Everything look right?') + '</h3></header>';
if (dogs.length) {
html += '<div class="otto-cfg-review-v3-section"><h4 class="otto-cfg-review-v3-section__title">Your Pack</h4><div class="otto-cfg-review-v3-dogs">';
dogs.forEach(function (dog, idx) {
var label = titleCase((dog && dog.name) || '') || ('Dog ' + (idx + 1));
var breed = '';
if (Array.isArray(selections.dogs_basic) && selections.dogs_basic[idx] && selections.dogs_basic[idx].breed) {
breed = String(selections.dogs_basic[idx].breed || '').trim();
}
if (!breed && dog && dog.breed) breed = String(dog.breed || '').trim();
var heading = breed ? (label + ' the ' + breed) : label;
var meta = [];
if (dog && dog.weight) meta.push(String(dog.weight) + ' lbs');
if (dog && dog.life_stage) meta.push(lifeStageLabel(dog.life_stage));
if (dog && dog.activity) meta.push(formatActivityLevel(dog.activity) + ' activity');
html += '<div class="otto-cfg-review-v3-dog-row">' + buildDogAvatarHtml(dog, idx, 'otto-cfg-dog-avatar--review otto-cfg-review-v3-dog-row__avatar') + '<div class="otto-cfg-review-v3-dog-row__copy"><strong>' + esc(heading) + '</strong><span>' + esc(meta.join(' • ')) + '</span></div></div>';
});
html += '</div></div>';
}
if (!currentSubs.length) {
html += '<div class="otto-cfg-review-v3-section"><p class="otto-cfg-card__helper">Complete ' + (pickupModeEnabled() ? 'pickup' : 'delivery') + ' selections to see your subscription details.</p></div>';
html += '</section>';
return html;
}
var totalLbs = 0;
var totalMeals = 0;
var totalPerDelivery = 0;
var totalDaily = Math.max(0, Number(selections.daily_total || 0));
var freezerProgramSelected = !!(selections.freezer_program || currentSubs.some(function (sub) { return !!(sub && sub.freezer_program); }));
var freezerDiscountPercent = freezerProgramSelected ? Math.max(0, Number(getFreezerProgramDiscountPercent() || 0)) : 0;
var regularScenarioMetrics = computeOttoScenarioMetrics('regular');
var isMultiDogMultiProtein = !!(!freezerProgramSelected && selections.per_dog_protein && dogs.length > 1 && currentSubs.length > 1);
if (isMultiDogMultiProtein) {
var dogProteins = Array.isArray(selections.dog_proteins) ? selections.dog_proteins : [];
var subListClass = 'otto-cfg-review-v3-sub-list' + (currentSubs.length > 1 ? ' otto-cfg-review-v3-sub-list--multi' : '');
html += '<div class="otto-cfg-review-v3-section"><h4 class="otto-cfg-review-v3-section__title">Subscriptions</h4><div class="' + subListClass + '">';
var dogByName = {};
dogs.forEach(function (dog, idx) {
var key = normalizeName(dog && dog.name);
if (key && !dogByName[key]) dogByName[key] = { dog: dog, idx: idx };
});
currentSubs.forEach(function (sub, idx) {
if (idx > 0 && currentSubs.length > 1) {
html += '<div class="otto-cfg-review-v3-sub-divider" aria-hidden="true"></div>';
}
var proteinName = String((sub && sub.protein) || '').trim() || (String(selections.protein || '').trim() || 'Plan pending');
var matchedDogRows = [];
if (Array.isArray(sub && sub.dogs) && sub.dogs.length) {
sub.dogs.forEach(function (dogName) {
var mapped = dogByName[normalizeName(dogName)];
if (mapped) matchedDogRows.push(mapped);
});
}
if (!matchedDogRows.length && dogProteins.length) {
dogProteins.forEach(function (row) {
if (!proteinsMatch(row && row.protein, proteinName)) return;
var mapped = dogByName[normalizeName(row && row.dogName)];
if (mapped && !matchedDogRows.some(function (existing) { return existing.idx === mapped.idx; })) matchedDogRows.push(mapped);
});
}
if (matchedDogRows.length > 1) {
var seenDogRows = {};
matchedDogRows = matchedDogRows.filter(function (row) {
var dogIdx = Math.floor(Number(row && row.idx));
if (!isFinite(dogIdx) || dogIdx < 0) return false;
if (seenDogRows[dogIdx]) return false;
seenDogRows[dogIdx] = true;
return true;
});
}
var shareCount = Math.max(1, matchedDogRows.length || Number((Array.isArray(sub && sub.dogs) && sub.dogs.length) ? sub.dogs.length : 0) || 1);
var totes = Math.max(0, Math.floor(Number((sub && sub.totes) || 0)));
var lbs = Number((sub && sub.lbs) || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
var interval = Math.max(0, Math.floor(Number((sub && sub.interval) || 0)));
var subDailyTotal = Number((sub && sub.dailyTotal) || 0);
var subMealsRate = reviewMealsPerDayForDogIndexes(matchedDogRows.map(function (row) { return row.idx; }));
var baseMeals = (lbs > 0 && subDailyTotal > 0 && subMealsRate > 0) ? ((lbs / subDailyTotal) * subMealsRate) : 0;
var mealsPerDog = baseMeals > 0 ? Math.round(baseMeals) : 0;
var meals = mealsPerDog > 0 ? (mealsPerDog * shareCount) : 0;
var unitPrice = Number((sub && sub.price) || 0);
var perDelivery = (unitPrice > 0 && lbs > 0) ? (unitPrice / 100) * lbs : 0;
var perMeal = (perDelivery > 0 && meals > 0) ? (perDelivery / meals) : 0;
totalLbs += Math.max(0, lbs);
totalMeals += Math.max(0, meals);
totalPerDelivery += Math.max(0, perDelivery);
var leadDog = matchedDogRows.length ? matchedDogRows[0] : { dog: null, idx: idx };
var label = '';
if (matchedDogRows.length === 1) {
label = formatPossessivePlanLabel(titleCase((leadDog.dog && leadDog.dog.name) || '') || ('Dog ' + (leadDog.idx + 1)));
} else if (matchedDogRows.length > 1) {
var names = matchedDogRows.map(function (row) { return titleCase((row.dog && row.dog.name) || '') || ('Dog ' + (row.idx + 1)); });
label = formatSharedPlanLabel(names);
} else {
label = 'Subscription ' + (idx + 1);
}
var headerAvatarHtml = '';
if (matchedDogRows.length > 1) {
headerAvatarHtml = '<div class="otto-cfg-review-v3-sub-card__avatars">' + matchedDogRows.map(function (row) {
return buildDogAvatarHtml(row.dog || {}, row.idx, 'otto-cfg-dog-avatar--review otto-cfg-review-v3-dog-row__avatar otto-cfg-review-v3-sub-card__avatar');
}).join('') + '</div>';
} else {
headerAvatarHtml = buildDogAvatarHtml(leadDog.dog || {}, leadDog.idx, 'otto-cfg-dog-avatar--review otto-cfg-review-v3-dog-row__avatar otto-cfg-review-v3-sub-card__avatar');
}
html += '<article class="otto-cfg-review-v3-sub-card"><div class="otto-cfg-review-v3-sub-card__head">' + headerAvatarHtml + '<div class="otto-cfg-review-v3-sub-card__title-wrap"><h5 class="otto-cfg-review-v3-sub-card__title">' + esc(label) + '</h5></div></div>';
html += '<div class="otto-cfg-review-v3-stats-grid">';
html += statCell('protein', 'Recipe', proteinName);
html += statCell('lbs', 'Weight', lbs > 0 ? (formatLbs(lbs) + ' lbs') : 'Pending');
html += statCell('meals', 'Meals', mealsPerDog > 0 ? (shareCount > 1 ? (String(mealsPerDog) + ' per dog') : String(mealsPerDog)) : 'Pending');
html += statCell('cadence', 'Frequency', interval > 0 ? formatCadenceText(interval, sub && sub.weeks) : 'Pending');
html += '<div class="otto-cfg-review-v3-stats-pricing">' + buildV3PriceRow(perDelivery, perMeal, shareCount > 1, {
freezerProgram: freezerProgramSelected,
discountPercent: freezerDiscountPercent
}) + '</div>';
html += '</div></article>';
});
html += '</div></div>';
} else {
currentSubs.forEach(function (sub) {
var totes = Math.max(0, Math.floor(Number(sub && sub.totes || 0)));
var lbs = Number(sub && sub.lbs || 0);
if (!lbs && totes > 0) lbs = totes * LBS_PER_TOTE;
var daily = Number(sub && sub.dailyTotal || totalDaily || 0);
var meals = (lbs > 0 && daily > 0 && effectiveMealsForReview > 0) ? Math.round((lbs / daily) * effectiveMealsForReview) : 0;
var price = Number(sub && sub.price || 0);
var perDelivery = (price > 0 && lbs > 0) ? (price / 100) * lbs : 0;
totalLbs += Math.max(0, lbs);
totalMeals += Math.max(0, meals);
totalPerDelivery += Math.max(0, perDelivery);
});
var primarySub = currentSubs[0] || {};
var cadence = Math.max(0, Math.floor(Number(primarySub.interval || selections.delivery_interval || 0)));
var primaryShareCount = 1;
if (currentSubs.length === 1 && dogs.length > 1) {
if (Array.isArray(primarySub.dogs) && primarySub.dogs.length) primaryShareCount = Math.max(1, primarySub.dogs.length);
else primaryShareCount = dogs.length;
}
var mealsValueText = totalMeals > 0 ? (primaryShareCount > 1 ? (String(totalMeals) + ' per dog') : String(totalMeals)) : 'Pending';
var proteinLabel = '';
if (currentSubs.length === 1) {
proteinLabel = String(primarySub.protein || '').trim() || 'Pending';
} else {
var names = {};
var proteinNames = [];
currentSubs.forEach(function (sub) {
var protein = String(sub && sub.protein || '').trim();
if (!protein) return;
var key = normalizeName(protein);
if (names[key]) return;
names[key] = true;
proteinNames.push(protein);
});
proteinLabel = proteinNames.length ? proteinNames.join(' + ') : 'Mixed plan';
}
html += '<div class="otto-cfg-review-v3-section"><h4 class="otto-cfg-review-v3-section__title">Subscription Details</h4><div class="otto-cfg-review-v3-stats-grid">';
var isFreezerSummary = freezerProgramSelected;
if (isFreezerSummary) {
html += buildFreezerTypePill();
html += buildFreezerRecipeAllocationStat(currentSubs);
} else {
html += statCell('protein', 'Recipe', proteinLabel);
}
html += statCell('lbs', 'Weight', totalLbs > 0 ? (formatLbs(totalLbs) + ' lbs') : 'Pending');
html += statCell('meals', 'Meals', mealsValueText);
html += statCell('cadence', 'Frequency', cadence > 0 ? formatCadenceText(cadence, primarySub.weeks) : 'Pending');
var priceMealBase = primaryShareCount > 1 ? (totalMeals * primaryShareCount) : totalMeals;
var perMealSingle = (totalPerDelivery > 0 && priceMealBase > 0) ? (totalPerDelivery / priceMealBase) : 0;
var scenarioMode = freezerProgramSelected ? 'freezer' : 'regular';
var scenarioMetrics = computeOttoScenarioMetrics(scenarioMode);
if (scenarioMetrics && scenarioMetrics.perMeal > 0) {
perMealSingle = scenarioMetrics.perMeal;
}
if (freezerProgramSelected && regularScenarioMetrics && regularScenarioMetrics.perMeal > 0) {
perMealSingle = regularScenarioMetrics.perMeal;
}
var showPerDogPricingLabel = (primaryShareCount > 1) || (freezerProgramSelected && dogs.length > 1);
html += '<div class="otto-cfg-review-v3-stats-pricing">' + buildV3PriceRow(totalPerDelivery, perMealSingle, showPerDogPricingLabel, {
freezerProgram: freezerProgramSelected,
discountPercent: freezerDiscountPercent
}) + '</div>';
html += '</div></div>';
}
html += buildV3ComparisonShell(currentSubs);
html += '</section>';
return html;
}
var packDogsHtml = '';
if (dogs.length) {
          hasSummaryData = true;
packDogsHtml = '<div class="otto-cfg-review-pack__dogs">' + dogs.map(function (dog, idx) {
return buildDogBlockHtml(dog, idx);
}).join('') + '</div>';
} else {
packDogsHtml = '<p class="otto-cfg-card__helper">No dog details available yet.</p>';
}
/* Per-dog -> per-recipe subscription breakdown (the customer portal model:
 * each dog its own profile, its recipes split from one household cadence). */
function buildPerDogReviewSubscriptions() {
var plan = (typeof buildPerDogRecipePlan === 'function') ? buildPerDogRecipePlan() : { ok: false };
if (!plan || !plan.ok || !Array.isArray(plan.dogs) || !plan.dogs.length) return '';
var interval = 0, weeks = 0;
var sharedPackRecipes = !selections.per_dog_protein && plan.dogs.length > 1;
var allRows = '';
if (sharedPackRecipes) {
var byProtein = {};
var order = [];
plan.dogs.forEach(function (dog) {
if (dog.interval > 0) { interval = dog.interval; weeks = dog.weeks; }
(dog.recipes || []).forEach(function (rec) {
var key = String(rec && rec.protein || '').trim().toLowerCase();
if (!key) return;
if (!byProtein[key]) {
byProtein[key] = { protein: rec.protein, lbs: 0, price_cents: rec.price_cents };
order.push(key);
}
byProtein[key].lbs += Math.max(0, Number(rec.lbs || 0));
});
});
allRows = '<div class="otto-cfg-review-tile__line otto-cfg-review-tile__line--head">'
+ '<span class="otto-cfg-review-tile__label">Your Pack\'s Recipes</span></div>'
+ order.map(function (key) { return buildPackTotalsRecipeRowHtml(byProtein[key]); }).join('');
} else {
allRows = plan.dogs.map(function (dog, dogIdx) {
if (dog.interval > 0) { interval = dog.interval; weeks = dog.weeks; }
var recipeRows = (dog.recipes || []).map(function (rec) {
return buildPackTotalsRecipeRowHtml(rec);
}).join('');
var dogName = titleCase(dog.name) || 'Dog';
var possessive = dogName.charAt(dogName.length - 1).toLowerCase() === 's' ? (dogName + '\'') : (dogName + '\'s');
var headClass = 'otto-cfg-review-tile__line--head' + (dogIdx > 0 ? ' otto-cfg-review-tile__line--section-start' : '');
var header = '<div class="otto-cfg-review-tile__line ' + headClass + '">'
+ '<span class="otto-cfg-review-tile__label">' + esc(possessive + ' Recipes') + '</span></div>';
return header + recipeRows;
}).join('');
}
var summaryDivider = '<div class="otto-cfg-review-tile__totals-divider" role="presentation"></div>';
var summaryRows = buildPackTotalsPriceSummaryRows(plan, interval, weeks);
return '<div class="otto-cfg-review-pack__subscriptions">'
+ '<section class="otto-cfg-review-tile-group"><div class="otto-cfg-review-tile' +
(foundingModeEnabled() ? ' otto-cfg-review-tile--founding' : '') + '">'
+ allRows + summaryDivider + summaryRows
+ '</div></section>'
+ '</div>';
}
var subscriptionsHtml = '';
if (!selections.freezer_program && typeof buildPerDogRecipePlan === 'function') {
subscriptionsHtml = buildPerDogReviewSubscriptions();
}
if (!String(subscriptionsHtml || '').trim()) subscriptionsHtml = buildReviewSubscriptions();
var pricingHtml = buildPricingTransparency();
/* Full Otto-vs-competitor comparison (the brand-toggle matrix). Decoupled from
 * the review-version gate so the per-dog summary always shows it. */
var comparisonHtml = buildV3ComparisonShell(getCurrentReviewSubscriptions(), { embedInAccordion: false });
subscriptionsHtml = embedComparisonInSubscriptions(subscriptionsHtml, comparisonHtml);
if (String(subscriptionsHtml || '').indexOf('otto-cfg-review-pack__subscriptions') !== -1) {
hasSummaryData = true;
}
      if (!hasSummaryData) {
        setReviewTrust(false);
        body.innerHTML = '<p class="otto-cfg-card__helper">Complete the steps above to see your summary.</p>';
        return;
      }
function rebuildDogsFromReviewEdits() {
if (!Array.isArray(selections.dogs_basic) || !selections.dogs_basic.length) return;
var nextDogs = [];
var totalDaily = 0;
selections.dogs_basic.forEach(function (basicDog, idx) {
var prevDog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var weight = Math.max(0, Math.floor(Number((basicDog && basicDog.weight) || (prevDog && prevDog.weight) || 0)));
var birthdate = String((basicDog && basicDog.birthdate) || (prevDog && prevDog.birthdate) || '').trim();
var ageEstimated = !!((basicDog && basicDog.birthdate) ? basicDog.age_estimated : (prevDog && prevDog.age_estimated));
var rebuildBreed = String((basicDog && basicDog.breed) || (prevDog && prevDog.breed) || '').trim();
var lifeStage = birthdate ? deriveStageFromBirthdate(birthdate, rebuildBreed, weight) : '';
if (!lifeStage) {
lifeStage = String((prevDog && prevDog.life_stage) || 'adult').trim().toLowerCase();
var knownStages = { puppy: 1, adult: 1, senior: 1, young_puppy: 1, growing_puppy: 1, juvenile: 1, young_adult: 1 };
if (!knownStages[lifeStage]) lifeStage = 'adult';
}
var activity = String((prevDog && prevDog.activity) || 'recommended').trim().toLowerCase();
if (activity !== 'light' && activity !== 'recommended' && activity !== 'active') activity = 'recommended';
var goal = normalizeGoalValue((prevDog && prevDog.goal) || '');
if (isGrowthStageKey(lifeStage)) {
goal = 'maintain';
activity = 'recommended';
}
var daily = (weight > 0) ? getDailyIntake(weight, lifeStage, activity, goal) : 0;
totalDaily += daily;
var avatar = getDogAvatarModel({
name: (basicDog && basicDog.name) || '',
breed: (basicDog && basicDog.breed) || '',
avatar: (basicDog && basicDog.avatar) || '',
avatar_fallback: (basicDog && basicDog.avatar_fallback) || ''
}, idx);
nextDogs.push({
name: (basicDog && basicDog.name) || '',
breed: (basicDog && basicDog.breed) || '',
avatar: avatar.src,
avatar_fallback: avatar.fallback,
sex: (basicDog && basicDog.sex) || '',
weight: weight,
life_stage: lifeStage,
birthdate: birthdate,
age_estimated: ageEstimated,
activity: activity,
goal: goal,
daily_intake: daily
});
});
selections.dogs = nextDogs;
selections.daily_total = totalDaily;
}
function syncPerDogProteinsFromSubscriptions() {
if (!Array.isArray(selections.dog_proteins) || !selections.dog_proteins.length) return;
if (!Array.isArray(selections.subscriptions) || !selections.subscriptions.length) return;
var indexByName = {};
(selections.dogs || []).forEach(function (dog, idx) {
var key = normalizeName(dog && dog.name);
if (key && indexByName[key] == null) indexByName[key] = idx;
});
selections.subscriptions.forEach(function (sub) {
var protein = String((sub && sub.protein) || '').trim();
if (!protein || !Array.isArray(sub && sub.dogs)) return;
sub.dogs.forEach(function (dogName) {
var idx = indexByName[normalizeName(dogName)];
if (idx == null || idx < 0) return;
if (!selections.dog_proteins[idx]) {
selections.dog_proteins[idx] = {
dogIdx: idx,
dogName: titleCase((selections.dogs[idx] && selections.dogs[idx].name) || '') || ('Dog ' + (idx + 1)),
protein: protein,
price: resolveProteinPrice(protein),
daily_intake: Number((selections.dogs[idx] && selections.dogs[idx].daily_intake) || 0)
};
} else {
selections.dog_proteins[idx].protein = protein;
selections.dog_proteins[idx].price = resolveProteinPrice(protein);
}
});
});
}
function applyReviewEditorMutation() {
var retained = tryRetainDeliverySelectionsAfterProductMutation();
if (!retained) {
invalidateDeliverySelections();
}
renderDeliveryTiles(true);
renderFreezerProgramCard(true);
updateMealPrices();
updateIncomplete();
buildReview();
}
function bindReviewV2Editors() {
if (!useReviewV2) return;
body.querySelectorAll('[data-cfg-review-edit-dog]').forEach(function (input) {
var eventName = input.tagName === 'SELECT' ? 'change' : 'blur';
input.addEventListener(eventName, function () {
var idx = parseInt(input.getAttribute('data-cfg-review-dog-idx'), 10);
var field = String(input.getAttribute('data-cfg-review-dog-field') || '').trim();
if (!isFinite(idx) || idx < 0 || !field) return;
if (!Array.isArray(selections.dogs_basic) || !selections.dogs_basic[idx]) return;
var nextValue = input.value;
if (field === 'name' || field === 'breed') {
nextValue = titleCase(String(nextValue || '').trim());
}
if (field === 'weight') {
nextValue = Math.max(0, Math.floor(Number(nextValue || 0)));
if (nextValue <= 0) return;
}
if (field === 'sex') {
nextValue = String(nextValue || '').toLowerCase() === 'female' ? 'female' : 'male';
}
if (field === 'age_bucket') {
var bucketValue = String(nextValue || '').trim().toLowerCase();
if (!bucketValue) return;
var bucketBasic = selections.dogs_basic[idx];
var syntheticBirthdate = (Engine && typeof Engine.birthdateForStage === 'function')
? Engine.birthdateForStage(bucketValue, settings, null, sizeClassFor(String(bucketBasic.breed || ''), Number(bucketBasic.weight || 0), ''))
: '';
if (!syntheticBirthdate) return;
bucketBasic.birthdate = syntheticBirthdate;
bucketBasic.age_estimated = true;
bucketBasic.life_stage = bucketValue;
if (Array.isArray(selections.dogs) && selections.dogs[idx]) {
selections.dogs[idx].birthdate = syntheticBirthdate;
selections.dogs[idx].age_estimated = true;
}
} else if (field === 'birth_month' || field === 'birth_year' || field === 'birth_day') {
var monthSel = body.querySelector('[data-cfg-review-edit-dog][data-cfg-review-dog-idx="' + idx + '"][data-cfg-review-dog-field="birth_month"]');
var yearSel = body.querySelector('[data-cfg-review-edit-dog][data-cfg-review-dog-idx="' + idx + '"][data-cfg-review-dog-field="birth_year"]');
var daySel = body.querySelector('[data-cfg-review-edit-dog][data-cfg-review-dog-idx="' + idx + '"][data-cfg-review-dog-field="birth_day"]');
var bMonth = monthSel ? parseInt(monthSel.value, 10) : 0;
var bYear = yearSel ? parseInt(yearSel.value, 10) : 0;
var bDay = daySel ? parseInt(daySel.value, 10) : 0;
if (!(bMonth >= 1 && bMonth <= 12) || !(bYear > 1980)) return;
// Day is optional; drop impossible dates (e.g. Feb 31) silently.
var bDayValid = bDay >= 1 && bDay <= 31 && new Date(bYear, bMonth - 1, bDay).getDate() === bDay;
var bNow = new Date();
if (bYear > bNow.getFullYear()
|| (bYear === bNow.getFullYear() && bMonth > bNow.getMonth() + 1)
|| (bYear === bNow.getFullYear() && bMonth === bNow.getMonth() + 1 && bDayValid && bDay > bNow.getDate())) return;
var newBirthdate = bYear + '-' + (bMonth < 10 ? '0' : '') + bMonth + (bDayValid ? '-' + (bDay < 10 ? '0' : '') + bDay : '');
selections.dogs_basic[idx].birthdate = newBirthdate;
selections.dogs_basic[idx].age_estimated = false;
if (Array.isArray(selections.dogs) && selections.dogs[idx]) {
selections.dogs[idx].birthdate = newBirthdate;
selections.dogs[idx].age_estimated = false;
}
} else if (field === 'life_stage' || field === 'activity') {
if (!Array.isArray(selections.dogs) || !selections.dogs[idx]) return;
selections.dogs[idx][field] = String(nextValue || '').trim().toLowerCase();
} else {
selections.dogs_basic[idx][field] = nextValue;
if (field === 'breed') {
selections.dogs_basic[idx].avatar = '';
selections.dogs_basic[idx].avatar_fallback = '';
}
if (field === 'name' && Array.isArray(selections.dog_proteins) && selections.dog_proteins[idx]) {
selections.dog_proteins[idx].dogName = titleCase(String(nextValue || '')) || ('Dog ' + (idx + 1));
}
}
rebuildDogsFromReviewEdits();
syncPerDogProteinsFromSubscriptions();
applyReviewEditorMutation();
});
});
body.querySelectorAll('[data-cfg-review-edit-sub-protein]').forEach(function (select) {
select.addEventListener('change', function () {
var subIdx = parseInt(select.getAttribute('data-cfg-review-sub-idx'), 10);
if (!isFinite(subIdx) || subIdx < 0) return;
var nextProtein = String(select.value || '').trim();
if (!nextProtein) return;
var nextPrice = resolveProteinPrice(nextProtein);
if (Array.isArray(selections.subscriptions) && selections.subscriptions[subIdx]) {
selections.subscriptions[subIdx].protein = nextProtein;
if (nextPrice > 0) selections.subscriptions[subIdx].price = nextPrice;
}
if (!selections.per_dog_protein && subIdx === 0) {
selections.protein = nextProtein;
if (nextPrice > 0) selections.product_price = nextPrice;
}
if (selections.per_dog_protein) {
syncPerDogProteinsFromSubscriptions();
}
applyReviewEditorMutation();
});
});
body.querySelectorAll('[data-cfg-review-v2-protein-swap]').forEach(function (btn) {
btn.addEventListener('click', function () {
var freezerCard = getFreezerProgramCard();
if (selections.freezer_program && freezerCard && !freezerCard.hidden) {
scrollToCard(freezerCard);
setTimeout(function () {
var builderToggle = freezerCard.querySelector('[data-cfg-freezer-accordion-toggle][data-cfg-freezer-accordion-target="builder"]');
if (builderToggle) builderToggle.click();
}, 220);
return;
}
var productCard = $('[data-cfg-type="product_selector"]');
if (productCard) scrollToCard(productCard);
});
});
body.querySelectorAll('[data-cfg-review-pricing-mode]').forEach(function (btn) {
btn.addEventListener('click', function () {
var mode = String(btn.getAttribute('data-cfg-review-pricing-mode') || '').trim().toLowerCase();
if (mode !== 'regular' && mode !== 'freezer') return;
selections.review_pricing_mode = mode;
saveProgressState();
buildReview();
});
});
}
function bindV3ComparisonToggle() {
/* Works for V3 and for the per-dog summary, which now embeds the same shell. */
var comparisonShell = body.querySelector('.otto-cfg-review-v3-comparison-shell');
if (!comparisonShell) return;
var comparisonLink = comparisonShell.querySelector('.otto-cfg-review-v3-comparison-shell__link');
if (!comparisonLink) return;
var openLabel = String(comparisonLink.textContent || '').trim() || 'See price comparison';
var closeLabel = 'Close';
function syncComparisonToggleLabel() {
var isOpen = comparisonShell.hasAttribute('open');
comparisonLink.textContent = isOpen ? closeLabel : openLabel;
if (reviewCardEl) reviewCardEl._comparisonShellOpen = isOpen;
}
syncComparisonToggleLabel();
comparisonShell.addEventListener('toggle', syncComparisonToggleLabel);
}
function bindV3ComparisonCarousel() {
/* Works for V3 and for the per-dog summary, which now embeds the same shell. */
var comparisonShell = body.querySelector('.otto-cfg-review-v3-comparison-shell');
if (!comparisonShell) return;
var labelEl = comparisonShell.querySelector('[data-cfg-comp-label]');
var prevBtn = comparisonShell.querySelector('[data-cfg-comp-prev]');
var nextBtn = comparisonShell.querySelector('[data-cfg-comp-next]');
var valueCells = comparisonShell.querySelectorAll('[data-cfg-comp-value-cell]');
var titleEl = comparisonShell.querySelector('[data-cfg-comp-savings-title]');
if (!labelEl || !prevBtn || !nextBtn || !valueCells.length) return;
var panel = comparisonShell.querySelector('.otto-cfg-review-v3-comparison-shell__panel');
var competitorCount = 3;
var suppressClickUntil = 0;
var activeIdx = reviewCardEl ? Math.floor(Number(reviewCardEl._comparisonShellCompetitorIdx)) : 0;
if (!isFinite(activeIdx) || activeIdx < 0 || activeIdx >= competitorCount) activeIdx = 0;
function formatComparisonValue(value) {
var amount = Number(value || 0);
return amount > 0 ? money(amount) : 'TBD';
}
function getLabelAt(idx) {
return String(comparisonShell.getAttribute('data-cfg-comp-label-' + idx) || '').trim();
}
function getNumericAttribute(name) {
var raw = Number(comparisonShell.getAttribute(name) || 0);
return isFinite(raw) ? raw : 0;
}
function formatSavingsAmount(value) {
var amount = Number(value || 0);
if (!isFinite(amount) || amount < 0) amount = 0;
return '$' + amount.toFixed(2);
}
function buildComparisonSavingsTitleHtml(activeLabel, perMealSavings, perMonthSavings) {
var label = String(activeLabel || '').trim() || 'this option';
return 'You\'ll save <span class="otto-cfg-review-v3-comparison-shell__title-amount">' + esc(formatSavingsAmount(perMealSavings)) + '</span>'
+ ' per meal and <span class="otto-cfg-review-v3-comparison-shell__title-amount">' + esc(formatSavingsAmount(perMonthSavings)) + '</span>'
+ ' per month by feeding <span class="otto-cfg-review-v3-comparison-shell__title-brand">otto</span> vs. ' + esc(label) + '.';
}
function syncComparisonTitle(idx, activeLabel) {
if (!titleEl) return;
var ottoPerMeal = getNumericAttribute('data-cfg-comp-permeal-otto');
var ottoPerMonth = getNumericAttribute('data-cfg-comp-permonth-otto');
var competitorPerMeal = getNumericAttribute('data-cfg-comp-permeal-' + idx);
var competitorPerMonth = getNumericAttribute('data-cfg-comp-permonth-' + idx);
var perMealSavings = Math.max(0, competitorPerMeal - ottoPerMeal);
var perMonthSavings = Math.max(0, competitorPerMonth - ottoPerMonth);
titleEl.innerHTML = buildComparisonSavingsTitleHtml(activeLabel, perMealSavings, perMonthSavings);
}
function normalizeIdx(rawIdx) {
var idx = Math.floor(Number(rawIdx));
if (!isFinite(idx)) idx = 0;
if (idx < 0) idx = competitorCount - 1;
if (idx >= competitorCount) idx = 0;
return idx;
}
function syncComparisonColumn(nextIdx) {
var idx = normalizeIdx(nextIdx);
var activeLabel = getLabelAt(idx) || 'Competitor';
labelEl.textContent = activeLabel;
syncComparisonTitle(idx, activeLabel);
for (var i = 0; i < valueCells.length; i += 1) {
var cell = valueCells[i];
var brandEl = cell.querySelector('[data-cfg-comp-value-brand]');
var valueEl = cell.querySelector('[data-cfg-comp-value-amount]');
if (brandEl) brandEl.textContent = activeLabel;
if (valueEl) {
var valueRaw = Number(cell.getAttribute('data-cfg-comp-value-' + idx) || 0);
valueEl.textContent = formatComparisonValue(valueRaw);
}
}
activeIdx = idx;
if (reviewCardEl) reviewCardEl._comparisonShellCompetitorIdx = idx;
}
function shiftColumn(direction) {
var currentIdx = normalizeIdx(activeIdx || 0);
syncComparisonColumn(currentIdx + direction);
}
function onChevronPress(direction, evt) {
evt.preventDefault();
evt.stopPropagation();
shiftColumn(direction);
}
prevBtn.addEventListener('touchstart', function (evt) {
onChevronPress(-1, evt);
suppressClickUntil = Date.now() + 450;
}, { passive: false });
nextBtn.addEventListener('touchstart', function (evt) {
onChevronPress(1, evt);
suppressClickUntil = Date.now() + 450;
}, { passive: false });
prevBtn.addEventListener('click', function (evt) {
if (Date.now() < suppressClickUntil) {
evt.preventDefault();
evt.stopPropagation();
return;
}
onChevronPress(-1, evt);
});
nextBtn.addEventListener('click', function (evt) {
if (Date.now() < suppressClickUntil) {
evt.preventDefault();
evt.stopPropagation();
return;
}
onChevronPress(1, evt);
});
var touchStartX = 0;
var touchStartY = 0;
if (panel) {
panel.addEventListener('touchstart', function (evt) {
var t = evt.touches && evt.touches[0];
if (!t) return;
touchStartX = t.clientX;
touchStartY = t.clientY;
}, { passive: true });
panel.addEventListener('touchend', function (evt) {
var t = evt.changedTouches && evt.changedTouches[0];
if (!t) return;
var deltaX = t.clientX - touchStartX;
var deltaY = t.clientY - touchStartY;
if (Math.abs(deltaX) < 36 || Math.abs(deltaY) > 32) return;
if (deltaX < 0) shiftColumn(1);
else shiftColumn(-1);
}, { passive: true });
}
syncComparisonColumn(activeIdx);
}
if (useReviewV3) {
setReviewTrust(true);
body.innerHTML = '<div class="otto-cfg-review-grid">' + buildV3ReviewCard() + '</div>';
bindV3ComparisonToggle();
bindV3ComparisonCarousel();
return;
}
tiles.push(packTile(buildReviewAccordion(packDogsHtml, subscriptionsHtml, pricingHtml, comparisonHtml)));
      setReviewTrust(true);
      body.innerHTML = '<div class="otto-cfg-review-grid">' + tiles.join('') + '</div>';
bindReviewV2Editors();
bindV3ComparisonToggle();
bindV3ComparisonCarousel();
    }
    function hydrateDogInfoFromState() {
      var dogsBasic = Array.isArray(selections.dogs_basic) ? selections.dogs_basic : [];
      if (!dogsBasic.length) return;
      var dogInfoCard = $('[data-cfg-type="dog_info"]');
      if (!dogInfoCard) return;
      var container = dogInfoCard.querySelector('[data-cfg-dogs-container]');
      var addBtn = dogInfoCard.querySelector('[data-cfg-add-dog]');
      var continueBtn = dogInfoCard.querySelector('[data-cfg-doginfo-continue]');
      var breedOther = dogInfoCard.getAttribute('data-cfg-breed-other-value') || 'Mixed Breed / Other';
      var knownBreeds = {};
      try {
        var hydratedBreedOptions = JSON.parse(dogInfoCard.getAttribute('data-cfg-breed-options') || '[]');
        if (Array.isArray(hydratedBreedOptions)) {
          hydratedBreedOptions.forEach(function (val) {
            var key = String(val || '').trim().toLowerCase();
            if (key) knownBreeds[key] = true;
          });
        }
      } catch (_e) {}
      knownBreeds[String(breedOther || '').trim().toLowerCase()] = true;
      if (!container) return;
      function isBreedOtherValue(value) {
        return String(value || '').trim().toLowerCase() === String(breedOther || '').trim().toLowerCase();
      }
      function isKnownBreedValue(value) {
        return !!knownBreeds[String(value || '').trim().toLowerCase()];
      }
      function getEntries() {
        return container.querySelectorAll('[data-cfg-dog-entry]');
      }
      while (getEntries().length < dogsBasic.length) {
        if (typeof dogInfoCard._ottoAddDog === 'function') dogInfoCard._ottoAddDog();
        else if (addBtn) addBtn.click();
        else break;
        if (getEntries().length >= dogsBasic.length) break;
      }
      while (getEntries().length > dogsBasic.length && getEntries().length > 1) {
        var entriesForRemove = getEntries();
        var lastEntry = entriesForRemove[entriesForRemove.length - 1];
        var removeBtn = lastEntry.querySelector('[data-cfg-remove-dog]');
        if (removeBtn) removeBtn.click();
        else lastEntry.remove();
      }
      var entries = getEntries();
      entries.forEach(function (entry, idx) {
        var dog = dogsBasic[idx] || {};
        var nameEl = entry.querySelector('[data-cfg-dog-name]');
        var weightEl = entry.querySelector('[data-cfg-weight]');
        var breedEl = entry.querySelector('[data-cfg-breed]');
        var customWrap = entry.querySelector('[data-cfg-breed-custom-wrap]');
        var customInput = entry.querySelector('[data-cfg-breed-custom]');
        if (nameEl) {
          nameEl.value = dog.name || '';
          nameEl.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (weightEl) {
          // setEntryWeight lives inside the dog_info card closure — call via the
          // card helper (or set hidden + display directly as fallback).
          if (typeof dogInfoCard._ottoSetEntryWeight === 'function') {
            dogInfoCard._ottoSetEntryWeight(entry, dog.weight || '');
          } else {
            var n = parseInt(dog.weight, 10);
            var displayEl = entry.querySelector('[data-cfg-weight-display]');
            weightEl.value = (n > 0) ? String(n) : '';
            if (displayEl) displayEl.value = (n > 0) ? (n + ' lbs') : '';
          }
          weightEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
var activityEl = entry.querySelector('[data-cfg-activity]');
if (activityEl) {
var hydratedDogActivity = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var activityValue = String((dog.activity || hydratedDogActivity.activity || '')).trim().toLowerCase();
activityEl.value = activityValue;
activityEl.dispatchEvent(new Event('change', { bubbles: true }));
}
var goalEl = entry.querySelector('[data-cfg-goal]');
if (goalEl) {
var hydratedDogGoal = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var goalValue = normalizeGoalValue(dog.goal || hydratedDogGoal.goal || '');
goalEl.value = goalValue;
goalEl.dispatchEvent(new Event('change', { bubbles: true }));
}
var rawPercentEl = entry.querySelector('[data-cfg-raw-percent]');
if (rawPercentEl) {
var hydratedRawDog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var rawPct = Number(dog.raw_percent || hydratedRawDog.raw_percent);
if (rawPct > 0) rawPercentEl.value = String(normalizeRawPercent(rawPct));
rawPercentEl.dispatchEvent(new Event('change', { bubbles: true }));
}
        if (breedEl) {
          var normalizedBreed = String(dog.breed || '').trim();
          if (isKnownBreedValue(normalizedBreed) && !isBreedOtherValue(normalizedBreed)) {
            breedEl.value = dog.breed;
            breedEl.setAttribute('data-cfg-committed-breed', dog.breed);
            if (customWrap) customWrap.hidden = true;
            if (customInput) customInput.value = '';
          } else if (normalizedBreed) {
            breedEl.value = breedOther;
            breedEl.setAttribute('data-cfg-committed-breed', breedOther);
            if (customWrap) customWrap.hidden = false;
if (customInput) customInput.value = isBreedOtherValue(normalizedBreed) ? '' : normalizeCustomBreedLabel(dog.breed);
          }
          breedEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
// Birthday hydration runs after breed/weight so the size-aware stage
// derivation sees the dog's real context.
var hydratedDog = (Array.isArray(selections.dogs) && selections.dogs[idx]) ? selections.dogs[idx] : {};
var hydratedBirthdate = String(dog.birthdate || hydratedDog.birthdate || '').trim();
var hydratedEstimated = !!(dog.birthdate ? dog.age_estimated : hydratedDog.age_estimated);
if (!hydratedBirthdate) {
// Legacy saved state (3-stage, no birthdate): approximate via the stage
// bucket midpoint so the new age model has something to work with.
var legacyStage = String((dog.life_stage || hydratedDog.life_stage || '')).trim().toLowerCase();
if (legacyStage && Engine && typeof Engine.birthdateForStage === 'function') {
var mappedStage = legacyStage === 'puppy' ? 'juvenile' : legacyStage;
hydratedBirthdate = Engine.birthdateForStage(mappedStage, settings, null, sizeClassFor(String(dog.breed || ''), Number(dog.weight || 0), '')) || '';
hydratedEstimated = true;
}
}
if (hydratedBirthdate && typeof dogInfoCard._ottoHydrateEntryBirthday === 'function') {
dogInfoCard._ottoHydrateEntryBirthday(entry, hydratedBirthdate, hydratedEstimated);
var stageEl = entry.querySelector('[data-cfg-life-stage]');
if (stageEl) stageEl.dispatchEvent(new Event('change', { bubbles: true }));
}
var sexEl = entry.querySelector('[data-cfg-sex]');
if (sexEl) {
var sexVal = String(dog.sex || '').trim();
var sexMatch = '';
Array.prototype.forEach.call(sexEl.options, function (opt) {
if (String(opt.value || '').trim().toLowerCase() === sexVal.toLowerCase()) sexMatch = opt.value;
});
sexEl.value = sexMatch || sexVal;
sexEl.dispatchEvent(new Event('change', { bubbles: true }));
}
        });
      if (typeof dogInfoCard._ottoValidateDogInfo === 'function') dogInfoCard._ottoValidateDogInfo();
      // Ensure hydrated selections immediately recalculate Continue enabled state.
      if (continueBtn) {
        var allValid = true;
        entries.forEach(function (entry) {
          var nameEl = entry.querySelector('[data-cfg-dog-name]');
          if (!nameEl || !nameEl.value.trim()) allValid = false;
          var w = parseInt((entry.querySelector('[data-cfg-weight]') || {}).value, 10);
          if (!w || w <= 0) allValid = false;
var sexElHydrate = entry.querySelector('[data-cfg-sex]');
if (!sexElHydrate || !String(sexElHydrate.value || '').trim()) allValid = false;
          var breedInput = entry.querySelector('[data-cfg-breed]');
          var customInput = entry.querySelector('[data-cfg-breed-custom]');
          if (!breedInput || !String(breedInput.value || '').trim()) {
            allValid = false;
          } else if (isBreedOtherValue(breedInput.value) && customInput && !customInput.value.trim()) {
            allValid = false;
          }
var lifeStageElHydrate = entry.querySelector('[data-cfg-life-stage]');
var hydrateStageValue = lifeStageElHydrate ? String(lifeStageElHydrate.value || '').trim() : '';
if (!hydrateStageValue) allValid = false;
if (!isGrowthStageKey(hydrateStageValue)) {
var activityElHydrate = entry.querySelector('[data-cfg-activity]');
if (!activityElHydrate || !String(activityElHydrate.value || '').trim()) allValid = false;
var goalElHydrate = entry.querySelector('[data-cfg-goal]');
if (!goalElHydrate || !String(goalElHydrate.value || '').trim()) allValid = false;
}
        });
        continueBtn.disabled = false;
        continueBtn.setAttribute('aria-disabled', allValid ? 'false' : 'true');
        continueBtn.classList.toggle('is-blocked', !allValid);
      }
      if (typeof dogInfoCard._ottoSyncPortionPanels === 'function') dogInfoCard._ottoSyncPortionPanels();
      if (typeof dogInfoCard._ottoSyncAddDog === 'function') dogInfoCard._ottoSyncAddDog();
updateDogInfoPortionSummary();
if (dogInfoCard._ottoUpdateEntriesView) {
dogInfoCard._ottoUpdateEntriesView(dogsBasic.length - 1);
    }
}
    function hydrateZipFromState() {
      var zipCard = $('[data-cfg-type="zip_validator"]');
      if (!zipCard) return;
      var stepNum = parseInt(zipCard.getAttribute('data-cfg-step'), 10);
      if (pickupModeEnabled() && (selections.zip || selections.zip_attempted)) {
        if (!selections.zip) selections.zip = String(selections.zip_attempted || '').replace(/\D/g, '').slice(0, 5);
        selections.founding_choice = 'pickup';
        selections.founding_choice_ack = true;
        selections.fulfillment = 'pickup';
        applyServiceZone('pickup');
        applyPickupWeekdayPolicy();
        markStepCompleted(stepNum);
        if (zipCard.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
        zipCard.classList.remove('is-zip-failed', 'is-zip-loading');
        zipCard.classList.add('is-zip-success');
        var zipInputPickup = zipCard.querySelector('[data-cfg-zip]');
        if (zipInputPickup) zipInputPickup.value = String(selections.zip || '');
        var zipOutPickup = zipCard.querySelector('[data-cfg-zip-out]');
        if (zipOutPickup) zipOutPickup.hidden = true;
        var zipErrorPickup = zipCard.querySelector('[data-cfg-zip-error]');
        if (zipErrorPickup) zipErrorPickup.hidden = true;
        syncWaitlistPitchCardVisibility();
        fetchDeliveryWeekdayPolicy(selections.zip, function () {
          var ddCardPickup = $('[data-cfg-type="delivery_day"]');
          if (ddCardPickup && ddCardPickup._renderDeliveryDay) ddCardPickup._renderDeliveryDay();
        });
        return;
      }
      if (!selections.zip && waitlistPathActive()) {
        applyServiceZone('waitlist');
        markStepCompleted(stepNum);
        if (zipCard.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
        zipCard.classList.add('is-zip-failed');
        var zipOutHydrate = zipCard.querySelector('[data-cfg-zip-out]');
        if (zipOutHydrate) zipOutHydrate.hidden = true;
        var zipInputHydrate = zipCard.querySelector('[data-cfg-zip]');
        if (zipInputHydrate) zipInputHydrate.value = String(selections.zip_attempted || '');
        return;
      }
      if (!selections.zip) return;
      var zipInput = zipCard.querySelector('[data-cfg-zip]');
      var zipCheck = zipCard.querySelector('[data-cfg-zip-check]');
      var zipError = zipCard.querySelector('[data-cfg-zip-error]');
      var zipOut = zipCard.querySelector('[data-cfg-zip-out]');
      var zipSuccess = zipCard.querySelector('[data-cfg-zip-success]');
      var liveSet = parseZipAllowSet(zipCard.getAttribute('data-valid-zips') || '');
      var foundingSet = parseZipAllowSet(zipCard.getAttribute('data-founding-zips') || '');
      var matureSet = parseZipAllowSet(zipCard.getAttribute('data-mature-zips') || '');
      var zone = classifyServiceZone(selections.zip, liveSet, foundingSet, matureSet);
      if (zone === 'waitlist' && pickupModeEnabled()) {
        applyServiceZone('pickup');
        applyPickupWeekdayPolicy();
        markStepCompleted(stepNum);
        if (zipCard.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
        zipCard.classList.remove('is-zip-failed');
        zipCard.classList.add('is-zip-success');
        if (zipInput) zipInput.value = String(selections.zip || '');
        if (zipOut) zipOut.hidden = true;
        if (zipError) zipError.hidden = true;
        syncWaitlistPitchCardVisibility();
        fetchDeliveryWeekdayPolicy(selections.zip, function () {
          var ddCardWaitlistPickup = $('[data-cfg-type="delivery_day"]');
          if (ddCardWaitlistPickup && ddCardWaitlistPickup._renderDeliveryDay) ddCardWaitlistPickup._renderDeliveryDay();
        });
        return;
      }
      if (zone === 'waitlist') {
        /* Saved zip no longer eligible (lists or founding toggle changed). */
        var attempted = String(selections.zip || '').trim();
        delete selections.zip;
        selections.zip_attempted = attempted;
        applyServiceZone('waitlist');
        markStepCompleted(stepNum);
        if (zipCard.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
        zipCard.classList.add('is-zip-failed');
        if (zipOut) zipOut.hidden = true;
        return;
      }
      applyServiceZone(zone);
      if (zipInput) {
        zipInput.value = String(selections.zip || '');
      }
      var zipTermsInput = zipCard.querySelector('[data-cfg-zip-terms]');
      if (zipTermsInput && selections.owner && selections.owner.terms_accepted) {
        zipTermsInput.checked = true;
      }
      zipCard.classList.remove('is-zip-loading');
      zipCard.classList.add('is-zip-success');
      if (zipError) zipError.hidden = true;
      if (zipOut) zipOut.hidden = true;
      if (zipSuccess) {
        zipSuccess.hidden = true;
        zipSuccess.textContent = '';
      }
      if (zipCheck) {
        zipCheck.classList.remove('is-zip-loading');
        zipCheck.removeAttribute('aria-busy');
        setZipButtonLabel(
          zipCheck,
          zone === 'founding' ? 'Pick-up available' : 'Delivery available',
          false
        );
      }
      /* Mid-flow restore: if they already configured later steps, treat pitch as acknowledged. */
      if (zone === 'founding' && (
        hasValidProductSelection() ||
        hasValidDeliverySelection() ||
        hasValidFreezerSpaceSelection() ||
        hasValidDeliveryDaySelection()
      )) {
        if (!selections.founding_choice) selections.founding_choice = 'pickup';
        selections.founding_choice_ack = true;
        selections.founding_pitch_ack = true;
      }
      syncFoundingPathUi();
      if (zipCard.hasAttribute('data-locks-remaining')) unlockCardsAfter(stepNum);
      fetchDeliveryWeekdayPolicy(selections.zip, function () {
        var ddCard = $('[data-cfg-type="delivery_day"]');
        if (ddCard && ddCard._renderDeliveryDay) ddCard._renderDeliveryDay();
      });
    }
    function hydrateDietFromState() {
      if (!Array.isArray(selections.dogs_basic) || !selections.dogs_basic.length) return;
      var dietCard = $('[data-cfg-type="diet_profile"]');
      if (!dietCard) return;
      renderDietTiles(dietCard, true);
      if (Array.isArray(selections.dogs) && selections.dogs.length) {
        selections.dogs.forEach(function (dog, idx) {
          if (!dog) return;
          var stageGroup = dietCard.querySelector('[data-cfg-diet-stage-group="' + idx + '"]');
          var actGroup = dietCard.querySelector('[data-cfg-diet-activity-group="' + idx + '"]');
          if (stageGroup && dog.life_stage) {
            stageGroup.querySelectorAll('.otto-cfg-tile--diet').forEach(function (tile) {
              tile.classList.toggle('is-selected', tile.getAttribute('data-cfg-diet-value') === dog.life_stage);
            });
          }
          if (actGroup && dog.activity) {
            actGroup.querySelectorAll('.otto-cfg-tile--diet').forEach(function (tile) {
              tile.classList.toggle('is-selected', tile.getAttribute('data-cfg-diet-value') === dog.activity);
            });
          }
        });
        recalcDiet(dietCard);
      }
    }
function hydrateFeedingSetupFromState() {
var feedingCard = $('[data-cfg-type="feeding_setup"]');
if (feedingCard && feedingCard._syncFeedingSetupUI) feedingCard._syncFeedingSetupUI();
var feedingProteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (feedingProteinModeCard && feedingProteinModeCard._syncFeedingProteinModeUI) feedingProteinModeCard._syncFeedingProteinModeUI();
}
    function hydrateProductFromState() {
      var productCard = $('[data-cfg-type="product_selector"]');
      if (!productCard) return;
if (productCard._showProteinToggle) productCard._showProteinToggle();
if (selections.per_dog_protein && productCard._renderPerDogTiles) productCard._renderPerDogTiles();
      if (selections.per_dog_protein && Array.isArray(selections.dog_proteins) && selections.dog_proteins.length) {
var savedDogProteins = selections.dog_proteins.slice();
var singleWrap = productCard.querySelector('[data-cfg-protein-single]');
        var perDogWrap = productCard.querySelector('[data-cfg-protein-per-dog]');
if (singleWrap) singleWrap.hidden = true;
if (perDogWrap) perDogWrap.hidden = false;
var expectedDogs = Array.isArray(selections.dogs) ? selections.dogs : [];
var indexedRows = savedDogProteins.map(function (dp, rowIdx) {
return {
raw: dp,
idx: Number(dp && dp.dogIdx),
name: String((dp && dp.dogName) || '').trim().toLowerCase(),
protein: String((dp && dp.protein) || '').trim(),
rowIdx: rowIdx
};
});
var hasZeroBased = indexedRows.some(function (row) { return isFinite(row.idx) && row.idx === 0; });
var hasOneBased = indexedRows.some(function (row) { return isFinite(row.idx) && row.idx === 1; });
var useOneBasedIndexes = !hasZeroBased && hasOneBased;
var usedRowIndexes = {};
expectedDogs.forEach(function (dog, dogIdx) {
var dogName = String((dog && dog.name) || '').trim().toLowerCase();
var targetIndex = useOneBasedIndexes ? (dogIdx + 1) : dogIdx;
var match = indexedRows.find(function (row) {
if (usedRowIndexes[row.rowIdx]) return false;
if (!isFinite(row.idx)) return false;
return row.idx === targetIndex;
});
if (!match && dogName) {
match = indexedRows.find(function (row) {
if (usedRowIndexes[row.rowIdx]) return false;
return row.name && row.name === dogName;
});
}
if (!match) {
match = indexedRows.find(function (row) {
if (usedRowIndexes[row.rowIdx]) return false;
return !!row.protein;
});
}
if (match) usedRowIndexes[match.rowIdx] = true;
if (!match || !match.protein || !perDogWrap) return;
/* Restore EVERY saved recipe for this dog (multi-recipe). Clicking toggles,
 * so only click recipes not already selected by the per-dog tile preselect —
 * otherwise we would toggle a pre-selected recipe back off. */
var savedRow = match.raw || {};
var proteinList = (Array.isArray(savedRow.proteins) && savedRow.proteins.length)
? savedRow.proteins.map(function (p) { return String((typeof p === 'string') ? p : (p && p.protein) || '').trim(); }).filter(Boolean)
: (match.protein ? [match.protein] : []);
var buttons = perDogWrap.querySelectorAll('[data-cfg-perdog-protein="' + dogIdx + '"]');
proteinList.forEach(function (protName) {
buttons.forEach(function (btn) {
if (btn.classList.contains('is-selected')) return;
if (proteinsMatch(btn.getAttribute('data-cfg-tile-value'), protName)) btn.click();
});
});
        });
        if (selections.meals_per_day) {
var feedingCard = $('[data-cfg-type="feeding_setup"]');
if (feedingCard && feedingCard._syncFeedingSetupUI) feedingCard._syncFeedingSetupUI();
var feedingProteinModeCard = $('[data-cfg-type="feeding_protein_mode"]');
if (feedingProteinModeCard && feedingProteinModeCard._syncFeedingProteinModeUI) feedingProteinModeCard._syncFeedingProteinModeUI();
}
var normalizedFromSaved = getNormalizedPerDogProteinMap(expectedDogs.length, savedDogProteins, expectedDogs);
if (expectedDogs.length > 0 && Object.keys(normalizedFromSaved).length < expectedDogs.length) {
var orderedProteins = savedDogProteins
.map(function (row) { return String((row && row.protein) || '').trim(); })
.filter(function (protein) { return !!protein; });
if (orderedProteins.length >= expectedDogs.length) {
for (var fallbackIdx = 0; fallbackIdx < expectedDogs.length; fallbackIdx++) {
if (!normalizedFromSaved[fallbackIdx]) normalizedFromSaved[fallbackIdx] = orderedProteins[fallbackIdx];
}
}
}
if (expectedDogs.length > 0 && Object.keys(normalizedFromSaved).length === expectedDogs.length) {
selections.dog_proteins = expectedDogs.map(function (dog, idx) {
var mappedProtein = normalizedFromSaved[idx];
var mappedSavedRow = savedDogProteins.find(function (row) {
return row && proteinsMatch(row.protein, mappedProtein);
});
var mappedPrice = Number((mappedSavedRow && mappedSavedRow.price) || 0);
return {
dogIdx: idx,
dogName: titleCase((dog && dog.name) || '') || ('Dog ' + (idx + 1)),
protein: mappedProtein,
price: mappedPrice,
proteins: (mappedSavedRow && Array.isArray(mappedSavedRow.proteins) && mappedSavedRow.proteins.length)
? mappedSavedRow.proteins.slice()
: [{ protein: mappedProtein, price_cents: mappedPrice }],
daily_intake: Number((dog && dog.daily_intake) || 0)
};
});
}
if (hasValidProductSelection()) markStepCompleted(getStepByType('product_selector'));
if (productCard._syncProductContinueState) productCard._syncProductContinueState();
        return;
      }
      if (selections.protein || (Array.isArray(selections.household_proteins) && selections.household_proteins.length)) {
        /* Restore EVERY saved household recipe (multi-recipe). Clicking toggles,
         * so only click recipes not already selected by showToggleIfNeeded's
         * preselect — otherwise we would toggle a pre-selected recipe back off. */
        var hhRestore = getHouseholdProteinList();
        var hhRestoreNames = hhRestore.map(function (r) { return String(r.protein || '').trim(); }).filter(Boolean);
        var singleButtons = productCard.querySelectorAll('[data-cfg-protein-single] [data-cfg-tile-value]');
        singleButtons.forEach(function (btn) {
          if (btn.classList.contains('is-selected')) return;
          var val = btn.getAttribute('data-cfg-tile-value');
          for (var hi = 0; hi < hhRestoreNames.length; hi++) {
            if (proteinsMatch(val, hhRestoreNames[hi])) { btn.click(); break; }
          }
        });
      }
      if (selections.meals_per_day) {
var feedingCardSingle = $('[data-cfg-type="feeding_setup"]');
if (feedingCardSingle && feedingCardSingle._syncFeedingSetupUI) feedingCardSingle._syncFeedingSetupUI();
var feedingProteinModeCardSingle = $('[data-cfg-type="feeding_protein_mode"]');
if (feedingProteinModeCardSingle && feedingProteinModeCardSingle._syncFeedingProteinModeUI) feedingProteinModeCardSingle._syncFeedingProteinModeUI();
}
if (hasValidProductSelection()) markStepCompleted(getStepByType('product_selector'));
if (productCard._syncProductContinueState) productCard._syncProductContinueState();
}
function reconcileCoreStepCompletionFromCanonical() {
var dogInfoStep = getStepByType('dog_info');
var dogProfileStep = getStepByType('dog_profile');
var dietStep = getStepByType('diet_profile');
var feedingSetupStep = getStepByType('feeding_setup');
var feedingProteinModeStep = getStepByType('feeding_protein_mode');
var productStep = getStepByType('product_selector');
if (hasValidDogInfoSelection()) {
markStepCompleted(dogInfoStep);
}
if (shouldShowRawPortionCard() && hasValidRawPortionSelection()) {
markStepCompleted(getStepByType('raw_portion_check'));
}
if (shouldShowRawShareCard() && hasValidRawShareSelection()) {
markStepCompleted(getStepByType('raw_share'));
}
if (hasValidDogsBasicSelection()) {
markStepCompleted(dogProfileStep);
}
if (hasValidDietSelection()) markStepCompleted(dietStep);
if (hasValidFeedingSetupSelection()) markStepCompleted(feedingSetupStep);
if (hasValidFeedingProteinModeSelection()) markStepCompleted(feedingProteinModeStep);
if (hasValidProductSelection()) markStepCompleted(productStep);
}
    function hydrateFreezerSpaceFromState() {
      var selectedProfile = getSelectedFreezerSpaceProfile();
      if (!selectedProfile) return;
      var freezerSpaceCard = $('[data-cfg-type="freezer_space"]');
      if (!freezerSpaceCard) return;
      var btn = freezerSpaceCard.querySelector('[data-cfg-freezer-space-value="' + selectedProfile + '"]');
      if (btn) btn.click();
    }
    function hydrateDeliveryFromState() {
      if ((!selections.totes && !(Array.isArray(selections.subscriptions) && selections.subscriptions.length) && !selections.freezer_program)) return;
      renderDeliveryTiles(true);
      renderFreezerProgramCard(true);
      var tilesContainer = $('[data-cfg-delivery-tiles]');
      if (!tilesContainer) return;
      if (selections.freezer_program) {
        var freezerCard = getFreezerProgramCard();
        if (!freezerCard) return;
        if (freezerCard._applyFreezerProgram) freezerCard._applyFreezerProgram();
        return;
      }
      if (Array.isArray(selections.subscriptions) && selections.subscriptions.length > 1) {
        selections.subscriptions.forEach(function (sub) {
          var groups = tilesContainer.querySelectorAll('.otto-cfg-delivery-group');
          groups.forEach(function (group) {
var groupProtein = String(group.getAttribute('data-cfg-delivery-group-protein') || '').trim();
if (!groupProtein || !proteinsMatch(groupProtein, String(sub.protein || '').trim())) return;
            var groupButtons = group.querySelectorAll('[data-cfg-tile-value]');
            groupButtons.forEach(function (btn) {
              var totes = parseInt(btn.getAttribute('data-cfg-tile-value'), 10);
              var days = parseInt(btn.getAttribute('data-cfg-delivery-days'), 10);
              if (totes === Number(sub.totes || 0) && days === Number(sub.interval || 0)) btn.click();
            });
          });
        });
        return;
      }
      var targetSub = (Array.isArray(selections.subscriptions) && selections.subscriptions.length === 1) ? selections.subscriptions[0] : null;
      var targetTotes = targetSub ? Number(targetSub.totes || 0) : Number(selections.totes || 0);
      var targetDays = targetSub ? Number(targetSub.interval || 0) : Number(selections.delivery_interval || 0);
      tilesContainer.querySelectorAll('[data-cfg-tile-value]').forEach(function (btn) {
        var totes = parseInt(btn.getAttribute('data-cfg-tile-value'), 10);
        var days = parseInt(btn.getAttribute('data-cfg-delivery-days'), 10);
        if (totes === targetTotes && days === targetDays) btn.click();
      });
    }
    function hydrateFromSavedState() {
      if (!Object.keys(selections).length && !Object.keys(completedSteps).length) return;
      isHydratingState = true;
      try {
        hydrateZipFromState();
        hydrateDogInfoFromState();
        hydrateDietFromState();
hydrateFeedingSetupFromState();
        hydrateProductFromState();
        hydrateFreezerSpaceFromState();
        hydrateDeliveryFromState();
        snapHouseholdRawShareToPackMin();
      } finally {
        isHydratingState = false;
      }
      normalizeCompletedStepsFromSelections();
reconcileCoreStepCompletionFromCanonical();
      if (typeof syncRawShareCardVisibility === 'function') syncRawShareCardVisibility();
      if (typeof renderRawShareCard === 'function') renderRawShareCard();
      if (typeof syncRawPortionCardVisibility === 'function') syncRawPortionCardVisibility();
      if (typeof renderRawPortionCard === 'function') renderRawPortionCard();
var hydratedProductCard = $('[data-cfg-type="product_selector"]');
if (hydratedProductCard) {
if (hydratedProductCard._showProteinToggle) hydratedProductCard._showProteinToggle();
if (hydratedProductCard._syncProductContinueState) hydratedProductCard._syncProductContinueState();
}
      updateImage(currentStep);
      updateDots(currentStep);
      updateIncomplete();
      buildReview();
      syncAllAvatarElementsVisibility();
    }
    hydrateFromSavedState();
    syncFoundingPathUi();
    if (foundingModeEnabled()) {
      updateDots(currentStep);
      updateIncomplete();
      if (typeof buildReview === 'function') buildReview();
    }
    syncAllAvatarElementsVisibility();
    if (shouldForceFirstStep) {
      var firstCard = $('[data-cfg-step="1"]');
      if (firstCard) {
        setTimeout(function () {
          scrollToCard(firstCard);
        }, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }
}
var ottoCfgResumeCache;
var ottoCfgResumeFetchDone = false;
function prefetchOttoCfgResume(callback) {
  if (ottoCfgResumeFetchDone) {
    callback(ottoCfgResumeCache || null);
    return;
  }
  var token = '';
  try {
    token = String((new URLSearchParams(window.location.search || '')).get('resume') || '').trim();
  } catch (_resumeErr) {}
  if (!token) {
    ottoCfgResumeFetchDone = true;
    ottoCfgResumeCache = null;
    callback(null);
    return;
  }
  var workerUrl = '';
  try {
    var cfgNode = document.querySelector('[data-otto-cfg-config]');
    if (cfgNode) {
      var bootCfg = JSON.parse(cfgNode.textContent || '{}');
      workerUrl = String(bootCfg.workerUrl || '').replace(/\/$/, '');
    }
  } catch (_cfgErr) {}
  if (!workerUrl) {
    ottoCfgResumeFetchDone = true;
    ottoCfgResumeCache = null;
    callback(null);
    return;
  }
  fetch(workerUrl + '/configurator/draft?token=' + encodeURIComponent(token), {
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      return response.json().catch(function () { return {}; });
    })
    .then(function (data) {
      ottoCfgResumeFetchDone = true;
      ottoCfgResumeCache = data && data.ok && data.selections ? data : null;
      callback(ottoCfgResumeCache);
    })
    .catch(function () {
      ottoCfgResumeFetchDone = true;
      ottoCfgResumeCache = null;
      callback(null);
    });
}
function bootOttoConfigurators(scope) {
var container = scope || document;
var roots = container.querySelectorAll('[data-otto-cfg-v2-root]');
if (!roots.length) return;
prefetchOttoCfgResume(function (resumePayload) {
  if (resumePayload) window.__ottoCfgResumePayload = resumePayload;
  roots.forEach(function (root) {
    initOttoConfigurator(root);
  });
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { bootOttoConfigurators(document); });
} else {
bootOttoConfigurators(document);
}
document.addEventListener('shopify:section:load', function (event) {
var target = event && event.target ? event.target : document;
bootOttoConfigurators(target);
});
window.OttoConfiguratorInit = initOttoConfigurator;
})();
